/* hi-markt · Küchenplaner — die dritte Ansicht.

   Volumenkörper aus den Katalogmaßen, keine CAD-Modelle: Breite × Höhe × Tiefe stehen für
   541 von 544 Schränken im Katalog, es fehlt nichts. Fronten in der Serienfarbe, Korpus im
   zweiten Teil des Farbnamens, Raum in den Flächenfarben des Shops.

   Die Bibliothek wird ERST beim Klick auf „3D" geladen. Der kritische Pfad der Seite bleibt
   unangetastet — das war teuer erarbeitet und wird hier nicht wieder verspielt. Scheitert das
   Laden, bleibt die 2D-Ansicht maßgeblich und der Kunde liest, warum.

   Gerechnet wird auch hier nichts: jede Zahl kommt aus `hm-konfigurator.js`.
*/
(function (w) {
  'use strict';

  var K = w.HMKonfig;
  if (!K) return;

  var T = null, laeuft = false;
  var rd = null, sc = null, cam = null, root = null, kugel = null, ro = null;
  var raumJetzt = null, bbJetzt = null, hoeheJetzt = 250, datenJetzt = null;
  /* Der geschlossene Raum (raumHuelle): Rechteck um alle Waende und Bloecke, und wo ihm eine Wand fehlt. */
  var huelleJetzt = null;
  /* Hochglanz-Raum (glaenzende Fronten) — das Foto rechnet ihn dunkler und mit staerkerem LED-Licht. */
  var glanzRaum = false;
  var leinwand = null;
  /* Licht mit Schatten (fuer die Rahmung des Schattenwurfs gemerkt), die Gruppen je Schrank
     (fuer das Antippen) und die Markierung des gewaehlten Schranks. */
  var sonne = null, schrankGruppen = {}, markierung = null, markiertSel = null;
  /* Nachbearbeitung (Umgebungsverdeckung): Quelle von three, der fertige Zusammensetzer und ob
     gerade ein Finger zieht (auf dem Telefon wird waehrenddessen ohne sie gezeichnet). */
  var dreiQuelle = '', nach = null, nachLaeuft = false, zieht = false, ohneNach = false;
  /* Die Pendelleuchten ueber der Insel — nur in der freien Perspektive sichtbar. */
  var pendelGruppe = null;
  /* Boden und Decke ueber den Raum hinaus — nur fuer die Frontansicht mit langer Brennweite (siehe frontKamera). */
  var weitGruppe = null;
  /* LANGE BRENNWEITE FUER DIE FRONTANSICHT (Betreiber 2026-09-29 nach dem Hinweis seines Designers: „Front ohne Kamera").
     Waagrechter Bildwinkel in Grad; 0 = die alte Weitwinkel-Rahmung. */
  var FRONT_TELE = 17;
  /* NUR FUER DIE KUECHENZEILE (Betreiber 2026-09-29 nach den vier Beispielen: „ممتازة للمطبخ المستقيم … لكنها في L وU والجزيرة
     تُخفي جزءًا مما يريد العميل رؤيته"): eine Wand, keine Insel. In L, U, zweizeilig und mit Insel bleibt die Weitwinkel-
     Rahmung — von weit vorne wurden dort die Seitenzeilen zu schmalen Seitenflaechen und die Insel verdeckte die Zeile. */
  function teleHier() {
    return FRONT_TELE > 0 && !!raumJetzt && (raumJetzt.waende || []).length === 1 && !(raumJetzt.bloecke || []).length;
  }
  /* Der gedachte Studioraum (umgebung) — Lichtumgebung, solange kein geschlossener Raum sich selbst spiegelt. */
  var studioEnv = null;
  /* Die Deckenspots als echtes Licht (Stufe 3) — eine feste Anzahl, einmal angelegt: jede andere Zahl von Lichtern
     wuerde alle Materialien neu uebersetzen lassen (ein spuerbares Stocken bei jeder Planaenderung). */
  var deckenSpots = [], SPOT_ZAHL = 6, SPOT_STAERKE = 12000;
  /* LICHTREGIE (Betreiber 2026-09-29: „المصمم … اضاف ضوء الشمس والاضاءة الصفراء بحيث حافظ على لون المطبخ والظلال"). Wie ein
     Innenraumfotograf: ein neutrales Hauptlicht auf den Fronten (`sonne`, mit Schatten), die Sonne nur als Akzent durch EIN
     Fenster (`fensterSonne` hinter der `sonnenBlende`), ein kuehles Himmelslicht von der Fensterseite (`aufheller`), wenig
     Grundlicht (`grundLicht`); warmes Kunstlicht (Spots, LED, Voute) faellt auf Boden, Platte und Wand, kaum auf die Fronten. */
  var grundLicht = null, aufheller = null, fensterSonne = null, sonnenBlende = null, lichtFenster = null, ausgleich = null;
  /* EINE FARBE IN JEDER ZEILE (Betreiber 2026-09-30, Bild einer zweizeiligen Kueche: „لماذا تظهر بلونين — هذا غريب جدا — لاحظتها في اكثر
     من سيري واكثر من لون"; vorher „في غلانسيا ال u الابيض تظهر بعض الخزائن بالرمادي"). Haupt- und Himmelslicht kommen von EINER Seite
     (vorn, Fensterseite): die ihnen zugewandte Zeile lag im vollen Licht, die gegenueberliegende und die Seitenzeilen nur im
     Grundlicht — dieselbe Front zwei-, dreifarbig (gemessen: zweizeilig 190 zu 112, U Velora 163 / 104 / 62). Der Ausgleich:
     eine Lichtsonde (LightProbe, nur diffus: kein Glanzpunkt, keine Schatten), die jeder senkrechten Flaeche der Raumachsen
     (+x, -x, +z, -z) AUSGLEICH_ANTEIL dessen gibt, was ihr zur hellsten fehlt (der Rest kommt aus Grundlicht und Raumspiegel):
     E(n) = ax·nx + az·nz + b·(nx² − nz²) + c·(1 − ny²) — an den vier Achsen genau der Fehlbetrag, waagrechte Flaechen (Boden,
     Platte, Decke, Schrankunterseiten) 0. Die Grundrisse sind achsparallel, also bekommt jede Zeile genau ihren Teil. Die hellste
     Zeile und alle Schatten bleiben, wie sie sind. (Zuerst vier waagrechte Richtungslichter: sie legten Glanzpunkte auf Platte und
     Fronten und hellten — 6 Grad von unten — Decke und Schrankunterseiten auf; Code-Pruefung 2026-10-01.) Gemessen mit 0,75 (Probe zweifarbig-2026-09-30, Fronthelligkeit je
     Zeile): zweizeilig Lunara weiss 190/112 → 197/184, Glanzia weiss 205/146 → 208/191, U Glanzia weiss 238/195/226 → 240/228/233,
     L Lunara dunkelgrau 87/59 → 90/77. */
  /* 2026-10-01 von 0,75 auf 0,55 gesenkt (ChatGPT-Pruefung „Final Visual Validation", der Betreiber kann ueberstimmen): mit 0,75
     wurden Seitenwangen und Inselenden, die vom Hauptlicht wegzeigen, so hell wie die Front (Inselende Glanzia weiss 85,9 L*
     gegen Front 84,4) — die Schraenke wirkten flach. Mit 0,55 (Probe ausgleich55-2026-10-01, gleiche Bildpunkte, L*): Inselende
     80,7 gegen Front 84,1; Hochschrank-Seite Lunara weiss 79,1 → 73,5 bei Front 88,7; Fronten der Zeilen quer zum Licht 2–6
     dunkler (U Glanzia weiss Zeile C 82,9 → 77,2 gegen A 89,0), Farbton gleich (a*, b* ± 0,4), Boden am Schrank ± 0,7. */
  var AUSGLEICH_ANTEIL = 0.55;
  /* Wie weit vor dem Raum die Blende (und der Schatten der Sonne) reicht — so weit sieht die Frontansicht den Boden (cm). */
  var VOR_RAUM = 700;
  /* TONKURVE: 'neutral' = Khronos PBR Neutral — eine Grundfarbe unter weissem Licht der Staerke 1 kommt als dieselbe Farbe
     heraus (fuer Produktbilder gebaut); 'aces' = die bisherige filmische Kurve (hellt Mitten auf, entsaettigt, verschiebt
     Holz Richtung Orange). */
  var TONKURVE = 'neutral';
  /* ARCHITECTURAL SHELL, PHASE 1 (ChatGPT "Premium Lifestyle / Art Direction", 2026-10-01). Only the room around the kitchen
     changes, never the kitchen: one warm off-white wall colour for every wall with one fine painted plaster (relief strength
     `putzStaerke`), a shadow gap of `fuge` cm where the walls meet the ceiling, a floor laid plank by plank or tile by tile
     (`boden`: 'stein' large-format porcelain or 'eiche' natural oak, see BODEN_P1), and the daylight window as a real opening
     (reveal, frame, double glazing, interior sill; `rahmen`: 'warmweiss' or 'alu') with a photograph of a garden behind it
     (`aussicht`, phase 1.1; the same for the customer's windows). Lighting,
     camera, GTAO, contact shadows, the kitchen's materials and every rule of the core are untouched. Inputs are form and
     measured walls only — series, colour, worktop and gloss never reach this block. `an: false` restores the approved room. */
  var ARCHITEKTUR = { an: true, wand: '#EFEBE4', putz: 'acg-plaster002', putzStaerke: 0.25, fuge: 2.5, boden: 'stein',
    fenster: true, rahmen: 'warmweiss', aussicht: true, tageslicht: true };

  /* ---------- Laden ---------- */

  /* Geladen wird über ein eingefügtes Modul-Skript, NICHT über ein `import()` in dieser Datei.
     Grund, teuer gelernt: Shopify verarbeitet Theme-Assets vor dem Ausliefern und macht aus
     einem `import(x)` ein `require(x)` — das gibt es im Browser nicht, und die 3D-Ansicht
     meldete „nicht erreichbar", obwohl die Bibliothek erreichbar war. Ein Skript-Element mit
     `type="module"` geht durch dieselbe Verarbeitung unverändert hindurch. */
  /* Ein ES-Modul von aussen laden, ohne dass diese Datei selbst ein Modul sein muss (sie wird
     auch als klassisches Skript und in den Netzen per Function geladen). */
  function modul(quelle) {
    return new Promise(function (fertig, schief) {
      var marke = '__hmMod' + Date.now() + Math.floor(Math.random() * 1e6);
      var el = document.createElement('script');
      el.type = 'module';
      el.textContent = 'import * as M from ' + JSON.stringify(String(quelle)) + ';'
        + 'window[' + JSON.stringify(marke) + '] = M;'
        + 'window.dispatchEvent(new CustomEvent(' + JSON.stringify(marke) + '));';
      var abbruch = setTimeout(function () { schief(new Error('Zeitüberschreitung')); }, 30000);
      w.addEventListener(marke, function () {
        clearTimeout(abbruch);
        var m = w[marke];
        try { delete w[marke]; } catch (e) { w[marke] = null; }
        fertig(m);
      }, { once: true });
      el.addEventListener('error', function () { clearTimeout(abbruch); schief(new Error('Skript')); });
      document.head.appendChild(el);
    });
  }

  function laden(quelle) {
    if (T) return Promise.resolve(T);
    dreiQuelle = String(quelle || '');
    if (laeuft) return laeuft;
    laeuft = new Promise(function (fertig, schief) {
      var marke = '__hmDrei' + Date.now();
      var el = document.createElement('script');
      el.type = 'module';
      el.textContent = 'import * as M from ' + JSON.stringify(String(quelle)) + ';'
        + 'window[' + JSON.stringify(marke) + '] = M;'
        + 'window.dispatchEvent(new CustomEvent(' + JSON.stringify(marke) + '));';
      var abbruch = setTimeout(function () { schief(new Error('Zeitüberschreitung')); }, 20000);
      w.addEventListener(marke, function () {
        clearTimeout(abbruch);
        T = w[marke];
        try { delete w[marke]; } catch (e) { w[marke] = null; }
        fertig(T);
      }, { once: true });
      el.addEventListener('error', function () { clearTimeout(abbruch); schief(new Error('Skript')); });
      document.head.appendChild(el);
    }).then(function (mod) {
      laeuft = false;
      return mod;
    }).catch(function (e) {
      laeuft = false;
      throw e;
    });
    return laeuft;
  }

  /* ---------- Szene ---------- */

  /* EIN LOOK JE FRONTFARBE (Betreiber 2026-09-29: „يجب ان يكون لكل لون لوك خاص واقعي وغير الذي قبله"). Wie ein Katalog jede
     Farbe in einem eigenen Raum fotografiert: Wandfarbe, Boden, Teppich, (ohne gewaehlte Platte) eine passende Platte und
     die Lichtstimmung. Alles Raumbild — bepreist wird allein aus dem Plan. */
  /* `licht` (Lichtregie, Recherche 2026-09-29: Innenraumfotografie, Corona/V-Ray-Praxis, Khronos PBR Neutral):
     haupt/hauptFarbe  neutrales Hauptlicht auf den Fronten (mit Schatten) — die Fronten behalten ihre Farbe,
     sonne/sonneFarbe  die Sonne durch das Lichtfenster, 2–4 x heller als das Hauptlicht, hoechstens 6000 K neben dem
                       Weissabgleich (sonst wird Weiss cremig); `weite`: wie weit vom Fenster ihr Fleck faellt (cm) — weit
                       heisst tiefe Sonne und lange Streifen, nah heisst hohe Sonne,
     himmel            kuehles Himmelslicht von der Fensterseite, ohne Schatten,
     grund             Grundlicht (Himmel oben, Boden unten),
     spot/led/voute    warmes Kunstlicht (3000 K): Lichtinseln, Leisten unter den Haengeschraenken, Decke — Akzente auf
                       Boden, Platte und Wand, hoechstens ~5 % des Lichts auf einer Front,
     aussen            Helligkeit der Aussicht hinter den Fenstern, belichtung: Belichtung der Kamera,
     seite             auf welcher Seite das Lichtfenster sitzt, wenn beide frei sind. */
  var LOOKS = {
    hell: { name: 'Hell nordisch', wand: ['#F2EFEA', '#EDE9E3'], boden: 'dielen', teppich: '#E4DDD0', platte: null,
      licht: { haupt: 2.2, hauptHoehe: 34, hauptFarbe: '#FFFFFF', sonne: 9, sonneFarbe: '#FFF6EC', weite: 170, himmel: 0.6, himmelFarbe: '#EDF3FB',
        grund: 0.35, spot: 9000, spotFarbe: '#FFE9D2', led: 0.9, voute: 2.4, aussen: 1, belichtung: 1.0, seite: 'links' } },
    stadt: { name: 'Stadt', wand: ['#E6D3C5', '#E0CCBE'], boden: 'muster', teppich: '#EEEAE2', platte: 'marmorDunkel',
      licht: { haupt: 2.0, hauptHoehe: 34, hauptFarbe: '#FFFFFF', sonne: 12, sonneFarbe: '#FFE9D0', weite: 290, himmel: 0.5, himmelFarbe: '#E9EFF8',
        grund: 0.35, spot: 13000, spotFarbe: '#FFE0BC', led: 1.3, voute: 3.0, aussen: 0.9, belichtung: 0.85, seite: 'links' } },
    holz: { name: 'Warmes Holz', wand: ['#EFE9E1', '#E8E1D7'], boden: 'stein', teppich: '#D7CCBC', platte: null,
      licht: { haupt: 2.2, hauptHoehe: 34, hauptFarbe: '#FFFFFF', sonne: 9, sonneFarbe: '#FFEBD2', weite: 250, himmel: 0.6, himmelFarbe: '#EDF2FA',
        grund: 0.35, spot: 12000, spotFarbe: '#FFDDB5', led: 1.5, voute: 3.0, aussen: 1, belichtung: 0.92, seite: 'rechts' } },
    beige: { name: 'Sanftes Beige', wand: ['#EFE7DD', '#E9E0D5'], boden: 'dielen', teppich: '#E7DECF', platte: null,
      licht: { haupt: 2.2, hauptHoehe: 34, hauptFarbe: '#FFFFFF', sonne: 4.5, sonneFarbe: '#FFF0DC', weite: 220, himmel: 0.65, himmelFarbe: '#F0F2F6',
        grund: 0.4, spot: 11000, spotFarbe: '#FFE3C4', led: 1.1, voute: 2.8, aussen: 1, belichtung: 0.88, seite: 'links' } },
    natur: { name: 'Natur', wand: ['#F3F1EC', '#EEEBE5'], boden: 'dielen', teppich: '#E2DDD0', platte: null,
      licht: { haupt: 2.2, hauptHoehe: 34, hauptFarbe: '#FFFFFF', sonne: 11, sonneFarbe: '#FFF8F0', weite: 140, himmel: 0.6, himmelFarbe: '#E9F1FB',
        grund: 0.35, spot: 8000, spotFarbe: '#FFEBD6', led: 0.7, voute: 2.0, aussen: 1.1, belichtung: 1.0, seite: 'rechts' } },
    kontrast: { name: 'Kontrast', wand: ['#F4F2EE', '#EFECE7'], boden: 'fliesen', teppich: '#D6D0C6', platte: null,
      licht: { haupt: 2.2, hauptHoehe: 34, hauptFarbe: '#FFFFFF', sonne: 8, sonneFarbe: '#FFD9AE', weite: 330, himmel: 0.5, himmelFarbe: '#E3E9F4',
        grund: 0.35, spot: 15000, spotFarbe: '#FFDDB0', led: 1.8, voute: 3.4, aussen: 0.85, aussenFarbe: '#FFE6C8', belichtung: 1.05, seite: 'links' } }
  };
  var lookJetzt = LOOKS.hell;
  /* DIE BIBLIOTHEK (Betreiber 2026-09-29: „نزل مكتبة كبيرة وجرب عليها … ايضا جميع انواع الرخام واللمينات"): echte, gescannte
     Oberflaechen von ambientCG und Poly Haven (CC0, frei auch fuer den Laden), je drei Bilder (Farbe 1024, Relief 512, Rauheit
     512, WebP) in den Theme-Assets `hm-mat-<id>-{c,n,r}.webp`. Eintrag: [Art, Kachelmass in cm (echte Groesse eines Bildes),
     Mittelfarbe, Helligkeit L*]. Art: holz (Holzboden, Laminat, Parkett), fliese / stein (Boden), marmor, granit, holzdekor
     (Arbeitsplatte), putz (Wandrelief), wandfliese. Geladen wird nur, was der aktuelle Raum zeigt. */
  var BIBLIOTHEK = {
    'ph-laminate-floor': ['holz', 200, '#957244', 51],
    'ph-laminate-floor-02': ['holz', 170, '#9B8063', 56],
    'ph-laminate-floor-03': ['holz', 208, '#9A7247', 51],
    'ph-wood-floor': ['holz', 170, '#805F42', 43],
    'ph-wooden-floor-02': ['holz', 194, '#B88862', 61],
    'ph-herringbone-parquet': ['holz', 340, '#93704D', 50],
    'ph-rectangular-parquet': ['holz', 225, '#775C33', 41],
    'acg-woodfloor039': ['holz', 110, '#E0C59B', 81],
    'acg-woodfloor062': ['holz', 110, '#9E7147', 52],
    'acg-woodfloor064': ['holz', 110, '#6C4313', 32],
    'acg-woodfloor005': ['holz', 110, '#433728', 24],
    'acg-woodfloor010': ['holz', 160, '#9C8166', 56],
    'acg-woodfloor006': ['holz', 160, '#9D8960', 58],
    'acg-woodfloor051': ['holz', 160, '#9A7A5D', 54],
    'acg-woodfloor012': ['holz', 150, '#AA7F54', 57],
    'acg-woodfloor014': ['holz', 150, '#503A29', 27],
    'acg-woodfloor015': ['holz', 150, '#977760', 53],
    'acg-woodfloor034': ['holz', 150, '#916B43', 48],
    'acg-woodfloor036': ['holz', 150, '#E1C79E', 82],
    'acg-woodfloor055': ['holz', 110, '#947457', 51],
    'acg-woodfloor069': ['holz', 110, '#7D6038', 43],
    'acg-tiles002': ['fliese', 240, '#CDCDCC', 82],
    'acg-tiles139': ['fliese', 240, '#B39F89', 67],
    'acg-tiles142': ['fliese', 240, '#D9B48D', 76],
    'acg-tiles143': ['fliese', 240, '#D9B48D', 76],
    'acg-tiles013': ['fliese', 240, '#D7CAB7', 82],
    'acg-tiles055': ['fliese', 240, '#D8D5D0', 86],
    'acg-tiles057': ['fliese', 240, '#DBD8D2', 86],
    'acg-tiles074': ['fliese', 240, '#554B43', 33],
    'acg-tiles012': ['fliese', 240, '#868480', 55],
    'acg-tiles014': ['fliese', 240, '#7C7B77', 52],
    'acg-tiles138': ['fliese', 240, '#353636', 23],
    'acg-tiles109': ['fliese', 240, '#A69680', 63],
    'acg-tiles110': ['fliese', 240, '#A69680', 63],
    'acg-tiles107': ['fliese', 320, '#F7F7F7', 98],
    'acg-tiles079': ['fliese', 160, '#B8A897', 70],
    'acg-tiles016': ['fliese', 160, '#979591', 62],
    'ph-marble-01': ['fliese', 150, '#B19D79', 66],
    'ph-floor-tiles-02': ['fliese', 400, '#9E907E', 61],
    'ph-floor-tiles-04': ['fliese', 400, '#C7A679', 70],
    'ph-floor-tiles-06': ['fliese', 300, '#796F6B', 48],
    'ph-interior-tiles': ['fliese', 190, '#AA9784', 64],
    'ph-marble-tiles': ['fliese', 200, '#8B8071', 54],
    'ph-patterned-terracotta-tiling': ['fliese', 215, '#603623', 28],
    'acg-terrazzo001': ['stein', 100, '#BEBBBD', 76],
    'acg-terrazzo002': ['stein', 100, '#B9B2B0', 73],
    'acg-terrazzo004': ['stein', 100, '#D6D5D8', 86],
    'acg-terrazzo005': ['stein', 100, '#C1BCB8', 77],
    'acg-terrazzo009': ['stein', 100, '#C7C0B8', 78],
    'acg-terrazzo013': ['stein', 100, '#D1CCC6', 82],
    'acg-terrazzo019m': ['stein', 100, '#A08D74', 60],
    'acg-tiles040': ['stein', 100, '#DBD9DA', 87],
    'acg-tiles043': ['stein', 100, '#D6DCDA', 87],
    'acg-travertine001': ['stein', 160, '#A59982', 64],
    'acg-travertine009': ['stein', 160, '#DFCBAC', 83],
    'acg-travertine004': ['stein', 160, '#A39585', 62],
    'acg-travertine014': ['stein', 160, '#949083', 60],
    'acg-marble001': ['marmor', 150, '#DFDDD7', 88],
    'acg-marble002': ['marmor', 150, '#1F2022', 12],
    'acg-marble003': ['marmor', 150, '#AFB6C9', 74],
    'acg-marble004': ['marmor', 150, '#E6DED3', 89],
    'acg-marble005': ['marmor', 150, '#E4E8EA', 92],
    'acg-marble006': ['marmor', 150, '#191919', 9],
    'acg-marble007': ['marmor', 150, '#907B6A', 53],
    'acg-marble008': ['marmor', 150, '#715537', 38],
    'acg-marble009': ['marmor', 150, '#111514', 7],
    'acg-marble010': ['marmor', 150, '#A59694', 64],
    'acg-marble011': ['marmor', 150, '#5D5349', 36],
    'acg-marble012': ['marmor', 150, '#ACADB6', 71],
    'acg-marble013': ['marmor', 150, '#242324', 14],
    'acg-marble014': ['marmor', 150, '#D0C3B0', 80],
    'acg-marble015': ['marmor', 150, '#D8CDBB', 83],
    'acg-marble016': ['marmor', 150, '#3D3E3E', 26],
    'acg-marble017': ['marmor', 150, '#484848', 31],
    'acg-marble018': ['marmor', 150, '#BCB6B1', 75],
    'acg-marble019': ['marmor', 150, '#E9EAE9', 93],
    'acg-marble020': ['marmor', 150, '#B2A395', 68],
    'acg-marble021': ['marmor', 150, '#F3F2F0', 96],
    'acg-marble022': ['marmor', 150, '#977554', 52],
    'acg-marble023': ['marmor', 150, '#575E64', 40],
    'acg-marble024': ['marmor', 150, '#8F847A', 56],
    'acg-marble025': ['marmor', 150, '#D7D7D7', 86],
    'acg-marble026': ['marmor', 150, '#C3AD88', 72],
    'acg-onyx004': ['marmor', 200, '#CAC2B1', 79],
    'acg-onyx012': ['marmor', 200, '#A08F77', 60],
    'acg-onyx013': ['marmor', 200, '#34302B', 20],
    'acg-onyx014': ['marmor', 200, '#626158', 41],
    'acg-onyx015': ['marmor', 200, '#CDCAC8', 82],
    'acg-granite001a': ['granit', 70, '#A99685', 63],
    'acg-granite002a': ['granit', 70, '#B4B1AC', 72],
    'acg-granite003a': ['granit', 70, '#A29D9C', 65],
    'acg-granite004a': ['granit', 70, '#8F7D66', 54],
    'acg-granite004b': ['granit', 70, '#8F7D66', 54],
    'acg-granite005a': ['granit', 70, '#A19899', 64],
    'acg-granite007a': ['granit', 70, '#87745A', 50],
    'acg-wood014': ['holzdekor', 130, '#9F8062', 56],
    'acg-wood022': ['holzdekor', 130, '#CEAA75', 72],
    'acg-wood047': ['holzdekor', 130, '#AD8B68', 60],
    'acg-wood048': ['holzdekor', 130, '#B08F65', 62],
    'acg-wood049': ['holzdekor', 130, '#7B634D', 44],
    'acg-wood051': ['holzdekor', 130, '#41342E', 23],
    'acg-wood066': ['holzdekor', 130, '#593313', 26],
    'acg-wood068': ['holzdekor', 130, '#AC8A6C', 60],
    'acg-wood090a': ['holzdekor', 130, '#AD8C62', 61],
    'acg-wood091a': ['holzdekor', 130, '#D1A976', 72],
    'acg-wood095': ['holzdekor', 130, '#CC9C6E', 68],
    'acg-plaster001': ['putz', 200, '#D7D3D0', 85],
    'acg-plaster002': ['putz', 200, '#D9D5D2', 86],
    'acg-plaster003': ['putz', 200, '#D7D3D0', 85],
    'acg-plaster004': ['putz', 200, '#9A9A96', 64],
    'acg-plaster005': ['putz', 200, '#A6A5A1', 68],
    'acg-plaster006': ['putz', 200, '#A9A8A4', 69],
    'ph-white-plaster-02': ['putz', 200, '#8D877A', 57],
    'acg-tiles009': ['wandfliese', 120, '#EBE8DC', 92],
    'acg-tiles032': ['wandfliese', 120, '#1D4F36', 30],
    'acg-tiles034': ['wandfliese', 120, '#355134', 32],
    'acg-tiles010': ['wandfliese', 120, '#BFBFBF', 78],
    'acg-tiles036': ['wandfliese', 100, '#D0D0D0', 84],
    'acg-tiles071': ['wandfliese', 100, '#EBEBEB', 93],
    'acg-tiles136a': ['wandfliese', 100, '#CBCED0', 83],
    'acg-tiles129b': ['wandfliese', 100, '#1F1F1E', 12]
  };
  /* DIE PLATTENFAMILIE (2026-09-30): aus welcher Art der Bibliothek eine gewaehlte Shop-Platte ihre gescannte Oberflaeche
     nimmt, entscheidet allein das Katalogfeld `muster` — an dieser EINEN Stelle, nie ueber Namen oder Farben. Der Katalog
     schreibt eiche (Lamellen: Artisan, Lancelot) und block (Porterhouse, Stabholz); beides ist Holz und nimmt die Art
     `holzdekor` (nicht `holz`: das sind Boeden). Bis hierher prueften wir nur auf `holz`, das kein Eintrag fuehrt — so bekam
     jede Holzplatte einen Stein-/Marmor-Scan in Holzfarbe. Das feine Muster (eiche/block) zeichnet plattenBild weiter; zu
     sehen ist es nur, bis der Scan geladen ist oder wenn er fehlt. Ein Muster, das hier fehlt, bleibt Stein wie bisher. */
  var PLATTEN_FAMILIE = { marmor: 'marmor', stein: 'stein', holz: 'holz', eiche: 'holz', block: 'holz' };
  var FAMILIE_ARTEN = { marmor: ['marmor'], holz: ['holzdekor'], stein: ['granit', 'marmor', 'stein'] };
  function plattenFamilie(p) {
    var mu = p && p.muster;
    return Object.prototype.hasOwnProperty.call(PLATTEN_FAMILIE, mu) ? PLATTEN_FAMILIE[mu] : 'stein';
  }
  /* PLATTENSTAERKE (Betreiber 2026-09-30): jede Platte in ihrer Katalogstaerke statt fest 4 cm. Die eine Rechnung steht im Kern
     (K.plattenDicke: Katalog `dicke` in mm → cm, ohne gewaehlte Platte die Seriengeometrie); 3D, 2D, Anzeige und Pruefung teilen sie. */
  function plattenDicke(z, daten) {
    return K.plattenDicke ? K.plattenDicke(z, daten) : K.geo(daten).arbeitsplatte_dicke;
  }
  /* DAS RAUMREZEPT (Betreiber 2026-09-29: „في كل قياس وكل لون ارضيه مختلفة وغرفة مختلفة ولوك مختلف … اريد افكار جديدة في كل
     مرة"): aus Form, Massen, Serie und Farbe ein fester Zufall — dieselbe Kueche sieht immer gleich aus, jede andere Groesse
     oder Farbe bekommt einen eigenen Raum: Boden, Wandfarbe, Wandputz, Platte (solange keine gewaehlt ist), Fensterseite und
     Einrichtung. Die Auswahl je Look ist kuratiert (Kontrast zur Front, keine Holz-auf-Holz-Faelle).
     SEIT 2026-09-30 OHNE SERIE UND FARBE (Betreiber: beim Wechsel von Farbe, Oberflaeche oder Serie soll sich nur die Kueche
     aendern, nicht der Raum — sonst vergleicht der Kunde Matt und Hochglanz in zwei verschiedenen Raeumen): der Zufall kommt nur
     noch aus Form und Massen, der Look ist fuer alle Fronten derselbe (lookFuer). Jede Groesse behaelt ihren eigenen Raum. */
  var REZEPT = {
    hell: { boeden: ['ph-laminate-floor-02', 'ph-laminate-floor-03', 'acg-woodfloor039', 'acg-woodfloor036', 'ph-herringbone-parquet',
        'acg-woodfloor015', 'acg-tiles002', 'acg-tiles142', 'ph-marble-01', 'acg-terrazzo004', 'acg-terrazzo019m', 'acg-tiles013', 'acg-tiles057'],
      platten: ['acg-marble019', 'acg-marble005', 'acg-marble001', 'acg-marble021', 'acg-marble018', 'acg-wood022', 'acg-wood095', 'acg-onyx015'],
      waende: [['#F2EFEA', '#EDE9E3'], ['#EEF0EE', '#E7EAE8'], ['#F3EEE6', '#EDE6DC'], ['#E9ECEF', '#E2E6EA']] },
    stadt: { boeden: ['muster', 'acg-tiles079', 'acg-tiles012', 'acg-tiles014', 'acg-tiles074', 'acg-woodfloor064', 'acg-woodfloor014',
        'acg-terrazzo005', 'acg-woodfloor055'],
      platten: ['acg-marble006', 'acg-marble016', 'acg-marble017', 'acg-marble023', 'acg-marble013', 'acg-marble002', 'acg-granite002a', 'acg-onyx013'],
      waende: [['#E6D3C5', '#E0CCBE'], ['#D9D4CE', '#D2CCC5'], ['#E4E1DC', '#DDD9D3'], ['#CFC9C1', '#C8C2BA']] },
    holz: { boeden: ['acg-tiles142', 'acg-tiles143', 'acg-tiles139', 'acg-terrazzo019m', 'acg-travertine009', 'ph-floor-tiles-02', 'acg-tiles002',
        'acg-tiles109', 'acg-terrazzo001', 'ph-marble-01', 'stein'],
      platten: ['acg-marble021', 'acg-marble001', 'acg-marble015', 'acg-marble025', 'acg-granite002a', 'acg-marble019', 'acg-marble024', 'acg-marble016'],
      waende: [['#EFE9E1', '#E8E1D7'], ['#F2F0EC', '#ECE9E4'], ['#E7E3DB', '#E0DBD2'], ['#DCD8D0', '#D4CFC6']] },
    beige: { boeden: ['ph-laminate-floor', 'ph-laminate-floor-03', 'acg-woodfloor039', 'acg-tiles142', 'acg-travertine001',
        'acg-terrazzo019m', 'acg-woodfloor055', 'acg-woodfloor012', 'dielen'],
      platten: ['acg-marble014', 'acg-marble004', 'acg-marble015', 'acg-marble024', 'acg-marble020', 'acg-wood049', 'acg-wood095', 'acg-onyx012'],
      waende: [['#EFE7DD', '#E9E0D5'], ['#F1ECE4', '#EBE4DA'], ['#E8E2DA', '#E1DAD1'], ['#EDE8E0', '#E6E0D6']] },
    natur: { boeden: ['ph-laminate-floor-02', 'ph-laminate-floor-03', 'acg-woodfloor039', 'acg-woodfloor012', 'ph-herringbone-parquet',
        'acg-terrazzo009', 'acg-terrazzo013', 'acg-tiles013', 'ph-patterned-terracotta-tiling', 'acg-tiles139', 'dielen'],
      platten: ['acg-marble019', 'acg-marble018', 'acg-marble001', 'acg-wood047', 'acg-wood048', 'acg-wood022', 'acg-marble014', 'acg-marble003'],
      waende: [['#F3F1EC', '#EEEBE5'], ['#EEEFE9', '#E7E9E2'], ['#F2EEE6', '#ECE7DE'], ['#E6E4DC', '#DFDDD4']] },
    kontrast: { boeden: ['acg-tiles002', 'acg-tiles107', 'acg-terrazzo001', 'acg-terrazzo004', 'ph-laminate-floor-02', 'acg-woodfloor039',
        'acg-woodfloor015', 'acg-woodfloor010', 'ph-marble-01', 'acg-tiles142', 'fliesen'],
      platten: ['acg-marble021', 'acg-marble019', 'acg-wood049', 'acg-wood014', 'acg-marble005', 'acg-marble008', 'acg-granite001a', 'acg-marble012'],
      waende: [['#F4F2EE', '#EFECE7'], ['#E9E6E1', '#E2DED8'], ['#F0EDE8', '#E9E5DF'], ['#DEDCD7', '#D6D3CD']] }
  };
  var PUTZE = ['acg-plaster001', 'acg-plaster002', 'acg-plaster003', 'acg-plaster004', 'acg-plaster005', 'acg-plaster006', 'ph-white-plaster-02'];
  var rezeptJetzt = null;
  function rezeptFuer(z, look) {
    var schl = [z.form, z.A, z.B, z.C].join('|'), hsh = 2166136261;
    for (var i = 0; i < schl.length; i++) { hsh ^= schl.charCodeAt(i); hsh = Math.imul(hsh, 16777619) >>> 0; }
    var s = hsh % 2147483646 + 1, zu = function () { s = (s * 16807) % 2147483647; return (s - 1) / 2147483646; };
    var wahl = function (liste) { return liste[Math.floor(zu() * liste.length) % liste.length]; };
    var schluessel = Object.keys(LOOKS).filter(function (k) { return LOOKS[k] === look; })[0] || 'hell', r = REZEPT[schluessel] || REZEPT.hell;
    var sonne = { an: zu() >= 0.25, hoehe: 24 + Math.round(zu() * 18), seitwaerts: Math.round(zu() * 22), staerke: 0.7 + zu() * 0.4,
      waerme: Math.round((zu() * 1.2 - 0.4) * 100) / 100 };
    return { saat: hsh, boden: wahl(r.boeden), wand: wahl(r.waende), putz: wahl(PUTZE), platte: wahl(r.platten),
      seite: zu() < 0.5 ? 'links' : 'rechts', teppich: zu() < 0.6, sonne: sonne,
      decke: wahl(['spots', 'spots', 'aufbau', 'linie', 'schiene', 'voute']), deckeFinish: wahl(['weiss', 'weiss', 'schwarz', 'messing']),
      spotRaster: wahl([110, 130, 150]), zu: zu };
  }
  /* EIN LOOK FUER ALLE FRONTEN (Betreiber 2026-09-30): bis hierher waehlte die Frontfarbe den Look (Grau Hochglanz → Stadt,
     Eiche → Holz, Beige, Gruen, Dunkelgrau/Grau → Kontrast) — und mit ihm Wandfarben, Boeden, Licht und Belichtung. Jetzt
     steht jede Front im selben Raum: „Hell nordisch", in dem Weiss Matt und Weiss Hochglanz abgestimmt sind. Die anderen
     Looks bleiben als Werte stehen (Lichtpult), werden aber nicht mehr nach der Front gewaehlt. */
  function lookFuer() {
    return LOOKS.hell;
  }
  /* Auch die Einrichtung des Raums haengt nicht mehr an der Front (2026-09-30): Glasleuchten ueber der Insel, Licht im Sockel
     und helle Hocker gab es bisher nur zu Hochglanzfronten (HOCHGLANZ-RAUM, 2026-09-27). Jetzt steht jede Front in derselben
     Einrichtung wie bisher die matten: schwarze Pendelleuchten, dunkle Hocker, kein Sockellicht. Gemessen: die Glanzfronten
     sind in beiden Einrichtungen gleich hell mit gleichen Glanzlichtern, die Glasleuchten (transmission) kosten aber je Bild
     einen zweiten Durchgang der Szene (~30 % Bildzeit). true stellt die Hochglanz-Einrichtung fuer alle Fronten ein. */
  var RAUM_GLANZ = false;
  function bodenTextur(look, wx, wz) {
    return look.boden === 'muster' ? musterFliesen(wx, wz) : (look.boden === 'fliesen' ? fliesen(wx, wz)
      : (look.boden === 'stein' ? fliesen(wx, wz, 'stein') : dielen(wx, wz)));
  }

  function aufbauen(cv, z, daten) {
    if (!T || !cv) return;
    /* Die Platte liegt auf den Unterschraenken (Unterkante = korpus_hoehe); ihre Staerke kommt von der gewaehlten Platte
       (plattenDicke), und mit ihr die Oberkante und alles, was darauf steht oder daran anschliesst: Spuele, Kochfeld, Haube,
       Nischenrueckwand, Deko. K.geo liefert das geteilte Katalogobjekt — deshalb eine Kopie: 2D, Pruefungen und Beleg bleiben
       unberuehrt. Deckenstrahler und Pendelleuchten rechnen weiter mit der Seriengeometrie (gSerie), der Raum bleibt gleich. */
    var gSerie = K.geo(daten), g = Object.assign({}, gSerie, { arbeitsplatte_dicke: plattenDicke(z, daten) });
    var A = +z.A;
    var RH = +z.hoehe, t = g.korpus_tiefe;

    /* DIE EINE QUELLE. Vorher stand hier
         var B = (z.form === 'l' || z.form === 'u') ? +z.B : 300;
         var C = z.form === 'u' ? +z.C : 0;
       — 3D leitete die Raumform aus dem FORMNAMEN ab und hatte damit sein eigenes
       Raummodell neben dem des Grundrisses. Fuer die zweizeilige Kueche fiel B auf 300
       zurueck und C auf 0; ihre Wand C landete im Ursprung statt an ihrem Platz.
       Ab hier liest 3D dieselbe Geometrie wie Grundriss und Frontansicht. */
    var raum = K.raumGeometrie(z, t);
    /* Kamera und Rahmung brauchen dieselbe Geometrie wie die Szene — gemerkt statt zweimal
       gerechnet, sonst haette der Blickwinkel sein eigenes Raummodell. Genau daran ist die
       Wand C der Parallelkueche schon einmal gescheitert. */
    raumJetzt = raum; bbJetzt = K.raumBounds(raum, t); hoeheJetzt = RH; datenJetzt = daten;
    var teile = raum.waende.concat(raum.bloecke);
    var raumTiefe = teile.reduce(function (mx, w) {
      return Math.max(mx, w.p0.y, w.p1.y);
    }, 0);
    raum.bloecke.forEach(function (b) { raumTiefe = Math.max(raumTiefe, b.p0.y + t); });
    raumTiefe = raumTiefe || 300;

    if (!rd || leinwand !== cv) {
      if (rd) rd.dispose();
      /* `preserveDrawingBuffer`: sonst ist die 3D-Ansicht in jedem Bildschirmfoto und im
         Ausdruck leer. */
      sondeNieNegativ();   /* vor dem ersten Uebersetzen eines Shaders (Programme werden nach Art, nicht nach Quelltext gemerkt) */
      rd = new T.WebGLRenderer({ canvas: cv, antialias: true, preserveDrawingBuffer: true });
      /* Ein Groessenwechsel leert den Zeichenpuffer (auch mit preserveDrawingBuffer): bis zum naechsten malen() gibt es kein
         Bild, das eine Ueberblendung kopieren koennte (Code-Pruefung 2026-10-01: sonst schwarzer Blitz beim Drehen des Telefons). */
      ['setSize', 'setPixelRatio'].forEach(function (f) {
        var alt = rd[f];
        rd[f] = function () { pufferFrisch = true; return alt.apply(rd, arguments); };
      });
      rd.setPixelRatio(Math.min(w.devicePixelRatio || 1, 2));
      /* WIE EIN FOTO, NICHT WIE EIN MODELL (Betreiber 2026-09-24: „die Schraenke sind nicht
         echt"). Filmische Tonkurve statt linearer Werte — helle Fronten brennen nicht aus,
         dunkle saufen nicht ab —, und weiche Schatten: erst der Schatten unter dem
         Haengeschrank und am Boden laesst einen Korpus STEHEN statt schweben. */
      if (T.ACESFilmicToneMapping) { rd.toneMapping = T.ACESFilmicToneMapping; rd.toneMappingExposure = 1.1; }
      /* Produktfarben statt Filmkurve (Lichtregie 2026-09-29): Khronos PBR Neutral. ACES hob Grau 128 auf 153 und senkte
         Weiss 245 auf 225 (nachgerechnet am r160-Code) — die Fronten lagen nie in ihrer Katalogfarbe. */
      if (TONKURVE === 'neutral' && tonkurveNeutral()) rd.toneMapping = T.CustomToneMapping;
      rd.toneMappingExposure = LOOKS.hell.licht.belichtung;
      rd.shadowMap.enabled = true;
      rd.shadowMap.type = T.PCFSoftShadowMap;
      /* Schatten nur neu, wenn sich die Szene aendert (lichtRegie, Aufbau) — nicht bei jedem Bild: Richtungslicht haengt
         nicht vom Blick ab, und jedes Bild zeichnete die Schattenkarten sonst zweimal (Szene + Umgebungsverdeckung). */
      rd.shadowMap.autoUpdate = false;
      rd.shadowMap.needsUpdate = true;
      /* Die Sonnenblende steht nur waehrend des Schattenwurfs in der Szene — nie im Bild, im Spiegelbild oder in der
         Verdeckung. */
      (function (sm) {
        var schattenZeichnen = sm.render;
        sm.render = function (lichter, szene, kamera) {
          if (sonnenBlende) sonnenBlende.visible = true;
          try { schattenZeichnen.call(sm, lichter, szene, kamera); } finally { if (sonnenBlende) sonnenBlende.visible = false; }
        };
      })(rd.shadowMap);
      sc = new T.Scene();
      /* Hell wie ein Raum, nicht dunkel wie eine Buehne: vor dem fast schwarzen Grund wirkten
         Weiss und Beige grau, und keine der Komplettkuechen im Shop steht so im Dunkeln. */
      sc.background = new T.Color('#DCD7CE');
      studioEnv = umgebung(rd);
      sc.environment = studioEnv;
      glanzEnv = umgebungGlanz(rd);
      cam = new T.PerspectiveCamera(42, 2, 10, 4000);
      /* Kugelkoordinaten um den Raum: `ph` = 0 steht VOR Wand A, `ph` = pi/2 seitlich davon.
         Die Referenz startet bei 0,52 pi — das ist fast genau in der Wandebene, und der Kunde
         sah seine Zeile von der Schmalseite. Ein Dreiviertelblick zeigt Front und Tiefe. */
      /* Der Abstand folgt der GANZEN Ausdehnung, nicht nur der Laenge von Wand A. Eine
         tiefe U-Kueche oder eine Insel weit vor der Reihe lag sonst ausserhalb des Bildes:
         900 cm Tiefe und 360 cm Wand A ergaben einen Radius fuer 360. Winkel und Blick
         bleiben, wie sie waren — nur die Entfernung passt sich an. */
      var bb0 = K.raumBounds(K.raumGeometrie(z, t), t);
      kugel = { r: Math.max(bb0.breite, bb0.tiefe, 400) * 1.5,
                th: Math.PI * 0.16, ph: Math.PI * 0.26,
                /* Welcher der drei Schalter zuletzt gedrueckt wurde, und ob der Kunde seither
                   selbst gezoomt hat. Beides braucht die Rahmung der Draufsicht. */
                art: null, gezoomt: false, ziel: null, wandId: null, lupe: 1 };
      /* Neue Kamera: nichts, woraus eine Fahrt starten koennte; der erste Blick (Raumansicht der App) steht sofort. */
      fahrt = null; poseZuletzt = null; ersteAnsicht = true;
      /* Himmel und Boden als weiches Grundlicht, dazu EINE Sonne schraeg durch ein gedachtes
         Fenster, die Schatten wirft, und ein schwaches Gegenlicht, damit die Seiten nicht
         schwarz werden. Die Schattenkarte ist auf dem Telefon kleiner — sonst ruckelt das Drehen. */
      /* Licht fast neutral (2026-09-27): mit warmer Sonne und warmem Himmel lag jede Front 10 Stufen
         im Blau unter dem Produktfoto — Artisan Eiche wurde orange, Weiss cremig. */
      /* Stufe 3: das Grundlicht kommt jetzt zum groessten Teil aus dem Raum selbst (raumSpiegel) — Himmel/Boden-Licht
         und Aufheller nur noch schwach, sonst lag alles doppelt hell und flach (gemessen: Grau Hochglanz 150 → 191). */
      /* TAGESLICHT WIE DIE SERIENBILDER (Betreiber 2026-09-29: „مثل صور ku-s11"): hell, freundlich, viel Licht von den
         Fenstern — nicht das gedaempfte Abendlicht der ersten Stufe 3. */
      grundLicht = new T.HemisphereLight('#fdfcfa', '#b9b2a6', 0.35);
      sc.add(grundLicht);
      var dir = new T.DirectionalLight('#fffaf2', 1.6);
      dir.position.set(-260, 420, 380);
      /* OHNE SCHATTEN (Lichtregie 2026-09-29): das Hauptlicht ist Himmelslicht, weich und von ueberall — seine scharfen Schatten
         legten in der zweizeiligen Kueche die Gegenzeile als grosse schraege Kante quer ueber die Stirnwand (auch mit
         grober Karte). Die Verdeckung (GTAO) dunkelt Kehlen und Fugen ab; scharfe Schatten wirft nur die Sonne im Fenster. */
      /* NACHTRAG (Betreiber 2026-09-29: „يجب ان تحتوي ايضا الادوات على ظلال … بشكل احترافي"): das Hauptlicht wirft wieder
         Schatten — aber NUR die Einrichtung (Toepfe, Flaschen, Pflanzen …): kurze, weiche Schatten hinter und neben jedem Stueck,
         wie auf Katalogbildern. Schraenke und Waende werfen fuer dieses Licht nichts (onBeforeShadow, siehe Aufbau). Eine
         groebere Karte als die der Sonne: der Rand bleibt weich wie Licht von einer Fensterflaeche. */
      dir.castShadow = true;
      dir.shadow.bias = -0.0006;
      var karte = (w.innerWidth || 800) < 768 ? 1024 : 2048;
      dir.shadow.mapSize.set(karte / 2, karte / 2);
      dir.shadow.bias = -0.0004;
      dir.shadow.normalBias = 0.6;
      dir.shadow.radius = 4;
      sc.add(dir); sc.add(dir.target);
      sonne = dir;
      var fuell = new T.DirectionalLight('#ffffff', 0.45);
      fuell.position.set(320, 220, 520);
      sc.add(fuell); sc.add(fuell.target);
      aufheller = fuell;
      ausgleich = new T.LightProbe();
      ausgleich.userData.nurLive = true;
      sc.add(ausgleich);
      /* DIE SONNE DURCH DAS FENSTER (Lichtregie): scharfer, heller Fleck mit Sprossenschatten auf Boden und Unterschraenken —
         das Zeichen eines echten Raums auf jedem Katalogbild. Sie wirft Schatten, und die Sonnenblende laesst sie nur durch
         das Lichtfenster. */
      fensterSonne = new T.DirectionalLight('#FFF3E2', 0);
      fensterSonne.castShadow = true;
      fensterSonne.shadow.mapSize.set(karte, karte);
      fensterSonne.shadow.bias = -0.0004;
      fensterSonne.shadow.normalBias = 0.6;
      sc.add(fensterSonne); sc.add(fensterSonne.target);
      deckenSpots = [];
      for (var dsi = 0; dsi < SPOT_ZAHL; dsi++) {
        var dsp = new T.SpotLight('#FFF4E6', 0, 0, Math.PI / 3, 1, 2);
        dsp.castShadow = false;
        sc.add(dsp); sc.add(dsp.target);
        deckenSpots.push(dsp);
      }
      root = new T.Group();
      sc.add(root);
      steuerung(cv);
      leinwand = cv;
      nach = null;
      nachLaden();
    }

    /* The old kitchen is detached here and released after the first frame of the new one (szeneFreigeben, 2026-10-01). This
       loop used to dispose only the DIRECT children of root — everything inside wall, cabinet and room groups stayed in GPU
       memory. Without a frame (hidden canvas) at most two old kitchens wait. */
    freigabeOffen.push(root.children.splice(0, root.children.length));
    if (freigabeOffen.length > 2) szeneFreigeben();
    /* Der Auswahl-Umriss haengt in einer Wandgruppe (oder in root), die die Schleife oben nur abhaengt: Linien und Material hier
       freigeben (Code-Pruefung 2026-10-01, sonst blieben sie bei jedem Neuaufbau mit Auswahl liegen). */
    if (markierung) markierung.traverse(function (o) { if (o.geometry) o.geometry.dispose(); if (o.material) o.material.dispose(); });
    kistenJetzt = null;
    schrankGruppen = {}; markierung = null; sonnenBlende = null;
    kontaktAufraeumen();
    deckenSpots.forEach(function (dsp) { dsp.intensity = 0; });
    aussenGruppe = null; fensterEcht = false;

    var mat = function (col, rau) {
      return new T.MeshStandardMaterial({ color: col, roughness: rau == null ? 0.62 : rau, metalness: 0.02,
        envMapIntensity: 0.35 });
    };
    var front = K.frontFarbe(z), korpus = K.ton(K.korpusFarbe(z), -14);
    var frontDunkel = new T.Color(front).getHSL({}).l < 0.5;
    /* Dekore: Front aus dem Frontnamen, Korpus aus dem zweiten Teil („Beige / Dunkle Eiche") —
       bei Velora ist der Korpus immer Artisan Eiche (Serienoptik im Kern). */
    var frontDekor = K.istHolz(z) ? String(z.farbe || '').split('/')[0] : null;
    var korpusDekor = z.serie === 'Velora' ? 'Artisan Eiche'
      : (String(z.farbe || '').split('/')[1] || String(z.farbe || '').split('/')[0]);
    if (!DEKOR_MASS[dekorName(korpusDekor)]) korpusDekor = null;
    var saatZ = 0;
    /* Die Fronten: Hochglanz spiegelt die Umgebung (Glanzia, Lunara Hochglanz), Holz traegt eine
       Maserung aus derselben Frontfarbe, alles andere ist mattes Lack. Gemessen an den Fotos der
       Komplettkuechen im Shop — vorher war jede Front eine gleichmaessig eingefaerbte Kastenseite. */
    glanzRaum = K.istGlanz(z);
    var glanz = K.istGlanz(z), holzBild = K.istHolz(z) ? maserung(front, K.istAst(z)) : null;
    var frontMat = function (b, h) {
      /* Hochglanz ist ein Lack UEBER der Farbe: eine Klarlackschicht spiegelt, die Farbe darunter
         bleibt satt. Ein einzelnes glattes Material machte Weiss grau, weil es nur noch spiegelte. */
      var glanzia = z.serie === 'Glanzia';
      var m = glanz && T.MeshPhysicalMaterial
        ? new T.MeshPhysicalMaterial({ color: front, roughness: 0.16, metalness: 0, clearcoat: 1,
            clearcoatRoughness: 0.02,
            envMapIntensity: glanzia ? (frontDunkel ? GLANZIA_ENV[1] : GLANZIA_ENV[0]) : (frontDunkel ? ENV_GLANZ_DUNKEL : ENV_GLANZ),
            ior: frontDunkel ? GLANZ_IOR_DUNKEL : 1.5 })
        : new T.MeshStandardMaterial({ color: holzBild ? '#ffffff' : front,
            roughness: holzBild ? 0.6 : 0.72, metalness: 0, envMapIntensity: 0.35 });
      if (glanz && frontDunkel && glanzEnv) m.envMap = glanzEnv;
      /* HELLER HOCHGLANZ SPIEGELT DEN RAUM WIE GRAU (Betreiber 2026-09-29: „الغلانسيا الابيض اللامع لايبدو لامع انظر الى ku-s12",
         „مثل هذه", dann „درجة اللمعان مثل اخوه ku-s11"). Ohne eigene envMap spiegelt die Front die Umgebung der Szene — im
         geschlossenen Raum denselben Raum wie Grau Hochglanz (raumSpiegel), sonst den hellen Studioraum (die dunkle glanzEnv
         der grauen Front machte Weiss grau): Fenster, Boden und Gegenzeile stehen als Spiegelbild in der Front. Auf Weiss
         verschwindet ein Spiegelbild von 0,35 im Weiss, und envMapIntensity hebt Spiegelbild und Umgebungslicht gemeinsam.
         Deshalb (Betreiber 2026-09-30: Weiss Hochglanz sah aus wie Weiss Matt) reiner Lack ohne Metall und ohne Eigenhelle:
         Umgebungslicht 0,35 wie Matt, nur das Spiegelbild x GLANZ_HELL.spiegel (HM_SPIEGEL_STAERKE im Shader). */
      if (glanz && !frontDunkel && m.isMeshPhysicalMaterial) {
        m.roughness = GLANZ_HELL.rauh; m.clearcoatRoughness = GLANZ_HELL.lackRauh; m.envMapIntensity = GLANZ_HELL.env;
        m.defines = Object.assign({}, m.defines, { HM_SPIEGEL_NEUTRAL: '', HM_SPIEGEL_STAERKE: GLANZ_HELL.spiegel.toFixed(2) });
        m.userData.hellGlanz = true;
      }
      /* GLANZIA WIE DIE PRODUKTFOTOS (Betreiber 2026-09-28: „هذا لون وشكل الخزائن في غلانسيا", Fotos des D60R): Weiss ist
         weiss (Foto 225), Grau ein helles Mittelgrau (Foto 157). Live lagen die Fronten bei 163–188 bzw. 72–89 — der
         Klarlack spiegelt, die senkrechte Front bekommt wenig Licht. Eine Anhebung nur fuer die Live-Ansicht (wie beim
         Sockel); das Foto rechnet sein Licht selbst (fotoMat nimmt sie heraus). */
      var hebung = glanzia && glanz ? (frontDunkel ? GLANZIA_HEBUNG[1] : GLANZIA_HEBUNG[0]) : 0;
      if (hebung > 0 && m.emissive) {
        m.emissive.set(front); m.emissiveIntensity = hebung;
        m.userData.liveAufhellung = true;
      }
      var echt = frontDekor ? dekorAuf(frontDekor, b, h, null, ++saatZ) : null;
      if (echt) {
        m.map = echt; m.color.set('#ffffff'); m.roughness = 0.58;
      } else if (holzBild) {
        var tx = holzBild.clone();
        tx.needsUpdate = true;
        tx.repeat.set(b / 60, h / 140);
        m.map = tx;
      }
      return m;
    };
    /* Korpusflaechen in der Reihenfolge der BoxGeometry (+x, -x, +y, -y, +z, -z): Seiten mit
       senkrechter Faser, Boden und Deckel mit Faser in der Breite. Ohne Dekor die Korpusfarbe. */
    var korpusFlaechen = function (b, h, tt) {
      var masse = [[tt, h, 'y'], [tt, h, 'y'], [b, tt, 'x'], [b, tt, 'x'], [b, h, 'y'], [b, h, 'y']];
      return masse.map(function (q) {
        var tx = korpusDekor ? dekorAuf(korpusDekor, q[0], q[1], q[2], ++saatZ) : null;
        if (!tx) return mat(korpus);
        var m = mat('#ffffff', 0.6); m.map = tx;
        return m;
      });
    };
    /* Die Arbeitsplatte in heller Steinoptik mit feiner Koernung — bis eine Platte aus dem Shop
       gewaehlt ist (Schritt S3 des Plans), dann deren Bild. */
    var rz = rezeptJetzt = rezeptFuer(z, lookFuer(z));
    var platteMat = (function () {
      var pm2 = new T.MeshStandardMaterial({ color: '#ffffff', roughness: 0.42, metalness: 0, envMapIntensity: 0.55 });
      pm2.map = stein();
      /* Ohne gewaehlte Platte zeigt der Look „Stadt" dunklen Marmor wie KU-S11 — nur Bild, bepreist wird die Platte nur,
         wenn der Kunde eine waehlt. */
      if (lookFuer(z).platte === 'marmorDunkel') {
        pm2.map = plattenBild({ id: 'look-marmor-dunkel', muster: 'marmor', farbe: '#3D3C43', ader: '#CDC8CE', stark: true });
        pm2.roughness = 0.2; pm2.envMapIntensity = 0.9; pm2.userData.muster = true;
      }
      /* Gewaehlte Platte aus dem Shop: ihre Farbe (Mittel der Plattenoberseite im Produktbild,
         Katalog `farbe`) ueber der feinen Koernung. Das Produktbild selbst ist ein Eckfoto und
         taugt nicht als Flaechentextur. */
      var gewP = K.platteVon && K.platteVon(z, daten);
      if (gewP && gewP.farbe) {
        /* Mit gewaehlter Platte ihr Muster statt Farbe-ueber-Koernung (plattenBild). Marmor ist
           poliert und spiegelt, Holz und Stein sind matt. */
        pm2.map = plattenBild(gewP);
        pm2.roughness = gewP.muster === 'marmor' ? 0.2 : (gewP.muster === 'stein' ? 0.55 : 0.5);
        pm2.envMapIntensity = gewP.muster === 'marmor' ? 0.9 : 0.5;
        pm2.userData.muster = true;
        /* ECHTER STEIN, ECHTES HOLZ (Bibliothek, 2026-09-29): die naechste gescannte Oberflaeche derselben Art, getoent auf die
           Katalogfarbe — die Maserung und die Adern eines echten Materials, die Farbe des Produkts. */
        var gArten = FAMILIE_ARTEN[plattenFamilie(gewP)];
        var gId = bibNaechste(gewP.farbe, gArten);
        if (gId) bibSetzen(pm2, gId, 1, 1, 0, 0, bibTonung(gId, gewP.farbe));
      } else if (rz.platte && BIBLIOTHEK[rz.platte] && bibSetzen(pm2, rz.platte, 1, 1)) {
        /* Ohne gewaehlte Platte: die Platte des Raumrezepts (nur Bild — bepreist wird allein eine gewaehlte Platte). */
        pm2.userData.muster = true;
      }
      if (pm2.userData.bib) {
        var pArt = BIBLIOTHEK[pm2.userData.bib][0];
        pm2.userData.muster = true; pm2.envMapIntensity = pArt === 'holzdekor' ? 0.3 : 0.4;
      }
      return pm2;
    })();
    /* Je Stueck ein eigener Ausschnitt aus dem Plattenbild: Laenge massstaeblich, Lage aus der
       Position — zwei Stuecke einer Kueche zeigen nicht dieselben Adern. Dasselbe Bild auf der
       Grafikkarte, nur Wiederholung und Versatz sind je Stueck. */
    var platteFuer = function (s) {
      if (!platteMat.userData.muster) return platteMat;
      if (platteMat.userData.bib) {
        /* Bibliothek: massstaeblich (Kachelmass), je Stueck ein anderer Ausschnitt; Relief und Rauheit laufen mit. */
        var mb = platteMat.clone(), cmB = platteMat.userData.bibCm, lenB = s.bis - s.von;
        var hb = Math.sin((s.von + 1) * 12.9898 + String(s.wand).charCodeAt(0) * 78.233) * 43758.5453; hb -= Math.floor(hb);
        ['map', 'normalMap', 'roughnessMap'].forEach(function (k) {
          var tb = platteMat[k].clone(); tb.repeat.set(lenB / cmB, K.platteTiefe() / cmB); tb.offset.set(hb, (hb * 7.31) % 1); mb[k] = tb;
        });
        return mb;
      }
      var m2 = platteMat.clone(), tx = platteMat.map.clone(), len = s.bis - s.von;
      tx.needsUpdate = true;
      tx.repeat.set(Math.min(1, len / PLATTE_BILD_CM[0]), K.platteTiefe() / PLATTE_BILD_CM[1]);
      var frei = Math.max(0, 1 - tx.repeat.x);
      var h = Math.sin((s.von + 1) * 12.9898 + String(s.wand).charCodeAt(0) * 78.233) * 43758.5453;
      tx.offset.set(frei * (h - Math.floor(h)), 0);
      m2.map = tx;
      return m2;
    };
    var schwarz = new T.MeshStandardMaterial({ color: K.GRIFF_SCHWARZ, roughness: 0.38, metalness: 0.55 });
    var messing = new T.MeshStandardMaterial({ color: K.GRIFF_MESSING, roughness: 0.28, metalness: 0.9 });
    var fugeMat = mat(K.ton(korpus, -38), 0.9);
    /* Griffleiste (Glanzia) in der Farbe der Front (Betreiber 2026-09-30: „في خزائن الغلانسيا المقابض يجب ان تكون بلون الخزائن"):
       seidenmatter Lack statt Hochglanz — sie hebt sich nur durch Glanz und Licht von der Front ab, nicht durch eine eigene Farbe.
       Die Schattenfuge ist die Frontfarbe −38 (auf Grau dunkler, auf Weiss ein heller Grauton), damit die Griffkante lesbar bleibt.
       Bis hierher gebuerstetes Aluminium (#D5D7DA, 2026-09-28) mit grauer Fuge #74777B. */
    var leisteFront = mat(front, 0.3);
    var leisteFuge = mat(K.ton(front, -38), 0.5);

    /* Boden und Wände in den Flächenfarben des Shops. */
    /* Boden: helle Eichendielen statt einer beigen Flaeche — der Beige-auf-Beige-Raum war das,
       was der Betreiber als „seltsame Farbe" beschrieb. */
    var look = lookJetzt = lookFuer(z);
    /* Phase 1 (ARCHITEKTUR): the closed room, its daylight window and the room-system floor (bodenP1) instead of the recipe floor. */
    var hP1 = ARCHITEKTUR.an ? raumHuelle(raum, t) : null;
    var fP1 = hP1 && ARCHITEKTUR.fenster ? lichtFensterWaehlen(hP1, RH, { seite: rz.seite }) : null;
    var fugeP1 = hP1 ? ARCHITEKTUR.fuge : 0, RHw = RH + fugeP1;
    var oeffP1 = hP1 ? oeffnungenP1(raum, hP1, z, RH, fP1) : null;
    oeffnungenJetzt = oeffP1;
    var bodenMat = new T.MeshStandardMaterial({ color: '#ffffff', roughness: 0.78, metalness: 0, envMapIntensity: 0.3 });
    /* Boden aus dem Raumrezept: ein gescannter Boden der Bibliothek — oder eine der gezeichneten Arten (dielen, fliesen,
       stein, muster). Solange die Bilder laden, steht die gezeichnete Art des Looks. */
    var bodenBib = !hP1 && BIBLIOTHEK[rz.boden] ? rz.boden : null;
    if (!hP1 && !bodenBib && rz.boden) look = lookJetzt = Object.create(look, { boden: { value: rz.boden } });
    if (!hP1) bodenMat.map = bodenTextur(look, A + 400, raumTiefe + 400);
    /* HOCHGLANZ-RAUM (Betreiber 2026-09-27, Vorlage: Foto einer weissen Hochglanzkueche mit Insel).
       Zu glaenzenden Fronten gehoert ein anderer Raum als zu Holz: grosse helle Fliesen mit
       leichtem Glanz statt Dielen, warm-beige Waende, Licht im Sockel, Glasleuchten. Welcher Raum,
       entscheidet allein die Front (K.istGlanz) — keine zweite Serienliste. Seit 2026-09-30 haengt der Raum nicht mehr an der Front (lookFuer, RAUM_GLANZ). */
    /* Seit den Looks (2026-09-29) entscheidet der Look, nicht mehr allein der Glanz: Fliesen mit leichtem Glanz, Stein
       seidenmatt, Zementfliesen matt, Dielen geoelt. */
    if (hP1) bodenMat = bodenP1(ARCHITEKTUR.boden, hP1);
    else if (look.boden === 'fliesen') { bodenMat.roughness = 0.22; bodenMat.envMapIntensity = 0.75; }
    else if (look.boden === 'stein') { bodenMat.roughness = 0.36; bodenMat.envMapIntensity = 0.6; }
    else if (look.boden === 'muster') { bodenMat.roughness = 0.5; bodenMat.envMapIntensity = 0.45; }
    if (bodenBib && bibSetzen(bodenMat, bodenBib, A + 400, raumTiefe + 400)) {
      bodenMat.envMapIntensity = BIBLIOTHEK[bodenBib][0] === 'holz' ? 0.5 : 0.8;
      bodenMat.normalScale = new T.Vector2(0.8, 0.8);
    }
    /* Phase 1: the floor ends under every wall with a window (otherwise it would be seen continuing outside), and runs 2 m beyond
       the room on every other side as before. */
    var bodenRand = function (seite) { return oeffP1 && oeffP1[seite].length ? 1 : 200; };
    var boden = hP1
      ? new T.Mesh(new T.PlaneGeometry(hP1.maxX - hP1.minX + bodenRand('minX') + bodenRand('maxX'),
          hP1.maxY - hP1.minY + bodenRand('minY') + bodenRand('maxY')), bodenMat)
      : new T.Mesh(new T.PlaneGeometry(A + 400, raumTiefe + 400), bodenMat);
    boden.receiveShadow = true;
    boden.rotation.x = -Math.PI / 2;
    if (hP1) boden.position.set((hP1.minX - bodenRand('minX') + hP1.maxX + bodenRand('maxX')) / 2, 0,
      (hP1.minY - bodenRand('minY') + hP1.maxY + bodenRand('maxY')) / 2);
    else boden.position.set(A / 2, 0, raumTiefe / 2);
    root.add(boden);
    /* WEITER BODEN (Frontansicht mit langer Brennweite, 2026-09-29): die Kamera steht dort 10–25 m vor der Wand, weit
       ausserhalb des Raums — unten im Bild lag hinter dem Bodenrand ein grauer Streifen. Ein grosser Boden 3 mm unter
       dem Raumboden, dasselbe Material, die Dielen/Fliesen genau auf Stoss mit denen im Raum. Sichtbar nur in der
       Frontansicht (malen); im Raum deckt ihn der Raumboden. */
    weitGruppe = new T.Group();
    weitGruppe.visible = false;
    root.add(weitGruppe);
    (function () {
      var W = 8000, Wr = A + 400, Hr = raumTiefe + 400;
      var tx = hP1 ? null : bodenTextur(look, W, W);
      var wm = hP1 ? bodenP1(ARCHITEKTUR.boden, hP1) : bodenMat.clone();
      if (tx) {
        var kachel = W / (tx.repeat.x || 1);
        tx.offset.set(((Wr - W) / (2 * kachel)) % 1, ((Hr - W) / (2 * kachel)) % 1);
        wm.map = tx;
      }
      if (bodenMat.userData.bib) {
        var cmW = bodenMat.userData.bibCm;
        bibSetzen(wm, bodenMat.userData.bib, W, W, ((Wr - W) / (2 * cmW)) % 1, ((Hr - W) / (2 * cmW)) % 1);
      }
      var wr = oeffP1 ? weitRechteck(hP1, oeffP1, A / 2, raumTiefe / 2, W) : { b: W, t: W, x: A / 2, z: raumTiefe / 2 };
      var wb = new T.Mesh(new T.PlaneGeometry(wr.b, wr.t), wm);
      wb.rotation.x = -Math.PI / 2;
      wb.position.set(wr.x, -0.3, wr.z);
      wb.userData.ohneSchatten = true; wb.userData.durchlaessig = true;
      weitGruppe.add(wb);
    })();

    /* Jede vorhandene Wand bekommt ihre Flaeche — auch eine, die nicht bestueckt wird.
       Der Durchgang einer Parallelkueche ist eine echte Wand; er traegt keine Schraenke,
       aber Fenster und Heizkoerper, und ohne ihn steht der Raum offen da, wo er es nicht
       ist. Lage und Drehung kommen aus wandTransform3D, nicht aus dem Buchstaben:
       PlaneGeometry blickt nach lokal +z, und das ist nach der Drehung genau die
       Innennormale — die Wandflaeche schaut also immer in den Raum. */
    var mitBlende = !!raumHuelle(raum, t);
    raum.waende.forEach(function (w, i) {
      var tr = K.wandTransform3D(w);
      /* Die erste Wand der Kette ist etwas breiter als ihre Strecke: so laeuft sie hinter
         den Ecken durch und der Raum wirkt geschlossen. Altbestand aus der ersten Fassung,
         hier bewusst erhalten, damit L, U und die gerade Kueche unveraendert bleiben. */
      var breite = tr.laenge + (i === 0 ? 40 : 0);
      var mitte = K.weltPunkt3D(w, tr.laenge / 2, -1, RHw / 2);
      var wandMat = mat(hP1 ? ARCHITEKTUR.wand : (i === 0 ? rz.wand[0] : rz.wand[1]), 0.95);
      wandMat.map = wandBild(breite);
      putzRelief(wandMat, breite, RHw);
      /* Phase 1: the customer's windows open this wall (their measured position, width and sill height; plane centred on the wall). */
      var loecherW = hP1 ? K.aktiveMerkmale(z).filter(function (m) { return m.wand === w.id && m.typ === 'fenster' && m.breite > 0; }).map(function (m) {
        var fo = K.fensterOeffnung(m, RH); return { x0: m.x - tr.laenge / 2, x1: m.x + m.breite - tr.laenge / 2, y0: fo.unten, y1: fo.oben };
      }) : [];
      var fl = loecherW.length ? new T.Mesh(wandFlaecheMitLoechern(breite, RHw, loecherW), wandMat) : new T.Mesh(new T.PlaneGeometry(breite, RHw), wandMat);
      if (loecherW.length) mitte.y = 0;
      fl.rotation.y = tr.gierung;
      fl.position.set(mitte.x, mitte.y, mitte.z);
      /* Keine Schatten aus den Waenden (Lichtregie 2026-09-29): das Hauptlicht ist Himmelslicht, und in der zweizeiligen
         Kueche legte die gegenueberliegende Wand seinen Schatten als grosse schraege Kante quer ueber Stirnwand und Gang.
         Die Sonne haelt die Sonnenblende auf, die an jeder Seite des Raums steht. */
      if (mitBlende) fl.userData.ohneSchatten = true;
      root.add(fl);
    });

    /* DER RAUM IST ZU (Vorschlag Realismus 2026-09-28). Bisher standen nur die Waende mit Schraenken im Bild, frei vor
       einem einfarbigen Grund, ohne Decke — das Modell auf dem Tisch, nicht der Raum. Jetzt schliessen die uebrigen Seiten
       und eine Decke mit Einbauleuchten den Raum. Alle nach INNEN gewandt: von aussen (Perspektive von oben, Draufsicht)
       sieht man durch sie hindurch wie bisher, von innen (Front- und Raumansicht) stehen sie da. Sie werfen keinen
       Schatten (sonst laege die Kueche unter der Decke im Dunkeln), treffen keinen Tipp (Rueckseiten zaehlen nicht) und
       gehoeren noch nicht ins Foto (dessen Licht faellt von oben durch den offenen Raum). */
    huelleJetzt = raumHuelle(raum, t);
    lichtFenster = lichtFensterWaehlen(huelleJetzt, RH, { seite: rz.seite });
    if (huelleJetzt) (function (h) {
      /* `raum`: gehoert zum geschlossenen Raum — das Foto nimmt ihn mit, wenn die Kamera drinnen steht (fotoSzene). */
      var nurAnsicht = function (o) { o.userData.ohneSchatten = true; o.userData.nurLive = true; o.userData.raum = true; return o; };
      var wandFarbe = hP1 ? ARCHITEKTUR.wand : rz.wand[1];
      /* Die Seitenwaende stehen oft quer zur Sonne und bekaemen nur das Grundlicht (Zeile: dunkles Taupe) — in einem
         echten Raum hellt das Licht von Boden und Gegenwand sie auf. Ein schwaches Eigenleuchten gleicht das aus. */
      var dekoWandMat = mat(wandFarbe, 0.95);
      /* Seit 2026-10-01 hellt der Ausgleich (AUSGLEICH_ANTEIL) quer stehende Waende auf — mit 0,28 Eigenleuchten dazu waeren
         sie heller als die Hauptwand (Code-Pruefung). */
      dekoWandMat.emissive = new T.Color(wandFarbe); dekoWandMat.emissiveIntensity = 0;
      dekoWandMat.userData.liveAufhellung = true;   /* im Foto rechnet echtes Licht, kein Eigenleuchten */
      h.luecken.forEach(function (l) {
        var len = l.b - l.a;
        var stueckMat = dekoWandMat.clone();
        stueckMat.userData = { liveAufhellung: true };
        stueckMat.map = wandBild(len + 2);
        putzRelief(stueckMat, len + 2, RHw);
        var m0 = (l.a + l.b) / 2;
        /* Phase 1: where the daylight window sits, the wall is built around its opening (wandMitLoch) — in the plane's own
           frame, whose x runs with +x (minY), -x (maxY), -z (minX) or +z (maxX). */
        var loch = fP1 && fP1.seite === l.seite && fP1.a >= l.a - 1 && fP1.b <= l.b + 1 ? fP1 : null, fl2;
        if (loch) {
          var sg = { minY: 1, maxY: -1, minX: -1, maxX: 1 }[l.seite], lx0 = sg * (loch.a - m0), lx1 = sg * (loch.b - m0);
          fl2 = new T.Mesh(wandFlaecheMitLoechern(len + 2, RHw, [{ x0: Math.min(lx0, lx1), x1: Math.max(lx0, lx1), y0: loch.unten, y1: loch.oben }]), stueckMat);
        } else fl2 = new T.Mesh(new T.PlaneGeometry(len + 2, RHw), stueckMat);
        nurAnsicht(fl2);
        var yW = loch ? 0 : RHw / 2;
        if (l.seite === 'minY') { fl2.position.set(m0, yW, h.minY - 1); }
        else if (l.seite === 'maxY') { fl2.position.set(m0, yW, h.maxY + 1); fl2.rotation.y = Math.PI; }
        else if (l.seite === 'minX') { fl2.position.set(h.minX - 1, yW, m0); fl2.rotation.y = Math.PI / 2; }
        else { fl2.position.set(h.maxX + 1, yW, m0); fl2.rotation.y = -Math.PI / 2; }
        root.add(fl2);
      });
      /* Lichtregie: das Fenster, durch das der Tag hereinkommt (sichtbar nur in einer Seitenwand), und die Blende, die die
         Sonne nur dort durchlaesst. */
      /* Phase 1: the daylight window as a real opening with a view in depth — also the one in the open front of a U kitchen
         (behind the customer's camera), whose light the room already had. */
      fensterEcht = !!fP1;
      fensterGruppe = fP1 ? fensterEchtBauen(lichtFenster, h, wandFarbe)
        : (lichtFenster && lichtFenster.sichtbar ? raumFensterBauen(lichtFenster, h, look.licht, wandFarbe) : null);
      if (fensterGruppe) root.add(fensterGruppe);
      /* The view out: one per side of the room that has an opening (daylight window and/or customer windows), centred on them. */
      /* which photograph: the rule (form + measured room); a preset name in ARCHITEKTUR.aussicht forces it (probes only) */
      aussichtJetzt = !oeffP1 || !ARCHITEKTUR.aussicht ? null
        : (typeof ARCHITEKTUR.aussicht === 'string' && AUSSICHT_P1[ARCHITEKTUR.aussicht] ? ARCHITEKTUR.aussicht : aussichtRegel(z, hP1));
      if (oeffP1 && ARCHITEKTUR.aussicht) ['minX', 'maxX', 'minY', 'maxY'].forEach(function (seite) {
        var ol = oeffP1[seite];
        if (!ol.length) return;
        if (!aussenGruppe) { aussenGruppe = new T.Group(); root.add(aussenGruppe); }
        var fS = { seite: seite, a: Math.min.apply(null, ol.map(function (o) { return o.a; })), b: Math.max.apply(null, ol.map(function (o) { return o.b; })),
          unten: 90, oben: 200 };
        aussenGruppe.add(aussenFotoBauen(fS, h, aussichtJetzt));
      });
      if (!aussenGruppe) fotoBehalten(null);
      sonnenBlende = blendeBauen(h, RH, lichtFenster, oeffP1);
      root.add(sonnenBlende);
      var HB = h.maxX - h.minX, HT = h.maxY - h.minY, cx0 = (h.minX + h.maxX) / 2, cz0 = (h.minY + h.maxY) / 2;
      /* Eine Decke bekommt ihr Licht von unten zurueck (Boden, Waende) — das kennt diese Ansicht nicht, ohne Ausgleich stand
         sie braungrau da. Ein schwaches Eigenleuchten gibt ihr das helle, leicht schattige Weiss eines Fotos. */
      var deckeMat = mat('#F4F2EE', 0.95);
      deckeMat.emissive = new T.Color('#E6E2DB'); deckeMat.emissiveIntensity = 0.3;
      deckeMat.userData.liveAufhellung = true;
      deckeMat.map = deckenBild();
      /* LICHTVOUTE (Stufe 3, Vorlagen 3 und 4 des Betreibers): ringsum ein indirektes Licht unter der Decke. Die Decke
         leuchtet an ihren Raendern warm auf und wird zur Mitte hin ruhig — auf jedem der Vorlagenfotos das, was den Raum
         „teuer" macht. Und Hochglanz spiegelt genau diesen hellen Rand als Lichtband (Vorlage 4). Das Leuchten ist ein
         Bild auf der Decke (vouteBild), kein zusaetzliches Licht: leicht auf jedem Geraet. */
      deckeMat.emissive = new T.Color('#ffffff'); deckeMat.emissiveIntensity = look.licht.voute || VOUTE_STAERKE;
      /* Grundhelle der Decke je Look (`decke`, vorher fest 0,3): unter der neutralen Tonkurve stand sie als grosse graue Flaeche
         oben im Bild (gemessen 175–198). */
      deckeMat.emissiveMap = vouteBild(HB + 4, HT + 4, Math.min(1, (look.licht.decke || 0.42) / deckeMat.emissiveIntensity));
      var deckeB = HB + 4, deckeT = HT + 4;
      if (fugeP1 > 0) {
        /* Phase 1: shadow gap around the ceiling (deckenFuge); the board is 2 x fuge smaller, its images cropped to stay put. */
        deckeB = HB - 2 * fugeP1; deckeT = HT - 2 * fugeP1;
        deckeMat.map = deckeAusschnitt(deckeMat.map, HB + 4, HT + 4, deckeB, deckeT);
        deckeMat.emissiveMap = deckeAusschnitt(deckeMat.emissiveMap, HB + 4, HT + 4, deckeB, deckeT);
        root.add(nurAnsicht(deckenFuge(h, RH, fugeP1)));
      }
      var decke = nurAnsicht(new T.Mesh(new T.PlaneGeometry(deckeB, deckeT), deckeMat));
      decke.rotation.x = Math.PI / 2;
      decke.position.set(cx0, RH, cz0);
      root.add(decke);
      /* Die Decke ueber den Raum hinaus (Frontansicht, siehe weitGruppe): ruhiges Weiss ohne Voute. */
      if (weitGruppe) {
        var weitDeckeMat = mat('#F4F2EE', 0.95);
        weitDeckeMat.emissive = new T.Color('#E6E2DB'); weitDeckeMat.emissiveIntensity = 0.3;
        var wdr = oeffP1 ? weitRechteck(h, oeffP1, cx0, cz0, 8000) : { b: 8000, t: 8000, x: cx0, z: cz0 };
        var wd = new T.Mesh(new T.PlaneGeometry(wdr.b, wdr.t), weitDeckeMat);
        wd.rotation.x = Math.PI / 2;
        wd.position.set(wdr.x, RH + fugeP1 + 0.3, wdr.z);
        wd.userData.ohneSchatten = true; wd.userData.durchlaessig = true;
        weitGruppe.add(wd);
      }
      /* Kein Voutenprofil an der Wand (2026-09-29): zwischen zwei Haengeschraenken ueber dem Fenster las sich die Leiste 14 cm
         unter der Decke als glaeserner Schrank (Betreiber: „الخزانة العلوية فوق حافة الشباك"). Das Leuchten liegt allein auf der
         Decke (vouteBild) — wie bei einer Voute in einer abgehaengten Decke. */
      /* DECKENLICHT JE RAUM (Betreiber 2026-09-29: „بالنسبة للسبوتات في السقف جميع اللقطات نفس السبوتات — اريد ان تكون اكثر
         ابداعا"). Aus dem Raumrezept eine von fuenf Loesungen, wie Lichtplaner sie fuer Kuechen zeichnen: Einbauspots (Ring
         weiss, schwarz oder Messing, Raster 110–150 cm), Aufbauzylinder, ein schlankes LED-Lichtprofil parallel zur Zeile,
         eine Stromschiene mit Strahlern, die Lichtinseln auf Platte und Rueckwand setzen, oder nur die Voute (indirekt).
         Die sechs Deckenlichter (feste Zahl, kein Shader-Neubau) wandern je Loesung an ihren Platz. */
      var deckeArt = rz.decke || 'spots', finish = rz.deckeFinish || 'weiss', lichtStaerke = look.licht.spot || SPOT_STAERKE;
      var finishMat = finish === 'schwarz' ? new T.MeshStandardMaterial({ color: '#1C1D1F', roughness: 0.45, metalness: 0.3 })
        : (finish === 'messing' ? new T.MeshStandardMaterial({ color: '#B8955C', roughness: 0.3, metalness: 0.85 }) : mat('#E4E4E2', 0.35));
      var spotMat = new T.MeshStandardMaterial({ color: '#ffffff', emissive: '#FFF1DA', emissiveIntensity: 7, roughness: 0.3 });
      var raster = rz.spotRaster || 130;
      var reihe = function (von, bis) {
        var n = Math.max(1, Math.round((bis - von - 140) / raster) + 1), out = [];
        for (var i = 0; i < n; i++) out.push(n === 1 ? (von + bis) / 2 : von + 70 + i * (bis - von - 140) / (n - 1));
        return out;
      };
      /* LICHTKEGEL (Realismus, 2026-09-28: „اريد زيادة الواقعية اكثر"): jede Einbauleuchte nahe einer Wand zeichnet auf ihr
         den Bogen, den man auf jedem Innenraumfoto sieht — oben scharf abgeschnitten, nach unten weich auslaufend. Eine
         durchscheinende, additive Flaeche 5 mm vor der Wand; Schraenke davor verdecken sie wie echtes Licht (Tiefentest).
         Kein zusaetzliches Licht im Rechner — so bleibt die Ansicht auf jedem Geraet leicht. */
      var kegelMat = new T.MeshBasicMaterial({ map: kegelBild(), color: '#FFE3C2', transparent: true, opacity: 0.42,
        blending: T.AdditiveBlending, depthWrite: false });
      var kegel = function (sx, sz, seite) {
        if (oeffP1) {
          var uK = seite === 'minY' || seite === 'maxY' ? sx : sz;
          if (oeffP1[seite].some(function (o) { return uK + 47.5 > o.a - 5 && uK - 47.5 < o.b + 5; })) return;
        }
        var b = 95, hk = Math.min(175, RH - 20), k = nurAnsicht(new T.Mesh(new T.PlaneGeometry(b, hk), kegelMat));
        k.userData.durchlaessig = true;
        var y = RH - 1 - hk / 2;
        if (seite === 'minY') k.position.set(sx, y, h.minY + 0.5);
        else if (seite === 'maxY') { k.position.set(sx, y, h.maxY - 0.5); k.rotation.y = Math.PI; }
        else if (seite === 'minX') { k.position.set(h.minX + 0.5, y, sz); k.rotation.y = Math.PI / 2; }
        else { k.position.set(h.maxX - 0.5, y, sz); k.rotation.y = -Math.PI / 2; }
        root.add(k);
      };
      var reihenAbstand = function (px, pz) {
        return (raum.waende || []).concat(raum.bloecke || []).reduce(function (m, w) {
          var ax = w.p0.x, az = w.p0.y, bx = w.p1.x - ax, bz = w.p1.y - az, L2 = bx * bx + bz * bz || 1;
          var u = Math.max(0, Math.min(1, ((px - ax) * bx + (pz - az) * bz) / L2));
          return Math.min(m, Math.hypot(px - ax - u * bx, pz - az - u * bz));
        }, Infinity);
      };
      /* Ein Deckenlicht an seinen Platz: Lage, Ziel, Oeffnungswinkel (Grad), Staerke. */
      var licht = function (i, px, py, pz, zx, zy, zz2, winkel, staerke) {
        var dsp = deckenSpots[i];
        if (!dsp) return;
        dsp.position.set(px, py, pz); dsp.target.position.set(zx, zy, zz2); dsp.target.updateMatrixWorld();
        dsp.angle = winkel * Math.PI / 180; dsp.penumbra = winkel < 30 ? 0.55 : 1; dsp.intensity = staerke;
      };
      var wA = (raum.waende || [])[0], lA = wA ? Math.hypot(wA.p1.x - wA.p0.x, wA.p1.y - wA.p0.y) : 0;
      if ((deckeArt === 'linie' || deckeArt === 'schiene') && !(lA > 120)) deckeArt = 'spots';
      if (deckeArt === 'spots' || deckeArt === 'aufbau') {
        var spotStellen = [], aufbau = deckeArt === 'aufbau';
        reihe(h.minX, h.maxX).forEach(function (sx) {
          reihe(h.minY, h.maxY).forEach(function (sz) {
            spotStellen.push([sx, sz]);
            if (aufbau) {
              /* Aufbauzylinder: 13 cm lang, unten die leuchtende Scheibe. */
              var zyl = nurAnsicht(new T.Mesh(new T.CylinderGeometry(4.8, 4.8, 13, 32), finishMat));
              zyl.position.set(sx, RH - 6.5, sz); root.add(zyl);
              var sch = nurAnsicht(new T.Mesh(new T.CircleGeometry(3.6, 28), spotMat));
              sch.rotation.x = Math.PI / 2; sch.position.set(sx, RH - 13.05, sz); root.add(sch);
            } else {
              var spot = nurAnsicht(new T.Mesh(new T.CircleGeometry(4.2, 28), spotMat));
              spot.rotation.x = Math.PI / 2; spot.position.set(sx, RH - 0.3, sz); root.add(spot);
              var ring = nurAnsicht(new T.Mesh(new T.RingGeometry(4.2, 5.6, 28), finishMat));
              ring.rotation.x = Math.PI / 2; ring.position.set(sx, RH - 0.2, sz); root.add(ring);
            }
            if (sz - h.minY <= 80) kegel(sx, sz, 'minY');
            if (h.maxY - sz <= 80) kegel(sx, sz, 'maxY');
            if (sx - h.minX <= 80) kegel(sx, sz, 'minX');
            if (h.maxX - sx <= 80) kegel(sx, sz, 'maxX');
          });
        });
        /* DECKENLICHT ALS LICHT (Stufe 3): die sechs Leuchten, die ihren Reihen am naechsten sind, leuchten wirklich. */
        spotStellen.sort(function (p, q) { return reihenAbstand(p[0], p[1]) - reihenAbstand(q[0], q[1]); });
        spotStellen.slice(0, deckenSpots.length).forEach(function (st, i) {
          licht(i, st[0], aufbau ? RH - 13.5 : RH - 2, st[1], st[0], 0, st[1], look.licht.spotWinkel || 38, lichtStaerke);
        });
      } else if (deckeArt === 'linie' || deckeArt === 'schiene') {
        var lang2 = Math.max(120, lA * (deckeArt === 'linie' ? 0.74 : 0.62)), dA = deckeArt === 'linie' ? 92 : 118;
        var mitteA = K.weltPunkt3D(wA, lA / 2, dA, RH), endA = K.weltPunkt3D(wA, lA / 2 + 10, dA, RH);
        var gier = Math.atan2(-(endA.z - mitteA.z), endA.x - mitteA.x);
        if (deckeArt === 'linie') {
          /* LED-Lichtprofil: schlank, buendig unter der Decke, darunter die leuchtende Linie. */
          var prof = nurAnsicht(new T.Mesh(new T.BoxGeometry(lang2, 2.2, 4.2), finishMat));
          prof.position.set(mitteA.x, RH - 1.1, mitteA.z); prof.rotation.y = gier; root.add(prof);
          var band = nurAnsicht(new T.Mesh(new T.BoxGeometry(lang2 - 2, 0.2, 2.6),
            new T.MeshStandardMaterial({ color: '#ffffff', emissive: '#FFF4E4', emissiveIntensity: 6, roughness: 0.4 })));
          band.position.set(mitteA.x, RH - 2.3, mitteA.z); band.rotation.y = gier; root.add(band);
          var nL = Math.min(deckenSpots.length, Math.max(2, Math.round(lang2 / 90)));
          for (var il = 0; il < nL; il++) {
            var sL = lA / 2 - lang2 / 2 + lang2 * (il + 0.5) / nL, pL = K.weltPunkt3D(wA, sL, dA, RH - 3), zL = K.weltPunkt3D(wA, sL, dA - 25, 0);
            licht(il, pL.x, pL.y, pL.z, zL.x, 0, zL.z, 62, lichtStaerke * 0.62);
          }
        } else {
          /* Stromschiene mit Strahlern: jeder Kopf zeigt auf die Rueckwand ueber der Platte — Lichtinseln wie im Showroom. */
          var schiene = nurAnsicht(new T.Mesh(new T.BoxGeometry(lang2, 2.4, 3.4), finishMat));
          schiene.position.set(mitteA.x, RH - 1.2, mitteA.z); schiene.rotation.y = gier; root.add(schiene);
          var nS = Math.min(deckenSpots.length, Math.max(3, Math.round(lang2 / 70)));
          var topW = gSerie.korpus_hoehe + gSerie.arbeitsplatte_dicke;
          for (var is = 0; is < nS; is++) {
            var sS = lA / 2 - lang2 / 2 + lang2 * (is + 0.5) / nS, pS = K.weltPunkt3D(wA, sS, dA, RH - 9), zS = K.weltPunkt3D(wA, sS, 6, topW + 22);
            var kopf = new T.Group(); kopf.position.set(pS.x, pS.y, pS.z);
            var gehaeuse = nurAnsicht(new T.Mesh(new T.CylinderGeometry(3.1, 3.1, 11, 28), finishMat));
            gehaeuse.rotation.x = Math.PI / 2; kopf.add(gehaeuse);
            var linse = nurAnsicht(new T.Mesh(new T.CircleGeometry(2.4, 24), spotMat)); linse.position.z = 5.55; kopf.add(linse);
            kopf.lookAt(zS.x, zS.y, zS.z);
            root.add(kopf);
            var stiel = nurAnsicht(new T.Mesh(new T.BoxGeometry(1.2, 7, 1.2), finishMat)); stiel.position.set(pS.x, RH - 5.2, pS.z); root.add(stiel);
            licht(is, pS.x, pS.y, pS.z, zS.x, zS.y, zS.z, 24, lichtStaerke * 1.15);
          }
        }
      } else {
        /* Nur die Voute: indirektes Licht aus der Decke, etwas kraeftiger; die Deckenlichter ruhen. */
        deckeMat.emissiveIntensity *= 1.25;
      }
      /* FENSTERLICHT IM SPIEGELBILD (Stufe 3): auf jeder offenen Raumseite (dort, wo keine Wand des Kunden steht — meist
         hinter der Kamera) ein helles Fenster, das NUR die Rundumaufnahme sieht (Ebene 1). Hochglanz, Geraeteglas und Boden
         spiegeln dann ein Fenster wie auf jedem Kuechenfoto; im Bild selbst steht es nicht, der Raum des Kunden bleibt
         unveraendert. */
      h.luecken.forEach(function (l) {
        var len = l.b - l.a, fb = Math.min(len - 60, 240), fhk = Math.min(150, RH - 105);
        if (fb < 60 || fhk < 60) return;
        /* Wo das echte Lichtfenster steht, spiegelt es sich selbst — keine zweite Fensterkarte daneben. */
        if (lichtFenster && (lichtFenster.sichtbar || fensterEcht) && l.seite === lichtFenster.seite && lichtFenster.a >= l.a - 1 && lichtFenster.b <= l.b + 1) return;
        var karte = new T.Mesh(new T.PlaneGeometry(fb, fhk),
          new T.MeshBasicMaterial({ map: fensterKarteBild(), color: aussenFarbe(12) }));
        karte.layers.set(1);
        karte.userData.ohneSchatten = true; karte.userData.nurLive = true; karte.userData.durchlaessig = true;
        var m0 = (l.a + l.b) / 2, yk = 95 + fhk / 2;
        if (l.seite === 'minY') karte.position.set(m0, yk, h.minY + 0.5);
        else if (l.seite === 'maxY') { karte.position.set(m0, yk, h.maxY - 0.5); karte.rotation.y = Math.PI; }
        else if (l.seite === 'minX') { karte.position.set(h.minX + 0.5, yk, m0); karte.rotation.y = Math.PI / 2; }
        else { karte.position.set(h.maxX - 0.5, yk, m0); karte.rotation.y = -Math.PI / 2; }
        root.add(karte);
      });
    })(huelleJetzt);

    /* TEPPICH (Looks, 2026-09-29): ein flach gewebter Teppich auf dem freien Boden vor der Kueche, nahe der Hauptzeile — wie
       auf den Serienbildern. Nicht bei einer Insel (dort steht sie), nicht in zu engen Raeumen. */
    if (huelleJetzt && look.teppich && rz.teppich && !(raum.bloecke || []).length) (function (h) {
      var bs = belegteSeiten(h);
      var x0 = h.minX + (bs.minX ? 65 : 12), x1 = h.maxX - (bs.maxX ? 65 : 12);
      var z0 = h.minY + (bs.minY ? 65 : 12), z1 = h.maxY - (bs.maxY ? 65 : 12);
      if (x1 - x0 < 150 || z1 - z0 < 130) return;
      var tb = Math.min(240, x1 - x0 - 70), tt = Math.min(170, z1 - z0 - 80);
      var tm = new T.MeshStandardMaterial({ color: '#ffffff', roughness: 1, metalness: 0, envMapIntensity: 0.2, map: teppichBild(look.teppich) });
      var tep = new T.Mesh(new T.PlaneGeometry(tb, tt), tm);
      tep.rotation.x = -Math.PI / 2;
      tep.position.set((x0 + x1) / 2, 0.4, z0 + 35 + tt / 2);
      tep.userData.ohneSchatten = true; tep.userData.durchlaessig = true;
      root.add(tep);
    })(huelleJetzt);

    /* `flucht` = Tiefe, auf der die Vorderkanten dieser REIHE liegen. Unten ist das die
       Korpusflucht (59,5 cm), oben die Tiefe des Schranks selbst — Hängeschränke hängen an
       der Wand und dürfen nicht auf die Unterschranktiefe vorgezogen werden. */
    /* `seite` legt fest, welche Flaeche die Front traegt: ohne Angabe die zum Raum (+z), beim
       zweiten Schenkel eines Eckschranks die INNENSEITE des L (+x oder -x). Reihenfolge der
       BoxGeometry-Flaechen: +x, -x, +y, -y, +z, -z. */
    /* `mitTueren`: die Vorderseite ist dann nur die Fuge hinter den Tuerblaettern, die `fronten()`
       davorsetzt. Ohne (Eckschenkel) traegt sie selbst die Frontfarbe wie bisher. */
    var kasten = function (b, h, tt, gruppe, x, y, flucht, seite, mitTueren, ohneDeckel) {
      var geo = new T.BoxGeometry(b, h, tt);
      var ms = korpusFlaechen(b, h, tt);
      /* Spuelen- und Herdumbauschrank sind oben offen (Produktfotos D60Z, D60ZK) — mit Deckel lag
         Holz im Spuelenausschnitt statt des Beckens. */
      if (ohneDeckel) ms[2] = new T.MeshBasicMaterial({ visible: false });
      /* Auf der Seitenflaeche (Eckschenkel) ist die Front tt breit, nicht b — sonst lag das Dekor dort 1,8-fach gestreckt
         (Code-Pruefung 2026-10-01, vorbestehend). */
      ms[seite === 'px' ? 0 : (seite === 'nx' ? 1 : 4)] = mitTueren ? fugeMat : frontMat(seite === 'px' || seite === 'nx' ? tt : b, h);
      var me = new T.Mesh(geo, ms);
      var zv = Math.max(tt, flucht || tt);
      me.position.set(x + b / 2, y + h / 2, zv - tt / 2);
      gruppe.add(me);
      /* Der KOERPER des Schranks fuer die Markierung (Betreiber 2026-09-27: „التحديد يجب ان يكون بحجم الخزانة تماما"):
         Korpus bis zur Tuerflaeche (Tuerblaetter 1,8 cm, ihre Flaeche 2 mm vor der Kante), ohne Fuesse, Becken, Armatur und Griffe.
         Bis 2026-10-01 stand hier +2 — der Umriss schwebte 2,4 cm vor den Tueren. */
      (gruppe.userData.koerper = gruppe.userData.koerper || []).push([x, y, zv - tt, x + b, y + h, zv + (mitTueren ? 0.2 : 0)]);
      /* Keine Kantenlinien mehr (2026-09-27): selbst als Hauch flimmerten sie an den Haengeschraenken
         als punktierte dunkle Linien, die kein Kuechenfoto hat. Die Schraenke trennen Fugen,
         Schatten und die Umgebungsverdeckung. */
    };

    /* Tuerblaetter, Auszuege und Griffe aus K.frontTeile — dieselbe Aufteilung wie in der
       Frontansicht. 1,8 cm stark, 3 mm Fuge ringsum, 2 mm vor der Korpuskante. */
    /* GERUNDETE FRONTKANTEN (R1, 2026-09-27). Ein Tuerblatt hat eine gerundete Kante, die das
       Licht als feine helle Linie faengt — genau die trennt auf den Shopfotos zwei Tueren. Scharfe
       Quader lasen sich als „Pappe" (Betreiber). Gezogene Rechteckform mit 3,5 mm Rundung, die
       Texturkoordinaten auf 0..1 ueber das Blatt gebracht wie beim Quader, damit die Holzmaserung
       gleich sitzt. Je Mass einmal gebaut. */
    var frontGeos = {};
    var frontGeo = function (bb, hh, D) {
      var sch = bb.toFixed(1) + '|' + hh.toFixed(1) + '|' + D;
      if (frontGeos[sch]) return frontGeos[sch];
      var r = Math.min(0.35, bb / 4, hh / 4, D / 3);
      var form = new T.Shape(), x0 = -bb / 2 + r, y0 = -hh / 2 + r;
      form.moveTo(x0, y0); form.lineTo(-x0, y0); form.lineTo(-x0, -y0); form.lineTo(x0, -y0); form.lineTo(x0, y0);
      var geo = new T.ExtrudeGeometry(form, { depth: D - 2 * r, bevelEnabled: true, bevelThickness: r,
        bevelSize: r, bevelSegments: 3, curveSegments: 1 });
      geo.translate(0, 0, -(D - 2 * r) / 2);
      var pos = geo.attributes.position, uv = geo.attributes.uv;
      for (var i = 0; i < pos.count; i++) uv.setXY(i, (pos.getX(i) + bb / 2) / bb, (pos.getY(i) + hh / 2) / hh);
      uv.needsUpdate = true;
      frontGeos[sch] = geo;
      return geo;
    };
    var fronten = function (gruppe, it, y, flucht) {
      var D = 1.8, S = 0.15, vorne = flucht + 0.2, rahmen = K.istRahmen(z);
      /* Die Fuge eines Hochschranks auf der Hoehe der Unterschraenke (ohne den Sockel, der hier schon abgezogen ist). */
      K.frontTeile(z, it.m, it.b, it.m.h, g.korpus_hoehe - (it.sockel || 0)).forEach(function (p) {
        if (p.art === 'nische' || p.art === 'ofen') return;
        var bb = Math.max(0.5, p.b - 2 * S), hh = Math.max(0.5, p.h - 2 * S);
        var cx = it.x + p.x + p.b / 2, cy = y + it.m.h - (p.y + p.h / 2);
        var blatt = new T.Mesh(frontGeo(bb, hh, D), frontMat(bb, hh));
        blatt.position.set(cx, cy, vorne - D / 2);
        gruppe.add(blatt);
        if (p.art === 'glas') {
          var sch = new T.Mesh(new T.BoxGeometry(Math.max(0.5, bb - 8), Math.max(0.5, hh - 8), 0.3),
            new T.MeshStandardMaterial({ color: '#CFE0E6', roughness: 0.05, metalness: 0.1, transparent: true, opacity: 0.6 }));
          sch.position.set(cx, cy, vorne + 0.1);
          gruppe.add(sch);
        } else if (rahmen) {
          /* Rahmenfront: vier Leisten, 5,5 cm breit, 5 mm vor dem Feld. */
          var r = Math.min(5.5, bb * 0.14, hh * 0.2);
          if (bb - 2 * r >= 4 && hh - 2 * r >= 4) {
            [[bb, r, 0, hh / 2 - r / 2], [bb, r, 0, -hh / 2 + r / 2],
             [r, hh - 2 * r, -bb / 2 + r / 2, 0], [r, hh - 2 * r, bb / 2 - r / 2, 0]].forEach(function (l) {
              /* Gerundet und 0,9 cm stark: als flacher Quader verschwand der Rahmen weiss auf weiss
                 (Livaro „Weiss Rahmen", Vergleich mit der Komplettkueche 2026-09-27). */
              var leiste = new T.Mesh(frontGeo(l[0], l[1], 0.9), frontMat(l[0], l[1]));
              leiste.position.set(cx + l[2], cy + l[3], vorne + 0.45);
              gruppe.add(leiste);
            });
          }
        }
        K.griffe(z, p).forEach(function (g) { griffZeichnen(gruppe, g, it.x + g.x, y + it.m.h - g.y, vorne, p); });
      });
    };
    /* Ein Griff `g` (K.griffe) an seiner Stelle: gx/gy Mitte in der Gruppe, vorne = Frontebene, p = sein Frontteil. Auch fuer
       die Tueren der Eckschraenke, die keine Frontteile haben (eckGriff). */
    var griffZeichnen = function (gruppe, g, gx, gy, vorne, p) {
      var gm;
      if (g.art === 'kante' && z.serie === 'Lunara') {
        /* U57 an der Tuerkante: K.griffe setzt die Mitte 0,7 cm innerhalb der Teilkante, das Tuerblatt endet 0,15 cm davor. */
        var u57unten = g.y > p.y + p.h / 2, kante = u57unten ? gy - 0.55 : gy + 0.55;
        gm = new T.Mesh(u57Geometrie(u57unten), schwarz);
        gm.position.set(gx, kante, vorne);
        /* Echte Laenge 11,5 cm; nur auf sehr schmalen Fronten kuerzer. */
        if (p.b - 2 < 11.5) gm.scale.x = Math.max(0.3, (p.b - 2) / 11.5);
      } else if (g.art === 'kante') {
        gm = new T.Mesh(new T.BoxGeometry(g.l, 1.2, 2.6), schwarz);
        gm.position.set(gx, gy, vorne + 0.5);
      } else if (g.art === 'stange') {
        gm = new T.Mesh(new T.BoxGeometry(g.l, 1.2, 1.2), schwarz);
        gm.position.set(gx, gy, vorne + 2.4);
        [-1, 1].forEach(function (sg) {
          var fuss = new T.Mesh(new T.BoxGeometry(1, 1, 2.4), schwarz);
          fuss.position.set(gx + sg * (g.l / 2 - 1.5), gy, vorne + 1.2);
          gruppe.add(fuss);
        });
      } else if (g.art === 'knopf') {
        /* Kleiner waagrechter Messinggriff auf zwei Fuesschen (Rahmenfront). */
        gm = new T.Mesh(new T.CylinderGeometry(0.55, 0.55, g.l, 16), messing);
        gm.rotation.z = Math.PI / 2;
        gm.position.set(gx, gy, vorne + 1.6);
        [-1, 1].forEach(function (sg) {
          var fs2 = new T.Mesh(new T.CylinderGeometry(0.45, 0.45, 1.6, 12), messing);
          fs2.rotation.x = Math.PI / 2;
          fs2.position.set(gx + sg * (g.l / 2 - 0.9), gy, vorne + 0.8);
          gruppe.add(fs2);
        });
      } else if (g.art === 'mulde') {
        /* GRIFFLEISTE (Betreiber 2026-09-28 mit den Fotos des D60R: „انظر الى القبضات ليست باللون الاسود"; seit 2026-09-30 in
           Frontfarbe, siehe leisteFront). An der Griffkante jeder Glanzia-Front sitzt ein Streifen; bis 28.09 ein 1,6 cm Streifen
           in Korpusfarbe −38, auf dem weissen Korpus fast unsichtbar („القبضات ليست واضحة"). Davor eine feine Schattenfuge,
           damit er sich von der Front abhebt. */
        var ml = Math.max(0.5, g.l - 0.3), aussen = g.y < p.y + p.h / 2 ? 1 : -1;
        /* Die Kante liegt 0,8 cm jenseits von gy; die Leiste laeuft 1,4 cm von ihr nach innen, die Fuge schliesst an. */
        gm = new T.Mesh(new T.BoxGeometry(ml, 1.4, 0.35), leisteFront);
        gm.position.set(gx, gy + aussen * 0.1, vorne + 0.12);
        var fuge2 = new T.Mesh(new T.BoxGeometry(ml, 0.4, 0.2), leisteFuge);
        fuge2.position.set(gx, gy - aussen * 0.8, vorne + 0.06);
        gruppe.add(fuge2);
      }
      if (gm) gruppe.add(gm);
    };
    /* GRIFFE AN DEN ECKSCHRAENKEN (Betreiber 2026-09-28: „لماذا لم تضع مقابض لخزائن الزاوية العلوية والسفلية"). Ihre Tueren
       waren nur gefaerbte Kastenseiten ohne Griff. Jetzt wie jede Front derselben Serie (K.griffe): am L des Eck-Unterschranks
       auf beiden Tueren die Griffleiste bzw. die Kante, Stange und Knopf nur auf der Tuer zum Raum (Produktfoto Velora D90N);
       an der schraegen Tuer des Eck-Haengeschranks unten — wo die Serie oben Griffe zeigt. `dreh`: Drehung der Tuerflaeche um
       die Hochachse (0 = sie schaut in den Raum dieser Wand); cx/cz: Mitte der Tuerflaeche in der Gruppe. */
    var eckGriff = function (gruppe, cx, cz, dreh, breite, hoehe, unten, haengt, zumRaum) {
      var p = { art: 'front', x: 0, y: 0, b: breite, h: hoehe, lage: haengt ? 'unten' : 'oben', haengt: haengt };
      var gs = K.griffe(z, p);
      if (!gs.length || (!zumRaum && /^(stange|knopf)$/.test(gs[0].art))) return;
      var tr = new T.Group();
      tr.position.set(cx, 0, cz);
      tr.rotation.y = dreh;
      gruppe.add(tr);
      gs.forEach(function (g) { griffZeichnen(tr, g, g.x - breite / 2, unten + hoehe - g.y, 0.2, p); });
    };

    /* Tiefe der Seitenwaende des Diagonal-Eckhaengeschranks: die Tiefe, die die geraden
       Haengeschraenke DIESER Serie am haeufigsten haben — gemessen 32 cm bei Velora, Glanzia und
       Livaro, 30 cm bei Lunara. Kein Katalogfeld traegt sie; der Eckschrank selbst steht mit
       60 x 60 als Quadrat im Katalog. */
    var obenTiefe = (function () {
      var n = {};
      ((daten && daten.modelle) || []).forEach(function (m) {
        if (m.reihe !== 'oben' || K.istEck(m)) return;
        var tt = K.nennTiefe(m);
        n[tt] = (n[tt] || 0) + 1;
      });
      var best = Object.keys(n).sort(function (a, b) { return n[b] - n[a] || a - b; })[0];
      return best ? +best : 32;
    })();
    var diagonalEck = function (gruppe, it, y) {
      var B = it.b, h = it.m.h, anf = it.eckseite !== 'ende';
      /* Haengt die Nachbarreihe von ihrer Wand weg (Wandversatz, oben negativ), ist dieser Schrank auf seiner Wand um
         `a` breiter (it.b) und steht um `a` von der Nachbarwand ab — seine Tiefe um die Ecke bleibt die Nenntiefe. */
      var Bz = K.nennTiefe(it.m) || B, a = Math.max(0, B - Bz);
      var X = anf ? it.x : it.x + it.b, s = anf ? 1 : -1;
      var d = Math.min(obenTiefe, Bz - 1);
      var form = new T.Shape();
      form.moveTo(X + s * a, 0);
      form.lineTo(X + s * B, 0);
      form.lineTo(X + s * B, d);
      form.lineTo(X + s * (a + d), Bz);
      form.lineTo(X + s * a, Bz);
      var geo = new T.ExtrudeGeometry(form, { depth: h, bevelEnabled: false });
      /* Die Form liegt in x/y und wird entlang z gezogen. Um +90 Grad um x gekippt wird aus y
         die Raumtiefe und aus der Zugrichtung die Hoehe — nach unten, daher `y + h`. */
      var me = new T.Mesh(geo, [mat(korpus), mat(korpus)]);
      me.rotation.x = Math.PI / 2;
      me.position.set(0, y + h, 0);
      gruppe.add(me);
      var kante = new T.LineSegments(new T.EdgesGeometry(geo),
        new T.LineBasicMaterial({ color: tok('--hm-ink', '#201D17'), transparent: true, opacity: 0.12 }));
      kante.rotation.copy(me.rotation);
      kante.position.copy(me.position);
      gruppe.add(kante);
      /* Die Tuer auf der Schraege, eine Spur vor der Flaeche, damit beide nicht flackern. */
      var tuer = new T.Mesh(new T.BoxGeometry((Bz - d) * Math.SQRT2, h, 0.4), frontMat((Bz - d) * Math.SQRT2, h));
      tuer.rotation.y = anf ? Math.PI / 4 : -Math.PI / 4;
      tuer.position.set(X + s * (B + a + d) / 2 + s * Math.SQRT1_2 * 0.3, y + h / 2,
        (Bz + d) / 2 + Math.SQRT1_2 * 0.3);
      gruppe.add(tuer);
      eckGriff(gruppe, tuer.position.x, tuer.position.z, tuer.rotation.y, (Bz - d) * Math.SQRT2, h, y, true, true);
    };
    /* LIVARO: DER ECK-HAENGESCHRANK IST EIN L (Betreiber 2026-09-29: „خزانة ال livaro الزاوية العلوية ليست صحيحة"; Produktfotos
       G60N2 geschlossen und offen): zwei Schenkel in der Tiefe der geraden Haengeschraenke, innen ein L-Fach mit L-Boeden, und
       ZWEI Tueren in der Innenecke — je eine auf der Front eines Schenkels, im rechten Winkel zueinander. Keine schraege Tuer.
       Masse wie beim Diagonalschrank (60 x 60, Wandversatz `a` genauso); welche Serie so gebaut ist, sagt die Serienoptik
       (`eckOben: 'L'`, Kern). */
    var lEckOben = function (gruppe, it, y) {
      var B = it.b, h = it.m.h, anf = it.eckseite !== 'ende';
      var Bz = K.nennTiefe(it.m) || B, a = Math.max(0, B - Bz);
      var X = anf ? it.x : it.x + it.b, s = anf ? 1 : -1;
      var d = Math.min(obenTiefe, Bz - 1), D = 1.8, S = 0.15;
      var form = new T.Shape();
      form.moveTo(X + s * a, 0);
      form.lineTo(X + s * B, 0);
      form.lineTo(X + s * B, d);
      form.lineTo(X + s * (a + d), d);
      form.lineTo(X + s * (a + d), Bz);
      form.lineTo(X + s * a, Bz);
      var geo = new T.ExtrudeGeometry(form, { depth: h, bevelEnabled: false });
      /* Wie beim Diagonalschrank: Form in x/y, entlang z gezogen, um +90 Grad um x gekippt (y wird Raumtiefe, z die Hoehe). */
      var me = new T.Mesh(geo, [mat(korpus), mat(korpus)]);
      me.rotation.x = Math.PI / 2;
      me.position.set(0, y + h, 0);
      gruppe.add(me);
      /* Tuer 1 auf dem Schenkel an DIESER Wand (schaut in den Raum), Tuer 2 auf dem Schenkel an der Nachbarwand (schaut an
         dieser Wand entlang). Beide 2 mm vor ihrer Schenkelfront wie jede Tuer (fronten); Tuer 1 beginnt hinter der Staerke
         von Tuer 2, damit sich die Blaetter in der Innenecke nicht durchdringen. */
      var w1 = B - a - d - D, w2 = Bz - d - D;
      if (w1 > 4) {
        var t1 = new T.Mesh(frontGeo(w1 - 2 * S, h - 2 * S, D), frontMat(w1 - 2 * S, h - 2 * S));
        t1.position.set(X + s * (a + d + D + w1 / 2), y + h / 2, d + 0.2 - D / 2);
        gruppe.add(t1);
        eckGriff(gruppe, t1.position.x, d, 0, w1, h, y, true, true);
      }
      if (w2 > 4) {
        var t2 = new T.Mesh(frontGeo(w2 - 2 * S, h - 2 * S, D), frontMat(w2 - 2 * S, h - 2 * S));
        t2.rotation.y = s * Math.PI / 2;
        t2.position.set(X + s * (a + d + 0.2 - D / 2), y + h / 2, d + D + w2 / 2);
        gruppe.add(t2);
        eckGriff(gruppe, X + s * (a + d), t2.position.z, t2.rotation.y, w2, h, y, true, true);
      }
      /* Der Koerper fuer die Markierung: beide Schenkel samt Tuer. */
      var x0 = X + s * a, x1 = X + s * B, xL = X + s * (a + d + 0.2);
      (gruppe.userData.koerper = gruppe.userData.koerper || []).push(
        [Math.min(x0, x1), y, 0, Math.max(x0, x1), y + h, d + 0.2],
        [Math.min(x0, xL), y, 0, Math.max(x0, xL), y + h, Bz]);
    };

    /* Ein offenes Regal hat KEINE Front. `kasten` faerbt die Vorderflaeche mit der Frontfarbe
       und zeigte damit eine Tuer, wo keine ist — gemeldet fuer Glanzia G25PZ, das im Shop ein
       "Regalhängeschrank" mit zwei offenen Faechern ist. Woran es erkannt wird, ist dasselbe
       wie in der 2D-Zeichnung: ein Frontplan, der NUR aus Nischen besteht. Eine zweite Kennung
       waere eine zweite Wahrheit.

       Gebaut wird der Korpus in Korpusfarbe, die Vorderflaeche zurueckgesetzt dunkler, und die
       Boeden sitzen an den Fachgrenzen aus demselben Plan. */
    var istRegal = function (m) {
      var f = m && m.front;
      return !!(f && f.length && f.every(function (t) { return t[0] === 'nische'; }));
    };
    var regal = function (gruppe, it, y, flucht) {
      var b = it.b, h = it.m.h, tt = K.nennTiefe(it.m);
      var zM = Math.max(tt, flucht || tt) - tt / 2;
      var geo = new T.BoxGeometry(b, h, tt);
      var innen = mat(K.ton(korpus, -26), 0.9);
      var me = new T.Mesh(geo, [mat(korpus), mat(korpus), mat(korpus), mat(korpus), innen, mat(korpus)]);
      me.position.set(it.x + b / 2, y + h / 2, zM);
      gruppe.add(me);
      var kante = new T.LineSegments(new T.EdgesGeometry(geo),
        new T.LineBasicMaterial({ color: tok('--hm-ink', '#201D17'), transparent: true, opacity: 0.38 }));
      kante.position.copy(me.position); gruppe.add(kante);
      var teile = it.m.front, summe = 0, i, yy = y + h;
      for (i = 0; i < teile.length; i++) summe += (+teile[i][1] || 0);
      for (i = 0; i < teile.length - 1; i++) {
        yy -= h * (+teile[i][1] || 0) / (summe || 1);
        var boden = new T.Mesh(new T.BoxGeometry(Math.max(0, b - 3.2), 1.8, Math.max(0, tt - 2)),
          mat(K.ton(korpus, 6)));
        boden.position.set(it.x + b / 2, yy, zM);
        gruppe.add(boden);
      }
    };

    /* Becken und Armatur auf dem Spuelenschrank. Das Becken liegt 0,2 cm ueber der Platte (eine
       eigene, dunklere Flaeche mit Rand), die Armatur hinten mittig. */
    /* SPUELE (Betreiber 2026-09-27: „die Spuele ist seltsam, nicht echt"). Vorher lag eine graue
       Platte AUF der Arbeitsplatte, dazu ein gerades Rohr als Armatur. Jetzt: ein Ausschnitt in der
       Platte (platteMitLoch), darin ein Edelstahlbecken 18 cm tief mit gerundeten Ecken, schmaler
       Rand, Ablauf, und eine Armatur mit geschwungenem Auslauf ueber der Beckenmitte. Masse wie
       bisher: bis 50 cm breit (Schrank minus 14), 40 cm tief, 3 cm vor der Plattenmitte. */
    var rundeForm = function (p, x0, y0, x1, y1, r) {
      p.moveTo(x0 + r, y0); p.lineTo(x1 - r, y0); p.quadraticCurveTo(x1, y0, x1, y0 + r);
      p.lineTo(x1, y1 - r); p.quadraticCurveTo(x1, y1, x1 - r, y1);
      p.lineTo(x0 + r, y1); p.quadraticCurveTo(x0, y1, x0, y1 - r);
      p.lineTo(x0, y0 + r); p.quadraticCurveTo(x0, y0, x0 + r, y0);
      return p;
    };
    var spuelMass = function (it) {
      return { cx: it.x + it.b / 2, cz: K.platteTiefe() / 2 + 3, b: Math.min(it.b - 14, 50), t: 40, r: 4 };
    };
    var stahlB = new T.MeshStandardMaterial({ color: '#C8CBCC', roughness: 0.34, metalness: 0.85, side: T.DoubleSide });
    var chrom = new T.MeshStandardMaterial({ color: '#E4E6E8', roughness: 0.12, metalness: 1 });
    /* Flache Ringform (Rand, Beckenwand): aussen und innen gerundet, gezogen und flach gelegt. */
    var ring = function (b0, t0, r0, breite, hoch) {
      var f = rundeForm(new T.Shape(), -b0 / 2 - breite, -t0 / 2 - breite, b0 / 2 + breite, t0 / 2 + breite, r0 + breite);
      f.holes.push(rundeForm(new T.Path(), -b0 / 2, -t0 / 2, b0 / 2, t0 / 2, r0));
      var geo = new T.ExtrudeGeometry(f, { depth: hoch, bevelEnabled: false, curveSegments: 8 });
      geo.rotateX(Math.PI / 2);          /* Formebene -> Boden, Zugrichtung -> nach unten */
      return geo;
    };
    /* Livaro: schwarzes Becken und schwarze Armatur, wie in allen Livaro-Komplettkuechen
       (Serienoptik `spuele: 'schwarz'`); sonst Edelstahl und Chrom. */
    var optikZ = (K.optikSerie && K.optikSerie(z)) || {};
    var spuelSchwarz = optikZ.spuele === 'schwarz'
      || (optikZ.spuele === 'nachFront' && !/wei/i.test(String(z.farbe || '').split('/')[0]));
    if (spuelSchwarz) {
      stahlB = new T.MeshStandardMaterial({ color: '#232425', roughness: 0.55, metalness: 0, side: T.DoubleSide });
      chrom = new T.MeshStandardMaterial({ color: '#1B1C1D', roughness: 0.35, metalness: 0.4 });
    }
    var spuele = function (gruppe, it) {
      var top = g.korpus_hoehe + g.arbeitsplatte_dicke, o = spuelMass(it), tief = 18;
      var randMat = spuelSchwarz ? stahlB : stahl;
      var teil = function (geo, m, x, y, zz) {
        var me = new T.Mesh(geo, m); me.position.set(x, y, zz); gruppe.add(me); return me;
      };
      /* Beckenwand, Boden, Rand */
      teil(ring(o.b - 0.3, o.t - 0.3, o.r - 0.15, 0.15, tief), stahlB, o.cx, top, o.cz);
      var bodenG = new T.ShapeGeometry(rundeForm(new T.Shape(), -o.b / 2, -o.t / 2, o.b / 2, o.t / 2, o.r), 8);
      bodenG.rotateX(-Math.PI / 2);
      teil(bodenG, stahlB, o.cx, top - tief, o.cz);
      teil(ring(o.b, o.t, o.r, 1.2, 0.25), randMat, o.cx, top + 0.25, o.cz);
      /* Ablauf */
      teil(new T.CylinderGeometry(2.6, 2.6, 0.3, 28), randMat, o.cx, top - tief + 0.15, o.cz + 6);
      teil(new T.CylinderGeometry(1.7, 1.7, 0.32, 24), glasO, o.cx, top - tief + 0.2, o.cz + 6);
      /* Armatur hinter dem Becken, Auslauf zur Mitte */
      var fx = o.cx, fz = o.cz - o.t / 2 - 4.5;
      teil(new T.CylinderGeometry(2.3, 2.7, 4, 28), chrom, fx, top + 2, fz);
      var kurve = new T.CubicBezierCurve3(new T.Vector3(0, 4, 0), new T.Vector3(0, 38, 0),
        new T.Vector3(0, 40, 21), new T.Vector3(0, 25, 21));
      teil(new T.TubeGeometry(kurve, 48, 1.05, 16, false), chrom, fx, top, fz);
      teil(new T.CylinderGeometry(1.35, 1.2, 2.6, 20), chrom, fx, top + 24, fz + 21);
      var hebel = teil(new T.CylinderGeometry(0.55, 0.55, 9, 12), chrom, fx + 3.6, top + 11, fz);
      hebel.rotation.z = -0.55;
      teil(new T.CylinderGeometry(1.4, 1.4, 2.2, 16), chrom, fx + 2.2, top + 8, fz).rotation.z = Math.PI / 2;
    };
    /* PLATTENKANTEN (2026-09-30): Oberseite und Kanten zeigen dasselbe Bild, aber jede Flaeche mit ihrer eigenen Projektion.
       Bis hierher bekamen beim Spuelenstueck auch die senkrechten Flaechen die Koordinaten der Draufsicht — u/v nur aus x
       und z, ueber die Hoehe konstant, also zog jede Bildspalte als senkrechter Streifen ueber die Kante („Barcode"); beim
       Quader lagen die ganzen 60 cm Bildtiefe auf den 4 cm Kante. Jetzt massstaeblich wie oben (u: 1 = Stuecklaenge, v: 1 =
       Plattentiefe): Vorder-, Rueckkante und Lochwaende quer zur Tiefe laufen in x weiter wie die Oberseite; Stirnseiten und
       Lochwaende quer zur Laenge nehmen die Tiefe als u und die Hoehe als v. `weiter` (gescannte Bibliotheksoberflaeche,
       kachelt nahtlos): das Bild laeuft ueber die Kante weiter wie eine umgeleimte Dekorschicht, die Stirnseite setzt die
       Vorderkante um die senkrechte Ecke fort — gespiegelt machte jede schraege Marmorader zur Pfeilspitze. Ohne `weiter`
       (gemaltes plattenBild, kachelt nicht): gespiegelt ins Material, damit die Kante im Bildausschnitt des Stuecks bleibt
       und keine Naht zeigt. Ober- und Unterseite behalten ihre Koordinaten. `ox`/`oy`/`oz` verschieben auf
       Stueckkoordinaten: links 0, Oberseite 0, Wand 0. */
    var plattenKantenUV = function (geo, len, ox, oy, oz, weiter) {
      var pt0 = K.platteTiefe(), pos = geo.attributes.position, nor = geo.attributes.normal, uv = geo.attributes.uv, f = weiter ? -1 : 1;
      for (var i = 0; i < pos.count; i++) {
        var nx = nor.getX(i), ny = nor.getY(i), nz = nor.getZ(i);
        if (Math.abs(ny) >= Math.abs(nx) && Math.abs(ny) >= Math.abs(nz)) continue;
        var x = pos.getX(i) + ox, unter = -(pos.getY(i) + oy), zz = pos.getZ(i) + oz;
        if (Math.abs(nz) >= Math.abs(nx)) uv.setXY(i, x / len, 1 - zz / pt0 + f * (nz > 0 ? 1 : -1) * unter / pt0);
        else uv.setXY(i, x / len - f * (nx > 0 ? 1 : -1) * (pt0 - zz) / len, f * unter / pt0);
      }
      uv.needsUpdate = true;
      return geo;
    };
    /* Die Arbeitsplatte eines Stuecks MIT Spuelenausschnitt: Rechteck mit gerundetem Loch, flach
       gelegt; Texturkoordinaten 0..1 ueber das Stueck wie beim Quader (platteFuer). */
    var platteMitLoch = function (s, loecher) {
      var len = s.bis - s.von, d = g.arbeitsplatte_dicke, pt0 = K.platteTiefe();
      var form = new T.Shape();
      form.moveTo(0, 0); form.lineTo(len, 0); form.lineTo(len, pt0); form.lineTo(0, pt0); form.lineTo(0, 0);
      loecher.forEach(function (o) {
        form.holes.push(rundeForm(new T.Path(), o.cx - s.von - o.b / 2, o.cz - o.t / 2,
          o.cx - s.von + o.b / 2, o.cz + o.t / 2, o.r));
      });
      var geo = new T.ExtrudeGeometry(form, { depth: d, bevelEnabled: false, curveSegments: 8 });
      geo.rotateX(Math.PI / 2);
      var pos = geo.attributes.position, uv = geo.attributes.uv;
      for (var i = 0; i < pos.count; i++) uv.setXY(i, pos.getX(i) / len, 1 - pos.getZ(i) / pt0);
      return plattenKantenUV(geo, len, 0, 0, 0, !!platteMat.userData.bib);
    };

    /* Backofen als Gerät, nicht als Schrankfront: 60 cm hohes Einbaugerät mit Glasscheibe,
       Blende und Stahlgriff, 1 cm vor die Front gesetzt. Beim Herdumbau sitzt es unten und
       trägt oben ein Kochfeld, im Hochschrank sitzt es in Augenhöhe. */
    var stahl = new T.MeshStandardMaterial({ color: '#B9BDBE', roughness: 0.28, metalness: 0.75 });
    var glasO = new T.MeshStandardMaterial({ color: '#15181A', roughness: 0.12, metalness: 0.3 });
    /* GERAETE ECHT (Betreiber 2026-09-27: „اريد البراد والاجهزة الكهربائية ان تبدو حقيقية"). Gebuerstetes Edelstahl, schwarzes
       Glas mit Klarlack (spiegelt die Umgebung wie eine echte Ofenscheibe), eine leuchtende Anzeige, Drehknebel mit Strich,
       Stabgriffe auf Stuetzen — die Details, an denen man ein Geraet von einem dunklen Kasten unterscheidet. */
    var edel = new T.MeshStandardMaterial({ color: '#C4C8CB', roughness: 0.3, metalness: 0.86, envMapIntensity: 0.95 });
    var glasS = T.MeshPhysicalMaterial
      ? new T.MeshPhysicalMaterial({ color: '#0C0E0F', roughness: 0.05, metalness: 0.08, clearcoat: 1, clearcoatRoughness: 0.02, envMapIntensity: 0.9 })
      : glasO;
    var fensterMat = new T.MeshStandardMaterial({ color: '#20272B', roughness: 0.04, metalness: 0.55, envMapIntensity: 1 });
    /* Sichtfenster mit Innenraum (ofenInnenBild): kein eigenes Licht der Szene auf dem Bild (Grundfarbe schwarz), der Garraum
       als sehr dunkles Eigenleuchten, darueber Klarlack, der den Raum spiegelt. */
    var innenFenster = function (mikro) {
      var P = T.MeshPhysicalMaterial || T.MeshStandardMaterial;
      var m = new P({ color: '#000000', roughness: 0.05, metalness: 0, envMapIntensity: 1 });
      if ('clearcoat' in m) { m.clearcoat = 1; m.clearcoatRoughness = 0.02; }
      var bi = ofenInnenBild(mikro);
      /* Mit Licht leuchtet der Garraum durch das getoente Glas (Lichthof im Bild); ohne bleibt er ein Schatten. */
      if (bi) { m.emissiveMap = bi; m.emissive = new T.Color('#ffffff'); m.emissiveIntensity = !mikro && OFEN_LICHT ? 0.55 : 1; }
      return m;
    };
    var ofenFenster = innenFenster(false), mikroFenster = innenFenster(true);
    var tasteMat = new T.MeshStandardMaterial({ color: '#5B6166', roughness: 0.4, metalness: 0.5 });
    var dunkelMat = new T.MeshStandardMaterial({ color: '#141617', roughness: 0.6, metalness: 0.2 });
    /* Gerundeter Koerper (Tuer, Blende): Umriss mit Eckradius, Kanten gefast — sie fangen das Licht wie echte Geraetetueren.
       Texturkoordinaten 0..1 ueber die Flaeche. Je Mass einmal gebaut. */
    var rundGeos = {};
    var rundKasten = function (b, h, t, r) {
      var sch = [b, h, t, r].map(function (v) { return v.toFixed(2); }).join('|');
      if (rundGeos[sch]) return rundGeos[sch];
      r = Math.min(r, b / 4, h / 4, t / 2.2);
      var fa = r * 0.55, form = new T.Shape(), x0 = -b / 2 + fa, y0 = -h / 2 + fa, rr = Math.max(0.01, r - fa);
      form.moveTo(x0 + rr, y0); form.lineTo(-x0 - rr, y0); form.quadraticCurveTo(-x0, y0, -x0, y0 + rr);
      form.lineTo(-x0, -y0 - rr); form.quadraticCurveTo(-x0, -y0, -x0 - rr, -y0);
      form.lineTo(x0 + rr, -y0); form.quadraticCurveTo(x0, -y0, x0, -y0 - rr);
      form.lineTo(x0, y0 + rr); form.quadraticCurveTo(x0, y0, x0 + rr, y0);
      var geo = new T.ExtrudeGeometry(form, { depth: Math.max(0.1, t - 2 * fa), bevelEnabled: true, bevelThickness: fa,
        bevelSize: fa, bevelSegments: 4, curveSegments: 8 });
      geo.translate(0, 0, -(t - 2 * fa) / 2);
      var pos = geo.attributes.position, uv = geo.attributes.uv;
      for (var i = 0; i < pos.count; i++) uv.setXY(i, (pos.getX(i) + b / 2) / b, (pos.getY(i) + h / 2) / h);
      uv.needsUpdate = true;
      geo.computeVertexNormals();
      rundGeos[sch] = geo;
      return geo;
    };
    var spiegel = function (m, st) { if (glanzEnv) { m.envMap = glanzEnv; m.envMapIntensity = st; } return m; };
    /* Gebuersteter Edelstahl: Striche als Helligkeit und Rauheit, Spiegelraum mit breiten Lichtbahnen. */
    var edelB = function (quer, wdh) {
      var m = new T.MeshStandardMaterial({ color: '#ffffff', roughness: 0.38, metalness: 0.92 });
      var t0 = buerste(quer);
      if (t0) { var t1 = t0.clone(); t1.needsUpdate = true; t1.repeat.set(quer ? 1 : wdh || 2, quer ? wdh || 2 : 1); m.map = t1; m.roughnessMap = t1; }
      else m.color.set('#C6CACD');
      if ('anisotropy' in m) m.anisotropy = 0.4;
      return spiegel(m, 1.05);
    };
    var leuchtAnzeige = function (text, symbole) {
      var bild = anzeigeBild(text, symbole);
      var m = new T.MeshStandardMaterial({ color: '#050606', roughness: 0.12, metalness: 0.2 });
      if (bild) { m.emissiveMap = bild; m.emissive = new T.Color('#ffffff'); m.emissiveIntensity = 1.1; }
      return spiegel(m, 0.9);
    };
    var kuehlFarbe = function () {
      var f = ((z && z.wunsch) || {}).kuehlFarbe;
      return f === 'schwarz' || f === 'grau' ? f : 'weiss';
    };
    var kuehlLack = function (f, seite) {
      if (f === 'grau') return edelB(false, seite ? 3 : 2);
      var P = T.MeshPhysicalMaterial || T.MeshStandardMaterial;
      if (f === 'schwarz') {
        return spiegel(new P({ color: '#121315', roughness: seite ? 0.45 : 0.22, metalness: 0.35, clearcoat: seite ? 0.3 : 1,
          clearcoatRoughness: 0.08 }), seite ? 0.5 : 1.0);
      }
      return spiegel(new P({ color: '#F4F5F5', roughness: seite ? 0.4 : 0.16, metalness: 0.02, clearcoat: seite ? 0.2 : 1,
        clearcoatRoughness: 0.06 }), seite ? 0.25 : 0.45);
    };
    var teil3 = function (gruppe, geo, m, x, y, zz) {
      var me = new T.Mesh(geo, m); me.position.set(x, y, zz); me.castShadow = true; me.receiveShadow = true; gruppe.add(me); return me;
    };
    /* Stabgriff: Rundstab quer (oder senkrecht) auf zwei Stuetzen, `abstand` vor der Flaeche bei zz. */
    var stabGriff = function (gruppe, m, cx, cy, zz, lang, senkrecht) {
      var stab = teil3(gruppe, new T.CylinderGeometry(0.75, 0.75, lang, 18), m, cx, cy, zz + 2.6);
      if (!senkrecht) stab.rotation.z = Math.PI / 2;
      [-1, 1].forEach(function (sg) {
        var st = teil3(gruppe, new T.CylinderGeometry(0.45, 0.45, 2.4, 12), m,
          senkrecht ? cx : cx + sg * (lang / 2 - 3), senkrecht ? cy + sg * (lang / 2 - 3) : cy, zz + 1.4);
        st.rotation.x = Math.PI / 2;
      });
    };
    /* Drehknebel mit Markierungsstrich. */
    var knebel = function (gruppe, cx, cy, zz) {
      var k = teil3(gruppe, new T.CylinderGeometry(1.9, 2.1, 1.8, 24), edel, cx, cy, zz + 0.9);
      k.rotation.x = Math.PI / 2;
      teil3(gruppe, new T.BoxGeometry(0.35, 1.5, 0.2), dunkelMat, cx, cy + 0.6, zz + 1.85);
    };
    var geraetFront = function (gruppe, it, y, flucht) {
      var gb = Math.min(it.b - 2, 58), gh = Math.min(60, it.m.h - 4);
      var hoch = /hochschrank_geraet/.test(it.m.funktion || '');
      var gy = hoch ? y + it.m.h - gh - 8 : y + (it.m.h - gh) / 2;
      /* Beim Herdumbau sitzt der Ofen dort, wo ihn die Front vorsieht — oben, ueber dem Auszug.
         Mittig gesetzt ueberlappte er die Schublade darunter. */
      /* Der Ofen sitzt in seinem Teil: `ofen` beim Herdumbau, `nische` beim Backofen-Unterschrank mit
         Frontplan (Lunara KU-DP60: 60er Nische ueber einem Auszug). Nur `ofen` gesucht, stand der
         Lunara-Ofen mittig und deckte den Auszug zu. */
      var teileG = K.frontTeile(z, it.m, it.b, it.m.h, g.korpus_hoehe - (it.sockel || 0));
      var nischenG = teileG.filter(function (p) { return p.art === 'nische'; });
      /* Im Hochschrank: der Backofen in der Nische, die einer Backofenhoehe (60) am naechsten
         kommt; eine zweite, niedrige Nische (Velora D60PM, Lunara S60PM) traegt die Mikrowelle. */
      var ofenTeil = teileG.filter(function (p) { return p.art === 'ofen'; })[0]
        || nischenG.slice().sort(function (p, q) { return Math.abs(p.h - 60) - Math.abs(q.h - 60); })[0];
      if (ofenTeil) { gh = Math.min(ofenTeil.h, 60); gy = y + it.m.h - ofenTeil.y - ofenTeil.h + (ofenTeil.h - gh) / 2; }
      nischenG.filter(function (p) { return p !== ofenTeil; }).forEach(function (p) {
        /* MIKROWELLE: Edelstahlrahmen, Glastuer mit dunklem Sichtfenster links, rechts die Bedienleiste mit Anzeige
           und Tasten, ein Tuergriff an der Kante. */
        var mh = Math.min(p.h - 1, 38), my = y + it.m.h - p.y - p.h + (p.h - mh) / 2, mcx = it.x + it.b / 2;
        var mb = Math.min(it.b - 2, 58), mz = flucht + 0.6, lb = Math.min(13, mb * 0.24), tb = mb - lb - 0.6;
        teil3(gruppe, new T.BoxGeometry(mb, mh, 1), edel, mcx, my + mh / 2, mz - 0.2);
        var tx = mcx - mb / 2 + 0.3 + tb / 2;
        teil3(gruppe, new T.BoxGeometry(tb, mh - 1.2, 1.1), glasS, tx, my + mh / 2, mz + 0.55);
        teil3(gruppe, new T.BoxGeometry(tb - 9, mh - 9, 0.3), mikroFenster, tx - 1.5, my + mh / 2, mz + 1.2);
        var lx = mcx + mb / 2 - 0.3 - lb / 2;
        teil3(gruppe, new T.BoxGeometry(lb, mh - 1.2, 1.1), glasS, lx, my + mh / 2, mz + 0.55);
        teil3(gruppe, new T.BoxGeometry(lb - 3, 2.6, 0.2), leuchtAnzeige('0:00'), lx, my + mh - 5, mz + 1.2);
        [0, 1, 2].forEach(function (k) {
          teil3(gruppe, new T.BoxGeometry(lb - 5, 1.6, 0.35), tasteMat, lx, my + mh - 10 - k * 3.4, mz + 1.25);
        });
        teil3(gruppe, new T.BoxGeometry(1.2, mh * 0.5, 1.6), edel, tx + tb / 2 - 2.2, my + mh / 2, mz + 1.6);
      });
      /* BACKOFEN: Edelstahlrahmen, oben die Bedienblende in schwarzem Glas mit Anzeige und zwei Drehknebeln, darunter die
         Glastuer mit grossem Sichtfenster und dem Rost dahinter, quer der Stabgriff. */
      var cx = it.x + it.b / 2, z0 = flucht + 0.6, bh = Math.min(10, gh * 0.18), th = gh - bh - 0.6;
      teil3(gruppe, new T.BoxGeometry(gb, gh, 1), edel, cx, gy + gh / 2, z0 - 0.2);
      teil3(gruppe, new T.BoxGeometry(gb - 1.2, bh - 0.8, 0.9), glasS, cx, gy + gh - bh / 2, z0 + 0.5);
      teil3(gruppe, new T.BoxGeometry(Math.min(10, gb * 0.2), 2.6, 0.2), leuchtAnzeige('12:00'), cx, gy + gh - bh / 2, z0 + 1.0);
      [-1, 1].forEach(function (sg) { knebel(gruppe, cx + sg * (gb / 2 - 7), gy + gh - bh / 2, z0 + 0.9); });
      teil3(gruppe, new T.BoxGeometry(gb - 1.2, th, 1.3), glasS, cx, gy + th / 2 + 0.3, z0 + 0.65);
      teil3(gruppe, new T.BoxGeometry(gb - 13, th - 15, 0.3), ofenFenster, cx, gy + th / 2 - 1.5, z0 + 1.36);
      [0.34, 0.58].forEach(function (f) { teil3(gruppe, new T.BoxGeometry(gb - 16, 0.35, 0.35), edel, cx, gy + th * f, z0 + 1.0); });
      stabGriff(gruppe, edel, cx, gy + th - 3.2, z0 + 1.3, gb - 8);
    };

    /* Eine Wandgruppe legt ihre lokale x-Achse auf die Wand und ihre lokale z-Achse in den
       Raum. Alles darin — Schraenke, Geraete, Fenster, Arbeitsplatte — rechnet danach in
       WANDLOKALEN Zentimetern, also in genau der Zahl, die auch der Grundriss und die
       Frontansicht verwenden. Frueher stand hier eine Tabelle aus vier Buchstaben; die
       Insel war darin eine Wand, obwohl sie keine ist. */
    /* Nischenrueckwand: weisser Marmor wie auf den Serienfotos — ist die gewaehlte Platte selbst
       Marmor, dann dieselbe (Platte und Rueckwand aus einem Stein). Sie reicht von der Platte bis
       zur Unterkante der Haengeschraenke und laeuft ueber dieselben Strecken wie die Platte;
       Fenster, deren Bruestung darunter liegt, bleiben frei. */
    var rueckwandMat = (function () {
      var gp = K.platteVon && K.platteVon(z, daten);
      var opt2 = (K.optikSerie && K.optikSerie(z)) || {};
      var p = gp && gp.muster === 'marmor' ? gp
        : opt2.rueckwand === 'panda'
          ? { id: 'rueckwand-panda', muster: 'marmor', farbe: '#EEECE9', ader: '#1E1C1B', stark: true }
          : { id: 'rueckwand-marmor', muster: 'marmor', farbe: '#ECEAE6', ader: '#9E9A95' };
      /* Umgebungslicht 0,35 statt 0,9 (Betreiber 2026-09-29: Schatten der Deko „بشكل احترافي"): der helle Raum im Spiegelbild
         hob jeden Schatten auf der Rueckwand auf; mit weniger davon zeichnen Topf, Vase und Kaffeemaschine ihren Schatten an die
         Wand, und der Marmor zeigt seine Adern statt eines weissen Schleiers (Probe: Umgebung x 0,35). */
      var m = new T.MeshStandardMaterial({ color: '#ffffff', roughness: 0.18, metalness: 0, envMapIntensity: 0.35 });
      m.map = plattenBild(p);
      m.userData.hell = new T.Color(p.farbe).getHSL({}).l > 0.6;
      m.userData.dunkel = new T.Color(p.farbe).getHSL({}).l < 0.3;
      return m;
    })();
    /* Ist die Platte hell? Ohne gewaehlte Platte liegt die helle Steinoptik. */
    var platteHell = (function () {
      var gp = K.platteVon && K.platteVon(z, daten);
      return !gp || new T.Color(gp.farbe).getHSL({}).l > 0.6;
    })();
    var platteDunkel = (function () {
      var gp = K.platteVon && K.platteVon(z, daten);
      return !!gp && new T.Color(gp.farbe).getHSL({}).l < 0.3;
    })();
    var rueckwandUndLicht = function (gr, wid) {
      var top = g.korpus_hoehe + g.arbeitsplatte_dicke, uk = g.haenge_unterkante, hR = uk - top;
      if (hR < 20) return;
      var fenster = K.aktiveMerkmale(z).filter(function (m) {
        return m.wand === wid && m.typ === 'fenster' && m.hoehe < uk;
      }).map(function (m) { return [m.x - 3, m.x + m.breite + 3]; });
      /* DIE ECKE GEHOERT ZUR RUECKWAND BEIDER WAENDE (Betreiber 2026-09-28, Bild: „فراغ غريب فوق سطح العمل"). Das
         Plattenquadrat einer Ecke liegt in den Stuecken nur EINER der beiden Waende; die andere Wand bekam darueber keine
         Rueckwand, und zwischen Platte und Eck-Haengeschrank stand 60 cm nackte Wand — in der U-Kueche an beiden Enden der
         Hauptwand. Deckt die Platte der Nachbarwand die Ecke, laeuft die Rueckwand dieser Wand bis in die Ecke — bis an
         die Rueckwand der Nachbarwand (0,8 cm vor der Ecke), nicht in sie hinein. */
      var alleStuecke = K.plattenStuecke(z, daten, true), wl = K.wandObj(z, wid).len, rwD = 0.8;
      var eckenHier = K.geometrischeEcken(K.raumGeometrie(z)).filter(function (e) { return e.a === wid || e.b === wid; });
      var nachbarDeckt = function (ende) {
        return eckenHier.some(function (e) {
          if (e.enden[wid] !== ende) return false;
          var n = e.a === wid ? e.b : e.a, nLen = K.wandObj(z, n).len;
          return alleStuecke.some(function (st) {
            return st.wand === n && (e.enden[n] === 'anfang' ? st.von < 0.5 : st.bis > nLen - 0.5);
          });
        });
      };
      var eckTiefe = K.platteTiefe() + 5;
      /* Wo ein flacher Schrank oben buendig ueber dem Kochfeld haengt (Startkueche): dort reicht die Rueckwand bis unter
         die Haube (6 cm). Die Bildgroesse gilt fuer die ganze Wand, damit das Bild nirgends umbricht; reicht die Hoehe
         nicht, waechst das Bild in beiden Richtungen (Adern behalten ihre Form). */
      var obenW = K.items(z, daten, wid, 'oben'), haubenZonen = [];
      K.kochstellen(z, daten, wid).forEach(function (h) {
        var o0 = obenW.filter(function (o) { return o.x < h.x + h.b - 2 && o.x + o.b > h.x + 2 && o.m.h <= 40; })[0];
        var extra = o0 ? (o0.off || 0) - 6 : 0;
        if (o0 && extra >= 5) haubenZonen.push({ a: o0.x, b: o0.x + o0.b, extra: extra });
      });
      var bildHoehe = Math.max(PLATTE_BILD_CM[1], hR + haubenZonen.reduce(function (m, hz) { return Math.max(m, hz.extra); }, 0));
      var bildBreite = PLATTE_BILD_CM[0] * bildHoehe / PLATTE_BILD_CM[1];
      alleStuecke.filter(function (st) { return st.wand === wid; }).forEach(function (st) {
        var von3 = st.von > 0.5 && st.von <= eckTiefe && nachbarDeckt('anfang') ? rwD : st.von;
        var bis3 = st.bis < wl - 0.5 && st.bis >= wl - eckTiefe && nachbarDeckt('ende') ? wl - rwD : st.bis;
        var teile3 = [[von3, bis3]];
        fenster.forEach(function (fe) {
          var neu3 = [];
          teile3.forEach(function (tt) {
            if (fe[1] <= tt[0] || fe[0] >= tt[1]) { neu3.push(tt); return; }
            if (fe[0] > tt[0]) neu3.push([tt[0], fe[0]]);
            if (fe[1] < tt[1]) neu3.push([fe[1], tt[1]]);
          });
          teile3 = neu3;
        });
        teile3.forEach(function (tt) {
          var bw = tt[1] - tt[0];
          if (bw < 5) return;
          /* Das Plattenbild ist 420 x 65 cm; die Adern laufen hier quer ueber die Wand. Ueber einem Kochfeld mit oben
             buendigem Schrank reicht die Rueckwand bis unter die Haube — als EIN Stueck von der Platte bis zur Haube, mit
             demselben Bild wie daneben (gleiches u je cm, v ab der Platte), sonst sass auf Hoehe der Haengeschraenke ein
             Schnitt im Marmor und das Bild wiederholte sich (Betreiber 2026-09-28, Bild: „هذه مشكلة للجدار فوق الفرن"). */
          var rx = Math.min(1, bw / bildBreite), ox = (tt[0] % 97) / 97 * Math.max(0, 1 - rx);
          var schnitte = [tt[0], tt[1]];
          haubenZonen.forEach(function (hz) {
            [hz.a, hz.b].forEach(function (x) { if (x > tt[0] + 0.5 && x < tt[1] - 0.5) schnitte.push(x); });
          });
          schnitte.sort(function (p, q) { return p - q; });
          for (var si = 0; si + 1 < schnitte.length; si++) {
            var a0 = schnitte[si], a1 = schnitte[si + 1], mitte = (a0 + a1) / 2;
            if (a1 - a0 < 0.5) continue;
            var hz0 = haubenZonen.filter(function (hz) { return mitte > hz.a && mitte < hz.b; })[0];
            var hS = hR + (hz0 ? hz0.extra : 0);
            var m2 = rueckwandMat.clone(), tx = rueckwandMat.map.clone();
            tx.needsUpdate = true;
            tx.repeat.set(rx * (a1 - a0) / bw, hS / bildHoehe);
            tx.offset.set(ox + rx * (a0 - tt[0]) / bw, 0);
            m2.map = tx;
            var rw2 = new T.Mesh(new T.BoxGeometry(a1 - a0, hS, 0.8), m2);
            rw2.position.set(mitte, top + hS / 2, 0.4);
            rw2.userData.durchlaessig = true;
            gr.add(rw2);
          }
        });
      });
      /* LED-Leiste unter jedem Haengeschrank: ein leuchtender Streifen vorn an der Unterseite.
         Im Foto (Pfadverfolgung) beleuchtet er Rueckwand und Platte selbst; in der Live-Ansicht
         legt ein weicher Lichtschein (additiv, nur live) denselben Eindruck auf Wand und Platte.
         Nicht unter dem Diagonal-Eckschrank und nicht unter hoeher gehaengten (Dunst-)Schraenken. */
      var ledM = new T.MeshStandardMaterial({ color: '#FFF1DA', emissive: '#FFE3B8', emissiveIntensity: 5 * (lookJetzt.licht.led || 1) });
      ledM.castShadow = false;
      var stueckeW = K.plattenStuecke(z, daten, true).filter(function (st) { return st.wand === wid; });
      var spuelZonenW = K.items(z, daten, wid, 'boden').filter(function (it) {
        return it.m.funktion === 'spuelen_unterschrank';
      }).map(function (it) { var o = spuelMass(it); return [o.cx - o.b / 2 - 1.5, o.cx + o.b / 2 + 1.5]; });
      K.items(z, daten, wid, 'oben').forEach(function (it) {
        if ((it.off || 0) > 5 || (it.eckseite && K.istEck(it.m)) || istRegal(it.m)) return;
        var tt4 = it.m.t || 32, bL = Math.max(4, it.b - 6);
        var y0 = uk + (it.off || 0);
        var led = new T.Mesh(new T.BoxGeometry(bL, 0.35, 1.4), ledM);
        led.position.set(it.x + it.b / 2, y0 - 0.2, tt4 - 4);
        led.userData.durchlaessig = true; led.userData.ohneSchatten = true; led.userData.led = { b: bL, staerke: glanz ? 26 : 14 };
        gr.add(led);
        var hW = Math.min(hR, 60);
        var schein = new T.Mesh(new T.PlaneGeometry(it.b + 10, hW), scheinMat('wand', rueckwandMat.userData.hell, rueckwandMat.userData.dunkel));
        schein.position.set(it.x + it.b / 2, y0 - hW / 2, 0.85);
        schein.userData.durchlaessig = true; schein.userData.ohneSchatten = true; schein.userData.nurLive = true;
        schein.renderOrder = 2;
        gr.add(schein);
        /* Der Schein auf der Platte nur, wo eine Platte liegt — ohne Unterschraenke schwebte er als
           heller Balken in der Luft (Betreiber-Bildschirmfoto 2026-09-27). */
        stueckeW.forEach(function (st) {
          var a0 = Math.max(st.von, it.x - 5), a1 = Math.min(st.bis, it.x + it.b + 5);
          /* Nicht ueber den Spuelenausschnitt: dort faerbte der Schein das Becken goldbraun
             (gesehen 2026-09-27 an der schwarzen Livaro-Spuele). */
          var teile4 = [[a0, a1]];
          spuelZonenW.forEach(function (sp) {
            var n4 = [];
            teile4.forEach(function (tt) {
              if (sp[1] <= tt[0] || sp[0] >= tt[1]) { n4.push(tt); return; }
              if (sp[0] > tt[0]) n4.push([tt[0], sp[0]]);
              if (sp[1] < tt[1]) n4.push([sp[1], tt[1]]);
            });
            teile4 = n4;
          });
          teile4.forEach(function (tt4) { scheinAufPlatte(tt4[0], tt4[1]); });
        });
        function scheinAufPlatte(a0, a1) {
          if (a1 - a0 < 5) return;
          var tP = Math.min(45, K.platteTiefe() - 5);
          var platz = new T.Mesh(new T.PlaneGeometry(a1 - a0, tP), scheinMat('platte', platteHell, platteDunkel));
          platz.rotation.x = -Math.PI / 2;
          platz.position.set((a0 + a1) / 2, top + 0.12, tP / 2);
          platz.userData.durchlaessig = true; platz.userData.ohneSchatten = true; platz.userData.nurLive = true;
          platz.renderOrder = 2;
          gr.add(platz);
        }
      });
    };

    var wandGruppe = function (w) {
      var wid = w.id;
      var tr = K.wandTransform3D(w);
      var gr = new T.Group();
      gr.position.set(tr.ursprung.x, tr.ursprung.y, tr.ursprung.z);
      gr.rotation.y = tr.gierung;
      root.add(gr);

      /* Die Wandgruppe heisst ab hier `wg`; `gr` ist innerhalb eines Schranks SEINE Gruppe —
         so kann ein Tipper in 3D den Schrank finden, den er getroffen hat (userData.sel). */
      var wg = gr;
      /* SOCKEL. Ein Unterschrank steht auf Fuessen: der Korpus beginnt auf Sockelhoehe (Katalog
         der Serie, 10 oder 15 cm), und darunter stehen die Fuesse — oder, wenn der Kunde die
         Sockelleiste dazugenommen hat, eine Blende in der Frontebene (seit 2026-09-30 buendig, vorher 5 cm
         zurueckgesetzt; K.SOCKEL_ZURUECK). So sieht er im Bild,
         was die Leiste ausmacht. Bis 2026-09-24 reichten die Fronten bis auf den Boden. */
      var sockelH = (daten && daten.sockel && +daten.sockel.hoehe) || 10;
      var mitLeiste = Object.keys(z.zubehoer || {}).some(function (k) { return /^sl/.test(k) && z.zubehoer[k] > 0; });
      /* Die Sockelleiste im Dekor ihrer Gruppe (K.sockelGruppe: „Artisan Eiche", „Beige", „Weiß" …),
         Holz mit Faser in der Laenge; sonst in der Serienfarbe dieses Namens. Vorher: der Korpus um
         30 Stufen abgedunkelt — ein Braun, das es im Shop nicht gibt. */
      var sgName = ((K.sockelGruppe(z, daten) || {}).gruppe || {}).name || korpusDekor || '';
      var leisteFarbe = K.frontFarbe({ serie: z.serie, farbe: sgName }) || K.ton(korpus, -10);
      var leisteMatFuer = function (len, hh) {
        var tx = dekorAuf(sgName, len, hh, 'x', ++saatZ);
        var m = mat(tx ? '#ffffff' : leisteFarbe, 0.62);
        if (tx) m.map = tx;
        /* Live leicht angehoben: der Sockel stand 5 cm unter dem Korpus zurueck, und die
           Umgebungsverdeckung machte aus Weiss matt ein Mittelgrau (gemessen 173) — damals 0,6. Seit er buendig steht
           (2026-09-30) ist er der Fuss des Schranks und liegt wie dieser im Licht: mit 0,6 leuchtete er heller als die Fronten
           (239 statt 216 an der Tuerunterkante), auch 0,2 las sich in der Bildkritik noch als Lichtleiste (Insel-Ende: Sockel
           170 ueber einer Seite von 138–150). Deshalb ohne Anhebung — der Verlauf zum Boden kommt aus Licht und Verdeckung. */
        m.emissive.set(tx ? '#000000' : leisteFarbe); m.emissiveIntensity = 0;
        m.userData.liveAufhellung = !tx;
        return m;
      };
      var fussMat = new T.MeshStandardMaterial({ color: '#2A2B2D', roughness: 0.5, metalness: 0.2 });
      ['boden', 'oben', 'aufsatz'].forEach(function (zl) {
        /* WANDVERSATZ (K.wandVersatz, 2026-09-28): die Reihe steht um vZ naeher an ihrer Wand (unten) bzw. weiter weg
           (oben, negativ). Jeder Schrank wird als Ganzes verschoben; die Platte bleibt an der Wand. */
        var vZ = K.wandVersatz ? K.wandVersatz(z, daten, wid, zl) : 0;
        K.items(z, daten, wid, zl).forEach(function (it) {
          var gr = new T.Group();
          gr.userData.sel = wid + '|' + zl + '|' + it.i;
          /* Oben rueckt nur der Eck-Haengeschrank von seiner Wand weg: er haengt an der Wand zwischen den Ecken (Betreiber
             2026-09-28: „كيف سيعلقها العميل اذا ابعدتها عن الحائط؟" — die uebrigen Haengeschraenke bleiben an ihrer Wand). */
          if (vZ && (zl !== 'oben' || it.eckseite)) gr.position.z = -vZ;
          wg.add(gr);
          schrankGruppen[gr.userData.sel] = gr;
          if (zl === 'boden' && it.m.funktion !== 'geschirrspuelerfront' && it.m.h > sockelH + 20) {
            var tzS = K.stellTiefe(it, t, 'boden'), vornS = K.flucht();
            /* Die Leiste selbst kommt je Wand aus K.sockelStrecken (unten) — durchgehend, auch um
               die Ecke und an offenen Enden. Hier stehen nur die Fuesse, wenn es keine gibt. */
            if (!mitLeiste) {
              [[5, 6], [it.b - 5, 6], [5, vornS - 8], [it.b - 5, vornS - 8]].forEach(function (f) {
                var fuss = new T.Mesh(new T.CylinderGeometry(1.6, 1.9, sockelH, 14), fussMat);
                fuss.position.set(it.x + f[0], sockelH / 2, Math.min(f[1], tzS - 4));
                gr.add(fuss);
              });
              /* Der zweite Schenkel eines Eckschranks reicht bis zur Nenntiefe (90) und stand ohne
                 eigene Fuesse in der Luft — der Betreiber sah Schraenke „schweben". */
              var eLF = K.eckL(z, wid, it, t);
              if (eLF) {
                var sdF = K.schenkel(it.b) - Math.max(0, K.nennMass(it.m) - it.b), etF = K.nennTiefe(it.m);
                var xl = eLF.x <= it.x + 0.5 ? it.x : it.x + it.b - sdF;
                [[xl + 5, etF - 6], [xl + sdF - 5, etF - 6]].forEach(function (f) {
                  var fuss = new T.Mesh(new T.CylinderGeometry(1.6, 1.9, sockelH, 14), fussMat);
                  fuss.position.set(f[0], sockelH / 2, f[1]);
                  gr.add(fuss);
                });
              }
            }
            /* Ab hier rechnet der Schrank ohne seinen Sockel: gleiche Stelle, kleinere Hoehe. */
            var mK = {}; for (var km in it.m) { if (Object.prototype.hasOwnProperty.call(it.m, km)) mK[km] = it.m[km]; }
            mK.h = it.m.h - sockelH;
            var itK = {}; for (var ki in it) { if (Object.prototype.hasOwnProperty.call(it, ki)) itK[ki] = it[ki]; }
            itK.m = mK; itK.sockel = sockelH;
            it = itK;
          }
          /* Die Geschirrspuelerfront: Lage aus K.gsLage (vollintegriert oben buendig, teilintegriert unten an der Tuer mit
             der Bedienleiste darueber), darunter der Geraetesockel — wie in 2D und im PDF. */
          var gsL = zl === 'boden' && it.m.funktion === 'geschirrspuelerfront'
            ? (K.gsLage ? K.gsLage(it.m, g) : { sockel: Math.max(0, g.korpus_hoehe - it.m.h), leiste: null }) : null;
          /* UNTEN BUENDIG (Betreiber 2026-09-29 mit Bildausschnitt: „تظهر الخزائن من الاسفل غير مستقيمة“): die Front
             (71,3 cm) sass oben buendig und endete 0,7 cm ueber den Nachbarfronten — der helle Sockel zeigte sich darunter
             als Stufe, in jeder Serie. Wie beim Einbau steht sie auf der Linie der Nachbarn und ist um diese 0,7 cm hoeher
             gezeichnet (die Fuge oben liegt unter der Platte). Nur das Bild — Artikel, Mass und Preis bleiben. */
          if (gsL && sockelH != null) {
            var gsDelta = gsL.sockel - sockelH;
            if (gsDelta > 0 && gsDelta < 3) {
              gsL = { unten: sockelH, h: gsL.h, sockel: sockelH, leiste: gsL.leiste ? [gsL.leiste[0] - gsDelta, gsL.leiste[1]] : null };
              if (!gsL.leiste) {
                var mG = {}; for (var kG in it.m) { if (Object.prototype.hasOwnProperty.call(it.m, kG)) mG[kG] = it.m[kG]; }
                mG.h = it.m.h + gsDelta;
                var itG = {}; for (var kI in it) { if (Object.prototype.hasOwnProperty.call(it, kI)) itG[kI] = it[kI]; }
                itG.m = mG; it = itG;
              }
            }
          }
          var gsLuecke = gsL ? gsL.sockel : 0;
          var y = zl === 'oben' ? g.haenge_unterkante + (it.off || 0)
                : (zl === 'aufsatz' ? g.hochschrank_hoehe + (it.off || 0) : gsLuecke + (it.sockel || 0));
          /* Mit Sockelleiste laeuft die Leiste auch unter der Geschirrspuelerfront durch (siehe
             unten); die graue buendige Platte gab es nur ohne sie. */
          if (gsLuecke && !mitLeiste) {
            /* Die Sockelblende des Geraets selbst: neutral dunkelgrau wie bei jedem Einbau-
               geschirrspueler — vorher ein Braun aus der Korpusfarbe (gesehen 2026-09-27). */
            var sockel = new T.Mesh(new T.BoxGeometry(it.b, gsLuecke, 1.8), mat('#3A3B3C', 0.55));
            sockel.position.set(it.x + it.b / 2, gsLuecke / 2, K.flucht() - 0.9);
            gr.add(sockel);
          }
          /* Jede Reihe hat ihre eigene Tiefe. Mit der Korpustiefe auch oben stünde ein
             Hängeschrank 52 cm tief im Raum, und der Eckhängeschrank bekäme zwei tiefe
             Schenkel statt zweier flacher. */
          var tz = zl === 'boden' ? t : (it.m.t || 32);
          var dz = K.stellTiefe(it, tz, zl);
          var flucht = zl === 'boden' ? K.flucht() : dz;
          var eL = K.eckL(z, wid, it, tz);
          if (eL) {
            /* Eckschrank: das Nennmaß beschreibt ein Quadrat (90 × 90), gebaut ist ein L —
               ein Schenkel an dieser Wand, einer um die Ecke. Ein voller Würfel zeigte dem
               Kunden eine 90 cm tiefe Wand aus Korpus statt zweier Fronten. */
            /* Drei Fehler an diesem L, gemessen und am Produktfoto des D90N geprueft:
               1. Der zweite Schenkel stand bei eL.x — eckL rechnet diese Kante aber mit der
                  Korpustiefe (47/52), gebaut wird er mit der Schenkelstaerke (59,5). Am Wandende
                  ragte er 12,5 cm (Velora, Glanzia) bzw. 7,5 cm (Livaro, Lunara) durch die
                  Nachbarwand.
               2. Beide Schenkel lagen im Eckquadrat UEBEREINANDER, mit zwei gleich hohen Deckeln
                  an derselben Stelle. Der zweite beginnt jetzt dort, wo der erste endet.
               3. Die Front sass am schmalen ENDE des zweiten Schenkels. Beim echten Schrank
                  sitzen die Tueren auf den beiden Innenseiten des L. */
            var sd = K.schenkel(it.b), et = K.nennTiefe(it.m);
            var amAnfang = eL.x <= it.x + 0.5;
            /* Rueckt die Nachbarreihe an ihre Wand (Wandversatz), liegt ihre Frontebene um so viel naeher an der Ecke —
               und mit ihr die Front des zweiten Schenkels: er wird um denselben Betrag duenner. */
            var sd2 = sd - Math.max(0, K.nennMass(it.m) - it.b);
            kasten(it.b, it.m.h, sd, gr, it.x, y, sd);
            kasten(sd2, it.m.h, et - sd, gr, amAnfang ? it.x : it.x + it.b - sd2, y, et,
              amAnfang ? 'px' : 'nx');
            /* Tuer 1 schaut in den Raum dieser Wand (zwischen dem zweiten Schenkel und dem Ende), Tuer 2 quer dazu. */
            var b1 = it.b - sd2, x1 = amAnfang ? it.x + sd2 + b1 / 2 : it.x + b1 / 2, b2 = et - sd;
            eckGriff(gr, x1, sd, 0, b1, it.m.h, y, false, true);
            eckGriff(gr, amAnfang ? it.x + sd2 : it.x + it.b - sd2, sd + b2 / 2, amAnfang ? Math.PI / 2 : -Math.PI / 2,
              b2, it.m.h, y, false, false);
            return;
          }
          /* Der Eck-HAENGEschrank ist kein L, sondern ein Diagonalschrank: zwei kurze Seiten an
             den Waenden, eine schraege Tuer quer ueber die Ecke, Boden und Deckel fuenfeckig — so
             zeigen ihn die Produktfotos. eckL gibt fuer ihn nie ein L zurueck (60 ist nicht
             breiter als 60 + 4), und ohne diesen Zweig entstand ein voller Wuerfel, 60 cm tief:
             doppelt so tief wie jeder Haengeschrank daneben. */
          if (zl !== 'boden' && it.eckseite && K.istEck(it.m)) {
            if (optikZ.eckOben === 'L') lEckOben(gr, it, y); else diagonalEck(gr, it, y);
            return;
          }
          if (istRegal(it.m)) { regal(gr, it, y, flucht); return; }
          if (gsL) {
            /* DAS GERAET HINTER DER FRONT (Betreiber 2026-09-27: „ان تكون الغسالة موجودة وليس فارغ بداخلها"): ein Edelstahl-
               gehaeuse in voller Reihentiefe statt eines leeren Korpus in Moebelfarbe; teilintegriert oben die Bedienleiste
               des Geraets mit Anzeige, Tasten und Griffmulde. */
            var gT = Math.max(20, dz - 0.4), gZ = Math.max(gT, flucht), gH = g.korpus_hoehe - 0.8 - gsLuecke;
            teil3(gr, new T.BoxGeometry(it.b - 0.6, gH, gT), edel, it.x + it.b / 2, gsLuecke + gH / 2, gZ - gT / 2);
            (gr.userData.koerper = gr.userData.koerper || []).push([it.x, gsLuecke, gZ - gT, it.x + it.b, g.korpus_hoehe, flucht + 0.2]);
            if (gsL.leiste) {
              /* Die Bedienleiste des Geraets: gebuerstete Blende mit Anzeige und Programmtasten (Bild), darunter die
                 Griffmulde mit Edelstahlkante — so sieht jeder teilintegrierte Geschirrspueler aus. */
              var lh = gsL.leiste[1] - gsL.leiste[0] - 0.6, lcy = gsL.leiste[0] + 0.3 + lh / 2, lz = flucht + 1.1;
              var bM = new T.MeshStandardMaterial({ color: '#ffffff', roughness: 0.3, metalness: 0.6 });
              var bB = bedienBild(); if (bB) bM.map = bB; else bM.color.set('#C9CDD0');
              spiegel(bM, 0.8);
              teil3(gr, rundKasten(it.b - 0.6, lh, 2.2, 0.6), bM, it.x + it.b / 2, lcy, lz);
              teil3(gr, new T.BoxGeometry(it.b * 0.5, 1.5, 0.7), dunkelMat, it.x + it.b / 2, gsL.leiste[0] + 1.5, lz + 0.9);
              teil3(gr, new T.BoxGeometry(it.b * 0.5, 0.35, 1.1), edelB(true, 1), it.x + it.b / 2, gsL.leiste[0] + 0.55, lz + 1.1);
            }
            fronten(gr, it, y, flucht);
            return;
          }
          kasten(it.b, it.m.h, dz, gr, it.x, y, flucht, null, true,
            zl === 'boden' && /spuelen_unterschrank|herdumbau/.test(it.m.funktion || ''));
          fronten(gr, it, y, flucht);
          if (/herdumbau|geraete_unterschrank|hochschrank_geraet/.test(it.m.funktion || '')) {
            geraetFront(gr, it, y, flucht);
          }
          /* SPUELE (R1, 2026-09-26): Becken in der Platte und Armatur — ohne sie war der
             Spuelenschrank im Bild ein Unterschrank wie jeder andere. Edelstahl wie der Backofen. */
          if (zl === 'boden' && it.m.funktion === 'spuelen_unterschrank') spuele(gr, it);
        });
      });

      /* KOCHFELD an jeder Kochstelle (K.kochstellen): auf dem Herdumbau / Backofen-Unterschrank oder,
         mit hohem Backofenschrank, auf den Schubladen daneben. Schwarze Glasplatte, vier Felder. */
      /* Schwarzes Glas mit Klarlack in einem feinen Edelstahlrahmen, vier Kochzonen (Kreis + Ring), vorn die Touch-
         Bedienung mit leuchtenden Punkten — so sieht jedes Glaskeramikfeld im Shop aus (Geraete echt, 2026-09-27). */
      var zonenMat = new T.MeshStandardMaterial({ color: '#59616A', roughness: 0.3, metalness: 0.25 });
      /* Das Kochfeld sitzt ueber seinem Schrank: rueckt die Reihe an die Wand, rueckt es mit. */
      var vK = K.wandVersatz ? K.wandVersatz(z, daten, wid, 'boden') : 0;
      K.kochstellen(z, daten, wid).forEach(function (it) {
        var kx = it.x + it.b / 2, ky = g.korpus_hoehe + g.arbeitsplatte_dicke, kb = Math.min(it.b - 2, 58);
        var rahmenK = new T.Mesh(new T.BoxGeometry(kb, 0.5, 51), edel);
        rahmenK.position.set(kx, ky + 0.25, 27 - vK); rahmenK.userData.durchlaessig = true; wg.add(rahmenK);
        var kochZonen = [[-14, -9, 7.5], [14, -9, 6], [-14, 9, 6], [14, 9, 8.5]];
        var kochBild = kochfeldBild(kb - 0.8, 50.2, kochZonen), kochMat = glasS;
        if (kochBild && glasS.clone) { kochMat = glasS.clone(); kochMat.color.set('#ffffff'); kochMat.map = kochBild; }
        var kf = new T.Mesh(new T.BoxGeometry(kb - 0.8, 0.8, 50.2), kochMat);
        kf.position.set(kx, ky + 0.5, 27 - vK); kf.userData.durchlaessig = true;
        wg.add(kf);
        /* Ohne Bild (kein Canvas): die Zonen als flache Ringe wie bisher. */
        if (!kochBild) kochZonen.forEach(function (pnt) {
          [[pnt[2] - 1.2, pnt[2]], [pnt[2] * 0.45 - 0.5, pnt[2] * 0.45]].forEach(function (r) {
            var zone = new T.Mesh(new T.RingGeometry(r[0], r[1], 36), zonenMat);
            zone.rotation.x = -Math.PI / 2;
            zone.position.set(kx + pnt[0], ky + 0.92, 27 - vK + pnt[1]); zone.userData.durchlaessig = true;
            wg.add(zone);
          });
        });
      });
      /* Die Sockelleiste als EIN Zug je Wand: Front, Ecke, Seitenstuecke, Inselrueckseite. */
      if (mitLeiste) {
        K.sockelStrecken(z, daten).filter(function (s) { return s.wand === wid; }).forEach(function (s) {
          /* Oberkante AN den Korpus (vorher 4 mm Fuge): buendig stehend zeigte die Fuge ihre helle Oberseite als gezackte Linie
             (Bildkritik 2026-09-30), auch 1 mm flimmerte noch punktiert an weissen Seiten. Oberseite der Leiste und Unterseite des
             Korpus liegen jetzt aufeinander — beide nur von innen sichtbar; die Tuerunterkante (2 mm davor) bleibt die Fuge. */
          var hL = sockelH;
          var lm = new T.Mesh(new T.BoxGeometry(s.x1 - s.x0, hL, s.z1 - s.z0),
            leisteMatFuer(Math.max(s.x1 - s.x0, s.z1 - s.z0), hL));
          lm.position.set((s.x0 + s.x1) / 2, hL / 2, (s.z0 + s.z1) / 2);
          /* Der Sockel ist auf jedem Foto hell (Glanzia/Lunara: immer weiss matt). Unter den
             Schraenken lag er im Schlagschatten und wirkte grau (gemessen 145 statt ~240). */
          /* Seit er buendig steht, empfaengt er Schatten (Hocker, Deko) — sonst endete ihr Schatten an seiner Oberkante. */
          lm.castShadow = true; lm.receiveShadow = true;
          wg.add(lm);
        });
      }
      schrankKontakt(wg, wid, z, daten, g);

      /* Bauliches im Raum: ohne Fenster, Tür und Heizkörper sähe der Kunde eine geschlossene
         Wand und könnte den gemeldeten Konflikt nicht nachvollziehen. Alle liegen in der
         lokalen x-Achse dieser Wandgruppe, z = 0 ist die Wandfläche. */
      var glas = new T.MeshStandardMaterial({ color: '#CFE0E6', roughness: 0.1, metalness: 0.1,
        transparent: true, opacity: 0.55 });
      var rahmen = mat(tok('--hm-bg', '#F5F1E7'), 0.7);
      K.aktiveMerkmale(z).filter(function (m) { return m.wand === wid; }).forEach(function (m) {
        var rt = 6, i;
        if (m.typ === 'fenster') {
          var f = K.fensterOeffnung(m, RH), fh = f.oben - f.unten;
          /* Phase 1: the real window in the opening of the wall (wall surface at -1 in wall coordinates). */
          if (hP1) {
            var fk = fensterKoerper(m.breite, f.unten, f.oben, ARCHITEKTUR.wand);
            fk.position.set(m.x + m.breite / 2, 0, -1);
            gr.add(fk);
            return;
          }
          /* TAGESLICHT (Realismus, 2026-09-28): hinter der Scheibe ein heller Himmel statt der Wand — ein Fenster,
             das leuchtet, macht aus einem Modell einen Raum. Unbeleuchtet (Grundmaterial) und ueber 1 hell: die Tonkurve
             nimmt es fast weiss, wie eine Kamera ein Fenster im Innenraum belichtet. */
          var fotoT = aussichtFuer(m.breite, fh);
          var himmel = new T.Mesh(new T.PlaneGeometry(m.breite, fh),
            new T.MeshBasicMaterial({ map: fotoT || himmelBild(), color: aussenFarbe(fotoT ? 1.9 : 2.4) }));
          himmel.position.set(m.x + m.breite / 2, m.hoehe + fh / 2, 0.6);
          himmel.userData.ohneSchatten = true; himmel.userData.durchlaessig = true;
          wg.add(himmel);
          var sch = new T.Mesh(new T.PlaneGeometry(m.breite, fh), glas);
          sch.position.set(m.x + m.breite / 2, m.hoehe + fh / 2, 1.2);
          wg.add(sch);
          /* Blendrahmen und Mittelpfosten: ohne sie wirkt die Scheibe wie ein Loch. DER RAHMEN GEHOERT ZUR FENSTERBREITE
             (Betreiber 2026-09-29: „الخزانة فوق حافة الشباك"): gemessen wird das Fenster samt Rahmen, und der Planer stellt die
             Haengeschraenke bis an diese Breite. Aussen herum gezeichnet lag der Rahmen 6 cm unter dem Nachbarschrank — der
             Schrank sass auf der Fensterkante, der linke Rahmen verschwand hinter ihm. Jetzt innen, die Bank ebenso. */
          [[m.breite, rt, m.x + m.breite / 2, m.hoehe + fh - rt / 2],
           [m.breite, rt, m.x + m.breite / 2, m.hoehe + rt / 2],
           [rt, fh - 2 * rt, m.x + rt / 2, m.hoehe + fh / 2],
           [rt, fh - 2 * rt, m.x + m.breite - rt / 2, m.hoehe + fh / 2],
           [2.5, fh - 2 * rt, m.x + m.breite / 2, m.hoehe + fh / 2]].forEach(function (r) {
            var b = new T.Mesh(new T.BoxGeometry(r[0], r[1], 4), rahmen);
            b.position.set(r[2], r[3], 2);
            gr.add(b);
          });
          var bank = new T.Mesh(new T.BoxGeometry(m.breite, 3, 14), mat(tok('--hm-line', '#E4DDCE'), 0.6));
          bank.position.set(m.x + m.breite / 2, m.hoehe - 1.5, 7);
          gr.add(bank);
        } else if (m.typ === 'tuer') {
          var zarge = new T.Mesh(new T.PlaneGeometry(m.breite, m.hoehe), mat(tok('--hm-tx2', '#8C8880'), 0.9));
          zarge.position.set(m.x + m.breite / 2, m.hoehe / 2, 1.2);
          gr.add(zarge);
          [[m.breite + rt * 2, rt, m.x + m.breite / 2, m.hoehe + rt / 2],
           [rt, m.hoehe, m.x - rt / 2, m.hoehe / 2],
           [rt, m.hoehe, m.x + m.breite + rt / 2, m.hoehe / 2]].forEach(function (r) {
            var b2 = new T.Mesh(new T.BoxGeometry(r[0], r[1], 5), rahmen);
            b2.position.set(r[2], r[3], 2.5);
            gr.add(b2);
          });
        } else if (m.typ === 'spueler') {
          /* EIGENER GESCHIRRSPUELER (Betreiber 2026-09-26): in der Nische steht das Geraet des Kunden.
             Bisher eine leere Nische (Boden und zwei Wangen) — im Bild ein Loch in der Kueche. Jetzt
             eine neutrale Geraetetuer: Edelstahlgrau, Bedienleiste oben, Griffleiste, dunkle
             Sockelblende. Antippen waehlt die Nische ('stell|<id>'), wie einen Schrank. */
          /* Zweite Runde (2026-09-27): gebuersteter Edelstahl mit gefasten Kanten, Bedienleiste mit Anzeige und
             Programmtasten, Griffmulde, dunkle Dichtfuge, Sockelblende. */
          var sh = Math.min(m.hoehe, g.korpus_hoehe), st = K.flucht();
          var sG = Math.min(sockelH, sh * 0.25), cx = m.x + m.breite / 2, tb = Math.max(1, m.breite - 0.6);
          var gs = new T.Group();
          gs.userData.sel = 'stell|' + m.id;
          /* Die Nische gehoert zur Bodenreihe: sie rueckt mit ihr an die Wand (Wandversatz). */
          gs.position.z = -(K.wandVersatz ? K.wandVersatz(z, daten, wid, 'boden') : 0);
          var bl = 9, tH = sh - sG - bl - 0.6;
          teil3(gs, new T.BoxGeometry(tb - 0.6, sh - sG - 0.4, st - 3), new T.MeshStandardMaterial({ color: '#2a2c2e', roughness: 0.6, metalness: 0.4 }),
            cx, sG + (sh - sG) / 2, (st - 3) / 2);
          teil3(gs, rundKasten(tb, tH, 2.6, 0.9), edelB(true, 1), cx, sG + tH / 2, st - 1.2);
          var leisteM = new T.MeshStandardMaterial({ color: '#ffffff', roughness: 0.3, metalness: 0.6 });
          var bb = bedienBild(); if (bb) leisteM.map = bb; else leisteM.color.set('#C9CDD0');
          spiegel(leisteM, 0.8);
          teil3(gs, rundKasten(tb, bl, 2.6, 0.6), leisteM, cx, sG + tH + 0.6 + bl / 2, st - 1.2);
          teil3(gs, new T.BoxGeometry(tb * 0.55, 1.6, 0.8), new T.MeshStandardMaterial({ color: '#0d0e0f', roughness: 0.8 }), cx, sG + tH - 1.4, st + 0.05);
          teil3(gs, new T.BoxGeometry(tb * 0.55, 0.35, 1.2), edelB(true, 1), cx, sG + tH - 0.4, st + 0.3);
          teil3(gs, new T.BoxGeometry(tb, sG, 1.5), mat('#2E3032', 0.6), cx, sG / 2, st - 4);
          gr.add(gs);
          schrankGruppen[gs.userData.sel] = gs;
        } else if (m.typ === 'kuehl') {
          /* EIGENER KUEHLSCHRANK (2026-09-26): in der raumhohen Nische steht das freistehende Geraet des
             Kunden — weiss, Gefrierteil unten, zwei Griffe, ein Stueck vor der Schrankflucht wie echte
             Standgeraete. Kein Moebel und kein Loch. Antippen waehlt die Nische ('stell|<id>'). */
          /* Echt statt Kasten (2026-09-27, zweite Runde nach „ليسو واقعيين"): Korpus in Seitenlack, zwei Tueren mit
             gerundeten, gefasten Kanten und dunkler Dichtung dahinter, Kuehlteil oben und Gefrierteil unten, lange Stabgriffe
             auf Stuetzen, Anzeige mit Temperatur, Scharnierabdeckung oben, Sockelblende mit Lueftungsschlitzen, Stellfuesse.
             Farbe Weiss / Schwarz / Grau (gebuersteter Edelstahl) aus wunsch.kuehlFarbe. */
          var kfl = K.flucht(), kh3 = Math.min(186, (+m.hoehe || 200) - 4), kb3 = Math.max(1, m.breite - 1.2);
          var tT = 5.5, ktf = kfl + 4, kcx = m.x + m.breite / 2, kFuss = 1.2, kSock = 7;
          var ks = new T.Group();
          ks.userData.sel = 'stell|' + m.id;
          ks.position.z = -(K.wandVersatz ? K.wandVersatz(z, daten, wid, 'boden') : 0);
          var kf3 = kuehlFarbe(), kTuerLack = kuehlLack(kf3, false), kSeite = kuehlLack(kf3, true);
          var kGriffMat = kf3 === 'schwarz' ? spiegel(new T.MeshStandardMaterial({ color: '#3E4246', roughness: 0.25, metalness: 0.9 }), 1) : edelB(false, 1);
          var dicht = new T.MeshStandardMaterial({ color: '#0d0e0f', roughness: 0.8, metalness: 0 });
          var hK = kh3 - kSock;
          teil3(ks, new T.BoxGeometry(kb3 - 0.4, hK, ktf - tT - 0.8), kSeite, kcx, kFuss + kSock + hK / 2, (ktf - tT - 0.8) / 2);
          var hU = Math.round(hK * 0.36), hO = hK - hU - 0.6;
          var tuerAn = function (y0, h0) {
            teil3(ks, new T.BoxGeometry(kb3 - 1.2, h0 - 1.2, 0.8), dicht, kcx, y0 + h0 / 2, ktf - tT - 0.4);
            teil3(ks, rundKasten(kb3, h0, tT, 1.6), kTuerLack, kcx, y0 + h0 / 2, ktf - tT / 2);
          };
          tuerAn(kFuss + kSock, hU);
          tuerAn(kFuss + kSock + hU + 0.6, hO);
          /* Stabgriffe: Kapsel auf zwei Stuetzen, an der Seite gegenueber den Scharnieren. */
          var griff = function (cy, lang) {
            var gx = m.x + m.breite - 4.5, gz = ktf + 2.4;
            var st = T.CapsuleGeometry ? new T.CapsuleGeometry(0.95, lang - 1.9, 6, 16) : new T.CylinderGeometry(0.95, 0.95, lang, 16);
            teil3(ks, st, kGriffMat, gx, cy, gz);
            [-1, 1].forEach(function (sg) {
              var h1 = teil3(ks, new T.CylinderGeometry(0.55, 0.65, 2.6, 14), kGriffMat, gx, cy + sg * (lang / 2 - 3), ktf + 1.1);
              h1.rotation.x = Math.PI / 2;
            });
          };
          griff(kFuss + kSock + hU + 0.6 + 32, 44);
          griff(kFuss + kSock + hU - 13, 22);
          /* Anzeige in Augenhoehe auf der oberen Tuer. */
          teil3(ks, new T.BoxGeometry(11, 3.2, 0.3), leuchtAnzeige('4 °C'), kcx - kb3 / 2 + 11, Math.min(kFuss + kh3 - 26, 152), ktf + 0.05);
          /* Scharnierabdeckung oben, Sockelblende mit Schlitzen, Stellfuesse. */
          teil3(ks, rundKasten(6, 1.6, 4, 0.5), dicht, m.x + 5.5, kFuss + kh3 + 0.4, ktf - tT / 2);
          teil3(ks, new T.BoxGeometry(kb3 - 1, kSock - 0.6, 1.2), dicht, kcx, kFuss + kSock / 2, ktf - 3);
          for (var sl = -4; sl <= 4; sl++) teil3(ks, new T.BoxGeometry(3.4, 0.7, 0.3), kf3 === 'schwarz' ? tasteMat : new T.MeshStandardMaterial({ color: '#2a2c2e', roughness: 0.7 }),
            kcx + sl * 5.4, kFuss + kSock / 2, ktf - 2.3);
          [[-1, 1], [1, 1], [-1, -1], [1, -1]].forEach(function (f) {
            teil3(ks, new T.CylinderGeometry(1.4, 1.6, kFuss + 0.2, 12), dicht, kcx + f[0] * (kb3 / 2 - 4), kFuss / 2, f[1] > 0 ? ktf - 8 : 6);
          });
          gr.add(ks);
          schrankGruppen[ks.userData.sel] = ks;
        } else if (m.typ === 'heizkoerper') {
          var hh = Math.max(20, m.hoehe - 12);
          var hk = new T.Mesh(new T.BoxGeometry(m.breite, hh, 9), mat('#EFE9DD', 0.55));
          hk.position.set(m.x + m.breite / 2, m.hoehe - hh / 2, 5.5);
          gr.add(hk);
          /* Rippen als flache Platten, damit der Körper nicht wie ein Kasten wirkt. */
          for (i = 4; i < m.breite - 3; i += 6) {
            var ri = new T.Mesh(new T.BoxGeometry(1.4, hh - 3, 11), mat(tok('--hm-line', '#E4DDCE'), 0.6));
            ri.position.set(m.x + i, m.hoehe - hh / 2, 6.5);
            gr.add(ri);
          }
        }
      });

      /* DUNSTABZUG UEBER DEM HERD (R1). Haengt dort ein flacher Haengeschrank (der Schrank ueber der
         Haube), sitzt darunter eine Unterbauhaube; ist darueber frei (Livaro fuehrt keinen Dunst-
         Haengeschrank, der Kern laesst dort die Luecke), steht eine Kaminhaube bis zur Decke. Steht
         ein normaler Haengeschrank darueber, bleibt das die Planung des Kunden. Eine als Geraet
         eingetragene Haube (Merkmal) hat Vorrang und wird oben gezeichnet. */
      var hatHaube = K.aktiveMerkmale(z).some(function (m) { return m.typ === 'haube' && m.wand === wid; });
      if (!hatHaube) {
        var obenIt = K.items(z, daten, wid, 'oben');
        K.kochstellen(z, daten, wid).forEach(function (h) {
          var drueber = obenIt.filter(function (o) { return o.x < h.x + h.b - 2 && o.x + o.b > h.x + 2; });
          var hbB = Math.min(60, h.b), hx = h.x + h.b / 2;
          if (!drueber.length) {
            var uk = g.korpus_hoehe + g.arbeitsplatte_dicke + 65, kh = Math.max(20, (hoeheJetzt || 250) - uk - 12);
            /* SCHRAEGHAUBE (Betreiber 2026-09-27: „Formen wie in meinen fertigen Kuechen"). Alle elf
               Livaro-Komplettkuechen — und die Serienfotos der anderen Serien — zeigen eine schwarze
               Glas-Schraeghaube mit schwarzem Kamin und zwei Lichtpunkten, keinen Edelstahlkasten. */
            var hGlas = T.MeshPhysicalMaterial
              ? new T.MeshPhysicalMaterial({ color: '#0C0D0E', roughness: 0.06, metalness: 0.1, clearcoat: 1, clearcoatRoughness: 0.03,
                  envMapIntensity: 0.25 })
              : new T.MeshStandardMaterial({ color: '#0C0D0E', roughness: 0.08, metalness: 0.2 });
            var hMatt = new T.MeshStandardMaterial({ color: '#17181A', roughness: 0.45, metalness: 0.3 });
            var neig = Math.atan2(30, 42), lang2 = Math.hypot(30, 42);
            var glasP = new T.Mesh(new T.BoxGeometry(hbB, lang2, 1), hGlas);
            glasP.rotation.x = -neig;
            glasP.position.set(hx, uk + 6 + 21, 6 + 15); gr.add(glasP);
            var boden2 = new T.Mesh(new T.BoxGeometry(hbB, 6, 36), hMatt);
            boden2.position.set(hx, uk + 3, 18); gr.add(boden2);
            [-1, 1].forEach(function (sg) {
              var spot = new T.Mesh(new T.CylinderGeometry(1.6, 1.6, 0.4, 16),
                new T.MeshStandardMaterial({ color: '#FFF4E0', emissive: '#FFE7C2', emissiveIntensity: 6 }));
              spot.position.set(hx + sg * hbB / 4, uk - 0.1, 24); spot.userData.ohneSchatten = true; gr.add(spot);
            });
            var kh2 = Math.max(10, (hoeheJetzt || 250) - (uk + 48));
            var kamin = new T.Mesh(new T.BoxGeometry(24, kh2, 22), hMatt);
            kamin.position.set(hx, uk + 48 + kh2 / 2, 11); gr.add(kamin);
          } else if (drueber.length === 1 && drueber[0].m.h <= 40) {
            var o0 = drueber[0], hb0 = g.haenge_unterkante + (o0.off || 0);
            var unterbau = new T.Mesh(new T.BoxGeometry(hbB, 6, Math.max(28, (o0.m.t || 32) - 2)), stahl);
            unterbau.position.set(hx, hb0 - 3, Math.max(28, (o0.m.t || 32) - 2) / 2); gr.add(unterbau);
          }
        });
      }

      /* DIE ARBEITSPLATTE kommt aus K.plattenStuecke — denselben Stuecken, die bepreist und
         bestellt werden. Bis 2026-09-26 lief hier eine Platte vom kleinsten bis zum groessten x
         der Bodenreihe: ueber jeden Hochschrank hinweg und ueber Luecken, und der Eckschenkel
         brauchte ein eigenes Zusatzstueck. Die Stuecke kennen Hochschraenke, Luecken, Ecken
         (die Eckschrank-Wand laeuft durch, die andere stoesst bei 60 an) und den Stoss ueber
         400 cm — im Bild sieht der Kunde, was er kauft. */
      var pt = K.platteTiefe();
      var spuelLoecher = K.items(z, daten, wid, 'boden').filter(function (it) {
        return it.m.funktion === 'spuelen_unterschrank';
      }).map(spuelMass);
      K.plattenStuecke(z, daten, true).filter(function (s) { return s.wand === wid; }).forEach(function (s) {
        var loecher = spuelLoecher.filter(function (o) { return o.cx - o.b / 2 > s.von + 2 && o.cx + o.b / 2 < s.bis - 2; });
        var pl;
        if (loecher.length) {
          pl = new T.Mesh(platteMitLoch(s, loecher), platteFuer(s));
          pl.position.set(s.von, g.korpus_hoehe + g.arbeitsplatte_dicke, 0);
        } else {
          pl = new T.Mesh(plattenKantenUV(new T.BoxGeometry(s.bis - s.von, g.arbeitsplatte_dicke, pt),
            s.bis - s.von, (s.bis - s.von) / 2, -g.arbeitsplatte_dicke / 2, pt / 2, !!platteMat.userData.bib), platteFuer(s));
          pl.position.set((s.von + s.bis) / 2, g.korpus_hoehe + g.arbeitsplatte_dicke / 2, pt / 2);
        }
        pl.userData.durchlaessig = true;
        gr.add(pl);
        /* Stoss zwischen zwei Stuecken: eine feine dunkle Fuge, wie im echten Zuschnitt. */
        if (s.enden.rechts === 'stoss') {
          var fu = new T.Mesh(new T.BoxGeometry(0.3, 0.2, pt), fugeMat);
          fu.position.set(s.bis, g.korpus_hoehe + g.arbeitsplatte_dicke + 0.05, pt / 2);
          gr.add(fu);
        }
      });
      /* NISCHENRUECKWAND UND LICHT UNTER DEN HAENGESCHRAENKEN (Betreiber 2026-09-27: „ja, ich will
         sie, sie machen das Bild schoener"). Beides zeigen die Serienfotos des Shops; beides ist
         Raumbild, keine Ware — bepreist wird allein aus dem Plan. Nur an Waenden, nicht an der Insel. */
      if (!(raum.bloecke || []).some(function (b) { return b.id === wid; })) rueckwandUndLicht(gr, wid);
      /* Die INSEL steht frei: ihre Rueckseite sieht jeder. Bisher waren dort die nackten
         Rueckwaende der Korpusse — der Betreiber: „die Insel sieht in 3D nicht gut aus". Eine
         Blende in Frontfarbe ueber die ganze Strecke, von der Sockelhoehe bis unter die Platte. */
      /* Nicht bei der Doppelinsel: dort steht hinter jeder Reihe die andere — die Blende laege IN ihr
         und flimmerte an den Stirnseiten als gestreifter Strich (Betreiber 2026-09-28). */
      if ((raum.bloecke || []).some(function (b) { return b.id === wid; }) && !K.inselOhnePlatte(z)) {
        var inselBo = K.items(z, daten, wid, 'boden');
        if (inselBo.length) {
          var ix0 = Infinity, ix1 = -Infinity;
          inselBo.forEach(function (x) { ix0 = Math.min(ix0, x.x); ix1 = Math.max(ix1, x.x + x.b); });
          var hR = g.korpus_hoehe - sockelH, bR = ix1 - ix0;
          var rw = new T.Mesh(new T.BoxGeometry(bR, hR, 1.8), frontMat(bR, hR));
          rw.position.set(ix0 + bR / 2, sockelH + hR / 2, -0.9);
          gr.add(rw);
        }
      }
      /* Phase 1: wall decals (contact seam, LED glow) are cut where a customer window opens this wall. */
      if (hP1) {
        var loecherG = K.aktiveMerkmale(z).filter(function (m) { return m.wand === wid && m.typ === 'fenster' && m.breite > 0; }).map(function (m) {
          var fo = K.fensterOeffnung(m, RH); return { x0: m.x, x1: m.x + m.breite, y0: fo.unten, y1: fo.oben };
        });
        if (loecherG.length) gr.children.slice().forEach(function (o) {
          if (o.isMesh && o.material && o.material.transparent && (o.userData.kontaktArt === 'wand' || o.renderOrder === 2)) decalOhneLoecher(o, loecherG);
        });
      }
    };
    /* DEKO (R1 Realismus, 2026-09-27). Jede Komplettkueche im Shop ist mit ein paar Dingen auf
       der Platte fotografiert — eine Pflanze, Bretter an der Wand, eine Schale. Ohne sie wirkt die
       Kueche wie ein Modell, nicht wie ein Raum. Gesetzt wird nur auf FREIE Plattenstrecken
       (nie auf Spuele oder Kochfeld, Abstand zu Ecken und Enden), fest je Wand und Stelle, damit
       dieselbe Kueche immer gleich aussieht. Alles ist `durchlaessig`: ein Tipper darauf meint den
       Schrank darunter. Kein Teil davon ist Ware; bepreist wird allein aus dem Plan. */
    var dekoM = {
      keramik: new T.MeshStandardMaterial({ color: '#F1EEE8', roughness: 0.42, metalness: 0 }),
      salbei: new T.MeshStandardMaterial({ color: '#9AA79A', roughness: 0.5, metalness: 0 }),
      erde: new T.MeshStandardMaterial({ color: '#3B2E25', roughness: 1 }),
      holz: new T.MeshStandardMaterial({ color: '#ffffff', roughness: 0.62, metalness: 0,
        map: (function () { var tx = maserung('#B48D66', false).clone(); tx.needsUpdate = true; tx.repeat.set(0.6, 0.35); return tx; })() }),
      blatt: ['#4B6B38', '#3A5A2C', '#62813F', '#56753A'].map(function (c) {
        return new T.MeshStandardMaterial({ color: c, roughness: 0.65, metalness: 0 });
      }),
      obst: ['#E8892B', '#C9452B', '#E3C54B', '#E8892B', '#9DB04A'].map(function (c) {
        return new T.MeshStandardMaterial({ color: c, roughness: 0.45, metalness: 0 });
      })
    };
    var dekoZufall = function (saat) {
      var s = Math.abs(Math.floor(saat)) % 2147483646 + 1;
      return function () { s = (s * 16807) % 2147483647; return (s - 1) / 2147483646; };
    };
    var dekoTeil = function (gruppe, geo, m, x, y, zz) {
      var me = new T.Mesh(geo, m);
      me.position.set(x, y, zz);
      me.userData.durchlaessig = true; me.userData.deko = true;
      gruppe.add(me);
      return me;
    };
    /* Ein echtes Modell setzen: Meter → cm mal `massstab`, gedreht (`drehe`), Boden auf die Platte, Mitte
       auf x/zz — oder mit der Rueckseite bei `wandZ` an die Rueckwand gelehnt. */
    var echtSetzen = function (gruppe, sz, x, y, zz, massstab, drehY, drehe, wandZ) {
      var k = sz.clone(true);
      k.scale.setScalar(100 * massstab);
      if (drehe) drehe(k);
      k.updateMatrixWorld(true);
      var bx = new T.Box3().setFromObject(k);
      k.position.x -= (bx.min.x + bx.max.x) / 2;
      k.position.y -= bx.min.y;
      k.position.z -= wandZ != null ? bx.min.z - wandZ : (bx.min.z + bx.max.z) / 2;
      var aussen = new T.Group();
      aussen.position.set(x, y, wandZ != null ? 0 : zz);
      aussen.rotation.y = drehY || 0;
      aussen.add(k);
      aussen.traverse(function (o) { o.userData.durchlaessig = true; o.userData.deko = true; });
      aussen.userData.dekoStueck = true;
      /* Nur fuer Stuecke, die auf der Platte STEHEN — nicht fuer Zweige in der Vase, Loeffel im Topf oder angelehnte Bretter
         (gedreht eingesetzt): deren Schatten hing sonst als helle Flaeche in der Luft (gesehen 2026-09-29, L rechts). */
      if (!gruppe.userData.dekoStueck && !drehe) {
        var sb = bx.max.x - bx.min.x, st2 = bx.max.z - bx.min.z;
        kontaktSchatten(aussen, sb, st2, 0, 0, wandZ != null ? wandZ + st2 / 2 : 0);
      }
      gruppe.add(aussen);
      return aussen;
    };
    var pflanze = function (gruppe, x, zz, top, saat) {
      var echt = dekoModell('pflanze');
      if (echt === 'warten') return;
      if (echt) { echtSetzen(gruppe, echt, x, top, zz, 0.46, dekoZufall(saat)() * Math.PI * 2); return; }
      var zu = dekoZufall(saat);
      dekoTeil(gruppe, new T.CylinderGeometry(7.5, 6, 15, 28), dekoM.keramik, x, top + 7.5, zz);
      dekoTeil(gruppe, new T.CylinderGeometry(7, 7, 0.6, 20), dekoM.erde, x, top + 14.6, zz);
      /* Laub aus gedrueckten Kugeln rund um einen gedachten Stiel — aus der Entfernung der
         Kamera liest sich das als Pflanze, nicht als Kugelhaufen. */
      for (var i = 0; i < 22; i++) {
        var hh = 16 + zu() * 22, a = zu() * Math.PI * 2, r = 2 + zu() * (4 + (hh - 16) * 0.35);
        var bl = dekoTeil(gruppe, new T.IcosahedronGeometry(1, 1), dekoM.blatt[i % dekoM.blatt.length],
          x + Math.cos(a) * r, top + hh, zz + Math.sin(a) * r * 0.8);
        bl.scale.set(4.5 + zu() * 2, 1.4 + zu(), 2.4 + zu());
        bl.rotation.set(zu() * 0.8 - 0.4, a, zu() * 0.9 - 0.45);
      }
    };
    var bretter = function (gruppe, x, top) {
      var echt = dekoModell('brett');
      if (echt === 'warten') return;
      if (echt) {
        /* Hochkant an die Rueckwand gelehnt: Laenge senkrecht, Flaeche zum Raum, oben leicht zur Wand. */
        echtSetzen(gruppe, echt, x + 8, top, 0, 0.95, 0, function (k) {
          k.rotateOnWorldAxis(new T.Vector3(0, 0, 1), Math.PI / 2);
          k.rotateOnWorldAxis(new T.Vector3(0, 1, 0), Math.PI / 2);
          k.rotateOnWorldAxis(new T.Vector3(1, 0, 0), -0.12);
        }, 1.4);
        return;
      }
      var b1 = dekoTeil(gruppe, new T.BoxGeometry(28, 42, 1.8), dekoM.holz, x, top + 20.6, 3.2);
      b1.rotation.x = -0.1;
      var b2 = dekoTeil(gruppe, new T.CylinderGeometry(13, 13, 1.6, 36), dekoM.holz, x + 17, top + 13, 5.2);
      b2.rotation.set(Math.PI / 2 - 0.12, 0, 0);
    };
    var dosen = function (gruppe, x, top) {
      var echt = dekoModell('krug');
      if (echt === 'warten') return;
      if (echt) { echtSetzen(gruppe, echt, x + 12, top, 14, 0.8, -0.5); return; }
      [[0, 19, dekoM.keramik], [12.5, 15, dekoM.salbei], [24, 11, dekoM.keramik]].forEach(function (d) {
        dekoTeil(gruppe, new T.CylinderGeometry(5.3, 5.3, d[1], 28), d[2], x + d[0], top + d[1] / 2, 11);
        dekoTeil(gruppe, new T.CylinderGeometry(5.5, 5.5, 1.6, 28), dekoM.holz, x + d[0], top + d[1] + 0.8, 11);
      });
    };
    var schale = function (gruppe, x, zz, top, saat) {
      var sm = dekoModell('schale'), am = dekoModell('apfel'), lm = dekoModell('limette');
      if (sm === 'warten' || am === 'warten' || lm === 'warten') return;
      if (sm && am && lm) {
        /* Holzschale mit zwei Aepfeln und zwei Limetten — das Obst dreht mit der Schale. */
        var zuE = dekoZufall(saat), schaleG = echtSetzen(gruppe, sm, x, top, zz, 0.85, zuE() * Math.PI * 2);
        [[am, -4.2, -2.4, 0.78], [am, 4.2, 2.1, 0.76], [lm, 1.2, -6.0, 0.95], [lm, -2.8, 5.2, 0.95]].forEach(function (f) {
          var o = echtSetzen(schaleG, f[0], f[1], 1.3, f[2], f[3], zuE() * Math.PI * 2);
          o.rotation.x = (zuE() - 0.5) * 0.4; o.rotation.z = (zuE() - 0.5) * 0.4;
        });
        return;
      }
      var zu = dekoZufall(saat), prof = [];
      for (var i = 0; i <= 8; i++) {
        var t0 = i / 8;
        prof.push(new T.Vector2(4 + Math.sin(t0 * Math.PI / 2) * 11, t0 * t0 * 7.5));
      }
      var geo = new T.LatheGeometry(prof, 40);
      var sh = dekoTeil(gruppe, geo, dekoM.keramik, x, top + 0.2, zz);
      sh.material = dekoM.keramik.clone(); sh.material.side = T.DoubleSide;
      [[0, 0], [5.5, 1.5], [-5, 2.5], [1.5, -5.5], [-1.5, 5]].forEach(function (o, i) {
        dekoTeil(gruppe, new T.SphereGeometry(3.4 + zu() * 0.8, 20, 14), dekoM.obst[i],
          x + o[0], top + 5.5 + (i ? 0 : 2.5), zz + o[1]);
      });
    };
    /* Freie Strecken der Platte an einer Wand: Stuecke minus Spuele und Kochfeld, mit Abstand
       zu Ecken (die Nachbarwand setzt dort) und zu offenen Enden. */
    var freiePlatte = function (wid) {
      var sperr = K.items(z, daten, wid, 'boden').filter(function (it) {
        return /spuelen_unterschrank/.test(it.m.funktion || '');
      }).concat(K.kochstellen(z, daten, wid)).map(function (it) { return [it.x - 4, it.x + it.b + 4]; });
      var frei = [];
      K.plattenStuecke(z, daten, true).filter(function (s) { return s.wand === wid; }).forEach(function (s) {
        /* 10 cm Abstand an jedem Ende, auch an der Ecke: die Platte der Nachbarwand beginnt erst hinter
           dem Eckquadrat (plattenStuecke), die Stuecke ueberlappen nie. Mit 70 cm an der Ecke blieb auf
           der kurzen Wand neben Herd und Ecke nichts frei (Betreiber 2026-09-27: dort fehlte Deko). */
        var a = s.von + 10, b = s.bis - 10;
        var teile2 = [[a, b]];
        sperr.forEach(function (sp) {
          var neu = [];
          teile2.forEach(function (tt) {
            if (sp[1] <= tt[0] || sp[0] >= tt[1]) { neu.push(tt); return; }
            if (sp[0] > tt[0]) neu.push([tt[0], sp[0]]);
            if (sp[1] < tt[1]) neu.push([sp[1], tt[1]]);
          });
          teile2 = neu;
        });
        teile2.forEach(function (tt) { if (tt[1] - tt[0] >= 20) frei.push(tt); });
      });
      frei.herd = K.kochstellen(z, daten, wid).map(function (it) { return it.x + it.b / 2; });
      frei.sort(function (p, q) { return (q[1] - q[0]) - (p[1] - p[0]); });
      return frei;
    };
    /* Das Ende einer freien Strecke, das WEITER vom Kochfeld weg liegt — keine Pflanze neben
       dem Herd (gesehen 2026-09-27 in der geraden Kueche). */
    var herdFern = function (frei, tt, abstand) {
      var d = function (x) {
        return frei.herd.reduce(function (m, h) { return Math.min(m, Math.abs(h - x)); }, Infinity);
      };
      return d(tt[0]) >= d(tt[1]) ? tt[0] + abstand : tt[1] - abstand;
    };
    var dekoWand = 0;
    var deko = function (gruppe, wid, insel) {
      var top = g.korpus_hoehe + g.arbeitsplatte_dicke, pt2 = K.platteTiefe();
      var frei = freiePlatte(wid), saat = wid.charCodeAt(0) * 131;
      if (!frei.length) return;
      if (insel) {
        var fi = frei[0];
        schale(gruppe, (fi[0] + fi[1]) / 2, pt2 / 2, top, saat);
        return;
      }
      var nr = dekoWand++;
      var f0 = frei[0], lang = f0[1] - f0[0];
      /* Eine kurze Strecke traegt nur eine kleine Pflanze (Topf 15 cm). */
      if (lang < 40) { pflanze(gruppe, (f0[0] + f0[1]) / 2, 22, top, saat); return; }
      if (nr % 3 === 0) {
        var xp = herdFern(frei, f0, 14);
        pflanze(gruppe, xp, 22, top, saat);
        if (lang >= 110) bretter(gruppe, xp < (f0[0] + f0[1]) / 2 ? f0[1] - 36 : f0[0] + 18, top);
      } else if (nr % 3 === 1) {
        if (lang >= 40) dosen(gruppe, f0[0] + 10, top);
        if (lang >= 110) schale(gruppe, f0[1] - 22, 30, top, saat);
      } else {
        pflanze(gruppe, (f0[0] + f0[1]) / 2, 22, top, saat);
      }
      /* Eine zweite freie Strecke bekommt hoechstens eine Pflanze. */
      if (frei[1] && frei[1][1] - frei[1][0] >= 60 && nr % 3 !== 2) {
        pflanze(gruppe, herdFern(frei, frei[1], 14), 22, top, saat + 7);
      }
    };
    /* PENDELLEUCHTEN UEBER DER INSEL — wie in den Serienfotos; nur in der freien Perspektive
       (in Draufsicht und Frontansicht verdeckten sie, was der Kunde dort sehen will). */
    var leuchten = new T.Group();
    leuchten.userData.pendel = true;
    root.add(leuchten);
    pendelGruppe = leuchten;
    var pendel = function (gruppe, wid) {
      var bo = K.items(z, daten, wid, 'boden');
      if (!bo.length) return;
      var x0 = Infinity, x1 = -Infinity;
      bo.forEach(function (it) { x0 = Math.min(x0, it.x); x1 = Math.max(x1, it.x + it.b); });
      var n = x1 - x0 >= 180 ? 3 : 2, uk = gSerie.korpus_hoehe + gSerie.arbeitsplatte_dicke + 75;
      var schwarzM = new T.MeshStandardMaterial({ color: '#1F1F1F', roughness: 0.4, metalness: 0.6 });
      var licht = new T.MeshStandardMaterial({ color: '#FFF3DA', emissive: '#FFE2B0', emissiveIntensity: 5 });
      /* Der Pfadverfolger liest den Schattenwurf am MATERIAL (`castShadow`), nicht am Mesh. */
      schwarzM.castShadow = false; licht.castShadow = false;
      /* Zum Hochglanz-Raum Glasleuchten: klares Glas um einen warmen Leuchtkern (Vorlage). */
      var glasP = null;
      if (RAUM_GLANZ && T.MeshPhysicalMaterial) {
        glasP = new T.MeshPhysicalMaterial({ color: '#ffffff', roughness: 0.04, metalness: 0, transmission: 1,
          thickness: 0.4, ior: 1.5, side: T.DoubleSide });
        glasP.castShadow = false;
      }
      for (var i = 0; i < n; i++) {
        var x = x0 + (x1 - x0) * (i + 0.5) / n, zz = K.platteTiefe() / 2;
        if (glasP) {
          var glas2 = new T.Mesh(new T.CylinderGeometry(11, 11, 16, 40, 1, true), glasP);
          glas2.position.set(x, uk + 8, zz); glas2.userData.ohneSchatten = true; gruppe.add(glas2);
          var deckel = new T.Mesh(new T.CylinderGeometry(11, 11, 0.6, 40), glasP);
          deckel.position.set(x, uk + 16, zz); deckel.userData.ohneSchatten = true; gruppe.add(deckel);
          var kernM = licht.clone(); kernM.emissiveIntensity = 6; kernM.castShadow = false;
          var kern = new T.Mesh(new T.CylinderGeometry(3.4, 3.4, 12, 20), kernM);
          kern.position.set(x, uk + 8, zz); kern.userData.ohneSchatten = true; gruppe.add(kern);
          var fassung = new T.Mesh(new T.CylinderGeometry(2.2, 2.2, 3, 16), schwarzM);
          fassung.position.set(x, uk + 17.5, zz); fassung.userData.ohneSchatten = true; gruppe.add(fassung);
          var kabelG = new T.Mesh(new T.CylinderGeometry(0.25, 0.25, Math.max(10, RH - uk - 19), 6), schwarzM);
          kabelG.position.set(x, uk + 19 + Math.max(10, RH - uk - 19) / 2, zz);
          kabelG.userData.ohneSchatten = true; gruppe.add(kabelG);
          continue;
        }
        var schirm = new T.Mesh(new T.SphereGeometry(13, 32, 12, 0, Math.PI * 2, 0, Math.PI / 2), schwarzM);
        schirm.material = schwarzM.clone(); schirm.material.side = T.DoubleSide; schirm.material.castShadow = false;
        schirm.position.set(x, uk, zz);
        schirm.userData.ohneSchatten = true;
        gruppe.add(schirm);
        var birne = new T.Mesh(new T.SphereGeometry(3.2, 16, 12), licht);
        birne.position.set(x, uk + 1, zz);
        birne.userData.ohneSchatten = true;
        gruppe.add(birne);
        var kabel = new T.Mesh(new T.CylinderGeometry(0.25, 0.25, Math.max(10, RH - uk - 13), 6), schwarzM);
        kabel.position.set(x, uk + 13 + Math.max(10, RH - uk - 13) / 2, zz);
        kabel.userData.ohneSchatten = true;
        gruppe.add(kabel);
      }
    };

    /* LICHT IM SOCKEL (Hochglanz-Raum): eine Leiste unter der Korpusunterkante, knapp hinter der
       Front, die den Boden davor warm anstrahlt — wie in der Vorlage. Laeuft ueber dieselben
       Strecken wie die Sockelleiste (K.sockelStrecken), vorn und an der Inselrueckseite. Live ein
       additiver Schein auf dem Boden, im Foto ein Rechtecklicht (wie unter den Haengeschraenken). */
    var sockelLicht = function (gruppe, wid) {
      var sh = (daten && daten.sockel && +daten.sockel.hoehe) || 10;
      var ledS = new T.MeshStandardMaterial({ color: '#FFF1DA', emissive: '#FFE3B8', emissiveIntensity: 5 * (lookJetzt.licht.led || 1) });
      ledS.castShadow = false;
      K.sockelStrecken(z, daten).filter(function (s) {
        return s.wand === wid && (s.art === 'front' || s.art === 'rueck') && s.x1 - s.x0 >= 10;
      }).forEach(function (s) {
        var len = s.x1 - s.x0, mx = (s.x0 + s.x1) / 2, vorn = s.art === 'front';
        var kante = vorn ? s.z1 : s.z0, r = vorn ? 1 : -1;
        var led = new T.Mesh(new T.BoxGeometry(len - 4, 0.35, 1.4), ledS);
        led.position.set(mx, sh - 0.4, kante + r * 2);
        led.userData.durchlaessig = true; led.userData.ohneSchatten = true; led.userData.led = { b: len - 4, staerke: 34 };
        gruppe.add(led);
        var tiefe2 = 38;
        /* Auf dunklem Boden ein schwacher heller Hauch statt warmer Deckfarbe (auf dunklen Bibliotheksboeden lag sonst ein
           orangefarbenes Band vor dem Sockel, gesehen 2026-09-29). */
        var bodenL = rezeptJetzt && BIBLIOTHEK[rezeptJetzt.boden] ? BIBLIOTHEK[rezeptJetzt.boden][3] : 70;
        var schein = new T.Mesh(new T.PlaneGeometry(len + 16, tiefe2), bodenL > 58 ? scheinMat('boden', true) : scheinMat('boden', false, bodenL < 40));
        schein.rotation.set(-Math.PI / 2, 0, vorn ? 0 : Math.PI);
        schein.position.set(mx, 0.15, kante + r * (tiefe2 / 2 - 3));
        schein.userData.durchlaessig = true; schein.userData.ohneSchatten = true; schein.userData.nurLive = true;
        schein.renderOrder = 2;
        gruppe.add(schein);
      });
    };
    /* BARHOCKER an der Inselrueckseite — die Insel ist in jeder Vorlage ein Tresen, an dem man
       sitzt. Sitzhoehe 65 cm (Tresenhoehe 90), je 60 cm ein Hocker, hoechstens drei. */
    var hockerM = {
      sitz: new T.MeshStandardMaterial({ color: RAUM_GLANZ ? '#8C8176' : '#6E655C', roughness: 0.85, metalness: 0 }),
      bein: new T.MeshStandardMaterial({ color: RAUM_GLANZ ? '#C9C6C0' : '#2A2B2D', roughness: 0.3, metalness: 0.85 })
    };
    /* EINRICHTUNG WIE AUF DEN SERIENBILDERN (Betreiber 2026-09-29: „مثل صور ku-s11", Modelle von Poly Haven, CC0): auf dem
       Kochfeld ein Topf, am Ende der Platte ein Topf mit Holzloeffeln und Flaschen, auf langen Strecken ein Wasserkocher,
       dazu Pflanze, Bretter, Teeservice oder Obstschale; auf der Insel eine Vase mit Zweigen; auf der Fensterbank eine
       kleine Pflanze. Alles echte, massstaebliche Modelle (echtSetzen, Meter → cm); was noch laedt, erscheint beim
       naechsten Aufbau. Fehlt ein Modell ganz, bleibt die Stelle frei — die alte Deko (deko) laeuft nur ohne Modelle. */
    var EINRICHTUNG_NEU = !!dekoModellQuellen.kochtopf;
    /* KAFFEEMASCHINE (Betreiber 2026-09-29: „اضف ايضا ماكينات القهوة"): gebaut wie die Geraete (gebuersteter Stahl, schwarzes
       Glas, Anzeige). Zwei Arten: Siebtraeger aus Edelstahl mit Bruehgruppe, Siebtraeger, Manometer, Dampflanze und zwei Tassen,
       oder ein schwarzer Vollautomat mit Anzeige, Auslauf und Tasse. Mit der Rueckseite an der Wand, wirft Schatten wie die Deko. */
    var kaffeeTasse = new T.MeshStandardMaterial({ color: '#F4F2EE', roughness: 0.25, metalness: 0 });
    var kaffeemaschine = function (gruppe, x, top, zu) {
      var kg = new T.Group(), teil = function (geo, m, px, py, pz) {
        var me = new T.Mesh(geo, m); me.position.set(px, py, pz); me.userData.durchlaessig = true; me.userData.deko = true; kg.add(me); return me;
      };
      var tasse = function (px, pz, ph) {
        teil(new T.CylinderGeometry(2.7, 2.2, 5.2, 24, 1, true), kaffeeTasse, px, ph + 2.6, pz).material.side = T.DoubleSide;
        teil(new T.CylinderGeometry(2.2, 2.2, 0.4, 24), kaffeeTasse, px, ph + 0.2, pz);
        var henkel = teil(new T.TorusGeometry(1.5, 0.35, 8, 16, Math.PI), kaffeeTasse, px + 2.9, ph + 2.8, pz);
        henkel.rotation.z = -Math.PI / 2;
      };
      if (zu() < 0.55) {
        /* Siebtraeger, 28 breit, 36 hoch, 36 tief. */
        var st = edelB(true, 1), b = 28, h = 36, t2 = 36, zc = 2 + t2 / 2, vorn = 2 + t2;
        teil(rundKasten(b, h, t2, 2.2), st, 0, h / 2, zc);
        teil(new T.BoxGeometry(b - 3, 0.5, t2 - 5), dunkelMat, 0, h + 0.3, zc);
        teil(new T.CylinderGeometry(3.4, 3.8, 5, 28), st, 0, h - 13, vorn + 2.4);
        teil(new T.CylinderGeometry(3.6, 3.4, 2.6, 28), st, 0, h - 17, vorn + 2.4);
        var griff = teil(new T.CylinderGeometry(0.9, 1.1, 11, 14), dunkelMat, -4.5, h - 17.4, vorn + 8.5);
        griff.rotation.set(Math.PI / 2 - 0.08, 0, 0.55);
        var mano = teil(new T.CylinderGeometry(2.6, 2.6, 1.2, 28), st, 7.5, h - 7, vorn + 0.4); mano.rotation.x = Math.PI / 2;
        var zifferblatt = teil(new T.CylinderGeometry(2.1, 2.1, 0.3, 28), kaffeeTasse, 7.5, h - 7, vorn + 1.1); zifferblatt.rotation.x = Math.PI / 2;
        var lanze = teil(new T.CylinderGeometry(0.35, 0.35, 15, 10), st, b / 2 - 2.5, h - 21, vorn + 2.5); lanze.rotation.x = 0.28;
        teil(new T.BoxGeometry(b - 4, 2.2, 11), st, 0, 1.1, vorn + 4.5);
        teil(new T.BoxGeometry(b - 6, 0.3, 9), dunkelMat, 0, 2.35, vorn + 4.5);
        tasse(-5.5, vorn + 4.5, 2.5); tasse(5.5, vorn + 5, 2.5);
      } else {
        /* Vollautomat, schwarz, 24 breit, 36 hoch, 42 tief. */
        var b2 = 24, h2 = 36, t3 = 42, zc2 = 2 + t3 / 2, vorn2 = 2 + t3;
        teil(rundKasten(b2, h2, t3, 2.8), glasS, 0, h2 / 2, zc2);
        teil(new T.BoxGeometry(b2 - 6, 1.2, 0.6), edelB(true, 1), 0, h2 - 3, vorn2 + 0.1);
        var anz = leuchtAnzeige('Espresso');
        teil(new T.BoxGeometry(9, 5, 0.4), anz, 0, h2 - 9, vorn2 + 0.2);
        teil(new T.BoxGeometry(7, 3.2, 5), dunkelMat, 0, h2 - 17, vorn2 + 2.4);
        [-1.3, 1.3].forEach(function (dx) { teil(new T.CylinderGeometry(0.5, 0.5, 2.2, 10), edelB(true, 1), dx, h2 - 19.6, vorn2 + 3.2); });
        teil(new T.BoxGeometry(b2 - 3, 2.2, 10), dunkelMat, 0, 1.1, vorn2 + 4);
        teil(new T.BoxGeometry(b2 - 5, 0.3, 8), edelB(true, 1), 0, 2.35, vorn2 + 4);
        tasse(0, vorn2 + 3.2, 2.5);
      }
      kontaktSchatten(kg, 28, 40, 0, 0, 22);
      kg.position.set(x, top, 0);
      kg.rotation.y = (zu() - 0.5) * 0.12;
      gruppe.add(kg);
      return kg;
    };
    /* EINRICHTUNG JE RAUM (Betreiber 2026-09-29: „اريد ان تقوم بتنزيل ادوات مطبخ جديدة في كل مرة تستعمل واحدة … اريد افكار
       جديدة في كل مرة" — und „لايجب ان تكون هنالك مبالغة بالادوات"). Wie ein Stylist fuer ein Katalogbild: wenige Stuecke mit
       Absicht. Auf der Hauptzeile hoechstens vier (ein Topf auf dem Kochfeld, ein Gruen am herdfernen Ende, ein „Moment" auf der
       laengsten freien Strecke, auf langen Zeilen manchmal ein Getraenk), auf jeder weiteren Zeile hoechstens eines, auf der Insel
       eines. WELCHE Stuecke, bestimmt das Raumrezept — jede Groesse und Farbe eine andere Auswahl. Alle werfen Schatten
       (Hauptlicht, nur Deko). */
    /* LUFT ZWISCHEN DEN STUECKEN, auch ueber Eck (Betreiber 2026-09-29: „الفازة بجانب علبة القهوة لم تعجبني“): jede Stelle
       wird in Weltkoordinaten gemerkt; ein weiteres Stueck braucht 75 cm Abstand zu allen bisherigen — sonst bleibt es weg. */
    var dekoPunkte = [];
    var dekoPlatz = function (wid, x, zz, merkenOhnePruefung) {
      var w0 = teile.filter(function (t2) { return t2.id === wid; })[0];
      if (!w0) return true;
      var p0 = K.weltPunkt3D(w0, x, zz, 0);
      if (!merkenOhnePruefung) {
        for (var ip = 0; ip < dekoPunkte.length; ip++) if (Math.hypot(dekoPunkte[ip].x - p0.x, dekoPunkte[ip].z - p0.z) < 75) return false;
      }
      dekoPunkte.push(p0);
      return true;
    };
    var einrichten = function (gruppe, wid, insel) {
      var top = g.korpus_hoehe + g.arbeitsplatte_dicke, pt2 = K.platteTiefe();
      var frei = freiePlatte(wid), rs = (rezeptJetzt && rezeptJetzt.saat) || 0;
      var saat = wid.charCodeAt(0) * 131 + rs % 1000003, zu = dekoZufall(saat);
      var nr = dekoWand++;
      var M = function (n) { var x = dekoModell(n); return x && x !== 'warten' ? x : null; };
      var wahl = function (liste) { return liste[Math.floor(zu() * liste.length) % liste.length]; };
      var aufrecht = function (k) { k.rotateOnWorldAxis(new T.Vector3(1, 0, 0), -Math.PI / 2); };
      var vKd = K.wandVersatz ? K.wandVersatz(z, daten, wid, 'boden') : 0;
      /* Kochfeld: ein Kochgeschirr (nicht immer). */
      K.kochstellen(z, daten, wid).forEach(function (h) {
        if (zu() < 0.2) return;
        var art = wahl([['kochtopf', 0.72], ['topf-emaille', 0.95], ['topf-messing', 0.62], ['pfanne-messing', 0.9]]);
        var kt = M(art[0]);
        if (kt) { echtSetzen(gruppe, kt, h.x + h.b / 2 - 12, top + 0.9, 19 - vKd, art[1], zu() * Math.PI * 2); dekoPlatz(wid, h.x + h.b / 2, 20, true); }
      });
      if (!frei.length) return;
      /* Obst in einer flachen Schale oder auf einem Teller (Obst dreht mit). */
      var obst = function (x, zz) {
        var sch = M('holzschale-flach');
        var sorten = wahl([['apfel-rot', 'apfel-rot', 'birnen'], ['granatapfel', 'limette-frisch', 'granatapfel'], ['zitrone', 'zitrone', 'limette-frisch'],
          ['birnen', 'apfel-rot', 'kiwi']]);
        if (!sch) { schale(gruppe, x, zz, top, saat + 5); return; }
        var sg = echtSetzen(gruppe, sch, x, top, zz, 0.9, zu() * Math.PI * 2);
        [[-4.5, -2.5], [4.2, 2.2], [0.4, 5.2]].forEach(function (o, i) {
          var fm = M(sorten[i]);
          if (fm) echtSetzen(sg, fm, o[0], 2.2, o[1], 1, zu() * Math.PI * 2);
        });
      };
      /* Ein „Moment" auf der Platte: Brett mit Gemuese, Schale mit Obst, Teller mit Gebaeck, Loeffeltopf, Kaffee. */
      var moment = function (x, zz, art) {
        if (art === 'brett') {
          var br = M('schneidebrett');
          if (!br) return;
          var bg = echtSetzen(gruppe, br, x, top, zz, 0.9, (zu() - 0.5) * 0.5);
          var gm = M(wahl(['zwiebel', 'avocado', 'zitrone', 'suesskartoffel']));
          if (gm) echtSetzen(bg, gm, 6, 1.9, 1, 1, zu() * Math.PI * 2);
          var gm2 = M(wahl(['zwiebel', 'limette-frisch', 'avocado']));
          if (gm2 && zu() < 0.6) echtSetzen(bg, gm2, -2, 1.9, -3, 1, zu() * Math.PI * 2);
        } else if (art === 'obst') obst(x, zz);
        else if (art === 'backen') {
          var tl = M('holzteller');
          if (!tl) return;
          var tg = echtSetzen(gruppe, tl, x, top, zz, 1, zu() * Math.PI * 2);
          var back = M(wahl(['croissant', 'kuchen', 'torte']));
          if (back) echtSetzen(tg, back, 0, 1.2, 0, 0.9, zu() * Math.PI * 2);
        } else if (art === 'loeffel') {
          var tk = M('topfKeramik'), hl = M('holzloeffel');
          if (!tk) return;
          echtSetzen(gruppe, tk, x, top, 12, 0.3, 0);
          if (hl) [-0.2, 0.04, 0.24].forEach(function (neig, i) {
            echtSetzen(gruppe, hl, x + (i - 1) * 2.4, top + 1.5, 12 + (i % 2 ? 1.6 : -1.6), 1, zu() * Math.PI, function (k) {
              aufrecht(k); k.rotateOnWorldAxis(new T.Vector3(0, 0, 1), neig);
            });
          });
        } else if (art === 'kaffee') kaffeemaschine(gruppe, x, top, zu);
      };
      /* Gruen: Pflanze, Sukkulente, Vase mit Zweigen oder eine Vase allein. */
      var gruen = function (x, zz) {
        /* Ohne die gemusterte Vase (Betreiber 2026-09-29: „الفازة بجانب علبة القهوة لم تعجبني“). */
        var art = wahl(['pflanze', 'pflanze', 'sukkulente', 'zweige', 'vase-keramik3', 'vase-keramik2']);
        if (art === 'pflanze') { pflanze(gruppe, x, zz, top, saat); return; }
        if (art === 'zweige') {
          var va = M(wahl(['vase', 'vase-keramik4'])), zw = M('zweige');
          if (va) { echtSetzen(gruppe, va, x, top, zz, 1, 0); if (zw) echtSetzen(gruppe, zw, x, top + 24, zz, 0.42, zu() * Math.PI, aufrecht); }
          return;
        }
        var gm3 = M(art);
        if (gm3) echtSetzen(gruppe, gm3, x, top, zz, art === 'sukkulente' ? 0.9 : 1, zu() * Math.PI * 2);
      };
      /* Getraenk (nur lange Zeilen, nicht immer). */
      var getraenk = function (x, rueck) {
        var art = wahl(['wasserkocher', 'thermoskanne', 'flaschen', 'kanne-metall', 'teeservice']), gm4 = M(art);
        if (!gm4) return;
        if (art === 'flaschen') echtSetzen(gruppe, gm4, x, top, 0, 1, 0, null, 5);
        else echtSetzen(gruppe, gm4, x, top, art === 'teeservice' ? 26 : 16, art === 'teeservice' ? 0.9 : 1, Math.PI * (0.75 + zu() * 0.5));
      };
      if (insel) {
        var fi = frei[0], mi = (fi[0] + fi[1]) / 2;
        var ia = wahl(['zweige', 'obst', 'backen']);
        if (!dekoPlatz(wid, mi, pt2 / 2)) return;
        if (ia === 'zweige') gruen(mi, pt2 / 2); else moment(mi, pt2 / 2, ia);
        return;
      }
      var f0 = frei[0], lang = f0[1] - f0[0], mitte0 = (f0[0] + f0[1]) / 2;
      if (nr > 0) {
        /* Weitere Zeilen: hoechstens ein Stueck. */
        if (lang >= 55 && zu() < 0.6 && dekoPlatz(wid, mitte0, 24)) {
          var an = wahl(['gruen', 'obst', 'getraenk']);
          if (an === 'gruen') gruen(mitte0, 22); else if (an === 'obst') obst(mitte0, 26); else getraenk(mitte0);
        }
        return;
      }
      if (lang < 40) { if (dekoPlatz(wid, mitte0, 22)) gruen(mitte0, 22); return; }
      /* Hauptzeile: Gruen am herdfernen Ende, der Moment auf der laengsten Strecke, auf langen Zeilen ein Getraenk. */
      var fernX = herdFern(frei, f0, 16), nahLinks = fernX > mitte0, r = nahLinks ? 1 : -1;
      if (dekoPlatz(wid, fernX, 22)) gruen(fernX, 22);
      var art0 = wahl(['brett', 'obst', 'backen', 'loeffel', 'kaffee', 'kaffee']);
      var momX = lang >= 150 ? mitte0 + r * Math.min(35, lang * 0.12) : (nahLinks ? f0[0] + 30 : f0[1] - 30);
      /* Luft zwischen den Stuecken: mindestens 60 cm vom Gruen, sonst ans andere Ende (oder gar nicht). */
      if (Math.abs(momX - fernX) < 60) momX = nahLinks ? f0[0] + 30 : f0[1] - 30;
      if (lang >= 90 && Math.abs(momX - fernX) >= 60 && dekoPlatz(wid, momX, 24)) moment(momX, art0 === 'loeffel' ? 12 : 24, art0);
      var gX = nahLinks ? f0[0] + 20 : f0[1] - 20;
      if (lang >= 260 && zu() < 0.5 && dekoPlatz(wid, gX, 16)) getraenk(gX);
      /* Fensterbank: manchmal eine kleine Pflanze. */
      K.aktiveMerkmale(z).filter(function (m) { return m.wand === wid && m.typ === 'fenster'; }).forEach(function (m) {
        var su = M('sukkulente');
        /* Phase 1: on the middle of the new stone sill (the old flat bench stood 0-14 cm in front of the wall). */
        if (su && zu() < 0.5) echtSetzen(gruppe, su, m.x + m.breite * 0.28, m.hoehe, hP1 ? -1 + (FENSTER_P1.bankVor - FENSTER_P1.laibung) / 2 : 7, 0.9, zu() * Math.PI);
      });
    };
    var barhocker = function (gruppe, wid) {
      var bo = K.items(z, daten, wid, 'boden');
      if (!bo.length) return;
      var x0 = Infinity, x1 = -Infinity;
      bo.forEach(function (it) { x0 = Math.min(x0, it.x); x1 = Math.max(x1, it.x + it.b); });
      var n = Math.max(1, Math.min(3, Math.floor((x1 - x0) / 60))), hs = 65, zz = -34;
      /* Mit Modell: echte Barhocker (Poly Haven) statt der gezeichneten. */
      var bhM = dekoModell('barhocker');
      if (bhM === 'warten') return;
      if (bhM) {
        for (var ib = 0; ib < n; ib++) echtSetzen(gruppe, bhM, x0 + (x1 - x0) * (ib + 0.5) / n, 0, zz - 4, 1, 0);
        return;
      }
      for (var i = 0; i < n; i++) {
        var x = x0 + (x1 - x0) * (i + 0.5) / n;
        var sitz = dekoTeil(gruppe, new T.CylinderGeometry(19, 16, 5, 32), hockerM.sitz, x, hs, zz);
        sitz.castShadow = true;
        /* Lehne: ein halber Zylindermantel auf der Seite weg von der Insel. */
        var lehne = dekoTeil(gruppe, new T.CylinderGeometry(19, 18, 16, 32, 1, true, Math.PI / 2, Math.PI), hockerM.sitz,
          x, hs + 10, zz);
        lehne.material = hockerM.sitz.clone(); lehne.material.side = T.DoubleSide;
        [[-12, -12], [12, -12], [-12, 12], [12, 12]].forEach(function (p) {
          var bein = dekoTeil(gruppe, new T.CylinderGeometry(0.8, 0.8, hs, 8), hockerM.bein, x + p[0] * 1.05, hs / 2, zz + p[1] * 1.05);
          bein.rotation.set(p[1] * 0.006, 0, -p[0] * 0.006);
        });
        var ring = dekoTeil(gruppe, new T.TorusGeometry(14, 0.6, 8, 40), hockerM.bein, x, 24, zz);
        ring.rotation.x = Math.PI / 2;
      }
    };

    /* Waende UND freistehende Bloecke — beide haben zwei Punkte, beide brauchen dieselbe
       Behandlung. Die Insel wird nicht mehr als Wand ausgegeben. */
    teile.forEach(function (w) { wandGruppe(w); });
    /* Deko und Leuchten erst, wenn alle Wandgruppen stehen — sie liegen in deren Koordinaten. */
    teile.forEach(function (w) {
      var tr = K.wandTransform3D(w), dg = new T.Group();
      dg.position.set(tr.ursprung.x, tr.ursprung.y, tr.ursprung.z);
      dg.rotation.y = tr.gierung;
      root.add(dg);
      var istInsel = (raum.bloecke || []).some(function (b) { return b.id === w.id; });
      /* Die Rueckreihe der Doppelinsel ist derselbe Koerper: Deko und Leuchten einmal, an 'I'. */
      if (w.id === 'IH') { if (RAUM_GLANZ) sockelLicht(dg, w.id); return; }
      (EINRICHTUNG_NEU ? einrichten : deko)(dg, w.id, istInsel);
      if (RAUM_GLANZ) sockelLicht(dg, w.id);
      if (istInsel && !(raum.bloecke || []).some(function (b) { return b.id === 'IH'; })) barhocker(dg, w.id);
      if (istInsel) {
        var lg = new T.Group();
        lg.position.copy(dg.position); lg.rotation.copy(dg.rotation);
        leuchten.add(lg);
        pendel(lg, w.id);
      }
    });

    /* Schatten: jeder Koerper wirft und empfaengt, ausser Glas (es wuerde schwarz). Die
       Schattenkamera umfasst den ganzen Raum und nicht mehr — je enger, desto schaerfer. */
    root.traverse(function (o) {
      if (!o.isMesh) return;
      var durch = o.material && o.material.transparent;
      /* Die Pendelleuchten werfen keinen: die Sonne kommt von vorn und legte ihre Schirme als
         graue Scheiben auf die Fronten der Wand dahinter (gesehen 2026-09-27). */
      o.castShadow = !durch && o !== boden && !o.userData.ohneSchatten;
      o.receiveShadow = !o.userData.ohneEmpfang;
      /* Fuer das Hauptlicht (sonne) werfen nur die Deko-Stuecke; alles andere nur fuer die Fenstersonne. */
      if (o.castShadow && !o.userData.deko && o.onBeforeShadow !== nurFuerSonne && !lookJetzt.licht.hauptAlle) o.onBeforeShadow = nurFuerSonne;
    });
    /* Licht je Look (Lichtregie): Hauptlicht von oben, Fenstersonne, Himmel, Spots, Belichtung. Stufe 3 hatte das Hauptlicht
       steiler gestellt (Schatten unter die Haengeschraenke, kurz vor den Sockel) — so bleibt es. */
    lichtRegie(look.licht, raum, t);
    Object.keys(scheinMats).forEach(function (k) { scheinMats[k].color.setScalar(look.licht.led || 1); });
    if (markiertSel) markieren(markiertSel);

    /* Die Haube ist ein Gerät aus Schritt 2, kein Schrank — deshalb steht sie im Raum und
       nicht in einer Wandgruppe. */
    K.aktiveMerkmale(z).filter(function (m) { return m.typ === 'haube'; }).forEach(function (m) {
      var hw = m.breite || 60;
      var hb = new T.Mesh(new T.BoxGeometry(hw, K.HAUBE.h, K.HAUBE.t),
        new T.MeshStandardMaterial({ color: '#5A6064', roughness: 0.35, metalness: 0.5 }));
      /* Frueher vier Zweige nach Wandbuchstaben, jeder mit einer eigenen absoluten
         Rechnung — und der fuer Wand C war spiegelverkehrt: er setzte pz = m.x, obwohl die
         wandlokale Achse dort in die Gegenrichtung laeuft. Gemessen an einer 180er Wand,
         Haube bei x = 40: 70 statt 110, also 40 cm daneben. Jetzt dieselbe Projektion wie
         alles andere, und damit kein Sonderfall mehr. */
      var wh = teile.filter(function (x) { return x.id === m.wand; })[0];
      if (!wh) return;
      var trh = K.wandTransform3D(wh);
      var ph = K.weltPunkt3D(wh, m.x + hw / 2, K.HAUBE.t / 2, m.hoehe + K.HAUBE.h / 2);
      hb.rotation.y = trh.gierung;
      hb.position.set(ph.x, ph.y, ph.z);
      root.add(hb);
    });

    /* Der Raum spiegelt sich selbst (raumSpiegel), mit Box-Projektion; ohne geschlossenen Raum bleibt der Studioraum. */
    root.traverse(function (o) {
      if (o.isMesh) (Array.isArray(o.material) ? o.material : [o.material]).forEach(boxSpiegelMat);
    });
    rd.shadowMap.needsUpdate = true;
    if (!raumSpiegel()) sc.environment = studioEnv;
    groesse();
  }

  /* Eine kleine Lichtumgebung fuer Spiegelungen: ohne sie hat Hochglanz nichts zu spiegeln und
     sieht aus wie mattes Lack. Ein heller Raum mit Deckenlicht und zwei Fenstern, einmal
     vorgerechnet. Faellt das aus, bleibt die Szene ohne Umgebung — wie bisher. */
  function umgebung(rd) {
    try {
      var pm = new T.PMREMGenerator(rd), es = new T.Scene();
      es.add(new T.Mesh(new T.BoxGeometry(10, 6, 10), new T.MeshBasicMaterial({ color: '#6f6a61', side: T.BackSide })));
      /* Hohe, schmale Fenster: sie ergeben die senkrechten Lichtbahnen, die die Hochglanz-Fronten
         auf den Shopfotos zeigen. */
      [[6, 3, 0, 2.95, 0, 0, Math.PI / 2, 1.6], [1.4, 4.5, -4.95, 0.3, 0.5, Math.PI / 2, 0, 3],
       [1.4, 4.5, -4.95, 0.3, 2.6, Math.PI / 2, 0, 3], [1.4, 4.5, 0, 0.3, 4.95, Math.PI, 0, 2.2],
       [2, 3, 4.95, 0.4, -1, -Math.PI / 2, 0, 1.2]].forEach(function (l) {
        var m = new T.Mesh(new T.PlaneGeometry(l[0], l[1]),
          new T.MeshBasicMaterial({ color: new T.Color('#ffffff').multiplyScalar(l[7]), side: T.DoubleSide }));
        m.position.set(l[2], l[3], l[4]);
        m.rotation.set(l[6], l[5], 0);
        es.add(m);
      });
      var tex = pm.fromScene(es, 0.04).texture;
      pm.dispose();
      return tex;
    } catch (e) { return null; }
  }

  /* RAUMSPIEGEL (Realismus Stufe 3, 2026-09-28, Vorlagen des Betreibers: „اريد ان تعملها انت بدون خوادم"). Bisher
     spiegelten Hochglanz, Geraeteglas, Edelstahl und Boden einen gedachten Studioraum (umgebung) — helle Kaesten, die es
     in dieser Kueche nicht gibt; genau daran erkennt man ein Computerbild. Jetzt spiegeln sie DIESEN Raum: nach jedem
     Aufbau eine Rundumaufnahme aus der Raummitte (sechs Bilder zu 256 px, ohne Tonkurve), daraus die Lichtumgebung —
     mit ihr bekommt auch jede matte Flaeche das Licht, das Boden und Waende zurueckwerfen. Einmal je Aufbau, nicht je
     Bild: auf jedem Geraet leicht. Ohne geschlossenen Raum (keine Huelle) bleibt der Studioraum. */
  var spiegelZiel = null, spiegelTex = null, spiegelRT = null, SPIEGEL_AUGE = 125;
  /* Wie stark die Raumumgebung auf die Materialien wirkt (Anteil an ihrer envMapIntensity). Abgestimmt im Bild
     (2026-09-29, Lichtpult): mit vollem Anteil lag der ganze Raum gleich hell und flach — Grau Hochglanz 192 statt ~155. */
  var SPIEGEL_ANTEIL = 1.0;
  /* BOX-PROJEKTION (Stufe 3): eine Rundumaufnahme aus der Raummitte spiegelt in JEDER Front, als stuende man in der
     Mitte — die Lichtleiste im Boden erschien in der Hochglanzfront irgendwo, nicht direkt unter ihr. Mit dem Raum als
     Kasten (Huelle, Boden bis Decke) wird jeder Spiegelstrahl bis zur Raumwand verfolgt und dort nachgeschlagen: Boden,
     Sockellicht, Voute und Gegenwand stehen im Spiegelbild an ihrem Platz. Nur Rechnung im Bildpunkt, kein Mehrbild. */
  var boxU = null, BOX_ZIEL = 'reflectVec = inverseTransformDirection( reflectVec, viewMatrix );';
  var BOX_CODE = [
    '',
    '\t\t\tif ( hmBoxAn > 0.5 ) {',
    '\t\t\t\tvec3 rbMax = ( hmBoxMax - vHmWelt ) / reflectVec;',
    '\t\t\t\tvec3 rbMin = ( hmBoxMin - vHmWelt ) / reflectVec;',
    '\t\t\t\tvec3 rbW = vec3( reflectVec.x > 0.0 ? rbMax.x : rbMin.x, reflectVec.y > 0.0 ? rbMax.y : rbMin.y, reflectVec.z > 0.0 ? rbMax.z : rbMin.z );',
    '\t\t\t\tfloat rbT = max( 0.0, min( min( rbW.x, rbW.y ), rbW.z ) );',
    '\t\t\t\tvec3 rbP = vHmWelt + reflectVec * rbT - hmBoxPos;',
    '\t\t\t\treflectVec = normalize( mix( normalize( rbP ), reflectVec, clamp( roughness * roughness * 2.0, 0.0, 1.0 ) ) );',
    '\t\t\t}'
  ].join('\n');
  /* SPIEGELBILD OHNE FARBE auf hellem Hochglanz (Betreiber 2026-09-30: „في المنتصف يظهر لون ازرق وهذا تشوه بصري"): der
     Himmel im Fenster stand als blauer Fleck in den weissen Haengeschraenken. Mit HM_SPIEGEL_NEUTRAL (frontMat, nur
     hellGlanz) wird das Spiegelbild auf seine Helligkeit reduziert — Fenster und Boden bleiben als Glanz sichtbar, ohne
     Farbe. Grau und alle anderen Materialien spiegeln unveraendert. HM_SPIEGEL_STAERKE (nur hellGlanz) skaliert dasselbe
     Spiegelbild (Grundschicht und Klarlack); das Umgebungslicht (irradiance, „PI * envMapColor") erreicht der Ersatz nicht. */
  var NEUTRAL_ZIEL = 'return envMapColor.rgb * envMapIntensity;';
  var NEUTRAL_CODE = '\n\t\t\t#ifdef HM_SPIEGEL_NEUTRAL\n\t\t\t\tenvMapColor.rgb = vec3( dot( envMapColor.rgb, vec3( 0.2126, 0.7152, 0.0722 ) ) );\n'
    + '\t\t\t#endif\n\t\t\t#ifdef HM_SPIEGEL_STAERKE\n\t\t\t\tenvMapColor.rgb *= HM_SPIEGEL_STAERKE;\n\t\t\t#endif\n\t\t\t' + NEUTRAL_ZIEL;
  function boxUniforms() {
    if (!boxU) boxU = { hmBoxMin: { value: new T.Vector3() }, hmBoxMax: { value: new T.Vector3() },
      hmBoxPos: { value: new T.Vector3() }, hmBoxAn: { value: 0 } };
    return boxU;
  }
  function boxSpiegelMat(m) {
    if (!m || m.__hmBox || !m.isMeshStandardMaterial || !T.ShaderChunk) return;
    var chunk = T.ShaderChunk.envmap_physical_pars_fragment;
    if (!chunk || chunk.indexOf(BOX_ZIEL) < 0) return;
    m.__hmBox = true;
    var U = boxUniforms();
    m.onBeforeCompile = function (sh) {
      Object.keys(U).forEach(function (k) { sh.uniforms[k] = U[k]; });
      sh.vertexShader = 'varying vec3 vHmWelt;\n' + sh.vertexShader.replace('#include <worldpos_vertex>',
        '#include <worldpos_vertex>\n\tvHmWelt = ( modelMatrix * vec4( transformed, 1.0 ) ).xyz;');
      sh.fragmentShader = 'varying vec3 vHmWelt;\nuniform vec3 hmBoxMin;\nuniform vec3 hmBoxMax;\nuniform vec3 hmBoxPos;\nuniform float hmBoxAn;\n'
        + sh.fragmentShader.replace('#include <envmap_physical_pars_fragment>',
          chunk.replace(BOX_ZIEL, BOX_ZIEL + BOX_CODE).replace(NEUTRAL_ZIEL, NEUTRAL_CODE));
    };
    m.customProgramCacheKey = function () { return 'hmBox1'; };
    m.needsUpdate = true;
  }
  function raumSpiegel() {
    boxUniforms().hmBoxAn.value = 0;
    if (!rd || !sc || !root || !huelleJetzt || !T.CubeCamera || !T.WebGLCubeRenderTarget) return false;
    var h = huelleJetzt, markSicht = markierung ? markierung.visible : false;
    var pendelSicht = pendelGruppe ? pendelGruppe.visible : false, weitSicht = weitGruppe ? weitGruppe.visible : false;
    var aussenSicht = aussenGruppe ? aussenGruppe.visible : false;
    try {
      if (weitGruppe) weitGruppe.visible = false;
      /* 512 je Seite am Rechner (scharfe Spiegelbilder im Hochglanz), 256 am Telefon. */
      if (!spiegelZiel) spiegelZiel = new T.WebGLCubeRenderTarget((w.innerWidth || 800) < 768 ? 256 : 512, { type: T.HalfFloatType });
      var cc = new T.CubeCamera(5, 4000, spiegelZiel);
      cc.position.set((h.minX + h.maxX) / 2, SPIEGEL_AUGE, (h.minY + h.maxY) / 2);
      /* Ebene 1: das Fensterlicht, das nur im Spiegelbild steht. */
      cc.layers.enable(1);
      cc.children.forEach(function (k) { k.layers.enable(1); });
      if (markierung) markierung.visible = false;
      if (pendelGruppe) pendelGruppe.visible = true;
      var aussenSeiten = aussenGruppe ? aussenGruppe.children.map(function (g2) { return g2.visible; }) : [];
      if (aussenGruppe) { aussenGruppe.visible = true; aussenGruppe.children.forEach(function (g2) { g2.visible = true; }); }
      cc.update(rd, sc);
      var pm = new T.PMREMGenerator(rd), rt = pm.fromCubemap(spiegelZiel.texture), neu = rt.texture;
      pm.dispose();
      neu.userData.hmSpiegel = true;
      /* Materialien mit eigenem Spiegelraum (dunkler Hochglanz, Geraete) spiegeln ab jetzt ebenfalls den Raum; jedes
         Material bekommt einmal seinen Anteil (SPIEGEL_ANTEIL) — auch geteilte (Deko-Modelle) nur einmal. */
      root.traverse(function (o) {
        if (!o.isMesh) return;
        (Array.isArray(o.material) ? o.material : [o.material]).forEach(function (m) {
          if (!m) return;
          if (m.envMap && (m.envMap === glanzEnv || m.envMap === spiegelTex || m.envMap.userData.hmSpiegel)) { m.envMap = neu; m.needsUpdate = true; }
          if ('envMapIntensity' in m && !m.__hmEnvAnteil) { m.__hmEnvAnteil = true; m.envMapIntensity *= SPIEGEL_ANTEIL; }
        });
      });
      /* Release the old reflection as a RENDER TARGET: texture.dispose() on a render-target texture does nothing in r160 (the
         dispose listener sits on the target) — every rebuild left one cubeUV image and one framebuffer behind (measured +1/+1). */
      if (spiegelRT) spiegelRT.dispose();
      spiegelRT = rt; spiegelTex = neu;
      sc.environment = neu;
      var U = boxUniforms();
      U.hmBoxMin.value.set(h.minX - 1, 0, h.minY - 1);
      U.hmBoxMax.value.set(h.maxX + 1, hoeheJetzt, h.maxY + 1);
      U.hmBoxPos.value.copy(cc.position);
      U.hmBoxAn.value = 1;
      return true;
    } catch (e) {
      return false;
    } finally {
      if (markierung) markierung.visible = markSicht;
      if (pendelGruppe) pendelGruppe.visible = pendelSicht;
      if (weitGruppe) weitGruppe.visible = weitSicht;
      if (aussenGruppe) { aussenGruppe.visible = aussenSicht; aussenGruppe.children.forEach(function (g2, i2) { g2.visible = (aussenSeiten || [])[i2] !== false; }); }
    }
  }

  /* SPIEGELRAUM NUR FUER DUNKLEN HOCHGLANZ (Grau Hochglanz, Betreiber-Foto 2026-09-28): dort
     spiegeln die Fronten helle Fensterbahnen und den hellen Boden — auf unserer Front stand eine
     gleichmaessige Flaeche (gemessen 78 ueberall), weil die allgemeine Umgebung hinter dem Betrachter
     nur ein schmales Fenster hat. Eigene Umgebung am MATERIAL (envMap), damit Weiss, Holz, Boden
     und alles andere unveraendert bleiben: breite Fensterbahnen rundum, heller Boden, dunkle Decke. */
  var glanzEnv = null;
  function umgebungGlanz(rd) {
    try {
      var pm = new T.PMREMGenerator(rd), es = new T.Scene();
      es.add(new T.Mesh(new T.BoxGeometry(10, 6, 10), new T.MeshBasicMaterial({ color: '#3d3a36', side: T.BackSide })));
      var flaeche = function (w, h, x, y, z, rx, ry, st, farbe) {
        var m = new T.Mesh(new T.PlaneGeometry(w, h),
          new T.MeshBasicMaterial({ color: new T.Color(farbe || '#ffffff').multiplyScalar(st), side: T.DoubleSide }));
        m.position.set(x, y, z); m.rotation.set(rx, ry, 0); es.add(m);
      };
      /* Boden: von oben gesehen spiegeln die UNTERSCHRAENKE fast nur ihn (gemessen: einheitliche
         Flaeche). Helle Bahnen quer zur Wand — Licht aus den Fenstern — geben ihnen die senkrechten
         Lichtstreifen der Fotos. */
      flaeche(10, 10, 0, -2.95, 0, -Math.PI / 2, 0, 0.5, '#d9d2c6');
      [-3.8, -2.2, -0.6, 1.0, 2.6, 4.0].forEach(function (x, i) {
        flaeche(i % 2 ? 0.45 : 0.8, 10, x, -2.94, 0, -Math.PI / 2, 0, i % 2 ? 1.2 : 1.7, '#f4efe6');
      });
      [-3.6, -1.2, 1.2, 3.6].forEach(function (x) { flaeche(1.3, 4.4, x, 0.4, 4.95, 0, Math.PI, 2.4); });   /* Fenster gegenueber */
      [-2.5, 1.5].forEach(function (z) { flaeche(1.6, 4.4, 4.95, 0.4, z, 0, -Math.PI / 2, 1.8); flaeche(1.6, 4.4, -4.95, 0.4, z, 0, Math.PI / 2, 1.8); });
      flaeche(8, 0.25, 0, 2.95, 1.5, Math.PI / 2, 0, 3); flaeche(8, 0.25, 0, 2.95, -1.5, Math.PI / 2, 0, 3);  /* Lichtleisten */
      var tex = pm.fromScene(es, 0.02).texture;
      pm.dispose();
      return tex;
    } catch (e) { return null; }
  }

  /* Holzmaserung aus der Frontfarbe: 60 × 140 cm auf 256 × 1024 Punkten, senkrechte Fasern
     mit leichter Welle, fuer Artisan Eiche dazu Aeste. Fester Zufall — dieselbe Kueche sieht
     bei jedem Aufbau gleich aus. */
  function maserung(hex, ast) {
    var cv = document.createElement('canvas');
    cv.width = 256; cv.height = 1024;
    var c = cv.getContext('2d');
    /* Die Fasern sind ueberwiegend dunkler als der Grund; damit der Mittelwert die gemessene
       Frontfarbe trifft, liegt der Grund eine Spur heller. */
    c.fillStyle = K.ton(hex, 10); c.fillRect(0, 0, 256, 1024);
    var s = 7;
    var zufall = function () { s = (s * 16807) % 2147483647; return (s - 1) / 2147483646; };
    for (var i = 0; i < 110; i++) {
      var x = zufall() * 256, hell = zufall() < 0.45, amp = 1 + zufall() * 3, ph = zufall() * 6;
      c.strokeStyle = K.ton(hex, hell ? 8 + zufall() * 14 : -(10 + zufall() * 28));
      c.globalAlpha = 0.18 + zufall() * 0.32;
      c.lineWidth = 0.5 + zufall() * 2.4;
      c.beginPath();
      for (var y = 0; y <= 1024; y += 32) {
        var xx = x + Math.sin(y / 160 + ph) * amp;
        if (y === 0) c.moveTo(xx, y); else c.lineTo(xx, y);
      }
      c.stroke();
    }
    if (ast) {
      [[70, 250, 5, 11], [190, 640, 4, 9], [120, 900, 3, 7]].forEach(function (a) {
        for (var r = 3; r >= 1; r--) {
          c.globalAlpha = 0.22 + (3 - r) * 0.18;
          c.fillStyle = K.ton(hex, -30 - (3 - r) * 18);
          c.beginPath(); c.ellipse(a[0], a[1], a[2] * r * 0.8, a[3] * r * 0.8, 0, 0, Math.PI * 2); c.fill();
        }
      });
    }
    c.globalAlpha = 1;
    var t = new T.CanvasTexture(cv);
    t.wrapS = t.wrapT = T.RepeatWrapping;
    if (T.SRGBColorSpace) t.colorSpace = T.SRGBColorSpace;
    t.anisotropy = 4;
    return t;
  }

  /* Eichendielen fuer den Boden: 20 cm breite Dielen in drei Holztoenen, versetzte Stoesse,
     feine Fasern. Fester Zufall — derselbe Boden bei jedem Aufbau. Eine Kachel = 120 × 120 cm. */
  var dielenBild = null, dielenCm = 120;
  /* (breite, tiefe) in cm. Aus der Grafikkarte kommt eine 240-cm-Kachel (bodenGpu), gezeichnet eine von 120. */
  function dielen(wx, wz) {
    if (!dielenBild) {
      var gd = bodenGpu('dielen');
      if (gd) { dielenBild = leinwandBild(gd, 8); dielenCm = BODEN_KACHEL_CM; }
    }
    if (!dielenBild) {
      var cv = document.createElement('canvas');
      cv.width = 512; cv.height = 512;
      var c = cv.getContext('2d'), s = 11;
      var zufall = function () { s = (s * 16807) % 2147483647; return (s - 1) / 2147483646; };
      /* Nah beieinander liegende Toene: kraeftigere Unterschiede lasen sich als Muster, nicht als Holz. */
      var toene = ['#CFB28C', '#CAAD86', '#D3B792'];
      /* Erst der Grund: ohne ihn blieben zwischen den versetzten Stuecken durchsichtige
         Flecken, und die zeigte WebGL schwarz. */
      c.fillStyle = toene[0]; c.fillRect(0, 0, 512, 512);
      for (var reihe = 0; reihe < 6; reihe++) {
        var y0 = reihe * (512 / 6), versatz = zufall() * 300 - 300;
        for (var st = 0; st < 4; st++) {
          var x0 = versatz + st * 300;
          c.fillStyle = toene[Math.floor(zufall() * toene.length)];
          c.fillRect(x0, y0, 300, 512 / 6);
          for (var f = 0; f < 22; f++) {
            c.strokeStyle = zufall() < 0.5 ? 'rgba(120,90,55,0.10)' : 'rgba(255,245,225,0.10)';
            c.lineWidth = 0.6 + zufall() * 1.4;
            var yy = y0 + zufall() * (512 / 6);
            c.beginPath(); c.moveTo(x0, yy); c.bezierCurveTo(x0 + 100, yy + 2, x0 + 200, yy - 2, x0 + 300, yy + 1); c.stroke();
          }
          c.fillStyle = 'rgba(70,50,30,0.35)';
          c.fillRect(x0, y0, 1.2, 512 / 6);
        }
        c.fillStyle = 'rgba(70,50,30,0.30)';
        c.fillRect(0, y0, 512, 1.2);
      }
      dielenBild = new T.CanvasTexture(cv);
      dielenBild.wrapS = dielenBild.wrapT = T.RepeatWrapping;
      if (T.SRGBColorSpace) dielenBild.colorSpace = T.SRGBColorSpace;
      dielenBild.anisotropy = 8;
    }
    var t = dielenBild.clone();
    t.needsUpdate = true;
    t.repeat.set(wx / dielenCm, wz / dielenCm);
    return t;
  }

  /* Grosse helle Fliesen fuer den Hochglanz-Raum: 80 x 80 cm, je Fliese ein Hauch anderer Ton und
     leichte Wolken (Feinsteinzeug in Steinoptik), feine Fugen. Eine Kachel = 240 x 240 cm. */
  var fliesenBild = null;
  /* (breite, tiefe) in cm; eine Kachel = 240 cm, gerechnet (bodenGpu) oder gezeichnet. */
  var steinBild = null;
  function fliesen(wx, wz, art) {
    /* Grauer Naturstein (Look „Warmes Holz"): dieselben 80er Platten, kuehler und dunkler. */
    if (art === 'stein') {
      if (!steinBild) {
        var gs = gpuBild((w.innerWidth || 800) >= 768 ? 2048 : 1024, (w.innerWidth || 800) >= 768 ? 2048 : 1024, GLSL_FLIESEN,
          { uStein: { value: rgb01('#CBC7C0') }, uFuge: { value: rgb01('#ADA79E') } });
        if (gs) steinBild = leinwandBild(gs, 8);
      }
      if (steinBild) { var ts = steinBild.clone(); ts.needsUpdate = true; ts.repeat.set(wx / BODEN_KACHEL_CM, wz / BODEN_KACHEL_CM); return ts; }
    }
    if (!fliesenBild) {
      var gf = bodenGpu('fliesen');
      if (gf) fliesenBild = leinwandBild(gf, 8);
    }
    if (!fliesenBild) {
      var cv = document.createElement('canvas');
      cv.width = 768; cv.height = 768;
      var c = cv.getContext('2d'), s = 23, P = 256;
      var zufall = function () { s = (s * 16807) % 2147483647; return (s - 1) / 2147483646; };
      c.fillStyle = '#D8CEC0'; c.fillRect(0, 0, 768, 768);
      for (var ty = 0; ty < 3; ty++) {
        for (var tx = 0; tx < 3; tx++) {
          var x0 = tx * P + 1, y0 = ty * P + 1, w0 = P - 2;
          c.fillStyle = K.ton('#EDE6DB', (zufall() - 0.5) * 6);
          c.fillRect(x0, y0, w0, w0);
          for (var k = 0; k < 14; k++) {
            var gr = c.createRadialGradient(0, 0, 0, 0, 0, 1);
            var hell = zufall() < 0.5;
            gr.addColorStop(0, hell ? 'rgba(255,252,246,0.22)' : 'rgba(214,204,190,0.10)');
            gr.addColorStop(1, 'rgba(0,0,0,0)');
            c.save();
            c.beginPath(); c.rect(x0, y0, w0, w0); c.clip();
            c.translate(x0 + zufall() * w0, y0 + zufall() * w0);
            c.scale(30 + zufall() * 90, 20 + zufall() * 60);
            c.fillStyle = gr; c.beginPath(); c.arc(0, 0, 1, 0, Math.PI * 2); c.fill();
            c.restore();
          }
        }
      }
      fliesenBild = new T.CanvasTexture(cv);
      fliesenBild.wrapS = fliesenBild.wrapT = T.RepeatWrapping;
      if (T.SRGBColorSpace) fliesenBild.colorSpace = T.SRGBColorSpace;
      fliesenBild.anisotropy = 8;
    }
    var t = fliesenBild.clone();
    t.needsUpdate = true;
    t.repeat.set(wx / BODEN_KACHEL_CM, wz / BODEN_KACHEL_CM);
    return t;
  }

  /* Helle Steinoptik fuer die Arbeitsplatte: feine Koernung, einzelne dunklere Punkte. */
  var steinBild = null;
  /* GERAETE-BILDER (Betreiber 2026-09-27: „البراد وغسالة الصحون ليسو واقعيين"). Gezeichnet, nicht geladen: gebuersteter
     Edelstahl (feine Laengsstriche, die das Licht in Bahnen ziehen), Anzeigen mit echten Ziffern und Symbolen statt
     farbiger Rechtecke, die Bedienleiste eines Geschirrspuelers mit Programmsymbolen. Ohne Dokument (Netze) null. */
  var geraetBilder = {};
  /* INNENRAUM HINTER DER SCHEIBE (Stufe 3, Betreiber: „الاجهزة الالكترونية يجب ان تكون واقعية الى ابعد درجة"). Durch die
     dunkle Tuerscheibe eines echten Backofens sieht man schwach den Garraum: Seitenwaende mit Einschubleisten, den Rost, hinten
     die runde Luefterabdeckung. Gemalt statt gebaut (kein Garraum im Korpus noetig), als Eigenleuchten sehr dunkel — darueber
     spiegelt das Glas den Raum. Die Mikrowelle zeigt dazu das Lochblech ihres Sichtfensters. */
  /* BACKOFEN MIT LICHT (Betreiber 2026-09-29: „مثل صور ku-s11" — dort brennt im Ofen das Licht): der Garraum warm
     beleuchtet, der Rost glaenzt. Nur Raumbild, kein Geraetezustand. */
  /* WIEDER AUS (Betreiber 2026-09-29 07:40, mit Bildausschnitt der L-Kueche von 02:08: „اعجبني هذا الفرن مثل الذي في الصورة
     الذي انشأتها سابقا"): die dunkle Scheibe, in der sich der Raum spiegelt, gefiel ihm besser als der leuchtende Garraum. */
  var OFEN_LICHT = false;
  function ofenInnenBild(mikro) {
    var key = mikro ? 'innenMikro' : (OFEN_LICHT ? 'innenOfenLicht' : 'innenOfen');
    if (geraetBilder[key]) return geraetBilder[key];
    if (typeof document === 'undefined' || !document.createElement) return null;
    var W = 256, H = 192, cv = document.createElement('canvas'); cv.width = W; cv.height = H;
    var c = cv.getContext('2d');
    var x0 = W * 0.21, y0 = H * 0.2, x1 = W * 0.79, y1 = H * 0.84;
    if (!mikro && OFEN_LICHT) {
      var fl = function (farbe, pk) { c.fillStyle = farbe; c.beginPath(); c.moveTo(pk[0], pk[1]); for (var q = 2; q < pk.length; q += 2) c.lineTo(pk[q], pk[q + 1]); c.closePath(); c.fill(); };
      fl('#8f4a1c', [0, 0, x0, y0, x0, y1, 0, H]);
      fl('#7e3f17', [W, 0, x1, y0, x1, y1, W, H]);
      fl('#b8672a', [0, 0, W, 0, x1, y0, x0, y0]);
      fl('#5a2c10', [0, H, W, H, x1, y1, x0, y1]);
      var gl = c.createRadialGradient(W / 2, H * 0.42, 6, W / 2, H * 0.5, W * 0.4);
      gl.addColorStop(0, '#ffe2a8'); gl.addColorStop(0.45, '#e39448'); gl.addColorStop(1, '#9a4f1e');
      c.fillStyle = gl; c.fillRect(x0, y0, x1 - x0, y1 - y0);
      /* Lampe oben rechts, Luefterabdeckung, Einschubleisten, Rost — alles im warmen Licht */
      c.fillStyle = 'rgba(255,245,220,0.95)'; c.fillRect(x1 - 26, y0 + 4, 14, 8);
      c.lineWidth = 1.5;
      [22, 16, 10].forEach(function (r, i) { c.strokeStyle = 'rgba(255,230,190,' + (0.35 - i * 0.08) + ')'; c.beginPath(); c.arc(W / 2, H * 0.52, r, 0, Math.PI * 2); c.stroke(); });
      c.strokeStyle = 'rgba(255,225,180,0.55)'; c.lineWidth = 2;
      [0.36, 0.5, 0.64, 0.78].forEach(function (f) {
        var yv = H * f, yh = y0 + (y1 - y0) * (f - 0.1) / 0.8;
        c.beginPath(); c.moveTo(4, yv); c.lineTo(x0, yh); c.stroke();
        c.beginPath(); c.moveTo(W - 4, yv); c.lineTo(x1, yh); c.stroke();
      });
      var ry0 = H * 0.62, rh0 = y0 + (y1 - y0) * 0.65;
      c.strokeStyle = 'rgba(255,238,205,0.8)'; c.lineWidth = 1.8;
      c.beginPath(); c.moveTo(10, ry0); c.lineTo(W - 10, ry0); c.lineTo(x1 - 3, rh0); c.lineTo(x0 + 3, rh0); c.closePath(); c.stroke();
      c.lineWidth = 1.1;
      for (var kk = 1; kk < 14; kk++) { var f3 = kk / 14; c.beginPath(); c.moveTo(10 + (W - 20) * f3, ry0); c.lineTo(x0 + 3 + (x1 - x0 - 6) * f3, rh0); c.stroke(); }
      var tl = new T.CanvasTexture(cv);
      if (T.SRGBColorSpace) tl.colorSpace = T.SRGBColorSpace;
      geraetBilder[key] = tl;
      return tl;
    }
    var flaeche = function (farbe, pk) { c.fillStyle = farbe; c.beginPath(); c.moveTo(pk[0], pk[1]); for (var i = 2; i < pk.length; i += 2) c.lineTo(pk[i], pk[i + 1]); c.closePath(); c.fill(); };
    flaeche('#141617', [0, 0, x0, y0, x0, y1, 0, H]);          /* links */
    flaeche('#101213', [W, 0, x1, y0, x1, y1, W, H]);          /* rechts */
    flaeche('#191b1d', [0, 0, W, 0, x1, y0, x0, y0]);          /* Decke */
    flaeche('#0c0d0e', [0, H, W, H, x1, y1, x0, y1]);          /* Boden */
    var rg = c.createRadialGradient(W / 2, H * 0.5, 4, W / 2, H * 0.5, W * 0.34);
    rg.addColorStop(0, '#24272a'); rg.addColorStop(1, '#17191b');
    c.fillStyle = rg; c.fillRect(x0, y0, x1 - x0, y1 - y0);   /* Rueckwand */
    if (!mikro) {
      c.lineWidth = 1.4;
      [22, 17, 12, 7].forEach(function (r, i) {
        c.strokeStyle = 'rgba(150,156,160,' + (0.2 - i * 0.03) + ')';
        c.beginPath(); c.arc(W / 2, H * 0.52, r, 0, Math.PI * 2); c.stroke();
      });
      /* Einschubleisten: je Seite vier Stufen, perspektivisch zur Rueckwand */
      c.strokeStyle = 'rgba(160,166,170,0.22)'; c.lineWidth = 2;
      [0.36, 0.5, 0.64, 0.78].forEach(function (f) {
        var yv = H * f, yh = y0 + (y1 - y0) * (f - 0.1) / 0.8;
        c.beginPath(); c.moveTo(4, yv); c.lineTo(x0, yh); c.stroke();
        c.beginPath(); c.moveTo(W - 4, yv); c.lineTo(x1, yh); c.stroke();
      });
      /* Rost auf der zweiten Stufe: Rahmen und Staebe */
      var ry = H * 0.62, rh = y0 + (y1 - y0) * 0.65;
      c.strokeStyle = 'rgba(175,180,184,0.3)'; c.lineWidth = 1.6;
      c.beginPath(); c.moveTo(10, ry); c.lineTo(W - 10, ry); c.lineTo(x1 - 3, rh); c.lineTo(x0 + 3, rh); c.closePath(); c.stroke();
      c.lineWidth = 1;
      for (var k = 1; k < 14; k++) {
        var f2 = k / 14;
        c.beginPath(); c.moveTo(10 + (W - 20) * f2, ry); c.lineTo(x0 + 3 + (x1 - x0 - 6) * f2, rh); c.stroke();
      }
    } else {
      /* Drehteller */
      c.strokeStyle = 'rgba(160,166,170,0.3)'; c.lineWidth = 1.5;
      c.beginPath(); c.ellipse(W / 2, H * 0.8, W * 0.3, H * 0.07, 0, 0, Math.PI * 2); c.stroke();
      /* Lochblech im Sichtfenster: feines Punktraster ueber allem */
      c.fillStyle = 'rgba(0,0,0,0.55)';
      for (var py = 2; py < H; py += 5) for (var px = 2 + (py % 10 ? 2.5 : 0); px < W; px += 5) { c.beginPath(); c.arc(px, py, 1.4, 0, Math.PI * 2); c.fill(); }
    }
    var t = new T.CanvasTexture(cv);
    if (T.SRGBColorSpace) t.colorSpace = T.SRGBColorSpace;
    geraetBilder[key] = t;
    return t;
  }
  /* KOCHFELD MIT AUFDRUCK (Stufe 3): schwarzes Glas, die Kochzonen als feine graue Doppelkreise, vorn die Touch-Leiste mit
     Ein/Aus, Zonenwahl, Schieberegler 0–9 und Uhr — wie auf jedem Induktionsfeld. Unter dem Klarlack gedruckt (Farbbild des
     Glases), nicht als eigene Koerper. Oben im Bild liegt die Wandseite (BoxGeometry: v = 1 hinten). */
  function kochfeldBild(breiteCm, tiefeCm, zonen) {
    var key = 'koch' + breiteCm.toFixed(1);
    if (geraetBilder[key]) return geraetBilder[key];
    if (typeof document === 'undefined' || !document.createElement) return null;
    var W = 512, H = Math.round(512 * tiefeCm / breiteCm), pc = W / breiteCm;
    var cv = document.createElement('canvas'); cv.width = W; cv.height = H;
    var c = cv.getContext('2d');
    c.fillStyle = '#0b0c0d'; c.fillRect(0, 0, W, H);
    var X = function (x) { return (x + breiteCm / 2) * pc; }, Y = function (zz) { return (zz + tiefeCm / 2) * pc; };
    zonen.forEach(function (zn) {
      c.strokeStyle = '#6b7074'; c.lineWidth = 0.28 * pc;
      c.beginPath(); c.arc(X(zn[0]), Y(zn[1]), zn[2] * pc, 0, Math.PI * 2); c.stroke();
      c.strokeStyle = '#4e5357'; c.lineWidth = 0.2 * pc;
      c.beginPath(); c.arc(X(zn[0]), Y(zn[1]), zn[2] * 0.62 * pc, 0, Math.PI * 2); c.stroke();
    });
    var ty = Y(tiefeCm / 2 - 4.2);
    c.strokeStyle = '#a3a9ad'; c.fillStyle = '#a3a9ad'; c.lineWidth = 0.22 * pc;
    /* Ein/Aus */
    var ex = X(-breiteCm / 2 + 5);
    c.beginPath(); c.arc(ex, ty, 0.9 * pc, -Math.PI * 0.35, Math.PI * 1.35); c.stroke();
    c.beginPath(); c.moveTo(ex, ty - 1.1 * pc); c.lineTo(ex, ty - 0.2 * pc); c.stroke();
    /* Zonenwahl: vier kleine Kreise im Quadrat */
    [[-1, -1], [1, -1], [-1, 1], [1, 1]].forEach(function (q) {
      c.beginPath(); c.arc(X(-12) + q[0] * 0.8 * pc, ty + q[1] * 0.55 * pc, 0.35 * pc, 0, Math.PI * 2); c.stroke();
    });
    /* Schieberegler mit Teilung */
    var sx0 = X(-6), sx1 = X(12);
    c.beginPath(); c.moveTo(sx0, ty); c.lineTo(sx1, ty); c.stroke();
    for (var k = 0; k <= 9; k++) { var xx = sx0 + (sx1 - sx0) * k / 9; c.beginPath(); c.moveTo(xx, ty - 0.35 * pc); c.lineTo(xx, ty + 0.35 * pc); c.stroke(); }
    /* Uhr */
    var ux = X(breiteCm / 2 - 6);
    c.beginPath(); c.arc(ux, ty, 0.85 * pc, 0, Math.PI * 2); c.stroke();
    c.beginPath(); c.moveTo(ux, ty); c.lineTo(ux, ty - 0.55 * pc); c.moveTo(ux, ty); c.lineTo(ux + 0.4 * pc, ty + 0.25 * pc); c.stroke();
    var t = new T.CanvasTexture(cv);
    if (T.SRGBColorSpace) t.colorSpace = T.SRGBColorSpace;
    t.anisotropy = 8;
    geraetBilder[key] = t;
    return t;
  }
  function buerste(quer) {
    var key = quer ? 'q' : 'l';
    if (geraetBilder['b' + key]) return geraetBilder['b' + key];
    if (typeof document === 'undefined' || !document.createElement) return null;
    var cv = document.createElement('canvas'); cv.width = 256; cv.height = 256;
    var c = cv.getContext('2d'), s = 11;
    var zufall = function () { s = (s * 16807) % 2147483647; return (s - 1) / 2147483646; };
    c.fillStyle = '#9a9a9a'; c.fillRect(0, 0, 256, 256);
    for (var i = 0; i < 900; i++) {
      var g = 120 + Math.floor(zufall() * 110), a = 0.08 + zufall() * 0.22, lang = 40 + zufall() * 216, pos = zufall() * 256;
      c.fillStyle = 'rgba(' + g + ',' + g + ',' + g + ',' + a + ')';
      if (quer) c.fillRect(zufall() * 256 - 20, pos, lang, 0.6 + zufall() * 0.9);
      else c.fillRect(pos, zufall() * 256 - 20, 0.6 + zufall() * 0.9, lang);
    }
    var t = new T.CanvasTexture(cv);
    t.wrapS = t.wrapT = T.RepeatWrapping;
    geraetBilder['b' + key] = t;
    return t;
  }
  /* Anzeige: schwarzes Glas, darauf Ziffern (und optional Symbole) in kaltem Weiss — als Leuchtbild. */
  function anzeigeBild(text, symbole) {
    var key = 'a' + text + (symbole ? '+' : '');
    if (geraetBilder[key]) return geraetBilder[key];
    if (typeof document === 'undefined' || !document.createElement) return null;
    var cv = document.createElement('canvas'); cv.width = 256; cv.height = 64;
    var c = cv.getContext('2d');
    c.fillStyle = '#000000'; c.fillRect(0, 0, 256, 64);
    c.fillStyle = '#EAF6FF'; c.textBaseline = 'middle';
    c.font = '600 40px "Helvetica Neue", Arial, sans-serif';
    c.textAlign = symbole ? 'left' : 'center';
    c.fillText(text, symbole ? 14 : 128, 34);
    if (symbole) {
      /* Programmsymbole wie auf echten Leisten: Glas, Topf, Eco-Blatt, Uhr. */
      c.strokeStyle = '#EAF6FF'; c.lineWidth = 3;
      c.beginPath(); c.moveTo(150, 18); c.lineTo(156, 46); c.lineTo(166, 46); c.lineTo(172, 18); c.stroke();
      c.strokeRect(184, 24, 22, 20); c.beginPath(); c.moveTo(180, 24); c.lineTo(210, 24); c.stroke();
      c.beginPath(); c.arc(232, 32, 12, 0, Math.PI * 2); c.stroke();
      c.beginPath(); c.moveTo(232, 32); c.lineTo(232, 24); c.moveTo(232, 32); c.lineTo(238, 36); c.stroke();
    }
    var t = new T.CanvasTexture(cv);
    if (T.SRGBColorSpace) t.colorSpace = T.SRGBColorSpace;
    geraetBilder[key] = t;
    return t;
  }
  /* Bedienleiste eines Geschirrspuelers: Edelstahlflaeche, mittig das Anzeigefenster, rechts sechs Tasten mit Punkt. */
  function bedienBild() {
    if (geraetBilder.bed) return geraetBilder.bed;
    if (typeof document === 'undefined' || !document.createElement) return null;
    var cv = document.createElement('canvas'); cv.width = 512; cv.height = 64;
    var c = cv.getContext('2d');
    var gr = c.createLinearGradient(0, 0, 0, 64); gr.addColorStop(0, '#d7dadc'); gr.addColorStop(1, '#b9bdc0');
    c.fillStyle = gr; c.fillRect(0, 0, 512, 64);
    c.fillStyle = '#0b0c0d'; c.fillRect(150, 14, 120, 36);
    c.fillStyle = '#EAF6FF'; c.font = '600 26px "Helvetica Neue", Arial, sans-serif'; c.textBaseline = 'middle';
    c.fillText('2:45', 168, 33);
    c.fillStyle = '#7ED3FF'; c.fillRect(246, 24, 12, 12);
    for (var i = 0; i < 6; i++) {
      var x = 312 + i * 30;
      c.fillStyle = '#9ea3a7'; c.beginPath(); c.arc(x, 32, 10, 0, Math.PI * 2); c.fill();
      c.fillStyle = '#e9ecee'; c.beginPath(); c.arc(x, 31, 8.5, 0, Math.PI * 2); c.fill();
      c.fillStyle = '#5b6166'; c.beginPath(); c.arc(x, 32, 2.2, 0, Math.PI * 2); c.fill();
    }
    c.fillStyle = '#5b6166'; c.beginPath(); c.arc(40, 32, 12, 0, Math.PI * 2); c.fill();
    c.fillStyle = '#e9ecee'; c.beginPath(); c.arc(40, 31, 10.5, 0, Math.PI * 2); c.fill();
    c.strokeStyle = '#5b6166'; c.lineWidth = 2.5; c.beginPath(); c.arc(40, 32, 5, -1.1, 4.2); c.moveTo(40, 25); c.lineTo(40, 31); c.stroke();
    var t = new T.CanvasTexture(cv);
    if (T.SRGBColorSpace) t.colorSpace = T.SRGBColorSpace;
    geraetBilder.bed = t;
    return t;
  }

  function stein() {
    if (steinBild) return steinBild;
    var cv = document.createElement('canvas');
    cv.width = 256; cv.height = 256;
    var c = cv.getContext('2d'), s = 5;
    var zufall = function () { s = (s * 16807) % 2147483647; return (s - 1) / 2147483646; };
    c.fillStyle = '#E6E1D8'; c.fillRect(0, 0, 256, 256);
    for (var i = 0; i < 2600; i++) {
      var g = 150 + Math.floor(zufall() * 90);
      c.fillStyle = 'rgba(' + g + ',' + (g - 6) + ',' + (g - 14) + ',' + (0.12 + zufall() * 0.3) + ')';
      c.fillRect(zufall() * 256, zufall() * 256, 0.8 + zufall() * 1.6, 0.8 + zufall() * 1.6);
    }
    steinBild = new T.CanvasTexture(cv);
    steinBild.wrapS = steinBild.wrapT = T.RepeatWrapping;
    steinBild.repeat.set(4, 1);
    if (T.SRGBColorSpace) steinBild.colorSpace = T.SRGBColorSpace;
    return steinBild;
  }

  /* DIE GEWAEHLTE ARBEITSPLATTE ALS FLAECHE (R1, 2026-09-27). Die Produktbilder sind Eckfotos und
     taugen nicht als Textur; bis hierher lag nur die Mittelfarbe (`farbe`) ueber der Koernung —
     aus Schwarzem Marmor wurde eine braune Flaeche. Jetzt zeichnet das Muster aus dem Katalog
     (`muster`, `ader`) die Oberflaeche nach den Produktfotos: Marmor mit Adern, Eiche mit Lamellen
     und Aesten, Porterhouse als Stabholz, Vulkanschwarz als feiner Stein.
     Ein Bild = 420 x 65 cm, also eine ganze Platte ohne Wiederholung (Stuecke sind hoechstens
     400 cm); die Faser laeuft entlang der Platte. Fester Zufall je Platte: dieselbe Kueche sieht
     bei jedem Aufbau gleich aus. */
  /* Umgebungslicht der Hochglanzfronten. 1,5 wusch Grau Hochglanz zu Hellgrau aus (gemessen 221 statt
     156, 2026-09-27): der Faktor wirkt auch auf das diffuse Licht. Der Glanz kommt vom Klarlack. */
  var ENV_GLANZ = 0.35;
  /* Dunkle Hochglanzfronten (Grau): mehr Spiegelung ueber den Brechungsindex — ein hoeherer
     Umgebungsfaktor (0,9) hob auch das diffuse Licht und machte Grau wieder hell (gemessen 157). */
  var GLANZ_IOR_DUNKEL = 1.5;
  /* Grau Hochglanz spiegelte mit 0,35 fast nichts — die Fronten standen als gleichmaessige Flaeche
     (gemessen 78 ueberall, Betreiber-Foto 100–135 mit Lichtbahnen, 2026-09-28). */
  var ENV_GLANZ_DUNKEL = 0.8;
  /* Glanzia (2026-09-28, an den Produktfotos gemessen): Umgebungsfaktor [hell, dunkel] und Live-Anhebung [hell, dunkel]. */
  /* Weiss (hell): Anhebung 0,75 → Front 226–235 (Foto 225; vorher 160–212). Grau: nur die Grundfarbe #96989B (Kern), keine
     Anhebung → Seitenwand 136, Hauptwand 165–183, im Mittel 157 (Foto 155–159; vorher 66–113). Gemessen in Seiten- und
     Hauptansicht der L-Kueche 295/265 des Betreibers. Hell/dunkel nach der LINEAREN Helligkeit (three.js): Grau gilt als dunkel.
     Seit 2026-09-29 ist Grau #5E6366 (Foto der echten Tuer, im Raum 104/106/103) und spiegelt den Raum (raumSpiegel). */
  var GLANZIA_ENV = [0.35, 0.8], GLANZIA_HEBUNG = [0.75, 0];
  /* Heller Hochglanz (siehe frontMat), Stand 2026-09-30 (Betreiber: Weiss Hochglanz sah aus wie Weiss Matt): dielektrischer
     Lack, metalness 0, keine Eigenhelle. env 0,35 = Umgebungslicht wie Weiss Matt, die Front bleibt so weiss wie Matt;
     spiegel 3 hebt allein das Spiegelbild (wirksam 1,05) — Fenster, Raum und Lichtbaender stehen weich in der Front.
     rauh 0,1 / lackRauh 0,03: enges Glanzlicht, kein Chrom. Ersetzt 45 % Metall + Eigenhelle 0,4 (2026-09-29).
     Gilt nur live — das Foto rechnet mit eigenen Werten (FOTO_HELLGLANZ bei fotoMat). */
  var GLANZ_HELL = { rauh: 0.1, lackRauh: 0.03, env: 0.35, spiegel: 3 };
  if (TONKURVE === 'neutral') GLANZIA_HEBUNG = [0, 0];
  /* STEIN UND HOLZ AUS DER GRAFIKKARTE (Vorschlag Realismus, Betreiber 2026-09-28: „اريد زيادة واقعية المطابخ بشكل
     احترافي لكي لاتظهر كانها معمولة بالبلندر"). Die gezeichneten Bilder lasen sich als Zeichnung: Marmoradern als gleich
     dicke Linien mit grauem Hof, Fliesen mit Wolkenflecken, Dielen als Streifen. Jetzt rechnet die Grafikkarte die
     Flaeche aus Rauschen in verzerrtem Raum (fBm mit Domain Warping) — so wie Adern im Stein und Fasern im Holz wachsen:
     Adern mit wechselnder Breite, die auslaufen und sich kreuzen, Fliesen mit feiner Wolkung und scharfer Fuge, Dielen
     mit Faser, Fladerung und Poren. Einmal je Bild gerechnet, ausgelesen und als gewoehnliches Leinwandbild
     weitergegeben: Wiederholung, Foto und alles andere bleiben, wie sie mit den Leinwandbildern waren. Ohne Grafikkarte
     (Netze, Fehler) bleibt die Zeichnung. */
  var GLSL_RAUSCHEN = [
    'precision highp float;',
    'varying vec2 vUv;',
    'vec2 zz2(vec2 p) { p = vec2(dot(p, vec2(127.1, 311.7)), dot(p, vec2(269.5, 183.3))); return -1.0 + 2.0 * fract(sin(p) * 43758.5453123); }',
    'float zz1(vec2 p) { return fract(sin(dot(p, vec2(12.9898, 78.233))) * 43758.5453); }',
    'float rausch(vec2 p) {',
    '  vec2 i = floor(p), f = fract(p);',
    '  vec2 u = f * f * f * (f * (f * 6.0 - 15.0) + 10.0);',
    '  return mix(mix(dot(zz2(i), f), dot(zz2(i + vec2(1.0, 0.0)), f - vec2(1.0, 0.0)), u.x),',
    '             mix(dot(zz2(i + vec2(0.0, 1.0)), f - vec2(0.0, 1.0)), dot(zz2(i + vec2(1.0, 1.0)), f - vec2(1.0, 1.0)), u.x), u.y);',
    '}',
    'float fbm(vec2 p) {',
    '  float s = 0.0, a = 0.5;',
    '  for (int i = 0; i < 6; i++) { s += a * rausch(p); p = mat2(1.6, 1.2, -1.2, 1.6) * p + vec2(1.7, 9.2); a *= 0.5; }',
    '  return s;',
    '}',
    'float fbm01(vec2 p) { return clamp(fbm(p) * 0.85 + 0.5, 0.0, 1.0); }',
    /* Abstand zur naechsten ganzen Zahl eines Feldes: dort liegt eine Ader (oder Fuge). */
    'float linie(float feld) { float t = fract(feld); return min(t, 1.0 - t); }',
    ''
  ].join('\n');
  /* Ein Bild W x H aus einem Fragment-Shader: in ein Renderziel zeichnen, auslesen, auf eine Leinwand legen. */
  function gpuBild(W, H, frag, uniforms) {
    if (!rd || !T || typeof document === 'undefined' || !document.createElement) return null;
    var ziel = null, mat = null, geo = null;
    try {
      ziel = new T.WebGLRenderTarget(W, H, { depthBuffer: false, stencilBuffer: false });
      mat = new T.ShaderMaterial({
        vertexShader: 'varying vec2 vUv; void main() { vUv = uv; gl_Position = vec4(position.xy, 0.0, 1.0); }',
        fragmentShader: GLSL_RAUSCHEN + frag, uniforms: uniforms || {}, depthTest: false, depthWrite: false });
      geo = new T.PlaneGeometry(2, 2);
      /* Die Flaeche liegt schon im Bildraum (gl_Position = position); die Kamera ist nur Pflicht des Renderers. */
      var szene = new T.Scene(), kam = new T.Camera();
      szene.add(new T.Mesh(geo, mat));
      var vorher = rd.getRenderTarget();
      rd.setRenderTarget(ziel);
      rd.render(szene, kam);
      var px = new Uint8Array(W * H * 4);
      rd.readRenderTargetPixels(ziel, 0, 0, W, H, px);
      rd.setRenderTarget(vorher);
      var cv = document.createElement('canvas');
      cv.width = W; cv.height = H;
      var c = cv.getContext('2d'), bild = c.createImageData(W, H);
      /* readPixels liefert die unterste Zeile zuerst, die Leinwand die oberste. */
      for (var y = 0; y < H; y++) bild.data.set(px.subarray((H - 1 - y) * W * 4, (H - y) * W * 4), y * W * 4);
      c.putImageData(bild, 0, 0);
      return cv;
    } catch (e) {
      return null;
    } finally {
      if (ziel) ziel.dispose();
      if (mat) mat.dispose();
      if (geo) geo.dispose();
    }
  }
  function rgb01(hex) {
    var n = parseInt(String(hex || '#cccccc').replace('#', ''), 16);
    if (isNaN(n)) n = 0xcccccc;
    return new T.Vector3(((n >> 16) & 255) / 255, ((n >> 8) & 255) / 255, (n & 255) / 255);
  }
  function leinwandBild(cv, aniso) {
    var t = new T.CanvasTexture(cv);
    t.wrapS = t.wrapT = T.RepeatWrapping;
    if (T.SRGBColorSpace) t.colorSpace = T.SRGBColorSpace;
    t.anisotropy = aniso || 8;
    return t;
  }
  /* MARMOR (klassischer Turbulenz-Marmor): weisser Grund mit kaum sichtbarer Wolkung; lange, schraeg laufende Hauptadern
     sin(Richtung + Turbulenz) — die Betragssumme des Rauschens gibt ihnen die Knicke wie Risse im Stein —, mit wechselnder
     Breite und weichem grauem Hof, die auslaufen; duenne Nebenadern quer dazu. Panda (stark): wenige, breite, fast schwarze
     Adern. Dunkler Marmor: zusaetzlich feine helle Adern. In Zentimetern gerechnet (uCm). Der erste Versuch (Hoehenlinien
     eines stark verzerrten Feldes) ergab verschnoerkelte Linien wie auf einer Landkarte. */
  var GLSL_MARMOR = [
    'uniform vec3 uBasis; uniform vec3 uAder; uniform vec3 uAder2; uniform vec2 uCm;',
    'uniform float uSaat; uniform float uStark; uniform float uDunkel;',
    /* Turbulenz: Summe der Betraege — gibt den Adern ihre Knicke wie Risse im Stein. */
    'float turb(vec2 p) { float s = 0.0, a = 0.5; for (int i = 0; i < 6; i++) { s += a * abs(rausch(p)); p = mat2(1.6, 1.2, -1.2, 1.6) * p + vec2(3.1, 1.7); a *= 0.5; } return s; }',
    'void main() {',
    '  vec2 cm = vUv * uCm;',
    '  vec2 p = cm / 70.0 + vec2(uSaat * 7.13, uSaat * 3.71);',
    '  vec3 col = uBasis * (1.0 + 0.03 * fbm(p * 1.2) + 0.01 * rausch(cm * 0.8));',
    '  float a = 0.6 + 0.25 * sin(uSaat * 3.0);',
    '  float lin = cm.x * cos(a) + cm.y * sin(a);',
    '  float ph1 = lin / mix(52.0, 90.0, uStark) + 2.4 * turb(p * 0.85) + 0.9 * fbm(p * 0.3);',
    '  float m1 = abs(sin(ph1 * 3.14159));',
    '  float w1 = mix(0.02, 0.085, pow(fbm01(p * 0.7 + 11.0), 2.0)) * mix(1.0, 2.2, uStark);',
    '  float da = smoothstep(0.3, 0.6, fbm01(p * 0.25 + vec2(4.0, 1.0) + uSaat));',
    '  float kern1 = (1.0 - smoothstep(w1 * 0.35, w1, m1)) * da;',
    '  float hof1 = (1.0 - smoothstep(w1, w1 * 5.0, m1)) * da;',
    '  float b = -0.4 + 0.3 * cos(uSaat * 2.0);',
    '  float ph2 = (cm.x * cos(b) + cm.y * sin(b)) / 27.0 + 3.0 * turb(p * 1.6 + 5.0);',
    '  float kern2 = (1.0 - smoothstep(0.012, 0.04, abs(sin(ph2 * 3.14159)))) * smoothstep(0.52, 0.82, fbm01(p * 0.55 + 9.0));',
    '  col = mix(col, mix(col, uAder, 0.45), hof1 * mix(0.32, 0.4, uStark));',
    '  col = mix(col, uAder, kern1 * mix(0.72, 0.95, uStark));',
    '  col = mix(col, mix(uBasis, uAder, 0.7), kern2 * mix(0.45, 0.6, uStark));',
    '  if (uDunkel > 0.5) {',
    '    float ph4 = (cm.x * 0.3 + cm.y * 0.95) / 30.0 + 2.6 * turb(p * 1.2 + 3.0);',
    '    float k4 = (1.0 - smoothstep(0.01, 0.03, abs(sin(ph4 * 3.14159)))) * smoothstep(0.45, 0.8, fbm01(p * 0.8 + 17.0));',
    '    col = mix(col, uAder2, k4 * 0.6);',
    '  }',
    '  gl_FragColor = vec4(clamp(col, 0.0, 1.0), 1.0);',
    '}'
  ].join('\n');
  function marmorGpu(p, W, H) {
    var basis = p.farbe || '#cccccc';
    var dunkel = new T.Color(basis).getHSL({}).l < 0.4;
    if (dunkel) basis = K.ton(basis, -22);
    var s = 1;
    for (var k = 0; k < p.id.length; k++) s = (s * 31 + p.id.charCodeAt(k)) % 2147483647;
    return gpuBild(W, H, GLSL_MARMOR, {
      uBasis: { value: rgb01(basis) },
      uAder: { value: rgb01(p.ader || K.ton(basis, dunkel ? 60 : -30)) },
      uAder2: { value: rgb01('#ebe6de') },
      uCm: { value: new T.Vector2(PLATTE_BILD_CM[0], PLATTE_BILD_CM[1]) },
      uSaat: { value: (s % 997) / 97 },
      uStark: { value: p.stark ? 1 : 0 },
      uDunkel: { value: dunkel ? 1 : 0 }
    });
  }
  /* FLIESEN 80 x 80 (Feinsteinzeug in heller Steinoptik): je Fliese ein eigener Ausschnitt aus dem Stein (versetztes
     Rauschen), feine Wolkung und blasse Adern, eine Spur dunkler an der Kante, scharfe Fuge 4 mm. 3 x 3 Fliesen = 240 cm,
     nahtlos wiederholbar (die Bildkante liegt auf einer Fuge). */
  var GLSL_FLIESEN = [
    'uniform vec3 uStein; uniform vec3 uFuge;',
    'void main() {',
    '  vec2 cm = vUv * 240.0;',
    '  vec2 zelle = floor(cm / 80.0);',
    '  vec2 f = cm - zelle * 80.0;',
    '  float h = zz1(zelle + vec2(3.7, 1.9));',
    '  vec2 p = cm / 50.0 + vec2(h * 31.0, h * 17.0);',
    '  vec2 q = vec2(fbm(p * 0.6), fbm(p * 0.6 + vec2(4.1, 7.7)));',
    '  vec3 col = uStein * (1.0 + 0.028 * fbm(p * 0.9 + 1.5 * q) + 0.01 * rausch(cm * 1.7) + (h - 0.5) * 0.022);',
    '  float feld = (cm.x * 0.7 + cm.y * 0.35) / 60.0 + 1.8 * fbm(p * 0.7 + 2.0 * q) + h * 5.0;',
    '  float ad = (1.0 - smoothstep(0.003, 0.012, linie(feld))) * smoothstep(0.45, 0.8, fbm01(p * 0.5 + 9.0));',
    '  col = mix(col, uStein * 0.87, ad * 0.32);',
    '  float e = min(min(f.x, 80.0 - f.x), min(f.y, 80.0 - f.y));',
    '  col *= 1.0 - 0.045 * (1.0 - smoothstep(0.25, 1.2, e));',
    '  col = mix(col, uFuge, 1.0 - smoothstep(0.16, 0.26, e));',
    '  gl_FragColor = vec4(clamp(col, 0.0, 1.0), 1.0);',
    '}'
  ].join('\n');
  /* EICHENDIELEN 20 x 120 cm: je Diele ein Ton aus drei nahen Eichentoenen, lange Faser, bei manchen eine Fladerung
     (verbogene Jahresringe), feine Poren, dunkle Stoesse. 12 Reihen x 2 Dielen = 240 cm, nahtlos wiederholbar. */
  var GLSL_DIELEN = [
    'uniform vec3 uT1; uniform vec3 uT2; uniform vec3 uT3;',
    'void main() {',
    '  vec2 cm = vUv * 240.0;',
    '  float reihe = floor(cm.y / 20.0);',
    '  float hr = zz1(vec2(reihe, 4.3));',
    '  float x = cm.x + hr * 120.0;',
    '  float stueck = mod(floor(x / 120.0), 2.0);',
    '  float hs = zz1(vec2(reihe * 1.37 + stueck * 5.11, 2.9));',
    '  vec2 lok = vec2(mod(x, 120.0), cm.y - reihe * 20.0);',
    '  vec3 ton = mix(uT1, uT2, hs);',
    '  ton = mix(ton, uT3, smoothstep(0.6, 1.0, fract(hs * 7.31)) * 0.7);',
    '  float faser = fbm(vec2(lok.x / 110.0 + hs * 91.0, lok.y / 0.9 + hs * 37.0));',
    '  float mitte = 10.0 + 4.0 * rausch(vec2(hs * 13.0, 0.5));',
    '  float bog = abs(lok.y - mitte) + 5.0 * fbm(vec2(lok.x / 55.0 + hs * 7.0, hs * 3.0));',
    '  float ring = 0.5 + 0.5 * sin(bog * 2.4 + hs * 20.0);',
    '  float fl = smoothstep(0.45, 0.9, fbm01(vec2(lok.x / 80.0, hs * 11.0)));',
    '  vec3 col = ton * (1.0 + 0.10 * faser - 0.07 * ring * fl);',
    '  col *= 1.0 - 0.05 * smoothstep(0.55, 0.75, rausch(vec2(lok.x * 0.9, lok.y * 9.0) + hs * 50.0));',
    '  float fy = 1.0 - smoothstep(0.04, 0.12, min(lok.y, 20.0 - lok.y));',
    '  float fx = 1.0 - smoothstep(0.04, 0.12, min(lok.x, 120.0 - lok.x));',
    '  col *= 1.0 - 0.38 * max(fx, fy);',
    '  gl_FragColor = vec4(clamp(col, 0.0, 1.0), 1.0);',
    '}'
  ].join('\n');
  var BODEN_KACHEL_CM = 240;
  /* ZEMENTFLIESEN MIT MUSTER (Look „Stadt", Vorbild KU-S11): 20-cm-Fliesen, weiss mit schwarzem Rautengitter — die Rauten
     laufen ueber die Fugen weiter, wie bei echten Zementfliesen. Leicht unregelmaessig (Pigment, Kanten), 2 mm Fugen. */
  var GLSL_MUSTER = [
    'uniform vec3 uHell; uniform vec3 uDunkel; uniform vec3 uFuge;',
    'void main() {',
    '  vec2 cm = vUv * 240.0;',
    '  vec2 zelle = floor(cm / 20.0);',
    '  vec2 f = fract(cm / 20.0);',
    '  vec2 c = f - 0.5;',
    '  float d = abs(c.x) + abs(c.y);',
    '  float q = max(abs(c.x), abs(c.y));',
    '  float band = step(0.30, d) * (1.0 - step(0.40, d));',
    '  float ecke = step(0.86, d);',
    '  float kern = 1.0 - step(0.075, q);',
    '  float schwarz = clamp(band + ecke + kern, 0.0, 1.0);',
    '  float h = zz1(zelle + vec2(1.3, 7.1));',
    '  vec3 col = mix(uHell, uDunkel, schwarz);',
    '  col *= 1.0 + 0.035 * (fbm(cm * 0.18 + h * 11.0) - 0.5) + 0.012 * (rausch(cm * 3.1) - 0.5) + (h - 0.5) * 0.03;',
    '  vec2 g = min(f, 1.0 - f) * 20.0;',
    '  float e = min(g.x, g.y);',
    '  col = mix(col, uFuge, 1.0 - smoothstep(0.08, 0.16, e));',
    '  gl_FragColor = vec4(clamp(col, 0.0, 1.0), 1.0);',
    '}'
  ].join('\n');
  var musterBild = null;
  function musterFliesen(wx, wz) {
    if (!musterBild) {
      var gm = gpuBild((w.innerWidth || 800) >= 768 ? 2048 : 1024, (w.innerWidth || 800) >= 768 ? 2048 : 1024, GLSL_MUSTER,
        { uHell: { value: rgb01('#ECE8E1') }, uDunkel: { value: rgb01('#2B2A28') }, uFuge: { value: rgb01('#BDB6AB') } });
      if (gm) musterBild = leinwandBild(gm, 8);
    }
    if (!musterBild) return fliesen(wx, wz);
    var t = musterBild.clone();
    t.needsUpdate = true;
    t.repeat.set(wx / BODEN_KACHEL_CM, wz / BODEN_KACHEL_CM);
    return t;
  }
  /* TEPPICH (Looks): flach gewebt, feine Rippen und eine Borte — gemalt, 512 px, je Farbe einmal. */
  var teppichBilder = {};
  function teppichBild(farbe) {
    if (teppichBilder[farbe]) return teppichBilder[farbe];
    var N = 512, cv = document.createElement('canvas'); cv.width = N; cv.height = N;
    var c = cv.getContext('2d'), s0 = 29, zu = function () { s0 = (s0 * 16807) % 2147483647; return (s0 - 1) / 2147483646; };
    c.fillStyle = farbe; c.fillRect(0, 0, N, N);
    for (var y = 0; y < N; y += 3) {
      c.fillStyle = 'rgba(0,0,0,' + (0.03 + zu() * 0.035) + ')'; c.fillRect(0, y, N, 1);
      c.fillStyle = 'rgba(255,255,255,' + (0.02 + zu() * 0.03) + ')'; c.fillRect(0, y + 1, N, 1);
    }
    for (var k = 0; k < 2600; k++) { c.fillStyle = 'rgba(0,0,0,' + (zu() * 0.05) + ')'; c.fillRect(zu() * N, zu() * N, 2 + zu() * 3, 1); }
    c.strokeStyle = 'rgba(0,0,0,0.16)'; c.lineWidth = 10; c.strokeRect(22, 22, N - 44, N - 44);
    c.strokeStyle = 'rgba(0,0,0,0.08)'; c.lineWidth = 3; c.strokeRect(40, 40, N - 80, N - 80);
    var t = new T.CanvasTexture(cv);
    if (T.SRGBColorSpace) t.colorSpace = T.SRGBColorSpace;
    t.anisotropy = 8;
    teppichBilder[farbe] = t;
    return t;
  }
  function bodenGpu(art) {
    var gross = (w.innerWidth || 800) >= 768 ? 2048 : 1024;
    return art === 'fliesen'
      ? gpuBild(gross, gross, GLSL_FLIESEN, { uStein: { value: rgb01('#EAE4DA') }, uFuge: { value: rgb01('#CFC5B8') } })
      : gpuBild(gross, gross, GLSL_DIELEN, { uT1: { value: rgb01('#CFB28C') }, uT2: { value: rgb01('#C9AB83') },
          uT3: { value: rgb01('#D6BA95') } });
  }

  /* WAND, DECKE, LICHTKEGEL, HIMMEL (Realismus, 2026-09-28): kleine Leinwandbilder, einmal gerechnet.
     Wand: in einem echten Raum ist eine Wand nie gleich hell — unten etwas dunkler (Boden, Moebel), um Augenhoehe am
     hellsten, zur Decke hin dunkler (dort kommt am wenigsten Licht hin); dazu ein kaum sichtbarer Anstrich (Rolle, Putz).
     Ein Bild = 120 cm breit, ueber die ganze Raumhoehe. */
  var raumBilder = {};
  function wandBild(breiteCm) {
    if (!raumBilder.wand) {
      var W = 256, H = 256, cv = document.createElement('canvas'); cv.width = W; cv.height = H;
      var c = cv.getContext('2d'), bild = c.createImageData(W, H), s = 29;
      var zufall = function () { s = (s * 16807) % 2147483647; return (s - 1) / 2147483646; };
      var glatt = function (a, b, x) { var t = Math.max(0, Math.min(1, (x - a) / (b - a))); return t * t * (3 - 2 * t); };
      /* grobe Wolkung: kleines Raster, weich gemittelt */
      var grob = [], G = 16;
      for (var g = 0; g < G * G; g++) grob.push(zufall());
      var wolke = function (x, y) {
        var gx = x / W * G, gy = y / H * G, x0 = Math.floor(gx) % G, y0 = Math.floor(gy) % G, x1 = (x0 + 1) % G, y1 = (y0 + 1) % G;
        var fx = gx - Math.floor(gx), fy = gy - Math.floor(gy);
        var a = grob[y0 * G + x0] * (1 - fx) + grob[y0 * G + x1] * fx, b = grob[y1 * G + x0] * (1 - fx) + grob[y1 * G + x1] * fx;
        return a * (1 - fy) + b * fy;
      };
      for (var y = 0; y < H; y++) {
        var v = 1 - y / (H - 1);   /* 0 unten, 1 oben */
        var hell = 0.93 + 0.07 * glatt(0.0, 0.4, v) - 0.10 * glatt(0.62, 1.0, v);
        for (var x = 0; x < W; x++) {
          var f = hell * (1 + 0.018 * (wolke(x, y) - 0.5) + 0.01 * (zufall() - 0.5));
          var q = Math.max(0, Math.min(255, Math.round(255 * f))), i = (y * W + x) * 4;
          bild.data[i] = q; bild.data[i + 1] = q; bild.data[i + 2] = q; bild.data[i + 3] = 255;
        }
      }
      c.putImageData(bild, 0, 0);
      raumBilder.wand = leinwandBild(cv, 4);
    }
    var t = raumBilder.wand.clone(); t.needsUpdate = true;
    t.wrapT = T.ClampToEdgeWrapping;
    t.repeat.set(Math.max(1, breiteCm / 120), 1);
    return t;
  }
  /* Decke: in der Mitte heller, zu den Waenden hin etwas dunkler. */
  /* Voute: Farbe und Staerke des Deckenrands; `vouteBild` der Verlauf (Rand hell, nach ~30 cm abklingend, Mitte = alter
     Grundwert `grund`). Linear gemalt (keine sRGB-Kurve). */
  var VOUTE_STAERKE = 2.6;
  var vouteBilder = {};
  function vouteBild(B, Tf, grund) {
    var sch = Math.round(B) + 'x' + Math.round(Tf) + 'x' + grund.toFixed(3);
    if (vouteBilder[sch]) return vouteBilder[sch];
    var N = 256, cv = document.createElement('canvas');
    cv.width = N; cv.height = N;
    var c = cv.getContext('2d'), bild = c.createImageData(N, N);
    for (var y = 0; y < N; y++) {
      for (var x = 0; x < N; x++) {
        var u = (x + 0.5) / N, v = (y + 0.5) / N;
        var dx = Math.max(0, Math.min(u, 1 - u) * B - 2), dz = Math.max(0, Math.min(v, 1 - v) * Tf - 2);
        var gl = Math.min(1, 0.85 * Math.exp(-dx / 26) + 0.85 * Math.exp(-dz / 26) + 0.15 * Math.exp(-Math.min(dx, dz) / 6));
        /* Mitte neutral (die Decke bleibt weiss), der Rand im warmen Licht der Voute. */
        var i = (y * N + x) * 4;
        [[0.95, 1], [0.94, 0.906], [0.92, 0.784]].forEach(function (k, j) {
          bild.data[i + j] = Math.round(255 * Math.min(1, grund * k[0] + (1 - grund) * gl * k[1]));
        });
        bild.data[i + 3] = 255;
      }
    }
    c.putImageData(bild, 0, 0);
    var tex = new T.CanvasTexture(cv);
    tex.wrapS = tex.wrapT = T.ClampToEdgeWrapping;
    /* Only the current room size stays cached (2026-10-01): the key holds the room size, so every new size added one more
       image for the rest of the session. The previous image leaves with the old kitchen (szeneFreigeben). */
    vouteBilder = {};
    vouteBilder[sch] = tex;
    return tex;
  }
  function deckenBild() {
    if (!raumBilder.decke) {
      var cv = document.createElement('canvas'); cv.width = 128; cv.height = 128;
      var c = cv.getContext('2d'), gr = c.createRadialGradient(64, 64, 8, 64, 64, 92);
      gr.addColorStop(0, '#ffffff'); gr.addColorStop(1, '#e2e2e2');
      c.fillStyle = gr; c.fillRect(0, 0, 128, 128);
      raumBilder.decke = leinwandBild(cv, 2);
      raumBilder.decke.wrapS = raumBilder.decke.wrapT = T.ClampToEdgeWrapping;
    }
    return raumBilder.decke;
  }
  /* Lichtkegel einer Einbauleuchte auf der Wand: oben durch den Leuchtenrand scharf begrenzt (Parabel), nach unten und
     zur Seite weich auslaufend, knapp unter der Decke ein hellerer Kern. Weiss mit Deckkraft — die Farbe gibt das Material. */
  function kegelBild() {
    if (!raumBilder.kegel) {
      var W = 128, H = 256, cv = document.createElement('canvas'); cv.width = W; cv.height = H;
      var c = cv.getContext('2d'), bild = c.createImageData(W, H);
      var glatt = function (a, b, x) { var t = Math.max(0, Math.min(1, (x - a) / (b - a))); return t * t * (3 - 2 * t); };
      for (var y = 0; y < H; y++) {
        var v = y / (H - 1);   /* 0 oben (Decke), 1 unten */
        for (var x = 0; x < W; x++) {
          var u = (x / (W - 1)) * 2 - 1;
          var rand = v - 0.06 - 0.55 * u * u;
          var a = glatt(0, 0.05, rand) * Math.exp(-v * 2.3) * (1 - glatt(0.6, 1.0, Math.abs(u)))
            + 0.45 * Math.exp(-((u / 0.22) * (u / 0.22) + ((v - 0.1) / 0.09) * ((v - 0.1) / 0.09)));
          var i = (y * W + x) * 4;
          bild.data[i] = 255; bild.data[i + 1] = 255; bild.data[i + 2] = 255; bild.data[i + 3] = Math.round(255 * Math.min(1, a));
        }
      }
      c.putImageData(bild, 0, 0);
      var t = new T.CanvasTexture(cv);
      if (T.SRGBColorSpace) t.colorSpace = T.SRGBColorSpace;
      raumBilder.kegel = t;
    }
    return raumBilder.kegel;
  }
  /* Tageslicht hinter der Fensterscheibe: oben ein helles, kuehles Himmelweiss, unten waermer (Gegenlicht draussen). */
  /* Das Fenster im Spiegelbild: helle Scheibe, oben etwas heller, mit Rahmen und Kreuz (die Sprossen machen es im
     Spiegel zum Fenster statt zu einem hellen Fleck). Einmal gezeichnet. */
  /* AUSSICHT (2026-09-29, Poly Haven „wide_street_01", CC0): ein echtes Foto hinter jedem Fenster und in den Fenstern, die
     sich in Hochglanz und Glas spiegeln — Baeume, Haeuser, Himmel wie auf den Serienbildern (KU-S11). Bis es geladen ist,
     bleibt der gemalte Himmel. */
  var aussichtQuelle = null, aussichtTex = null, aussichtLaedt = false;
  function aussichtBild() {
    if (aussichtTex) return aussichtTex;
    if (aussichtQuelle && !aussichtLaedt && T) {
      aussichtLaedt = true;
      new T.TextureLoader().load(aussichtQuelle, function (t) {
        if (T.SRGBColorSpace) t.colorSpace = T.SRGBColorSpace;
        aussichtTex = t; fensterKarteTex = null;
        dekoNeuBauen();
      }, undefined, function () { /* ohne Foto bleibt der gemalte Himmel */ });
    }
    return null;
  }
  /* Ausschnitt der Aussicht fuer ein Fenster b x h: mittig, so breit wie das Fenster im Seitenverhaeltnis des Fotos. */
  function aussichtFuer(b, h) {
    var t0 = aussichtBild();
    if (!t0 || !t0.image || !t0.image.width) return null;
    var t = t0.clone(); t.needsUpdate = true;
    var ib = t0.image.width / t0.image.height, fb = b / Math.max(1, h);
    if (fb < ib) { t.repeat.set(fb / ib, 1); t.offset.set((1 - fb / ib) / 2, 0); }
    else { t.repeat.set(1, ib / fb); t.offset.set(0, (1 - ib / fb) * 0.35); }
    return t;
  }
  var fensterKarteTex = null;
  function fensterKarteBild() {
    if (fensterKarteTex) return fensterKarteTex;
    var foto = aussichtBild();
    if (foto && foto.image && foto.image.width) {
      /* Mit Foto: die Aussicht in die Scheibe, darueber Rahmen und Kreuz. */
      var cvF = document.createElement('canvas'); cvF.width = 512; cvF.height = 512;
      var cF = cvF.getContext('2d'), im = foto.image, q = Math.min(im.width, im.height * 1.0);
      cF.drawImage(im, (im.width - q) / 2, 0, q, im.height, 0, 0, 512, 512);
      cF.fillStyle = '#6d6a66';
      cF.fillRect(0, 0, 512, 16); cF.fillRect(0, 496, 512, 16); cF.fillRect(0, 0, 16, 512); cF.fillRect(496, 0, 16, 512);
      cF.fillRect(248, 0, 16, 512);
      fensterKarteTex = new T.CanvasTexture(cvF);
      if (T.SRGBColorSpace) fensterKarteTex.colorSpace = T.SRGBColorSpace;
      return fensterKarteTex;
    }
    /* Ein Fenster MIT AUSSICHT (Vorlage 4 des Betreibers: in den Hochglanzfronten steht eine Landschaft): heller Himmel,
       eine Baumreihe am Horizont, darunter Wiese — im Spiegel liest sich das als Fenster, nicht als heller Fleck. */
    var W = 256, H = 256, cv = document.createElement('canvas');
    cv.width = W; cv.height = H;
    var c = cv.getContext('2d'), gr = c.createLinearGradient(0, 0, 0, H * 0.6);
    gr.addColorStop(0, '#ffffff'); gr.addColorStop(1, '#dde8f3');
    c.fillStyle = gr; c.fillRect(0, 0, W, H);
    var s0 = 11, zu = function () { s0 = (s0 * 16807) % 2147483647; return (s0 - 1) / 2147483646; };
    /* Ferne Huegel, blaugrau */
    c.fillStyle = '#c4c9cc'; c.beginPath(); c.moveTo(0, H * 0.6);
    for (var x = 0; x <= W; x += 8) c.lineTo(x, H * (0.52 + 0.05 * Math.sin(x / 37) + 0.02 * Math.sin(x / 11)));
    c.lineTo(W, H * 0.6); c.fill();
    /* Baumreihe: dunkle, weiche Kronen */
    for (var i = 0; i < 70; i++) {
      var bx = zu() * W, by = H * (0.55 + zu() * 0.08), br = 6 + zu() * 14;
      c.fillStyle = ['#666a61', '#72766b', '#5d6159', '#7c7f74'][i % 4];
      c.beginPath(); c.arc(bx, by, br, 0, Math.PI * 2); c.fill();
    }
    var wg = c.createLinearGradient(0, H * 0.62, 0, H);
    wg.addColorStop(0, '#a8a79c'); wg.addColorStop(1, '#8f8c82');
    c.fillStyle = wg; c.fillRect(0, H * 0.62, W, H * 0.38);
    /* Rahmen und Kreuz */
    c.fillStyle = '#6d6a66';
    c.fillRect(0, 0, W, 9); c.fillRect(0, H - 9, W, 9); c.fillRect(0, 0, 9, H); c.fillRect(W - 9, 0, 9, H);
    c.fillRect(W / 2 - 5, 0, 10, H); c.fillRect(0, H * 0.34, W, 8);
    fensterKarteTex = new T.CanvasTexture(cv);
    if (T.SRGBColorSpace) fensterKarteTex.colorSpace = T.SRGBColorSpace;
    return fensterKarteTex;
  }
  function himmelBild() {
    if (!raumBilder.himmel) {
      var cv = document.createElement('canvas'); cv.width = 8; cv.height = 128;
      var c = cv.getContext('2d'), gr = c.createLinearGradient(0, 0, 0, 128);
      gr.addColorStop(0, '#E7F0FF'); gr.addColorStop(0.55, '#F4F6F8'); gr.addColorStop(1, '#F6EFE4');
      c.fillStyle = gr; c.fillRect(0, 0, 8, 128);
      raumBilder.himmel = leinwandBild(cv, 1);
      raumBilder.himmel.wrapS = raumBilder.himmel.wrapT = T.ClampToEdgeWrapping;
    }
    return raumBilder.himmel;
  }

  var PLATTE_BILD_CM = [420, 65], plattenBilder = {};
  function plattenBild(p) {
    var schl = p.id + '|' + (p.muster || '') + '|' + p.farbe;
    if (plattenBilder[schl]) return plattenBilder[schl];
    var W = 2048, H = 320, PX = W / PLATTE_BILD_CM[0];
    if ((p.muster || 'stein') === 'marmor') {
      var mg = marmorGpu(p, W, H);
      if (mg) return (plattenBilder[schl] = leinwandBild(mg, 8));
    }
    var cv = document.createElement('canvas');
    cv.width = W; cv.height = H;
    var c = cv.getContext('2d');
    var s = 1;
    for (var k = 0; k < p.id.length; k++) s = (s * 31 + p.id.charCodeAt(k)) % 2147483647;
    s = s || 3;
    var zufall = function () { s = (s * 16807) % 2147483647; return (s - 1) / 2147483646; };
    var basis = p.farbe || '#cccccc';
    /* Weiche Wolken: ein kleines Zufallsraster, weich hochgezogen. Hell und dunkel getrennt,
       damit der Mittelwert bei der Katalogfarbe bleibt. */
    var wolken = function (nx, ny, farbe, staerke) {
      var kl = document.createElement('canvas');
      kl.width = nx; kl.height = ny;
      var kc = kl.getContext('2d'), bild = kc.createImageData(nx, ny);
      var rgb = new T.Color(farbe);
      for (var i = 0; i < nx * ny; i++) {
        bild.data[i * 4] = rgb.r * 255; bild.data[i * 4 + 1] = rgb.g * 255; bild.data[i * 4 + 2] = rgb.b * 255;
        bild.data[i * 4 + 3] = Math.pow(zufall(), 2.2) * 255 * staerke;
      }
      kc.putImageData(bild, 0, 0);
      c.imageSmoothingEnabled = true;
      if ('imageSmoothingQuality' in c) c.imageSmoothingQuality = 'high';
      c.drawImage(kl, 0, 0, nx, ny, -W / nx, -H / ny, W + 2 * W / nx, H + 2 * H / ny);
    };
    c.fillStyle = basis; c.fillRect(0, 0, W, H);
    var muster = p.muster || 'stein';

    if (muster === 'marmor') {
      var dunkel = new T.Color(basis).getHSL({}).l < 0.4;
      /* Die Katalogfarbe ist das MITTEL der Plattenoberseite samt Adern und Glanzlicht; der
         Stein selbst ist beim dunklen Marmor fast schwarz (Produktfoto San Sebastian). */
      if (dunkel) { basis = K.ton(basis, -22); c.fillStyle = basis; c.fillRect(0, 0, W, H); }
      var hellM = !dunkel && new T.Color(basis).getHSL({}).l > 0.8;
      wolken(40, 7, K.ton(basis, dunkel ? 7 : (hellM ? 5 : 8)), hellM ? 0.35 : 0.55);
      wolken(90, 15, K.ton(basis, dunkel ? -8 : (hellM ? -4 : -7)), hellM ? 0.3 : 0.45);
      wolken(220, 34, K.ton(basis, dunkel ? 6 : 5), 0.3);
      /* Adern: eine gezogene Linie mit Hof. Jede Ader laeuft schraeg ueber die Platte, knickt
         unruhig und treibt duenne Zweige. Erst der breite, blasse Hof, dann der Kern. */
      var ader = function (x, y, winkel, laenge, breite, farbe, alpha, tiefe) {
        var pkte = [[x, y]], a = winkel;
        for (var n = 0; n < laenge; n += 10) {
          a += (zufall() - 0.5) * 0.55;
          a = winkel + Math.max(-0.9, Math.min(0.9, a - winkel));
          x += Math.cos(a) * 10; y += Math.sin(a) * 10;
          pkte.push([x, y]);
          if (tiefe < 2 && zufall() < 0.035) {
            ader(x, y, a + (zufall() < 0.5 ? -1 : 1) * (0.5 + zufall() * 0.6), 60 + zufall() * 260,
              breite * 0.55, farbe, alpha * 0.8, tiefe + 1);
          }
        }
        [[breite * 6, alpha * 0.07], [breite * 2.5, alpha * 0.18], [breite, alpha]].forEach(function (st) {
          c.globalAlpha = st[1];
          c.strokeStyle = farbe;
          c.lineWidth = st[0];
          c.lineJoin = 'round'; c.lineCap = 'round';
          c.beginPath();
          pkte.forEach(function (q, i) { if (i) c.lineTo(q[0], q[1]); else c.moveTo(q[0], q[1]); });
          c.stroke();
        });
        c.globalAlpha = 1;
      };
      var aderF = p.ader || K.ton(basis, dunkel ? 60 : -30);
      var zahl = dunkel ? 9 : (hellM ? 12 : 7);
      for (var i1 = 0; i1 < zahl; i1++) {
        var x0 = zufall() * W, obenStart = zufall() < 0.5;
        var wk = (obenStart ? 1 : -1) * (0.15 + zufall() * 0.45);
        if (zufall() < 0.5) wk = Math.PI - wk;
        ader(x0, obenStart ? -10 : H + 10, wk, 400 + zufall() * 900,
          (dunkel ? 0.5 + zufall() * 0.8 : 0.8 + zufall() * 1.6) * (p.stark ? 3.2 : 1), aderF,
          p.stark ? 0.92 : (dunkel ? 0.8 : (hellM ? 0.6 : 0.35)), 0);
      }
      /* Schwarzer Marmor (San Sebastian) hat neben den goldenen auch feine weisse Adern. */
      if (dunkel) {
        for (var i2 = 0; i2 < 5; i2++) {
          ader(zufall() * W, zufall() * H, (zufall() - 0.5) * 1.6, 150 + zufall() * 400, 0.6, '#ebe6de', 0.55, 1);
        }
      }
    } else if (muster === 'eiche') {
      /* Eiche: Lamellen quer zur Tiefe (10–18 cm breit), laengs gestossen alle 70–160 cm, jede
         eine Spur anders im Ton; darin Fasern mit Welle, ab und zu ein Ast. */
      var yy = 0;
      while (yy < H) {
        var lh = (14 + zufall() * 10) * PX, xx = -zufall() * 120 * PX;
        while (xx < W) {
          var ll = (90 + zufall() * 110) * PX;
          c.fillStyle = K.ton(basis, (zufall() - 0.5) * 12);
          c.fillRect(xx, yy, ll, lh);
          for (var f1 = 0; f1 < 60; f1++) {
            var fy = yy + zufall() * lh, amp = 1 + zufall() * 5, ph = zufall() * 6;
            c.strokeStyle = K.ton(basis, zufall() < 0.4 ? 10 + zufall() * 10 : -(10 + zufall() * 26));
            c.globalAlpha = 0.18 + zufall() * 0.35;
            c.lineWidth = 0.5 + zufall() * 1.8;
            c.beginPath();
            for (var gx = 0; gx <= ll; gx += 16) {
              var py = fy + Math.sin((xx + gx) / 140 + ph) * amp + Math.sin((xx + gx) / 37 + ph * 2) * amp * 0.25;
              if (gx === 0) c.moveTo(xx + gx, py); else c.lineTo(xx + gx, py);
            }
            c.stroke();
          }
          /* Fladerung: ineinanderliegende Boegen, wie sie ein Brett aus dem Stammrand zeigt. */
          if (zufall() < 0.4) {
            var fx = xx + ll * (0.2 + zufall() * 0.5), fm = yy + lh / 2, fl = ll * (0.25 + zufall() * 0.3);
            for (var bo = 1; bo <= 7; bo++) {
              var bh = lh * 0.07 * bo;
              c.strokeStyle = K.ton(basis, -(14 + zufall() * 18));
              c.globalAlpha = 0.22 + zufall() * 0.2;
              c.lineWidth = 0.8 + zufall() * 1.2;
              c.beginPath();
              c.moveTo(fx + fl, fm - bh);
              c.quadraticCurveTo(fx - fl * 0.25 * bo / 7, fm - bh, fx - 6 * bo, fm);
              c.quadraticCurveTo(fx - fl * 0.25 * bo / 7, fm + bh, fx + fl, fm + bh);
              c.stroke();
            }
            c.globalAlpha = 1;
          }
          if (zufall() < 0.45) {
            var ax = xx + zufall() * ll, ay = yy + zufall() * lh;
            for (var r = 3; r >= 1; r--) {
              c.globalAlpha = 0.25 + (3 - r) * 0.2;
              c.fillStyle = K.ton(basis, -28 - (3 - r) * 16);
              c.beginPath(); c.ellipse(ax, ay, 5 * r, 2.2 * r, 0, 0, Math.PI * 2); c.fill();
            }
          }
          c.globalAlpha = 0.3; c.fillStyle = K.ton(basis, -26);
          c.fillRect(xx + ll - 1, yy, 1, lh);
          c.globalAlpha = 1;
          xx += ll;
        }
        c.globalAlpha = 0.14; c.fillStyle = K.ton(basis, -24);
        c.fillRect(0, yy + lh - 1, W, 1);
        c.globalAlpha = 1;
        yy += lh;
      }
    } else if (muster === 'block') {
      /* Porterhouse: Stabholz — 3,5–5 cm breite Staebe, 20–70 cm lang, kraeftig im Ton gestreut
         (so zeigen es beide Produktfotos). */
      var sy = 0;
      while (sy < H) {
        var sh = (3.5 + zufall() * 1.5) * PX, sx = -zufall() * 60 * PX;
        while (sx < W) {
          var sl = (20 + zufall() * 50) * PX;
          c.fillStyle = K.ton(basis, (zufall() - 0.5) * 44);
          c.fillRect(sx, sy, sl, sh);
          for (var f2 = 0; f2 < 5; f2++) {
            c.strokeStyle = K.ton(basis, -(15 + zufall() * 30));
            c.globalAlpha = 0.25 + zufall() * 0.3;
            c.lineWidth = 0.5 + zufall();
            var by = sy + zufall() * sh;
            c.beginPath(); c.moveTo(sx, by); c.lineTo(sx + sl, by + (zufall() - 0.5) * 3); c.stroke();
          }
          c.globalAlpha = 0.55; c.fillStyle = K.ton(basis, -40);
          c.fillRect(sx + sl - 1, sy, 1.2, sh);
          c.globalAlpha = 1;
          sx += sl;
        }
        c.globalAlpha = 0.45; c.fillStyle = K.ton(basis, -38);
        c.fillRect(0, sy + sh - 1, W, 1);
        c.globalAlpha = 1;
        sy += sh;
      }
    } else {
      /* Stein (Vulkanschwarz): feine Koernung, kaum Wolken. */
      wolken(120, 20, K.ton(basis, 6), 0.35);
      for (var i3 = 0; i3 < 16000; i3++) {
        c.globalAlpha = 0.15 + zufall() * 0.35;
        c.fillStyle = K.ton(basis, zufall() < 0.5 ? 14 + zufall() * 16 : -8);
        c.fillRect(zufall() * W, zufall() * H, 1 + zufall() * 1.4, 1 + zufall() * 1.4);
      }
      c.globalAlpha = 1;
    }
    var tex = new T.CanvasTexture(cv);
    tex.wrapS = tex.wrapT = T.RepeatWrapping;
    if (T.SRGBColorSpace) tex.colorSpace = T.SRGBColorSpace;
    tex.anisotropy = 8;
    plattenBilder[schl] = tex;
    return tex;
  }

  /* ECHTE DEKORE (Betreiber 2026-09-27: „die Farben der Schraenke und der Sockel sind nicht wie in
     Wirklichkeit"). Die gezeichnete Maserung war eine gleichmaessige blasse Streifung mit runden
     Punkten — Artisan Eiche hat Fladern, Aeste und Risse, Sonoma und Dunkle Eiche eine feine
     senkrechte Faser. Jetzt liegt das Dekor aus dem Produktfoto auf Fronten, Korpus und Sockel:
     je Dekor die Tuerflaeche eines D60, perspektivisch entzerrt, Studiolicht ausgeglichen
     (Theme-Assets hm-dekor-*.jpg, Quellen im Planer-Ordner). `quer` = die Faser laeuft im Bild
     waagrecht (Velora-Tueren), sonst senkrecht. Bis ein Bild geladen ist — oder ohne Bild —
     bleibt die gezeichnete Maserung. */
  var dekorQuellen = {}, dekorTex = {}, dekorLaedt = {};
  /* ECHTE DEKO (Betreiber 2026-09-26: „die Deko auf der Platte sieht nicht echt aus" → echte Modelle).
     Pflanze, Holzschale mit Aepfeln und Limetten, Schneidebrett, Keramikkrug: Poly Haven (CC0), in
     ~/himarkt-planer-redesign/deko-modelle verkleinert (packen.py, Texturen 512/256 px, Geometrie mit
     KHR_mesh_quantization) → Theme-Assets hm-deko-*.glb, zusammen gut 2 MB. Geladen erst, wenn die
     Szene steht, mit dem GLTFLoader derselben three-Fassung von esm.sh; bis dahin steht dort nichts,
     danach wird einmal neu gebaut. Ohne Quelle (alte Seite) oder wenn etwas scheitert: die gezeichnete
     Deko wie bisher. */
  var dekoModellQuellen = {}, dekoModellFertig = {}, dekoModellLaedt = {};
  function gltfQuelle() {
    var m = /^https:\/\/esm\.sh\/three@([\d.]+)/.exec(dreiQuelle || '');
    return m ? 'https://esm.sh/three@' + m[1] + '/examples/jsm/loaders/GLTFLoader.js?deps=three@' + m[1] : null;
  }
  /* Quantisierte Attribute (int8/int16 normalisiert) als Float32 — Pfadverfolger und Strahltest
     sollen nichts Besonderes sehen. */
  function entquantisieren(geo) {
    ['position', 'normal', 'uv'].forEach(function (n) {
      var a = geo.getAttribute(n);
      if (!a || a.array instanceof Float32Array) return;
      var f = new Float32Array(a.count * a.itemSize), get = [a.getX, a.getY, a.getZ, a.getW];
      for (var i = 0; i < a.count; i++) for (var k = 0; k < a.itemSize; k++) f[i * a.itemSize + k] = get[k].call(a, i);
      geo.setAttribute(n, new T.BufferAttribute(f, a.itemSize));
    });
    geo.computeBoundingBox(); geo.computeBoundingSphere();
  }
  /* JE MODELL NACH BEDARF (2026-09-29: 13 weitere Deko-Modelle, zusammen 5,6 MB): geladen wird nur, was die Einrichtung
     der aktuellen Kueche wirklich setzt — nicht mehr alles auf einmal. Der GLTFLoader einmal; ist ein Modell da (oder
     fehlgeschlagen), wird die Szene gesammelt neu gebaut. */
  var gltfLader = null, dekoModellFehlt = {}, dekoNeuUhr = 0;
  function gltfLaden() {
    if (!gltfLader) {
      var q = gltfQuelle();
      gltfLader = q ? modul(q).then(function (M) { return new M.GLTFLoader(); }) : Promise.reject(new Error('keine Quelle'));
    }
    return gltfLader;
  }
  function dekoNeuBauen() {
    clearTimeout(dekoNeuUhr);
    dekoNeuUhr = setTimeout(function () { if (leinwand && zustand && datenJetzt) aufbauen(leinwand, zustand, datenJetzt); }, 150);
  }
  /* Die geladene Szene; 'warten', solange sie laedt (dann dort nichts setzen); null = gezeichnet. */
  /* KONTAKTSCHATTEN (Betreiber 2026-09-29: „يجب ان تحتوي ايضا الادوات على ظلال … بشكل احترافي"): unter jedem Stueck ein weicher
     Schatten, am Fuss dicht, nach aussen auslaufend — wie auf Produktbildern. Der Schatten des Hauptlichts allein ging im
     hellen Spiegelbild des Raums unter (gemessen: sichtbar erst ohne Raumumgebung). Ein Bild fuer alle, je Stueck gestreckt. */
  var kontaktMat = null;
  function kontaktSchattenMat() {
    if (kontaktMat || !T) return kontaktMat;
    var cv = document.createElement('canvas'); cv.width = cv.height = 128;
    var c = cv.getContext('2d'), gr = c.createRadialGradient(64, 64, 0, 64, 64, 64);
    /* Dicht bis knapp ueber den Fuss (Bildmitte bis ~0,5 = Grundflaeche), danach weich auslaufend. */
    gr.addColorStop(0, 'rgba(0,0,0,0.6)'); gr.addColorStop(0.44, 'rgba(0,0,0,0.55)'); gr.addColorStop(0.6, 'rgba(0,0,0,0.3)');
    gr.addColorStop(0.8, 'rgba(0,0,0,0.08)'); gr.addColorStop(1, 'rgba(0,0,0,0)');
    c.fillStyle = gr; c.fillRect(0, 0, 128, 128);
    var tx = new T.CanvasTexture(cv);
    kontaktMat = new T.MeshBasicMaterial({ map: tx, color: '#000000', transparent: true, depthWrite: false, polygonOffset: true,
      polygonOffsetFactor: -2, polygonOffsetUnits: -2 });
    return kontaktMat;
  }
  function kontaktSchatten(eltern, b, t2, x, y, zz) {
    var m = kontaktSchattenMat();
    if (!m || !(b > 0.5) || !(t2 > 0.5)) return null;
    var me = new T.Mesh(new T.PlaneGeometry(b * 1.9 + 4, t2 * 1.9 + 4), m);
    /* Nach dem LED-Schein auf der Platte zeichnen (dessen renderOrder 2): der Schein lag sonst ueber dem Schatten und hob ihn
       auf — das Stueck steht ja auch im Licht der Leiste. */
    me.rotation.x = -Math.PI / 2; me.position.set(x, y + 0.05, zz); me.renderOrder = 3;
    me.userData.ohneSchatten = true; me.userData.ohneEmpfang = true; me.userData.durchlaessig = true;
    eltern.add(me);
    return me;
  }
  /* KONTAKTSCHATTEN DER SCHRAENKE (Betreiber 2026-09-30: die Kueche wirkte, als schwebe sie). Kein Licht legt einen Schatten
     der Schraenke an ihren Fuss: das Hauptlicht wirft nur fuer die Einrichtung (nurFuerSonne), die Fenstersonne wird von den
     Zeilen ferngehalten, und Himmel, Aufheller, Spots und Raumspiegel kennen keine Verdeckung — der Boden war bis an den
     Sockel gleich hell. Die Umgebungsverdeckung (GTAO) dunkelt nur einen schmalen Saum ab, am Boden bei flachem Blick fast
     nichts, und auf dem Telefon beim Drehen gar nicht.
     Deshalb je Zeile EINE weiche Flaeche am Boden um den Grundriss (Neun-Felder-Netz: innen der Wert am Rand, aussen ein
     Abfall, der an den Ecken rund laeuft) — am Fuss dicht, nach wenigen Zentimetern fast weg; fuer Hochschraenke eine zweite,
     breitere und schwache; an der Wand ein feiner Saum um Haengeschraenke, Hochschraenke und die Zeile (sichtbar nur, wo die
     Wand neben oder ueber dem Schrank frei ist). Schwarz und durchscheinend wie kontaktSchatten — die Fronten bleiben, wie sie
     sind. Einmal je Aufbau gebaut, drei Bilder fuer alles, ein Material je Art; die Netze werden beim naechsten Aufbau
     freigegeben (kontaktAufraeumen). */
  var KONTAKT_PROFIL = {
    /* W: Reichweite nach aussen (cm); a: Dichte am Rand; c: Anteil des kurzen Abfalls k1 (cm), Rest mit k2 (cm). */
    boden: { W: 45, a: 0.55, c: 0.45, k1: 2, k2: 14 },
    hoch: { W: 45, a: 0.12, c: 0.3, k1: 6, k2: 18 },
    wand: { W: 12, a: 0.32, c: 0.55, k1: 1.5, k2: 5 }
  };
  /* Ohne Nachbearbeitung (Telefon beim Ziehen, three aus anderer Quelle) mischt der Schatten NACH Tonkurve und sRGB — dieselbe
     Deckkraft wirkt dort gut doppelt so dunkel (gemessen am Sockel 53 statt 24 Tonwerte, der Auslauf dreimal so breit). Mit 0,4
     liegen Fuss und Auslauf am naechsten an der Ansicht mit Nachbearbeitung. */
  var KONTAKT_DIREKT = 0.4, kontaktDeckkraft = 1;
  var kontaktMats = {}, kontaktGeos = [];
  function kontaktWeg(direkt) {
    var d = direkt ? KONTAKT_DIREKT : 1;
    if (d === kontaktDeckkraft) return;
    kontaktDeckkraft = d;
    Object.keys(kontaktMats).forEach(function (k) { if (kontaktMats[k]) kontaktMats[k].opacity = d; });
  }
  function kontaktProfilMat(art) {
    if (kontaktMats[art] || !T) return kontaktMats[art] || null;
    var P = KONTAKT_PROFIL[art], N = 128, cv = document.createElement('canvas'); cv.width = cv.height = N;
    var c = cv.getContext('2d'), bild = c.createImageData(N, N);
    for (var j = 0; j < N; j++) {
      for (var i = 0; i < N; i++) {
        /* Mitte des Bildes = Rand des Grundrisses; nach aussen W cm. An den Ecken zaehlt der Abstand zur Ecke. */
        var dx = Math.max(0, Math.abs((i + 0.5) / N - 0.5) * 2), dy = Math.max(0, Math.abs((j + 0.5) / N - 0.5) * 2);
        var d = Math.sqrt(dx * dx + dy * dy) * P.W;
        var fenster = d >= P.W ? 0 : 1 - Math.pow(Math.max(0, (d - 0.6 * P.W) / (0.4 * P.W)), 2);
        var al = P.a * (P.c * Math.exp(-d / P.k1) + (1 - P.c) * Math.exp(-d / P.k2)) * fenster;
        bild.data[(j * N + i) * 4 + 3] = Math.round(Math.max(0, Math.min(1, al)) * 255);
      }
    }
    c.putImageData(bild, 0, 0);
    var tx = new T.CanvasTexture(cv);
    /* Nur ein fester kleiner Tiefenversatz: mit Neigungsanteil (-2/-2) zog sich die Bodenflaeche bei flachem Blick ueber die
       untersten Bildpunkte des Sockels — eine deutliche graue Linie am Fuss (Bildkritik 2026-09-30). */
    kontaktMats[art] = new T.MeshBasicMaterial({ map: tx, color: '#000000', transparent: true, depthWrite: false,
      opacity: kontaktDeckkraft, polygonOffset: true, polygonOffsetFactor: 0, polygonOffsetUnits: -1 });
    return kontaktMats[art];
  }
  /* Neun-Felder-Netz um das Rechteck [a0,a1] x [b0,b1]: am Boden (x, y, z = b) oder an der Wand (x, y = b, z fest). */
  /* `offen` ({a0, a1, b0, b1}): an dieser Seite geht der Grundriss in einer Nachbarflaeche weiter — kein Auslauf (das Band hat
     die Breite 0), das Innere reicht bis an die Kante und stoesst ohne Ueberlappung an die Nachbarin. */
  function kontaktFlaeche(eltern, art, a0, a1, b0, b1, wand, hoehe, offen) {
    var m = kontaktProfilMat(art), W = KONTAKT_PROFIL[art].W, o = offen || {};
    if (!m || !(a1 - a0 > 0.5) || !(b1 - b0 > 0.5)) return null;
    var as = [o.a0 ? a0 : a0 - W, a0, a1, o.a1 ? a1 : a1 + W], bs = [o.b0 ? b0 : b0 - W, b0, b1, o.b1 ? b1 : b1 + W];
    var uv = [0, 0.5, 0.5, 1], pos = [], tex = [], idx = [];
    for (var j = 0; j < 4; j++) {
      for (var i = 0; i < 4; i++) {
        if (wand) pos.push(as[i], bs[j], hoehe); else pos.push(as[i], hoehe, bs[j]);
        tex.push(uv[i], uv[j]);
      }
    }
    for (var jj = 0; jj < 3; jj++) {
      for (var ii = 0; ii < 3; ii++) {
        var p0 = jj * 4 + ii, p1 = p0 + 1, p2 = p0 + 5, p3 = p0 + 4;
        /* Am Boden zeigt die Flaeche nach oben (+y), an der Wand in den Raum (+z). */
        if (wand) idx.push(p0, p1, p2, p0, p2, p3); else idx.push(p0, p2, p1, p0, p3, p2);
      }
    }
    var geo = new T.BufferGeometry();
    geo.setAttribute('position', new T.Float32BufferAttribute(pos, 3));
    geo.setAttribute('uv', new T.Float32BufferAttribute(tex, 2));
    geo.setIndex(idx);
    geo.computeVertexNormals();
    kontaktGeos.push(geo);
    var me = new T.Mesh(geo, m);
    me.renderOrder = 3;
    me.userData.ohneSchatten = true; me.userData.ohneEmpfang = true; me.userData.durchlaessig = true;
    me.userData.kontaktSchrank = true; me.userData.kontaktArt = art; me.userData.nurLive = true;
    eltern.add(me);
    return me;
  }
  function kontaktAufraeumen() {
    kontaktGeos.forEach(function (geo) { geo.dispose(); });
    kontaktGeos = [];
  }
  /* Je Wand (und Insel): Boden um jede Zeile (aus K.sockelStrecken — dieselben Laeufe wie die Sockelleiste, auch ohne sie), die
     Hochschraenke dazu, an der Wand die Zeile, die Hochschraenke und die Haengeschraenke gleicher Hoehe zusammen. Alles in
     Wandkoordinaten: x laengs, z = Abstand von der Wand (Wandflaeche bei -1), y hoch. */
  function schrankKontakt(wg, wid, z, daten, g) {
    if (!K.sockelStrecken) return;
    var st = K.sockelStrecken(z, daten).filter(function (s) { return s.wand === wid; });
    /* Hinterkante: die Rueckleiste der Insel (in der Flucht ihrer Rueckwand), sonst die Wand. */
    var hinten = st.reduce(function (m, s) { return s.art === 'front' ? m : Math.min(m, s.z0); }, 0);
    var BODEN_Y = 0.15, WAND_Z = -0.95, oben = g.korpus_hoehe + g.arbeitsplatte_dicke;
    /* Die Insel hat keine Wand hinter sich: dort nur der Boden (ein Saum bei z = -1 stuende sonst frei im Raum). */
    var bloecke = K.raumGeometrie(z).bloecke || [];
    var block = bloecke.some(function (b) { return b.id === wid; });
    /* DOPPELINSEL: I und IH stehen Ruecken an Ruecken. Alles bei I, in I-Koordinaten (IH: x gespiegelt, z hinter der Rueckwand).
       Je eigene Flaeche lagen an beiden Enden zwei Auslaeufe uebereinander (dunkler Keil in der Mitte); EIN Rechteck um beide
       (Stand 00:57) legte sein dunkles Inneres auf freien Boden, sobald die Haelften verschieden lang sind oder eine Luecke haben
       (Code-Pruefung 2026-10-01). Jetzt ein Raster: laengs zwischen allen Lauf-Enden, quer zwei Baender (I vorn, IH hinten) — je
       belegte Zelle eine Flaeche, die dort OFFEN ist, wo die Nachbarzelle belegt ist. So laeuft der Schatten genau um den Umriss
       beider Reihen, ohne Ueberlappung; nur in einer Innenecke liegen zwei Baender uebereinander (dort ist es auch in echt dunkler). */
    var doppel = block && bloecke.some(function (b) { return b.id === 'IH'; });
    var fronten = st.filter(function (s) { return s.art === 'front'; });
    var gruppen = function (liste, gleich) {
      var out = [];
      liste.slice().sort(function (p, q) { return p.x0 - q.x0; }).forEach(function (e) {
        var l = out[out.length - 1];
        if (l && e.x0 - l.x1 <= 2 && gleich(l, e)) { l.x1 = Math.max(l.x1, e.x1); l.y1 = Math.max(l.y1, e.y1); }
        else out.push({ x0: e.x0, x1: e.x1, y0: e.y0, y1: e.y1 });
      });
      return out;
    };
    var hoch = gruppen(K.items(z, daten, wid, 'boden').filter(function (it) { return it.m.reihe === 'voll'; })
      .map(function (it) { return { x0: it.x, x1: it.x + it.b, y0: 0, y1: +it.m.h || g.hochschrank_hoehe }; }), function () { return true; });
    if (doppel && wid === 'IH') return;
    var vorn = fronten.reduce(function (m, s) { return Math.max(m, s.z1); }, K.flucht());
    if (doppel) {
      var bI = bloecke.filter(function (b) { return b.id === 'I'; })[0], lenI = bI ? Math.hypot(bI.p1.x - bI.p0.x, bI.p1.y - bI.p0.y) : 0;
      var fh = K.sockelStrecken(z, daten).filter(function (s) { return s.wand === 'IH' && s.art === 'front'; });
      var zH = fh.reduce(function (m, s) { return Math.max(m, s.z1); }, K.flucht());
      var dicht = function (liste) {
        return gruppen(liste.map(function (q) { return { x0: q[0], x1: q[1], y0: 0, y1: 0 }; }), function () { return true; })
          .map(function (q) { return [q.x0, q.x1]; });
      };
      /* Raster je Art: laengs zwischen allen Lauf-Enden, quer Band I (0..vorn) und Band IH (−zH..0); je belegte Zelle eine
         Flaeche, offen zur belegten Nachbarzelle. Enden beider Reihen, die keine 5 cm auseinanderliegen, gelten als EIN Ende
         (das aeussere): sonst entstand dort eine Zelle von 0,5–2 cm, deren eigener Auslauf auf freiem Boden ueber dem der
         Nachbarzelle lag (doppelt dunkel), oder — bei genau 0,5 cm — eine Zelle ohne Flaeche, zu der die Nachbarin offen war
         (gar kein Auslauf). Code-Pruefung 2026-10-01. */
      var raster = function (art, lI, lH, y) {
        lI.forEach(function (qa) { lH.forEach(function (qb) {
          if (Math.abs(qa[0] - qb[0]) < 5) qa[0] = qb[0] = Math.min(qa[0], qb[0]);
          if (Math.abs(qa[1] - qb[1]) < 5) qa[1] = qb[1] = Math.max(qa[1], qb[1]);
        }); });
        var drin = function (liste, x) { return liste.some(function (q) { return q[0] <= x && x <= q[1]; }); };
        var pkt = lI.concat(lH).reduce(function (a, q) { return a.concat(q); }, []).sort(function (p, q) { return p - q; });
        var zellen = [];
        for (var k = 0; k + 1 < pkt.length; k++) {
          if (pkt[k + 1] - pkt[k] <= 0.5) continue;
          var mx = (pkt[k] + pkt[k + 1]) / 2, c = { x0: pkt[k], x1: pkt[k + 1], I: drin(lI, mx), H: drin(lH, mx) };
          if (c.I || c.H) zellen.push(c);
        }
        zellen.forEach(function (c, k) {
          var li = zellen[k - 1], re = zellen[k + 1], anL = li && Math.abs(li.x1 - c.x0) < 0.01, anR = re && Math.abs(re.x0 - c.x1) < 0.01;
          if (c.I) kontaktFlaeche(wg, art, c.x0, c.x1, 0, vorn, false, y, { a0: anL && li.I, a1: anR && re.I, b0: c.H });
          if (c.H) kontaktFlaeche(wg, art, c.x0, c.x1, -zH, 0, false, y, { a0: anL && li.H, a1: anR && re.H, b1: c.I });
        });
      };
      raster('boden', dicht(fronten.map(function (s) { return [s.x0, s.x1]; })), dicht(fh.map(function (s) { return [lenI - s.x1, lenI - s.x0]; })), BODEN_Y);
      /* Hochschraenke je Haelfte mit ihrer eigenen Tiefe (IH gespiegelt), im selben Raster — nicht mehr ueber beide Reihen. */
      raster('hoch', hoch.map(function (h) { return [h.x0, h.x1]; }),
        dicht(K.items(z, daten, 'IH', 'boden').filter(function (it) { return it.m.reihe === 'voll'; })
          .map(function (it) { return [lenI - it.x - it.b, lenI - it.x]; })), BODEN_Y + 0.02);
      return;
    }
    fronten.forEach(function (s) { kontaktFlaeche(wg, 'boden', s.x0, s.x1, hinten, s.z1, false, BODEN_Y); });
    /* Hochschraenke: zusammenhaengend (Luecke bis 2 cm) als eine Gruppe. */
    hoch.forEach(function (h) {
      kontaktFlaeche(wg, 'hoch', h.x0, h.x1, hinten, vorn, false, BODEN_Y + 0.02);
      if (!block) kontaktFlaeche(wg, 'wand', h.x0, h.x1, 0, h.y1, true, WAND_Z);
    });
    if (block) return;
    /* Wandsaum der Zeile nur, wo kein Hochschrank steht (der hat seinen eigenen bis oben): sonst lagen an einem offenen Ende zwei
       Saeume uebereinander, und die Linie sprang auf Arbeitshoehe (Code-Pruefung 2026-10-01). */
    fronten.forEach(function (s) {
      var teile = [[s.x0, s.x1]];
      hoch.forEach(function (h) {
        teile = teile.reduce(function (neu, t) {
          if (h.x1 <= t[0] + 0.5 || h.x0 >= t[1] - 0.5) { neu.push(t); return neu; }
          if (h.x0 - t[0] > 0.5) neu.push([t[0], h.x0]);
          if (t[1] - h.x1 > 0.5) neu.push([h.x1, t[1]]);
          return neu;
        }, []);
      });
      teile.forEach(function (t) { kontaktFlaeche(wg, 'wand', t[0], t[1], 0, oben, true, WAND_Z); });
    });
    /* Haengeschraenke (und Aufsaetze): nur gleiche Unter- und Oberkante bilden eine Flaeche — sonst laege innen eine dunkle
       Flaeche auf freier Wand (z. B. unter dem angehobenen flachen Schrank ueber dem Kochfeld). Eckschraenke stehen quer. */
    ['oben', 'aufsatz'].forEach(function (zl) {
      var basis = zl === 'oben' ? g.haenge_unterkante : g.hochschrank_hoehe;
      var liste = K.items(z, daten, wid, zl).filter(function (it) { return !it.eckseite; }).map(function (it) {
        var y0 = basis + (it.off || 0);
        return { x0: it.x, x1: it.x + it.b, y0: y0, y1: y0 + (+it.m.h || 72) };
      });
      gruppen(liste, function (l, e) { return Math.abs(l.y0 - e.y0) < 0.5 && Math.abs(l.y1 - e.y1) < 0.5; }).forEach(function (h) {
        kontaktFlaeche(wg, 'wand', h.x0, h.x1, h.y0, h.y1, true, WAND_Z);
      });
    });
  }
  /* Die neuen Einrichtungsstuecke (Bibliothek 2026-09-29, Poly Haven CC0): Datei hm-deko-<name>.glb neben dem Kochtopf. */
  var NEUE_DEKO = ['topf-emaille', 'topf-messing', 'pfanne-messing', 'kanne-metall', 'krug-keramik', 'schneidebrett', 'apfel-rot',
    'avocado', 'birnen', 'granatapfel', 'zwiebel', 'limette-frisch', 'croissant', 'kuchen', 'holzschale-flach', 'holzteller',
    'vase-antik', 'vase-keramik2', 'vase-keramik3', 'vase-keramik4', 'vase-messing3', 'vase-messing4', 'tontopf', 'thermoskanne',
    'korb-flach', 'suesskartoffel', 'kiwi', 'torte'];
  function dekoModell(name) {
    if (!dekoModellQuellen[name] && NEUE_DEKO.indexOf(name) >= 0) { var nq = bibUrl('hm-deko-' + name + '.glb'); if (nq) dekoModellQuellen[name] = nq; }
    if (!dekoModellQuellen[name] || dekoModellFehlt[name] || !T) return null;
    if (dekoModellFertig[name]) return dekoModellFertig[name];
    if (!dekoModellLaedt[name]) {
      dekoModellLaedt[name] = gltfLaden().then(function (L) { return L.loadAsync(dekoModellQuellen[name]); }).then(function (g) {
        g.scene.traverse(function (o) { if (o.isMesh) entquantisieren(o.geometry); });
        dekoModellFertig[name] = g.scene;
      }).catch(function () { dekoModellFehlt[name] = true; }).then(dekoNeuBauen);
    }
    return 'warten';
  }
  /* BIBLIOTHEK LADEN: die Bilder liegen neben den Deko-Modellen in den Theme-Assets; ihre Adresse folgt aus der eines
     bekannten Modells (Dateiname getauscht, Versionsanhang weg — neue Dateien haben neue Namen). Je Bild ein Laden; ist es da,
     wird die Szene gesammelt neu gebaut (wie bei den Modellen). Bis dahin zeigt der Raum die gezeichnete Oberflaeche. */
  var bibKarten = {}, bibLaedt = {}, bibFehlt = {};
  function bibUrl(datei) {
    var q = dekoModellQuellen.kochtopf || dekoModellQuellen.pflanze;
    return q ? String(q).replace(/[^\/]+$/, datei) : null;
  }
  function bibKarte(id, art) {
    var k = id + '-' + art;
    if (bibKarten[k]) return bibKarten[k];
    if (bibLaedt[k] || bibFehlt[id] || !T || !T.TextureLoader) return null;
    var url = bibUrl('hm-mat-' + id + '-' + art + '.webp');
    if (!url) return null;
    bibLaedt[k] = true;
    new T.TextureLoader().load(url, function (tx) {
      tx.wrapS = tx.wrapT = T.RepeatWrapping;
      if (art === 'c' && T.SRGBColorSpace) tx.colorSpace = T.SRGBColorSpace;
      tx.anisotropy = rd && rd.capabilities ? Math.min(8, rd.capabilities.getMaxAnisotropy()) : 1;
      bibKarten[k] = tx;
      dekoNeuBauen();
    }, undefined, function () { bibFehlt[id] = true; });
    return null;
  }
  /* Ein Material mit der Bibliotheksoberflaeche `id` belegen: Farbe, Relief und Rauheit, massstaeblich fuer eine Flaeche von
     `breite` x `tiefe` cm (Wiederholung = Flaeche / Kachelmass), versetzt um `ox`/`oy` (Bildbruchteile). `farbe`: statt Weiss
     eine Tonung (Katalogfarbe einer gewaehlten Platte). Ohne geladene Bilder: false, das Material bleibt, wie es ist. */
  function bibSetzen(m, id, breite, tiefe, ox, oy, farbe) {
    var e = BIBLIOTHEK[id];
    if (!e || !m) return false;
    var c = bibKarte(id, 'c'), n = bibKarte(id, 'n'), r = bibKarte(id, 'r');
    if (!c || !n || !r) return false;
    var kopie = function (t) { var k = t.clone(); k.repeat.set(breite / e[1], tiefe / e[1]); k.offset.set(ox || 0, oy || 0); return k; };
    m.map = kopie(c); m.normalMap = kopie(n); m.roughnessMap = kopie(r);
    if (m.color) m.color.copy(farbe || new T.Color('#ffffff'));
    m.roughness = 1; m.metalness = 0;
    m.userData.bib = id; m.userData.bibCm = e[1];
    m.needsUpdate = true;
    return true;
  }
  /* Wandputz: nur das Relief des Rezept-Putzes (die Farbe bleibt die Wandfarbe) — eine glatte Farbflaeche ist ein Zeichen
     fuer ein Computerbild; echter Putz faengt das Streiflicht des Fensters. */
  function putzRelief(m, breite, hoehe) {
    /* Phase 1 (ARCHITEKTUR): one fine painted plaster in every room at `putzStaerke`; the approved room: the recipe's plaster at 0.5. */
    var p1 = ARCHITEKTUR.an, id = p1 ? ARCHITEKTUR.putz : rezeptJetzt && rezeptJetzt.putz, e = BIBLIOTHEK[id], n = e ? bibKarte(id, 'n') : null;
    if (!n) return;
    var t = n.clone(); t.repeat.set(breite / e[1], hoehe / e[1]);
    var st = p1 ? ARCHITEKTUR.putzStaerke : 0.5;
    m.normalMap = t; m.normalScale = new T.Vector2(st, st); m.needsUpdate = true;
  }
  /* Die Tonung, mit der eine Bibliotheksoberflaeche im Mittel die Katalogfarbe `hex` bekommt (linear, je Kanal, begrenzt). */
  function bibTonung(id, hex) {
    var e = BIBLIOTHEK[id], soll = new T.Color(hex), ist = new T.Color(e ? e[2] : '#ffffff');
    var f = function (a, b) { return Math.max(0.35, Math.min(2.4, a / Math.max(0.01, b))); };
    return new T.Color().setRGB(f(soll.r, ist.r), f(soll.g, ist.g), f(soll.b, ist.b));
  }
  /* Die naechste Bibliotheksoberflaeche zu einer Katalogfarbe, innerhalb der passenden Arten (Farbabstand in Lab). */
  function bibNaechste(hex, arten) {
    var lab = function (h) {
      var c = new T.Color(h), f = function (t) { return t > 0.008856 ? Math.cbrt(t) : 7.787 * t + 16 / 116; };
      var X = (c.r * 0.4124 + c.g * 0.3576 + c.b * 0.1805) / 0.95047, Y = c.r * 0.2126 + c.g * 0.7152 + c.b * 0.0722,
        Z = (c.r * 0.0193 + c.g * 0.1192 + c.b * 0.9505) / 1.08883;
      return [116 * f(Y) - 16, 500 * (f(X) - f(Y)), 200 * (f(Y) - f(Z))];
    };
    var ziel = lab(hex), best = null, bd = Infinity;
    Object.keys(BIBLIOTHEK).forEach(function (id) {
      if (arten.indexOf(BIBLIOTHEK[id][0]) < 0 || bibFehlt[id]) return;
      var l = lab(BIBLIOTHEK[id][2]), d = Math.pow(l[0] - ziel[0], 2) + Math.pow(l[1] - ziel[1], 2) * 2 + Math.pow(l[2] - ziel[2], 2) * 2;
      if (d < bd) { bd = d; best = id; }
    });
    return best;
  }
  var DEKOR_MASS = {
    'artisan eiche': { b: 58, h: 60, quer: true },
    'sonoma eiche': { b: 58, h: 62, quer: false },
    'dunkle eiche': { b: 58, h: 62, quer: false }
  };
  function dekorName(n) { return String(n || '').toLowerCase().trim(); }
  function dekor(name) {
    var n = dekorName(name), url = dekorQuellen[n];
    if (!url || !T || !DEKOR_MASS[n]) return null;
    if (dekorTex[n]) return dekorTex[n];
    if (!dekorLaedt[n]) {
      dekorLaedt[n] = true;
      new T.TextureLoader().load(url, function (t) {
        t.wrapS = t.wrapT = T.RepeatWrapping;
        if (T.SRGBColorSpace) t.colorSpace = T.SRGBColorSpace;
        t.anisotropy = 8;
        dekorTex[n] = t;
        /* Einmal neu bauen, jetzt mit Dekor. */
        if (leinwand && zustand && datenJetzt) aufbauen(leinwand, zustand, datenJetzt);
      }, undefined, function () { /* ohne Bild bleibt die gezeichnete Maserung */ });
    }
    return null;
  }
  /* Das Dekor auf einer Flaeche von b x h cm, die Faser entlang `faser` ('x' | 'y'). `saat` verschiebt
     den Ausschnitt, damit nebeneinanderliegende Tueren nicht dasselbe Bild zeigen. */
  /* OHNE STOSS IN FASERRICHTUNG (2026-10-01, mit der gedrehten Seite gesehen): wo das Dekor entlang der Faser wiederholt
     (Seite eines Hochschranks, langer Sockel), stand an jedem Stoss eine Kante — das Foto ist an einem Ende heller, und die
     Fasern brachen ab: die Seite des Hochschranks lag in vier Kacheln uebereinander. Eine Kopie des Bildes, deren Ende auf einem
     Viertel der Laenge in den Anfang uebergeht, laeuft ohne Stoss weiter (um dieses Viertel kuerzer); in Faserrichtung um
     LAENGS_ZUG gestreckt, damit dieselben Aeste nicht alle 44 cm wiederkehren (im Produktfoto sind die Aeste an der Seite
     ohnehin laengs gezogen). Tueren und kurze Flaechen (bis 35 % Uebergroesse) bleiben beim Originalbild. */
  var dekorLaengs = {}, LAENGS_BLENDE = 0.25, LAENGS_ZUG = 1.6;
  function dekorNahtlos(n, t) {
    if (dekorLaengs[n]) return dekorLaengs[n];
    var img = t.image, W = img && img.width, H = img && img.height, quer = DEKOR_MASS[n].quer;
    if (!W || !H || typeof document === 'undefined') return null;
    var L = quer ? W : H, B = Math.round(L * LAENGS_BLENDE);
    var cv = document.createElement('canvas'); cv.width = quer ? W - B : W; cv.height = quer ? H : H - B;
    var c = cv.getContext('2d');
    c.drawImage(img, 0, 0);
    var st = document.createElement('canvas'); st.width = quer ? B : W; st.height = quer ? H : B;
    var s = st.getContext('2d');
    if (quer) s.drawImage(img, W - B, 0, B, H, 0, 0, B, H); else s.drawImage(img, 0, H - B, W, B, 0, 0, W, B);
    var g = quer ? s.createLinearGradient(0, 0, B, 0) : s.createLinearGradient(0, 0, 0, B);
    g.addColorStop(0, 'rgba(0,0,0,1)'); g.addColorStop(1, 'rgba(0,0,0,0)');
    s.globalCompositeOperation = 'destination-in'; s.fillStyle = g; s.fillRect(0, 0, st.width, st.height);
    c.drawImage(st, 0, 0);
    var nt = new T.CanvasTexture(cv);
    nt.wrapS = nt.wrapT = T.RepeatWrapping;
    if (T.SRGBColorSpace) nt.colorSpace = T.SRGBColorSpace;
    nt.anisotropy = 8;
    return (dekorLaengs[n] = { tex: nt, anteil: 1 - B / L });
  }
  function dekorAuf(name, b, h, faser, saat) {
    var n = dekorName(name), t = dekor(n);
    if (!t) return null;
    var d = DEKOR_MASS[n];
    var bildFaser = d.quer ? 'x' : 'y';
    var dreh = !!(faser && faser !== bildFaser);
    /* GEDREHT ZAEHLEN DIE WIEDERHOLUNGEN QUER (Betreiber 2026-10-01: „اللون الخشبي لفلمورا غير صحيح — وبالاخص الجوانب"). three
       dreht die Koordinaten der Flaeche ZUERST und skaliert DANACH: repeat.x wirkt entlang der Flaechenhoehe (Bild-x), repeat.y
       entlang ihrer Breite. Bis hierher stand dort b/d.h und h/d.b — vertauscht: die Seite eines Hochschranks zeigte das Dekor
       dreimal nebeneinander und fast vierfach in die Hoehe gezogen (Aeste als lange rote Striche, „Nadelstreifen"). Das
       Produktfoto (D60R Artisan Eiche) zeigt an der Seite dasselbe Dekor wie an der Tuer, nur mit senkrechter Faser. Gilt fuer
       jede gedrehte Flaeche: Velora-Korpusseiten, Deckel/Boden bei Sonoma und Dunkle Eiche, deren Sockel. */
    var rx = dreh ? h / d.b : b / d.b, ry = dreh ? b / d.h : h / d.h;
    /* Wiederholungen entlang der Faser: Bild-x bei quer liegendem Dekor, sonst Bild-y. Nur Korpus und Sockel (mit `faser`) —
       Tueren und Blenden bleiben beim Originalbild wie bisher (Code-Pruefung 2026-10-01: sonst lag eine 100 cm hohe Livaro-
       Haengeschranktuer 2,1-fach gestreckt neben der 1,2-fach gestreckten Unterschranktuer). */
    var nahtlos = faser && (d.quer ? rx : ry) > 1.35 ? dekorNahtlos(n, t) : null;
    if (nahtlos) { if (d.quer) rx /= nahtlos.anteil * LAENGS_ZUG; else ry /= nahtlos.anteil * LAENGS_ZUG; }
    var tx = (nahtlos ? nahtlos.tex : t).clone();
    tx.needsUpdate = true;
    /* KEINE NAHT IN DER TUER. Ein direkt wiederholtes Bild stand als Streifen mitten in der Tuer,
       ein gespiegeltes als symmetrischer „Schmetterling" (beides gesehen 2026-09-27). Bis 35 %
       Uebergroesse wird das Dekor gestreckt (das faellt am Holz nicht auf), und der Ausschnitt
       liegt ganz im Bild; erst lange Flaechen (Sockel, Seiten von Hochschraenken) wiederholen —
       dort sitzen auch in echt Stoesse. */
    var zu = function (k) { var q = Math.sin(((saat || 0) + k) * 12.9898) * 43758.5453; return q - Math.floor(q); };
    /* Die nahtlose Kopie wiederholt ohne Stoss: immer genau LAENGS_ZUG gestreckt, kein Ausschnitt (der Ausschnitt-Zweig legte
       bei 1,35 bis 1,62 Wiederholungen eine Kopie ueber die ganze Flaeche — bis 2,2-fach gestreckt, Code-Pruefung 2026-10-01). */
    var achse = function (r, k, laengs) {
      if (r <= 1.35 && !laengs) { var r1 = Math.min(1, r); return [r1, zu(k) * (1 - r1)]; }
      return [r, zu(k)];
    };
    var ax = achse(rx, 1, nahtlos && d.quer), ay = achse(ry, 2, nahtlos && !d.quer);
    tx.repeat.set(ax[0], ay[0]);
    tx.offset.set(ax[1], ay[1]);
    /* GEDREHT um die Mitte (0,5 | 0,5): three verschiebt dabei jeden Ausschnitt um (1 − r)/2 — ueber 0,5 hinaus lief er ueber den
       Bildrand, und mitten in der halben Zahl der Korpusseiten stand eine Bildkante (Code-Pruefung 2026-10-01). Ausgeglichen: der
       Ausschnitt liegt wie ungedreht bei [Versatz, Versatz + r]. */
    if (dreh) {
      tx.center.set(0.5, 0.5); tx.rotation = Math.PI / 2;
      tx.offset.set(ax[1] - 0.5 + ax[0] / 2, ay[1] - 0.5 + ay[0] / 2);
    }
    return tx;
  }

  /* LUNARA-GRIFF U57 (Betreiber 2026-10-01: „هذا شكل مقابض اللونارا — من عند التاجر", STL/DWG des Lieferanten). Ein
     Aluminiumprofil, 115 mm lang, das die Tuerkante umgreift: Rueckplatte 18 mm mit zwei Schraubloechern innen an der Tuer,
     Steg 40 mm ueber die Kante (1 mm stark, 21 mm vor der Tuerflaeche), vorn eine 9 mm hohe Lippe mit gerundeter Griffmulde;
     von vorn sieht man rund 1 cm Schwarz mit gerundeten Enden (Produktfoto KU-D60). Die Dreiecke sind die des Lieferanten
     (272, in mm; x Laenge, y von der Oberkante nach unten, z von der Rueckplatte nach vorn, negativ). Unterschrank: an der
     Oberkante; Haengeschrank: an der Unterkante, gespiegelt. */
  var U57 = { v: [6.73,11.15,-1,5.74,11.37,0,6.5,10,-1,5.5,10,0,5.74,8.63,0,6.44,12.57,0,7.38,12.12,-1,7.5,13.46,0,8.35,12.77,-1,8.81,13.94,0,9.5,13,-1,10.19,13.94,0,10.65,12.77,-1,11.5,13.46,0,11.62,12.12,-1,12.56,12.57,0,12.27,11.15,-1,13.26,11.37,0,12.5,10,-1,13.5,10,0,13.26,8.63,0,12.27,8.85,-1,12.56,7.43,0,11.62,7.88,-1,11.5,6.54,0,10.65,7.23,-1,10.19,6.06,0,9.5,7,-1,8.81,6.06,0,8.35,7.23,-1,7.5,6.54,0,7.38,7.88,-1,6.44,7.43,0,6.73,8.85,-1,102.73,11.15,-1,101.74,11.37,0,102.5,10,-1,101.5,10,0,101.74,8.63,0,102.44,12.57,0,103.38,12.12,-1,103.5,13.46,0,104.35,12.77,-1,104.81,13.94,0,105.5,13,-1,106.19,13.94,0,106.65,12.77,-1,107.5,13.46,0,107.62,12.12,-1,108.56,12.57,0,108.27,11.15,-1,109.26,11.37,0,108.5,10,-1,109.5,10,0,109.26,8.63,0,108.27,8.85,-1,108.56,7.43,0,107.62,7.88,-1,107.5,6.54,0,106.65,7.23,-1,106.19,6.06,0,105.5,7,-1,104.81,6.06,0,104.35,7.23,-1,103.5,6.54,0,103.38,7.88,-1,102.44,7.43,0,102.73,8.85,-1,107.89,6.69,-38.88,107.54,7.17,-39.11,106.94,8,-39,106.22,9,-39.56,106.22,9,-39,108.8,5.42,-38.51,8.78,9,-39,8.78,9,-39.56,8.06,8,-39,7.46,7.17,-39.11,7.11,6.69,-38.88,6.2,5.42,-38.51,107.59,0,-39.09,105.34,0,-39.77,105.16,9,-39.8,104.09,9,-39.95,103,0,-40,103,9,-40,109.67,0,-37.98,109.53,4.52,-38.07,110.29,3.71,-37.53,111.49,0,-36.49,111.08,2.97,-36.87,111.87,2.32,-36.08,112.6,1.78,-35.2,112.98,0,-34.67,113.24,1.37,-34.25,113.82,1.1,-33.18,114.09,0,-32.59,114.31,1,-32,114.77,0,-30.34,114.69,1,-30.7,114.92,1,-29.36,115,1,-28,115,0,-28,5.47,4.51,-38.07,4.69,3.69,-37.52,3.92,2.98,-36.88,3.16,2.33,-36.11,2.41,1.78,-35.22,1.74,1.36,-34.22,1.15,1.09,-33.13,0.69,1,-32,7.41,0,-39.09,5.33,0,-37.98,3.51,0,-36.49,2.02,0,-34.67,0.91,0,-32.59,0.23,0,-30.34,0.31,1,-30.7,0.08,1,-29.36,0,0,-28,0,1,-28,9.66,0,-39.77,9.84,9,-39.8,10.91,9,-39.95,12,9,-40,12,0,-40,115,1,-1,115,0,0,115,18,0,115,18,-1,0,1,-1,0,18,-1,0,18,0,0,0,0],
    i: [0,1,2,2,1,3,2,3,4,1,0,5,5,0,6,5,6,7,7,6,8,7,8,9,9,8,10,9,10,11,11,10,12,11,12,13,13,12,14,13,14,15,15,14,16,15,16,17,17,16,18,17,18,19,19,18,20,20,18,21,20,21,22,22,21,23,22,23,24,24,23,25,24,25,26,26,25,27,26,27,28,28,27,29,28,29,30,30,29,31,30,31,32,32,31,33,32,33,4,4,33,2,34,35,36,36,35,37,36,37,38,35,34,39,39,34,40,39,40,41,41,40,42,41,42,43,43,42,44,43,44,45,45,44,46,45,46,47,47,46,48,47,48,49,49,48,50,49,50,51,51,50,52,51,52,53,53,52,54,54,52,55,54,55,56,56,55,57,56,57,58,58,57,59,58,59,60,60,59,61,60,61,62,62,61,63,62,63,64,64,63,65,64,65,66,66,65,67,66,67,38,38,67,36,68,69,70,70,69,71,70,71,72,68,73,69,74,75,76,76,75,77,76,77,78,78,77,79,69,80,71,71,80,81,71,81,82,82,81,83,83,81,84,83,84,85,69,73,80,80,73,86,86,73,87,86,87,88,86,88,89,89,88,90,89,90,91,91,92,89,89,92,93,93,92,94,93,94,95,93,95,96,96,95,97,96,97,98,98,97,99,98,99,100,101,102,100,100,102,98,87,73,79,79,73,68,79,68,78,78,68,76,76,68,70,79,103,87,87,103,88,88,103,104,88,104,90,90,104,105,90,105,106,90,106,91,91,106,107,91,107,92,92,107,94,94,107,108,94,108,95,95,108,109,95,109,97,97,109,110,77,111,79,79,111,112,79,112,103,103,112,104,104,112,105,105,112,113,105,113,106,106,113,107,107,113,114,107,114,108,108,114,109,109,114,115,109,115,110,110,115,116,110,116,117,117,116,118,118,116,119,118,119,120,77,75,111,111,75,121,121,75,122,121,122,123,124,125,123,123,125,121,70,72,76,76,72,74,101,126,102,102,126,127,127,126,128,128,126,129,97,110,99,99,110,117,99,117,100,100,117,118,100,118,101,101,118,120,101,120,130,130,126,101,131,132,129,129,132,128,33,130,2,2,130,131,2,131,0,0,131,6,6,131,8,8,131,10,10,131,12,12,131,42,12,42,40,33,31,130,130,31,29,130,29,27,27,25,130,130,25,63,130,63,126,126,63,61,126,61,59,63,25,65,65,25,23,65,23,67,67,23,21,67,21,36,36,21,18,36,18,16,36,16,34,34,16,14,34,14,40,40,14,12,59,57,126,126,57,55,126,55,52,126,52,129,129,52,50,129,50,48,48,46,129,129,46,44,129,44,42,131,129,42,74,72,85,85,72,71,85,71,82,82,83,85,85,124,74,74,124,75,75,124,122,122,124,123,125,124,84,84,124,85,116,125,119,119,125,102,119,102,133,133,102,127,116,115,125,125,115,114,125,114,113,113,112,125,125,112,111,125,111,121,125,84,102,102,84,98,98,84,96,96,84,93,93,84,89,89,84,86,86,84,80,80,84,81,17,19,37,37,19,20,37,20,38,38,20,22,38,22,66,66,22,24,66,24,64,64,24,62,62,24,26,62,26,133,133,26,28,133,28,30,30,32,133,133,32,4,133,4,3,133,3,132,132,3,1,132,1,5,5,7,132,132,7,9,132,9,11,132,11,43,43,11,13,43,13,41,41,13,39,39,13,15,39,15,35,35,15,17,35,17,37,54,127,53,53,127,128,53,128,51,51,128,49,49,128,47,47,128,45,45,128,43,43,128,132,54,56,127,127,56,58,127,58,60,60,62,127,127,62,133,120,119,130,130,119,133,130,133,132,132,131,130] };
  var u57Geos = {};
  function u57Geometrie(unten) {
    var k = unten ? 'u' : 'o';
    if (u57Geos[k]) return u57Geos[k];
    var pos = [];
    for (var t = 0; t < U57.i.length; t += 3) {
      /* Gespiegelt (unten) kehrt sich die Umlaufrichtung um — die Ecken werden dann rueckwaerts gelesen. */
      (unten ? [U57.i[t], U57.i[t + 2], U57.i[t + 1]] : [U57.i[t], U57.i[t + 1], U57.i[t + 2]]).forEach(function (j) {
        /* Ursprung: Mitte der Laenge, Tuerkante (Unterseite des Stegs), Tuer-VORDERflaeche; die Rueckplatte liegt bei −1,8 cm
           an der Tuerrueckseite (Tuerblatt 1,8 cm), die Lippe endet 2,1 cm vor der Front. */
        var Y = (1 - U57.v[3 * j + 1]) / 10;
        pos.push((U57.v[3 * j] - 57.5) / 10, unten ? -Y : Y, -U57.v[3 * j + 2] / 10 - 1.9);
      });
    }
    var geo = new T.BufferGeometry();
    geo.setAttribute('position', new T.Float32BufferAttribute(pos, 3));
    geo.computeVertexNormals();
    geo.userData.geteilt = true;
    return (u57Geos[k] = geo);
  }

  /* Lichtschein der LED-Leisten fuer die Live-Ansicht: ein Verlauf, oben am hellsten, zu den
     Seiten weich auslaufend, additiv ueber Wand bzw. Platte gelegt. Einmal gezeichnet. */
  var scheinMats = {};
  /* `hell`: auf hellen Flaechen (weisser Marmor, helle Fliesen) verschwindet additives Licht im
     Weiss — dort ist der Schein ein warmer Farbton mit normaler Mischung (gesehen 2026-09-27). */
  /* `dunkel` (Betreiber 2026-09-26: „wenn die Arbeitsplatte schwarz ist, sieht das Licht seltsam aus"):
     auf schwarzem Stein lag derselbe additive Schein wie auf Holz — ein warmer Nebel, der den Stein
     gluehen liess. Schwarzer Stein schluckt das Licht; sichtbar bleibt nur ein schmaler, schwacher
     Hauch nahe der Leiste, fast weiss statt orange. */
  function scheinMat(art, hell, dunkel) {
    dunkel = !hell && !!dunkel;
    var schl = art + (hell ? '|hell' : (dunkel ? '|dunkel' : ''));
    if (scheinMats[schl]) return scheinMats[schl];
    var cv = document.createElement('canvas');
    cv.width = 128; cv.height = 128;
    var c = cv.getContext('2d'), bild = c.createImageData(128, 128);
    for (var y = 0; y < 128; y++) {
      for (var x = 0; x < 128; x++) {
        var u = x / 127, v = y / 127;
        var seite = Math.min(1, Math.min(u, 1 - u) / 0.12);
        seite = seite * seite * (3 - 2 * seite);
        /* Wand: v = 0 ist oben (an der Leiste); Platte: v = 1 ist an der Wand (nach der Drehung). */
        /* Zeile 0 ist nach der Drehung die Seite zur Wand bzw. zum Sockel. Auf der Platte liegt
           der hellste Fleck unter der Leiste (vorn am Haengeschrank, ~62 % der Tiefe). */
        var abst = art === 'platte' ? Math.min(1, Math.abs(v - 0.62) / 0.62) : v;
        var a = Math.pow(1 - abst, (art === 'wand' ? 2.2 : (art === 'boden' ? 1.8 : 1.6)) + (dunkel ? 1.4 : 0))
          * seite * (art === 'wand' ? 0.55 : (art === 'boden' ? 1.2 : 0.32));
        var i = (y * 128 + x) * 4;
        if (hell) { bild.data[i] = 255; bild.data[i + 1] = 196; bild.data[i + 2] = 120; a = Math.min(0.85, a * 0.75); }
        else if (dunkel) { bild.data[i] = 255; bild.data[i + 1] = 240; bild.data[i + 2] = 222; a *= 0.3; }
        else { bild.data[i] = 255; bild.data[i + 1] = 228; bild.data[i + 2] = 186; }
        bild.data[i + 3] = Math.round(a * 255);
      }
    }
    c.putImageData(bild, 0, 0);
    var tex = new T.CanvasTexture(cv);
    if (T.SRGBColorSpace) tex.colorSpace = T.SRGBColorSpace;
    var m = new T.MeshBasicMaterial({ map: tex, transparent: true, depthWrite: false,
      blending: hell ? T.NormalBlending : T.AdditiveBlending, toneMapped: true });
    m.castShadow = false;
    scheinMats[schl] = m;
    return m;
  }

  /* Den gewaehlten Schrank sichtbar machen: ein gruener Rahmen um seine Gruppe. Ein Rahmen
     statt eingefaerbter Materialien — viele Materialien (Griffe, Geraete) teilen sich mehrere
     Schraenke, und eine Faerbung liefe auf die Nachbarn ueber. */
  /* DIE MARKIERUNG (Betreiber 2026-09-27: „عند الضغط على خزانة يجب ان تظهر الخطوط بوضوح كبير", mit Bild): bisher ein
     BoxHelper — 1 px, in der dunklen Markenfarbe, auf grauen und dunklen Fronten kaum zu sehen. Jetzt die zwoelf Kanten
     als Linien fester BILDSCHIRMbreite (LineSegments2 aus three r160, gleiche esm.sh-Fassung wie three): ein weisser
     Saum und darauf ein kraeftiges Gruen, dazu (bis 2026-09-30) ein gruener Hauch ueber dem ganzen Schrank und alles ohne
     Tiefentest — seitdem ein Umriss der sichtbaren Kanten (unten). Bis die Linienbibliothek geladen ist (oder wenn sie
     fehlt), zeichnen einfache Linien in derselben Farbe. Nichts davon faengt Klicks ab. */
  /* EIN RUHIGER UMRISS (Betreiber 2026-09-30: „عند تحديد اي خزانة يظهر مربع اخضر شكله غريب وليس احترافي"). Der Glaskasten von
     oben — Schleier ueber dem ganzen Koerper, alle zwoelf Kanten ohne Tiefentest, also auch die Rueckkanten durch den Schrank,
     die Platte und die Nachbarn hindurch, 9 px Saum in Neongruen, und beides lief in die Umgebungsverdeckung (dunkle Flecken um
     den Kasten) — wird ein Umriss wie in Planungsprogrammen: nur die SICHTBAREN Kanten (Tiefentest), MARK_LUFT ausserhalb des
     Koerpers, damit ihn die eigenen Flaechen nicht verdecken; beim Eckschrank der Umriss beider Schenkel zusammen, ohne die
     Fuge dazwischen; klar (3 px) in der Markenfarbe mit weissem Saum, kein Schleier, nicht in der Verdeckung (nachLaden). */
  var MARK_BREITE = 3, MARK_SAUM = 7, MARK_LUFT = 0.6;
  function markFarbe() { return tok('--hm-gmeta', '#4F7547'); }
  /* Kanten des Umrisses mehrerer achsparalleler Koerper [x0,y0,z0,x1,y1,z1]: jede Kante an den Grenzen der anderen geteilt;
     wo die Flaeche nur weiterlaeuft (zwei der vier Viertel um die Kante nebeneinander drin), faellt sie weg. Jede bleibende
     Kante liegt L nach aussen versetzt (zur Seite ohne Koerper), an Koerperenden um L verlaengert. */
  function markKanten(koerper, L) {
    var drin = function (x, y, z) {
      return koerper.some(function (q) { return x > q[0] && x < q[3] && y > q[1] && y < q[4] && z > q[2] && z < q[5]; });
    };
    var p = [], eps = 0.05, VIERTEL = [[-1, -1], [1, -1], [1, 1], [-1, 1]];
    koerper.forEach(function (q) {
      var lo = [q[0], q[1], q[2]], hi = [q[3], q[4], q[5]];
      for (var a = 0; a < 3; a++) {
        var b = (a + 1) % 3, c = (a + 2) % 3, schnitte = [lo[a], hi[a]];
        koerper.forEach(function (o) { [o[a], o[a + 3]].forEach(function (v) { if (v > lo[a] + 0.01 && v < hi[a] - 0.01) schnitte.push(v); }); });
        schnitte.sort(function (u, v) { return u - v; });
        [lo[b], hi[b]].forEach(function (vb) {
          [lo[c], hi[c]].forEach(function (vc) {
            for (var k = 0; k + 1 < schnitte.length; k++) {
              var a0 = schnitte[k], a1 = schnitte[k + 1];
              if (a1 - a0 < 0.01) continue;
              var pt = [0, 0, 0], inn = VIERTEL.map(function (sg) { pt[a] = (a0 + a1) / 2; pt[b] = vb + sg[0] * eps; pt[c] = vc + sg[1] * eps; return drin(pt[0], pt[1], pt[2]); });
              var n = inn.filter(Boolean).length;
              if (n === 0 || n === 4 || (n === 2 && inn[0] !== inn[2])) continue;
              var ob = 0, oc = 0;
              VIERTEL.forEach(function (sg, i) { if (!inn[i]) { ob += sg[0]; oc += sg[1]; } });
              var e0 = [0, 0, 0], e1 = [0, 0, 0];
              e0[a] = a0 - (a0 === lo[a] ? L : 0); e1[a] = a1 + (a1 === hi[a] ? L : 0);
              e0[b] = e1[b] = vb + Math.sign(ob) * L; e0[c] = e1[c] = vc + Math.sign(oc) * L;
              p.push(e0[0], e0[1], e0[2], e1[0], e1[1], e1[2]);
            }
          });
        });
      }
    });
    return p;
  }
  var FETT = null, fettLaeuft = false;
  var LINIEN_QUELLE = 'https://esm.sh/three@0.160.0/examples/jsm/lines/';
  function fettLaden() {
    if (FETT || fettLaeuft || !/^https:\/\/esm\.sh\/three@0\.160\.0\/?$/.test(dreiQuelle)) return;
    fettLaeuft = true;
    Promise.all(['LineSegments2', 'LineSegmentsGeometry', 'LineMaterial'].map(function (n) {
      return modul(LINIEN_QUELLE + n + '.js');
    })).then(function (M) {
      fettLaeuft = false;
      FETT = { Linie: M[0].LineSegments2, Geo: M[1].LineSegmentsGeometry, Mat: M[2].LineMaterial };
      if (markiertSel) markieren(markiertSel);
    }).catch(function () { fettLaeuft = false; });
  }
  function markenAufloesung() {
    if (!markierung || !leinwand) return;
    /* Verborgen (2D) misst die Leinwand 0 x 0 — dann kein Ersatzmass: `groesse()` setzt es, sobald sie sichtbar ist. */
    var b = leinwand.clientWidth, h = leinwand.clientHeight;
    if (!b || !h) return;
    markierung.traverse(function (o) { if (o.material && o.material.resolution) o.material.resolution.set(b, h); });
  }
  function markieren(sel) {
    markiertSel = sel || null;
    if (!root) return;
    if (markierung) {
      if (markierung.parent) markierung.parent.remove(markierung);
      markierung.traverse(function (o) { if (o.geometry) o.geometry.dispose(); if (o.material) o.material.dispose(); });
      markierung = null;
    }
    var gr = sel && schrankGruppen[sel];
    if (!gr || !T.Box3) { zeichnen(); return; }
    /* Genau der Schrank: seine Koerper aus `kasten` (beim Eckschrank beide Schenkel), im Rahmen seiner Wand. Nur wo es
       keinen gibt (Nische mit Geraet, Eck-Haengeschrank, Regal), der Umriss der ganzen Gruppe. */
    var koerper = gr.userData.koerper, traeger = koerper && gr.parent ? gr.parent : root;
    /* Die Koerper stehen im Rahmen des Schranks; sein Wandversatz (gr.position) kommt dazu. */
    if (koerper && gr.position && (gr.position.x || gr.position.y || gr.position.z)) {
      var gp = gr.position;
      koerper = koerper.map(function (q) { return [q[0] + gp.x, q[1] + gp.y, q[2] + gp.z, q[3] + gp.x, q[4] + gp.y, q[5] + gp.z]; });
    }
    if (!koerper) {
      /* Weltmasse erst nach dem Nachrechnen der Matrizen (2026-09-29, DEV-Probe): direkt nach dem Neuaufbau (aufbauen ruft
         markieren, bevor gezeichnet wurde) galt fuer die neue Wandgruppe noch die Einheitsmatrix — der Rahmen der Nische stand
         dann neben dem Kuehlschrank. Box3.setFromObject aktualisiert nur das Objekt selbst, nicht seine Eltern. */
      gr.updateWorldMatrix(true, true);
      var k3 = new T.Box3().setFromObject(gr);
      if (k3.isEmpty()) { zeichnen(); return; }
      koerper = [[k3.min.x, k3.min.y, k3.min.z, k3.max.x, k3.max.y, k3.max.z]];
    }
    var nichts = function () {};
    markierung = new T.Group();
    var p = markKanten(koerper, MARK_LUFT), farbe = markFarbe();
    if (FETT) {
      [[MARK_SAUM, '#FFFFFF', 10], [MARK_BREITE, farbe, 11]].forEach(function (s) {
        var geo = new FETT.Geo(); geo.setPositions(p);
        var mt = new FETT.Mat({ color: s[1], linewidth: s[0], depthTest: true, depthWrite: false, transparent: true });
        var li = new FETT.Linie(geo, mt);
        li.renderOrder = s[2]; li.raycast = nichts;
        markierung.add(li);
      });
      traeger.add(markierung);
      markenAufloesung();
    } else {
      var lgeo = new T.BufferGeometry();
      lgeo.setAttribute('position', new T.Float32BufferAttribute(p, 3));
      var lin = new T.LineSegments(lgeo, new T.LineBasicMaterial({ color: farbe, depthTest: true, transparent: true }));
      lin.renderOrder = 11; lin.raycast = nichts;
      markierung.add(lin);
      traeger.add(markierung);
      fettLaden();
    }
    zeichnen();
  }

  /* Welcher Schrank liegt unter diesem Punkt der Leinwand? */
  function treffer(cv, cx, cy) {
    if (!cam || !root || !T.Raycaster) return null;
    var r = cv.getBoundingClientRect();
    var ray = new T.Raycaster();
    ray.setFromCamera(new T.Vector2((cx - r.left) / r.width * 2 - 1, -((cy - r.top) / r.height) * 2 + 1), cam);
    /* Was die Near-Ebene wegschneidet, ist nicht zu sehen — und darf nicht getroffen werden (2026-09-28).
       In der Frontansicht mit Gegenzeile (U-Kueche Seitenwand, zweizeilig, Insel Kuechenseite) steht die
       Kamera hinter der Gegenzeile: gemessen an der U-Kueche waehlte ein Tipp mitten auf die rechte Wand
       einen Kuehlumbauschrank der LINKEN. setFromCamera uebernimmt `near` nicht; die Ebene steht senkrecht
       zur Blickrichtung, entlang eines schraegen Strahls liegt sie um 1/cos weiter. */
    var vor = new T.Vector3();
    cam.getWorldDirection(vor);
    ray.near = (cam.near || 0) / Math.max(0.05, ray.ray.direction.dot(vor));
    var hits = ray.intersectObjects(root.children, true);
    for (var i = 0; i < hits.length; i++) {
      for (var o = hits[i].object; o; o = o.parent) {
        if (o.userData && o.userData.sel) return o.userData.sel;
      }
      /* Wand und Boden verdecken alles dahinter. Die Arbeitsplatte nicht: wer auf sie tippt,
         meint den Schrank darunter. */
      if (hits[i].object !== markierung && !hits[i].object.userData.durchlaessig) return null;
    }
    return null;
  }

  /* Die Farben kommen aus dem laufenden Dokument, nicht aus einer zweiten Liste im Code. */
  function tok(name, ersatz) {
    var v = getComputedStyle(document.documentElement).getPropertyValue(name);
    return (v && v.trim()) || ersatz;
  }

  function groesse() {
    if (!rd || !leinwand) return;
    /* VERBORGEN WIRD NICHT GEZEICHNET.

       Beim Wechsel auf 2D wird die 3D-Karte verborgen, die Leinwand misst 0 x 0, und ihr
       Beobachter meldet genau das. Bisher sprang hier ein Ersatzmass von 800 x 480 ein: der
       Puffer wurde darauf umgestellt, ein Bild gezeichnet, das niemand sieht, und die
       Wandnamen wurden auf einer Flaeche ohne Hoehe entzerrt — auf genau diesem Weg lief die
       Endlosschleife der Schilder an (7b3eb40). Gemessen vor dieser Aenderung an einer
       U-Kueche, 390 und 1440 px breit: jeder Wechsel 3D -> 2D eine Zeichnung auf der
       verborgenen Leinwand, ihr Puffer danach 800 x 480 je Pixeldichte, beim Zurueckschalten
       wieder umgestellt.

       Wird die Karte wieder sichtbar, meldet derselbe Beobachter die echte Groesse; erst dann
       wird gesetzt und gezeichnet. */
    var b = leinwand.clientWidth, h = leinwand.clientHeight;
    if (!b || !h) return;
    rd.setSize(b, h, false);
    if (nach) { nach.comp.setPixelRatio(rd.getPixelRatio()); nach.comp.setSize(b, h); }
    markenAufloesung();
    cam.aspect = b / Math.max(1, h);
    cam.updateProjectionMatrix();
    /* Die massstaeblichen Ausschnitte rechnet `zeichnen()` selbst neu — sie brauchen hier
       nichts, ausser dass gezeichnet wird. */
    zeichnen();
  }

  /* WANDNAMEN IM BILD.

     In 2D steht ueber jeder Zeichnung, welche Wand gemeint ist. In 3D stand es nirgends:
     der Kunde sah eine Ecke aus zwei Zeilen und konnte nicht sagen, welche davon „Wand B"
     ist — dieselbe Auskunft, die er im Grundriss danebenliegend bekommt.

     Die Namen sind HTML ueber der Leinwand, nicht Teil der Szene. Der Grund ist derselbe
     wie bei der Grundrissreferenz: die Szene bleibt die Wohnung des Kunden, und eine
     Beschriftung ist keine Einrichtung. Ausserdem bleibt Text so scharf, waehlbar und in
     den Farben des Shops, statt als Textur in die Geometrie eingebacken zu werden. */
  var schilderEbene = null;

  function schilder(kamera) {
    if (!leinwand || !raumJetzt) return;
    var eltern = leinwand.parentNode;
    if (!eltern) return;
    if (!schilderEbene || schilderEbene.parentNode !== eltern) {
      schilderEbene = document.createElement('div');
      schilderEbene.className = 'hm-kf__wschilder';
      schilderEbene.setAttribute('aria-hidden', 'true');
      eltern.appendChild(schilderEbene);
    }
    /* Die Ebene liegt exakt auf der Leinwand — die Karte hat Innenabstand, die Leinwand
       sitzt also nicht in der Ecke ihres Elternteils. */
    schilderEbene.style.left = leinwand.offsetLeft + 'px';
    schilderEbene.style.top = leinwand.offsetTop + 'px';
    schilderEbene.style.width = leinwand.clientWidth + 'px';
    schilderEbene.style.height = leinwand.clientHeight + 'px';

    var teile = raumJetzt.waende.concat(raumJetzt.bloecke || []);
    while (schilderEbene.children.length > teile.length) {
      schilderEbene.removeChild(schilderEbene.lastChild);
    }
    while (schilderEbene.children.length < teile.length) {
      var sp = document.createElement('span');
      sp.className = 'hm-kf__wschild';
      schilderEbene.appendChild(sp);
    }
    var b = leinwand.clientWidth, h = leinwand.clientHeight, gesetzt = [];
    teile.forEach(function (teil, i) {
      var el = schilderEbene.children[i];
      var tr = K.wandTransform3D(teil);
      var inh = wandInhalt(teil);
      /* Ueber dem hoechsten Schrank dieser Wand, aber unter der Decke: dort verdeckt der
         Name nichts, was der Kunde gerade auswaehlt. */
      var y = Math.max(60, Math.min(hoeheJetzt - 14, (inh ? inh.oben : 0) + 22));
      var mp = K.weltPunkt3D(teil, tr.laenge / 2, 0, 0);
      var v = new T.Vector3(mp.x, y, mp.z).project(kamera);
      /* Hinter der Kamera oder ausserhalb des Bildes: kein Schild. Ein Name, der am Rand
         klebt, zeigt auf die falsche Wand. */
      /* Hinter der Kamera oder seitlich aus dem Bild: kein Schild — ein Name am Rand zeigt
         auf die falsche Wand. Nur die HOEHE wird nicht zum Ausschlusskriterium: sitzt der
         Ankerpunkt knapp ueber dem oberen Rand, rutscht das Schild in den Rahmen hinein,
         statt zu verschwinden. Es gehoert immer noch ueber dieselbe Wand. */
      var drin = v.z < 1 && v.x > -1 && v.x < 1;
      el.hidden = !drin;
      if (!drin) return;
      el.textContent = teil.label;
      el.style.left = Math.round((v.x * 0.5 + 0.5) * b) + 'px';
      el.style.top = Math.round(Math.max(26, Math.min(h - 26, (-v.y * 0.5 + 0.5) * h))) + 'px';
      gesetzt.push(el);
    });

    /* ENTZERREN. Zwei Waende koennen im Bild an derselben Stelle enden — in der Inselkueche
       lag „Wand A" vollstaendig unter „Insel", und der Kunde sah nur eines der beiden
       Schilder. Wer sich ueberlappt, rutscht nach unten weg; die Reihenfolge bleibt, damit
       das Bild bei jedem Zeichnen gleich aussieht. */
    gesetzt.sort(function (x, y) { return parseFloat(x.style.top) - parseFloat(y.style.top); });
    gesetzt.forEach(function (el, i) {
      for (var j = 0; j < i; j++) {
        var a = gesetzt[j];
        var dx = Math.abs(parseFloat(a.style.left) - parseFloat(el.style.left));
        var dy = Math.abs(parseFloat(a.style.top) - parseFloat(el.style.top));
        /* NUR NEU SUCHEN, WENN SICH ETWAS BEWEGT HAT.

           `Math.min(h - 26, ...)` haelt das Schild am unteren Rand der Flaeche. Sitzt es dort
           schon, aendert die Zuweisung nichts — die Ueberlappung bleibt aber bestehen, und
           `j = -1` liess erneut von vorn suchen. Das war eine ENDLOSSCHLEIFE, die den
           Hauptfaden des Tabs anhielt: die Seite reagierte nicht mehr, ohne Fehler in der
           Konsole und ohne verlorenen WebGL-Kontext. Ohne Browser nachgestellt: bei h = 60
           und zwei Schildern auf 34 px laeuft sie ueber zwei Millionen Runden ohne Ende, bei
           h = 400 endet sie nach zwei.

           Ausgeloest hat es der RUECKWEG von 3D auf 2D: dort wird die Leinwand klein oder
           verborgen, `groesse()` liest eine kleine Hoehe, und mehrere Schilder landen
           zwangslaeufig gemeinsam auf demselben Anschlag. Mehr Waende heisst mehr Schilder —
           die U-Kueche traf es deshalb oefter als die L-Kueche (gemessen: U 6 von 12 Laeufen,
           L 0 von 8). Gefunden wurde es, indem der haengende Faden angehalten und gelesen
           wurde: `schilder` ← `zeichnen` ← `groesse` ← Rueckruf des `ResizeObserver`.

           Bewegt sich das Schild nicht mehr, ist auf dieser Flaeche kein Platz zum Entzerren.
           Dann stehen zwei Namen uebereinander — unschoen, aber die Seite lebt. */
        if (dx < 95 && dy < 26) {
          var neuOben = Math.min(h - 26, parseFloat(a.style.top) + 26);
          if (neuOben > parseFloat(el.style.top) + 0.5) {
            el.style.top = neuOben + 'px';
            j = -1;
          }
        }
      }
    });
  }

  var zustand = null;
  function zeichnen() {
    if (!rd || !zustand) return;
    /* Jede Bewegung, jede Groessenaenderung, jeder neue Plan beendet ein laufendes Foto: das
       Bild waere sonst eine Aufnahme von etwas, das nicht mehr so aussieht. */
    if (foto) fotoStop(true);
    var A = +zustand.A, sp = kugel;
    /* Zwei massstaebliche Blicke rechnen ihren Ausschnitt hier, bei jedem Zeichnen: nur so
       folgen sie dem Seitenverhaeltnis der Flaeche, ohne dass jemand klicken muss. Schlaegt
       die Rechnung fehl (keine Wand, keine Huelle), faellt der Blick auf die Perspektive
       zurueck — ein leeres Bild waere die schlechteste Antwort. */
    /* Die Frontansicht mit langer Brennweite schiebt die Fernebene weit hinaus; jede andere Ansicht bekommt ihre zurueck. */
    if (sp.art !== 'front' && cam.far !== 4000) { cam.far = 4000; cam.updateProjectionMatrix(); }
    if (sp.art === 'front' || sp.art === 'oben' || sp.art === 'raum') {
      var sf = Math.max(0.2, (leinwand && leinwand.clientHeight)
        ? (leinwand.clientWidth || 800) / leinwand.clientHeight : 2);
      var ok = sp.art === 'front' ? frontKamera(sf) : (sp.art === 'raum' ? raumKamera(sf) : obenKamera(sf));
      if (ok) {
        /* Die Frontansicht ist eine RAUMANSICHT und rendert perspektivisch; nur die
           Draufsicht ist massstaeblich. */
        fahrtAnwenden(); malen(); schilder(cam); return;
      }
    }
    /* Der Blickpunkt gehoert zur ANGESEHENEN Wand. Ohne Vorgabe bleibt es die Mitte von
       Wand A, 60 cm im Raum — der Wert, den Perspektive und Draufsicht immer hatten. */
    /* Die Front darf die Brennweite weiten; die freie Perspektive bekommt ihre zurueck. */
    /* Die Front darf schneiden und weiten; die freie Perspektive bekommt beides zurueck. */
    /* Im Raum (RAUM_KAMERA_DRIN) ein Innenraum-Objektiv (62 Grad), sonst wie immer 42. */
    /* Aus der Raumansicht uebernommen: deren Bildwinkel (fovBasis), sonst wie bisher. */
    var fovFrei = fovFreiJetzt(sp);
    if (cam.fov !== fovFrei || cam.near !== 10) { cam.fov = fovFrei; cam.near = 10; cam.updateProjectionMatrix(); }
    kugelKamera(sp, A);
    fahrtAnwenden();
    malen();
    schilder(cam);
  }
  /* Die freie Perspektive aus den Kugelwerten — dieselbe Rechnung fuer den Schirm und fuer den
     Schnappschuss des Planungs-PDF. */
  /* DIE KAMERA BLEIBT IM RAUM (Betreiber 2026-09-29: „نجعل المطبخ داخل غرفة حقيقية ونثبت الكاميرا بحيث لا تخرج منه مثل
     royal"). Wer in der freien Ansicht dreht oder zoomt, stand bisher bald ausserhalb des Raums und sah auf Rueckseiten von
     Waenden. Jetzt wird die Kamera in den Raum geklemmt: 25 cm vor jeder Wand, vor einer Wand mit Kuechenzeile 100 cm (vor den
     Fronten, nie im Schrank), zwischen 60 cm ueber dem Boden und 25 cm unter der Decke. Die Draufsicht bleibt, wie sie ist. */
  var RAUM_KAMERA_DRIN = true;
  /* Neigung der freien Kamera: im Raum wie ein Mensch, der sich umsieht (leicht nach unten bis knapp 30 Grad) — steil von
     oben oder von unten ist dort kein Bild, das jemand macht. Ohne Raum wie bisher (-0,15 … 1,2). */
  function thGrenze(oben) {
    var drin = RAUM_KAMERA_DRIN && !!huelleJetzt;
    return oben ? (drin ? 0.5 : 1.2) : (drin ? -0.05 : -0.15);
  }
  /* Welche Seiten der Huelle tragen eine Kuechenzeile (Kamera im Raum, Teppich)? */
  function belegteSeiten(h) {
    var belegt = { minX: false, maxX: false, minY: false, maxY: false };
    (raumJetzt.waende || []).forEach(function (w) {
      if (!K.items(zustand, datenJetzt, w.id, 'boden').length && !K.items(zustand, datenJetzt, w.id, 'oben').length) return;
      if (Math.abs(w.p0.y - w.p1.y) <= 0.5) {
        if (Math.abs(w.p0.y - h.minY) < 1) belegt.minY = true; else if (Math.abs(w.p0.y - h.maxY) < 1) belegt.maxY = true;
      } else if (Math.abs(w.p0.x - h.minX) < 1) belegt.minX = true; else if (Math.abs(w.p0.x - h.maxX) < 1) belegt.maxX = true;
    });
    return belegt;
  }
  function imRaum(p) {
    var h = huelleJetzt;
    if (!RAUM_KAMERA_DRIN || !h || !raumJetzt) return p;
    var belegt = belegteSeiten(h);
    var rand = function (seite) { return belegt[seite] ? 100 : 25; };
    var x0 = h.minX + rand('minX'), x1 = h.maxX - rand('maxX'), z0 = h.minY + rand('minY'), z1 = h.maxY - rand('maxY');
    if (x0 > x1) { x0 = x1 = (h.minX + h.maxX) / 2; }
    if (z0 > z1) { z0 = z1 = (h.minY + h.maxY) / 2; }
    return { x: Math.max(x0, Math.min(x1, p.x)), y: Math.max(60, Math.min(hoeheJetzt - 25, p.y)), z: Math.max(z0, Math.min(z1, p.z)) };
  }
  /* KEIN SPRUNG (Betreiber 2026-09-30: „لا اريد الكاميرا ان تقفز اثناء تحريك العميل للمطبخ" — „ولا في اي نقطة"). Gemessen
     (Probe ~/himarkt-planer-redesign/kamera-2026-09-30): beim ersten Zug aus der Raumansicht sprang die Kamera 42 cm, 7 Grad
     Richtung und 9 Grad Bildwinkel; aus der Wandansicht 11,7 m (von draussen in den Raum), aus der Draufsicht 3,7 m und 40 Grad;
     hinter die Zeile gedreht rutschte sie an der Wand entlang, und das Bild drehte sich bis 4,7-mal schneller als die Hand; am
     Rad lagen zehn Rasten ohne Wirkung. Jetzt:
       - Wechselt die Art der Kamera (Knopf, erster Zug aus Raum-, Wand- oder Draufsicht), faehrt sie weich (0,28 bis 0,7 s, nach
         dem Weg) aus der gezeigten Lage in die neue (Lage, Drehung, Bildwinkel); Eingaben waehrend der Fahrt gehen in das Ziel ein.
       - Aus der Raumansicht uebernimmt die freie Kamera deren Blickrichtung, Blickpunkt und Bildwinkel (aufPerspektive).
       - Die freie Kamera weicht an Wand, Boden und Decke auf IHREM Blickstrahl zurueck, statt seitlich zu rutschen; eine
         Richtung ohne Standort im Raum (hinter der Zeile) nimmt das Drehen nicht an — es bleibt dort stehen.
       - Erreicht der Bildwinkel an der Wand 100 Grad, waechst der Abstand nicht weiter: das Rad wirkt sofort in beide Richtungen. */
  var FAHRT_MS = 280, KAMERA_MIN = 120, fahrt = null, poseZuletzt = null, fahrtRuhe = false, ersteAnsicht = true, fahrtBild = 0, ersteBild = 0;
  /* true, solange ein Zeichnen direkt aus einer Bewegung des Kunden kommt (dort folgt die Kamera der Hand ohne Verzoegerung). */
  var eingabe = false;
  /* Foto und Deckblatt: die Lage, die der Kunde zuletzt sah, ohne Fahrt (laufende zu Ende), und danach kein Nachfahren. */
  function fahrtAnhalten() {
    fahrt = null; fahrtRuhe = true; deckeWeg();
    if (fahrtBild && w.cancelAnimationFrame) { w.cancelAnimationFrame(fahrtBild); } fahrtBild = 0;
  }
  function fahrtWeiter() { fahrtRuhe = false; poseZuletzt = cam ? poseJetzt() : null; }
  function jetztMs() { return w.performance && w.performance.now ? w.performance.now() : Date.now(); }
  function poseJetzt() { return { p: cam.position.clone(), q: cam.quaternion.clone(), fov: cam.fov, near: cam.near, far: cam.far }; }
  function fahrtStarten() {
    if (fahrtRuhe || !cam) return;
    /* Der erste Blick nach dem Aufbau steht sofort — auch ein zweiter im selben Schritt (Wandknopf in 2D gedrueckt: Raumansicht,
       dann Wandansicht), bis zum naechsten Bild. */
    if (ersteAnsicht) {
      poseZuletzt = null;
      if (!ersteBild) ersteBild = w.requestAnimationFrame ? w.requestAnimationFrame(function () { ersteAnsicht = false; ersteBild = 0; }) : (ersteAnsicht = false, 0);
      return;
    }
    /* Immer aus der GEZEIGTEN Lage (poseZuletzt): mitten in einer Fahrt sonst ein Satz um den Anteil des neuen Ziels (Code-Pruefung
       2026-10-01). Laeuft schon eine, beginnt die neue ohne Anfahren (bremsende Kurve) — sonst stuende das Bild bei vielen Neustarts
       hintereinander (alte Seite: Blick nach jedem Neuaufbau) fast still. */
    /* Steigt gerade eine Decke (verdeckter Schnitt), zeigt der Wechsel unter ihr ohnehin das NEUESTE Ziel — keine zweite. */
    if (decke && decke.phase !== 'auf') return;
    if (poseZuletzt) fahrt = { von: poseZuletzt, t: 0, zuletzt: jetztMs(), fliegend: !!fahrt };
  }
  /* Die Kamera steht jetzt in der Soll-Lage; laeuft eine Fahrt, wird zwischen der Lage beim Start und ihr gemischt. */
  function fahrtAnwenden() {
    if (fahrtRuhe) return;
    /* Waehrend eines verdeckten Schnitts bestimmt die Decke das Bild: bis zur vollen Deckung die alte Lage, danach die neue.
       Waehrend der Freigabe laeuft alles andere (Fahrt, naechster Knopf) wie sonst weiter. */
    if (decke) {
      deckeSchritt();
      if (decke && decke.phase !== 'auf') { poseZuletzt = poseJetzt(); return; }
    }
    /* Aendert sich die Lage OHNE Eingabe des Kunden (Neuaufbau nach einer spaet geladenen Deko, andere Groesse der Flaeche,
       Raumansicht nach einem neuen Schrank neu gesucht, Raumgrenze verschoben), faehrt die Kamera auch dorthin — nie ein Satz. */
    if (poseZuletzt && !eingabe) {
      /* Ohne Fahrt: Abstand zur gezeigten Lage. In einer Fahrt: hat sich ihr ZIEL ohne Eingabe verschoben (Neuaufbau, neu
         gesuchte Raumansicht), beginnt sie neu aus der gezeigten Lage — sonst sprang das Bild um den Anteil der Verschiebung. */
      var bezug = fahrt ? fahrt.soll : poseZuletzt;
      if (bezug && (cam.position.distanceTo(bezug.p) > 2 || cam.quaternion.angleTo(bezug.q) > 0.009 || Math.abs(cam.fov - bezug.fov) > 0.5)) {
        fahrt = { von: poseZuletzt, t: 0, zuletzt: jetztMs(), fliegend: !!fahrt };
      }
    }
    /* Fuehrt die gerade Linie durch einen Schrank, wird VERDECKT GESCHNITTEN statt gefahren (einmal je Fahrt entschieden; siehe
       deckeBeginnen). Ausnahmen:
       - eine reine Fahrt entlang der Blickachse (erster Zug aus der Wandansicht, Rad): die Nahgrenze haelt den Schnitt an
         seiner Stelle, die Fahrt ist sauber — sie bleibt eine Fahrt;
       - gleich nach einem Groessenwechsel (Puffer leer): das Bild wurde ohnehin neu gesetzt, ein Schnitt ist unsichtbar. */
    if (fahrt && fahrt.blende === undefined) {
      var weg = cam.position.clone().sub(fahrt.von.p), achse = new T.Vector3(0, 0, -1).applyQuaternion(cam.quaternion);
      var dolly = cam.quaternion.angleTo(fahrt.von.q) < 0.035 && (weg.length() < 1 || Math.abs(weg.dot(achse)) > 0.985 * weg.length());
      if (!dolly && durchKiste(fahrt.von.p, cam.position, 15)) {
        var drehAb = achsenFahrt(fahrt.von, cam.position, cam.quaternion);
        if (drehAb > 0) { fahrt.drehAb = drehAb; fahrt.blende = false; }
        else if (pufferFrisch) { fahrt = null; }
        else if (deckeBeginnen(fahrt.von)) { fahrt = null; deckeSchritt(); poseZuletzt = poseJetzt(); return; }
        else fahrt.blende = false;
      } else fahrt.blende = false;
    }
    if (fahrt) {
      /* Dauer nach dem Weg: kurze Wechsel ~0,3 s, der Flug aus der Wandansicht (von draussen) bis 0,7 s — nie ein Satz. */
      if (!fahrt.dauer) {
        var wegP = cam.position.distanceTo(fahrt.von.p), wegW = cam.quaternion.angleTo(fahrt.von.q) * 180 / Math.PI;
        fahrt.dauer = Math.max(FAHRT_MS, Math.min(700, FAHRT_MS + wegP * 0.5 + wegW * 3 + Math.abs(cam.fov - fahrt.von.fov) * 3));
      }
      /* Die Uhr der Fahrt laeuft je Bild hoechstens 50 ms weiter: haengt der Browser (Neuaufbau), landet der Rest der Fahrt
         nicht in einem einzigen Bild; ab 20 Bildern je Sekunde laeuft sie in Echtzeit. */
      var jetzt = jetztMs();
      fahrt.t += Math.min(50, Math.max(0, jetzt - fahrt.zuletzt)); fahrt.zuletzt = jetzt;
      var t = Math.min(1, fahrt.t / fahrt.dauer);
      fahrt.soll = poseJetzt();
      var e = t >= 1 ? 1 : (fahrt.fliegend ? 1 - Math.pow(1 - t, 3) : t * t * (3 - 2 * t)), eR = e;
      /* Erst fahren, dann drehen (achsenFahrt): bis zum freien Raum bleibt die Blickrichtung; dort beginnt die Drehung mit
         eigener Dauer (8 ms je Grad, mindestens 180 ms). In den Rest der Fahrt gepresst waren es bis 8 Grad je Bild (Probe
         kamera-uebergang-2026-10-01, zweizeilig, erster Zug aus Wand A: 23 Grad in 90 ms). */
      if (fahrt.drehAb > 0) {
        if (fahrt.drehT == null && e >= fahrt.drehAb) {
          fahrt.drehT = fahrt.t; fahrt.drehMs = Math.max(180, fahrt.soll.q.angleTo(fahrt.von.q) * 180 / Math.PI * 8);
        }
        if (fahrt.drehT == null) eR = 0;
        else { var rD = Math.min(1, (fahrt.t - fahrt.drehT) / fahrt.drehMs); eR = rD * rD * (3 - 2 * rD); }
      }
      if (e >= 1 && eR >= 1) fahrt = null;
      else {
        var v = fahrt.von, sp = cam.position.clone(), sq = cam.quaternion.clone();
        var sf = cam.fov, sn = cam.near, sfe = cam.far;
        cam.position.lerpVectors(v.p, sp, e);
        cam.quaternion.slerpQuaternions(v.q, sq, eR);
        /* Nahgrenze nach dem Weg: die Wandansicht blendet die Gegenzeile mit einer grossen Nahgrenze aus; so bleibt ausgeblendet,
           was vor der Kamera zwischen ihr und dem Ziel (bzw. Start) liegt. (Fahrten DURCH eine Zeile gibt es nicht mehr: Decke.) */
        cam.fov = v.fov + (sf - v.fov) * e; cam.far = Math.max(v.far, sfe);
        cam.near = Math.max(10, sn - cam.position.distanceTo(sp), v.near - cam.position.distanceTo(v.p));
        cam.updateProjectionMatrix(); cam.updateMatrixWorld(true);
        if (!fahrtBild && w.requestAnimationFrame) fahrtBild = w.requestAnimationFrame(function () { fahrtBild = 0; zeichnen(); });
      }
    }
    poseZuletzt = poseJetzt();
  }
  /* VERDECKTER SCHNITT STATT DURCH DIE ZEILE FAHREN. Die Fahrt zwischen zwei Wandansichten gegenueberliegender Zeilen (U: B↔C,
     zweizeilig: A↔C, Doppelinsel I↔IH) oder aus der Raumansicht auf die Gegenwand lief auf gerader Linie mitten durch die Zeilen
     (Code-Pruefung 2026-10-01: 1 bis 5 Bilder je Wechsel mit der Kamera IM Schrank, schraeg angeschnittene Korpusse); ein Bogen
     aussen herum zeigte Waende von aussen (Probe ~/himarkt-planer-redesign/bogen-2026-10-01). Einen Weg IM Raum gibt es nicht:
     beide Wandansichten stehen hinter der Gegenzeile bzw. ausserhalb des Raums (gemessen entlang der Blickachse bis zum freien
     Raum: U 116–144 cm, zweizeilig 278 cm, Doppelinsel 272–346 cm; Probe ~/himarkt-planer-redesign/kamera-uebergang-2026-10-01).
     Die Ueberblendung danach (das alte Bild als Kopie, 320 ms ausgeblendet) zeigte beide Kuechen uebereinander — ChatGPT-Pruefung
     2026-10-01: „double exposure / ghost image … The customer must NEVER see two kitchen views superimposed".
     Jetzt: fuehrt die gerade Linie durch einen Schrank (bis 15 cm daneben — die Nahgrenze von 10 cm schnitte ihn an), legt sich
     eine ruhige, EINFARBIGE Decke in der mittleren Farbe des gezeigten Bildes in DECKE_ZU_MS ueber die alte Ansicht (die Kamera
     steht dabei still), erst unter voller Deckung wechselt die Kamera, nach DECKE_HALT_MS (das neue Bild ist gezeichnet) gibt die
     Decke in DECKE_AUF_MS die neue Ansicht frei — zusammen rund 0,24 s. Kein Bild zeigt zwei Kuechen, keines Schwarz oder Weiss.
     Alle anderen Wechsel fahren wie bisher. */
  var kistenJetzt = null, DECKE_ZU_MS = 90, DECKE_HALT_MS = 30, DECKE_AUF_MS = 110, decke = null, pufferFrisch = true;
  function schrankKisten() {
    if (!kistenJetzt) {
      /* Nach einem Neuaufbau stehen die Weltmatrizen der neuen Wandgruppen noch auf Null, bis gezeichnet wurde (Code-Pruefung). */
      if (root) root.updateMatrixWorld(true);
      kistenJetzt = Object.keys(schrankGruppen).map(function (k) { return new T.Box3().setFromObject(schrankGruppen[k]); })
        .filter(function (b) { return !b.isEmpty(); });
    }
    return kistenJetzt;
  }
  function durchKiste(a, b, rand) {
    var kk = schrankKisten(), p = new T.Vector3();
    for (var i = 1; i < 32; i++) {
      p.lerpVectors(a, b, i / 32);
      for (var j = 0; j < kk.length; j++) if (kk[j].distanceToPoint(p) < rand) return true;
    }
    return false;
  }
  /* ERST FAHREN, DANN DREHEN. Der erste Zug aus einer Wandansicht (Kamera hinter der weggeschnittenen Gegenzeile) fuehrt die
     Kamera fast entlang ihrer Blickachse in den Raum — durch die Zeile, die die Nahgrenze dabei weiter wegschneidet (wie in der
     Wandansicht selbst). Gedreht wird erst im freien Raum: eine gekippte Nahgrenze schnitte die Zeile schraeg an. Gemessen
     (Probe kamera-uebergang-2026-10-01, U Wand C): der erste Zug brachte 169 cm Weg und 10 Grad Drehung — vorher ein Wechsel
     unter der Decke mitten im Zug. Liefert den Anteil des Wegs, ab dem gedreht wird, oder -1 (dann verdeckter Schnitt). */
  function achsenFahrt(von, nachP, nachQ) {
    var weg = nachP.clone().sub(von.p), l = weg.length();
    if (l < 1 || von.q.angleTo(nachQ) > 0.53) return -1;
    var achse = new T.Vector3(0, 0, -1).applyQuaternion(von.q);
    if (weg.dot(achse) < 0.9 * l) return -1;
    var kk = schrankKisten(), p = new T.Vector3(), zuletzt = -1;
    for (var i = 0; i <= 32; i++) {
      p.lerpVectors(von.p, nachP, i / 32);
      for (var j = 0; j < kk.length; j++) if (kk[j].distanceToPoint(p) < 15) { zuletzt = i; break; }
    }
    return zuletzt < 0 || zuletzt >= 32 ? -1 : (zuletzt + 1) / 32;
  }
  /* Die Farbe der Decke: das Mittel des gezeigten Bildes (6 x 6 verkleinert) — helle Kueche hell, dunkle dunkel, nie ein Blitz. */
  function deckeFarbe(cv, d) {
    try {
      var k = d.createElement('canvas'); k.width = 6; k.height = 6;
      var g = k.getContext('2d'); g.drawImage(cv, 0, 0, 6, 6);
      var px = g.getImageData(0, 0, 6, 6).data, r = 0, gr = 0, b = 0, n = 0;
      for (var i = 0; i < px.length; i += 4) { r += px[i]; gr += px[i + 1]; b += px[i + 2]; n++; }
      if (n) return 'rgb(' + Math.round(r / n) + ',' + Math.round(gr / n) + ',' + Math.round(b / n) + ')';
    } catch (e) { /* Rueckfall unten */ }
    return '#E4DFD8';
  }
  /* `von`: die gezeigte Lage — sie bleibt im Bild, bis die Decke deckt. Laeuft schon eine Decke (zweiter Knopf waehrend der
     Freigabe), steigt sie von der Deckung aus, die gerade zu sehen ist — ohne Ruck, und es bleibt bei EINER Kueche im Bild. */
  function deckeBeginnen(von) {
    var cv = rd && rd.domElement, eltern = cv && cv.parentNode, d = w.document;
    if (!cv || !eltern || !d || !cv.clientWidth || !cv.clientHeight) return false;
    var jetzt = jetztMs(), schon = decke ? decke.deckung : 0;
    if (!decke) {
      var el = d.createElement('div');
      el.setAttribute('aria-hidden', 'true');
      el.style.position = 'absolute'; el.style.pointerEvents = 'none'; el.style.margin = '0'; el.style.transition = 'none';
      decke = { el: el, deckung: 0 };
    }
    decke.el.style.background = deckeFarbe(cv, d);
    decke.el.style.opacity = String(schon);
    if (decke.el.parentNode !== eltern) eltern.insertBefore(decke.el, cv.nextSibling);
    /* Der Rest der ansteigenden Kurve: die Deckung `schon` entspricht dem Anteil s der Zeit (smoothstep umgekehrt genaehert). */
    var s = schon <= 0 ? 0 : (schon >= 1 ? 1 : 0.5 - Math.sin(Math.asin(1 - 2 * schon) / 3));
    decke.von = von; decke.phase = 'zu'; decke.start = jetzt - s * DECKE_ZU_MS;
    /* Rueckfall ohne Bildtakt (verborgene Seite): spaetestens dann ist die Decke weg und die neue Lage steht. */
    if (decke.zeit) w.clearTimeout(decke.zeit);
    decke.zeit = w.setTimeout(function () { if (decke) { deckeWeg(); zeichnen(); } }, DECKE_ZU_MS + DECKE_HALT_MS + DECKE_AUF_MS + 600);
    return true;
  }
  /* Ein Bild der Decke: vor dem Wechsel die alte Lage, die Decke steigt; mit voller Deckung bleibt die Kamera in der neuen Lage
     (vom Aufrufer gesetzt) und das neue Bild wird UNTER der Decke gezeichnet; danach gibt sie es frei. */
  function deckeSchritt() {
    var cv = rd && rd.domElement, jetzt = jetztMs(), a;
    if (cv) {
      decke.el.style.left = cv.offsetLeft + 'px'; decke.el.style.top = cv.offsetTop + 'px';
      decke.el.style.width = cv.clientWidth + 'px'; decke.el.style.height = cv.clientHeight + 'px';
    }
    if (decke.phase === 'zu') {
      var u = Math.min(1, (jetzt - decke.start) / DECKE_ZU_MS);
      if (u < 1) {
        a = u * u * (3 - 2 * u);
        var v = decke.von;
        cam.position.copy(v.p); cam.quaternion.copy(v.q); cam.fov = v.fov; cam.near = v.near; cam.far = v.far;
        cam.updateProjectionMatrix(); cam.updateMatrixWorld(true);
      } else { a = 1; decke.phase = 'halt'; decke.wechsel = jetzt; }
    } else if (decke.phase === 'halt') {
      a = 1;
      if (jetzt - decke.wechsel >= DECKE_HALT_MS) { decke.phase = 'auf'; decke.aufStart = jetzt; }
    } else {
      var f = Math.min(1, (jetzt - decke.aufStart) / DECKE_AUF_MS);
      if (f >= 1) { deckeWeg(); return; }
      a = 1 - f * f * (3 - 2 * f);
    }
    decke.deckung = a; decke.el.style.opacity = String(a);
    if (!fahrtBild && w.requestAnimationFrame) fahrtBild = w.requestAnimationFrame(function () { fahrtBild = 0; zeichnen(); });
  }
  function deckeWeg() {
    if (!decke) return;
    if (decke.zeit) w.clearTimeout(decke.zeit);
    if (decke.el && decke.el.parentNode) decke.el.parentNode.removeChild(decke.el);
    decke = null;
  }
  /* Wo auf dem Strahl vom Blickpunkt aus darf die Kamera stehen? Dieselben Grenzen wie imRaum (25 cm vor jeder Wand, 100 cm vor
     einer Zeile, 60 cm ueber dem Boden, 25 cm unter der Decke), als Abschnitt [von, bis]; null, wenn der Strahl den Raum nie trifft. */
  function strahlImRaum(ziel, dx, dy, dz) {
    var h = huelleJetzt;
    if (!RAUM_KAMERA_DRIN || !h || !raumJetzt) return { von: 0, bis: Infinity };
    var belegt = belegteSeiten(h), rand = function (seite) { return belegt[seite] ? 100 : 25; };
    var lo = [h.minX + rand('minX'), 60, h.minY + rand('minY')], hi = [h.maxX - rand('maxX'), hoeheJetzt - 25, h.maxY - rand('maxY')];
    var o = [ziel.x, ziel.y, ziel.z], d = [dx, dy, dz], von = 0, bis = Infinity;
    for (var a = 0; a < 3; a++) {
      if (lo[a] > hi[a]) { lo[a] = hi[a] = (lo[a] + hi[a]) / 2; }
      if (Math.abs(d[a]) < 1e-9) { if (o[a] < lo[a] - 1e-6 || o[a] > hi[a] + 1e-6) return null; continue; }
      var t1 = (lo[a] - o[a]) / d[a], t2 = (hi[a] - o[a]) / d[a];
      von = Math.max(von, Math.min(t1, t2)); bis = Math.min(bis, Math.max(t1, t2));
    }
    return bis >= von ? { von: von, bis: bis } : null;
  }
  function kugelRichtung(sp) { return [Math.sin(sp.ph) * Math.cos(sp.th), Math.sin(sp.th), Math.cos(sp.ph) * Math.cos(sp.th)]; }
  function kugelZiel(sp, A) {
    return { x: sp.ziel ? sp.ziel.x : (A == null ? +zustand.A : A) / 2,
             y: sp.ziel && sp.ziel.y != null ? sp.ziel.y : +zustand.hoehe * 0.38,
             z: sp.ziel ? sp.ziel.z : 60 };
  }
  /* Hat die Richtung der Kugel einen Standort im Raum, mindestens KAMERA_MIN vom Blickpunkt? */
  function kugelGueltig(sp) {
    if (!RAUM_KAMERA_DRIN || !huelleJetzt || !zustand) return true;
    var rr = kugelRichtung(sp), st = strahlImRaum(kugelZiel(sp), rr[0], rr[1], rr[2]);
    return !!st && st.bis >= KAMERA_MIN;
  }
  /* Bildwinkel der freien Kamera: aus der Raum-/Wandansicht uebernommen als WAAGRECHTER Winkel (bleibt beim Drehen des Telefons),
     sonst 62 im Raum / 42. */
  function fovFreiJetzt(sp) {
    if (sp && sp.fovBasisH) return Math.max(30, Math.min(100, 2 * Math.atan(sp.fovBasisH / Math.max(0.2, cam.aspect)) * 180 / Math.PI));
    return RAUM_KAMERA_DRIN && huelleJetzt ? 62 : 42;
  }
  /* Groesster sinnvoller Abstand in der aktuellen Richtung: dort erreicht der Bildwinkel an der Wand 100 Grad — weiter hinaus
     haette das Rad keine Wirkung (tote Zone). Nur beim Zoomen angewandt, nie beim Drehen (sonst schrumpfte der Zoom). */
  function kugelRGrenze(sp) {
    if (!RAUM_KAMERA_DRIN || !huelleJetzt || !zustand) return 2600;
    var rr = kugelRichtung(sp), st = strahlImRaum(kugelZiel(sp), rr[0], rr[1], rr[2]);
    if (!st || !(st.bis > 1) || !isFinite(st.bis)) return 2600;
    var halb = Math.tan(fovFreiJetzt(sp) * Math.PI / 360);
    return Math.min(2600, Math.max(st.bis, st.bis * Math.tan(50 * Math.PI / 180) / halb));
  }
  /* Nach einem Wechsel in die freie Kamera: liegt die Richtung ohne Standort (etwa aus der Draufsicht), die naechste gueltige
     suchen — sonst griffe die Sperre beim Drehen nicht, und die Kamera wechselte zwischen Strahl und Rueckfall (Satz). */
  function kugelGueltigMachen(sp) {
    if (kugelGueltig(sp)) return;
    var ph0 = sp.ph, th0 = sp.th, thListe = [th0, 0.35, 0.2, 0.1, 0.02];
    for (var k = 0; k <= 64; k++) {
      var dph = (k % 2 ? 1 : -1) * Math.ceil(k / 2) * Math.PI / 32;
      for (var j = 0; j < thListe.length; j++) {
        sp.ph = ph0 + dph; sp.th = Math.max(thGrenze(0), Math.min(thGrenze(1), thListe[j]));
        if (kugelGueltig(sp)) return;
      }
    }
    sp.ph = ph0; sp.th = th0;
  }
  function kugelKamera(sp, A) {
    var ziel = kugelZiel(sp, A), rr = kugelRichtung(sp), st = strahlImRaum(ziel, rr[0], rr[1], rr[2]), p;
    if (st && st.bis >= Math.max(1, st.von)) {
      var dS = Math.max(st.von, Math.min(sp.r, st.bis));
      p = { x: ziel.x + rr[0] * dS, y: ziel.y + rr[1] * dS, z: ziel.z + rr[2] * dS };
      /* Ohne Raumhuelle (sehr kurze Zeile) nie unter den Boden, wie bisher. */
      if (!RAUM_KAMERA_DRIN || !huelleJetzt) p.y = Math.max(30, p.y);
    } else {
      /* Kein Standort auf dem Strahl (Blickpunkt ausserhalb, Richtung in die Wand): wie bisher an den Raum geklemmt. */
      p = imRaum({ x: ziel.x + sp.r * rr[0], y: Math.max(30, ziel.y + sp.r * rr[1]), z: ziel.z + sp.r * rr[2] });
    }
    /* ZURUECK BIS ZUR WAND, DANN WEITWINKEL (Betreiber 2026-09-29: „ولا استطيع التبعيد"): haelt die Wand die Kamera fest,
       waechst der Bildwinkel so, wie der Ausschnitt aus dem gewuenschten Abstand waere — bis 100 Grad. */
    var dIst = Math.hypot(p.x - ziel.x, p.y - ziel.y, p.z - ziel.z);
    if (RAUM_KAMERA_DRIN && huelleJetzt && dIst > 1 && sp.r > dIst) {
      var halb = Math.tan(cam.fov * Math.PI / 360), fovW = 2 * Math.atan(halb * sp.r / dIst) * 180 / Math.PI;
      cam.fov = Math.min(100, fovW); cam.updateProjectionMatrix();
    }
    cam.position.set(p.x, p.y, p.z);
    cam.lookAt(ziel.x, ziel.y, ziel.z);
  }

  /* SCHNAPPSCHUSS FUER DAS DECKBLATT DES PLANUNGS-PDF (Betreiber 2026-09-26: „das Planungsdokument
     ist nicht professionell"). Das Deckblatt zeigt die Kueche so, wie der Kunde sie in 3D sieht —
     dieselbe Kamera, als Datei in fester Breite und ohne Auswahlrahmen. Alles geschieht in EINER
     Aufgabe: Puffer umstellen, zeichnen, auslesen, zurueckstellen, neu zeichnen. Der Browser malt
     dazwischen nicht; auf dem Schirm springt nichts.

     Seitenverhaeltnis 1,35 bis 1,7 (das Bildfeld des Deckblatts). Ist der Schirm schmaler, bleibt
     die senkrechte Oeffnung und seitlich kommt Raum dazu. Ist er breiter, bleibt die WAAGRECHTE
     Oeffnung (die senkrechte wird weiter) — sonst schnitte das Bild die Enden der Kueche ab, die der
     Kunde auf dem breiten Schirm sieht.

     Draufsicht und Frontblick sind Arbeitsansichten; fuer das Deckblatt gilt dann die Perspektive von
     der offenen Seite, wie beim ersten Oeffnen. Laeuft ein Foto oder steht eins im Bild, wird es nicht
     angefasst — dann gilt die Leinwand, wie sie ist. Verborgen (2D-Ansicht): kein Bild. */
  function schnappschuss(breite) {
    if (!rd || !sc || !cam || !zustand || !leinwand || !kugel) return null;
    var B = Math.max(320, Math.min(2400, Math.round(breite || 1600)));
    var cb = leinwand.clientWidth, ch = leinwand.clientHeight;
    if (!cb || !ch) return null;
    var cv = rd.domElement;
    if (foto) {
      var k2 = document.createElement('canvas');
      k2.width = B; k2.height = Math.max(1, Math.round(B * cv.height / Math.max(1, cv.width)));
      k2.getContext('2d').drawImage(cv, 0, 0, k2.width, k2.height);
      return k2.toDataURL('image/jpeg', 0.9);
    }
    var schirm = cb / ch, asp = Math.max(1.35, Math.min(1.7, schirm)), H = Math.round(B / asp);
    var alt = { art: kugel.art, th: kugel.th, ph: kugel.ph, r: kugel.r, ziel: kugel.ziel, wandId: kugel.wandId,
                gezoomt: kugel.gezoomt, lupe: kugel.lupe, fovBasisH: kugel.fovBasisH };
    /* Das Deckblatt ist kein Blickwechsel: keine Fahrt, und die gezeigte Lage bleibt die vorige. */
    fahrtAnhalten();
    var pr = rd.getPixelRatio(), fov = cam.fov, near = cam.near, aspect = cam.aspect;
    var markSicht = markierung ? markierung.visible : false;
    var bild = null;
    try {
      rd.setPixelRatio(1);
      rd.setSize(B, H, false);
      if (nach) { nach.comp.setPixelRatio(1); nach.comp.setSize(B, H); }
      cam.aspect = B / H;
      /* Neu gesetzt passt `blick` den Abstand schon an DIESES Bildfeld an (passRadius liest
         Oeffnung und Seitenverhaeltnis der Kamera) — dann bleibt die Oeffnung bei 42 Grad. */
      /* Aus der Raumansicht das, was der Kunde sieht (bisher die alten Kugelwerte der Perspektive — seit der Kamera auf dem
         Blickstrahl eine Nahaufnahme der Plattenecke, Code-Pruefung 2026-10-01). */
      var raumBild = kugel.art === 'raum' && raumKamera(B / H);
      if (!raumBild) {
        var neu = kugel.art === 'front' || kugel.art === 'oben';
        if (neu) { cam.fov = 42; cam.updateProjectionMatrix(); blick('perspektive'); }
        var halb = Math.tan(21 * Math.PI / 180);
        cam.fov = !neu && schirm > asp ? 2 * Math.atan(halb * schirm / asp) * 180 / Math.PI : 42;
        cam.near = 10;
        cam.updateProjectionMatrix();
        kugelKamera(kugel, +zustand.A);
      }
      kontaktWeg(!(nach && !ohneNach));
      if (markierung) markierung.visible = false;
      if (pendelGruppe) pendelGruppe.visible = true;
      if (nach && !ohneNach) { try { nach.comp.render(); } catch (e) { rd.render(sc, cam); } }
      else rd.render(sc, cam);
      bild = cv.toDataURL('image/jpeg', 0.9);
    } catch (e) {
      bild = null;
    }
    for (var k in alt) { if (Object.prototype.hasOwnProperty.call(alt, k)) kugel[k] = alt[k]; }
    if (markierung) markierung.visible = markSicht;
    rd.setPixelRatio(pr);
    rd.setSize(cb, ch, false);
    if (nach) { nach.comp.setPixelRatio(pr); nach.comp.setSize(cb, ch); }
    cam.aspect = aspect; cam.fov = fov; cam.near = near;
    cam.updateProjectionMatrix();
    fahrtRuhe = false;
    zeichnen();
    poseZuletzt = cam ? poseJetzt() : poseZuletzt;
    return bild;
  }

  /* UMGEBUNGSVERDECKUNG (R1 Realismus, 2026-09-27). Was ein Foto von einer Zeichnung trennt, ist
     das Licht, das in Ecken, Fugen und unter Haengeschraenken FEHLT: die Kehle zwischen Platte
     und Wand, die Fuge zwischen zwei Korpussen, der Boden unter dem Sockel. Die Schattenkarte der
     Sonne kennt nur eine Richtung; GTAO (three r160, examples) rechnet diese Verdeckung im Bild.
     Geladen aus derselben esm.sh-Fassung wie three — nur dann ist es dieselbe Instanz. Mit einer
     anderen Quelle (Theme-Asset) oder wenn das Laden scheitert, bleibt es beim direkten Zeichnen
     wie bisher. Auf dem Telefon wird waehrend des Ziehens ohne gezeichnet, am Ende einmal mit. */
  var POST_QUELLE = 'https://esm.sh/three@0.160.0/examples/jsm/postprocessing/';
  /* Randabdunklung (elliptisch, bis 15 % in den Ecken) und festes Korn (je Bildpunkt, in den Schatten etwas staerker). */
  var FOTO_LOOK = {
    uniforms: { tDiffuse: { value: null }, uRand: { value: 0.15 }, uKorn: { value: 0.022 } },
    vertexShader: 'varying vec2 vUv; void main() { vUv = uv; gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0); }',
    fragmentShader: [
      'uniform sampler2D tDiffuse; uniform float uRand; uniform float uKorn; varying vec2 vUv;',
      'float zz(vec2 p) { return fract(sin(dot(p, vec2(12.9898, 78.233))) * 43758.5453); }',
      'void main() {',
      '  vec4 c = texture2D(tDiffuse, vUv);',
      '  vec2 d = (vUv - 0.5) * vec2(1.0, 0.8);',
      '  c.rgb *= 1.0 - uRand * smoothstep(0.2, 0.62, length(d));',
      '  float l = dot(c.rgb, vec3(0.299, 0.587, 0.114));',
      /* Bright surfaces keep only a quarter of the grain: on the ceiling and light walls it read as speckle (2026-10-01). */
      '  c.rgb += (zz(floor(gl_FragCoord.xy)) - 0.5) * uKorn * (0.55 + 0.45 * (1.0 - l)) * mix(1.0, 0.25, smoothstep(0.62, 0.86, l));',
      '  gl_FragColor = c;',
      '}'
    ].join('\n')
  };
  /* GTAO NOISE WITHOUT THE COST (2026-10-01). The 5-px dot grid had two causes in three r160 (also still in r182):
     1. GTAO turns its 3 slice directions with a fixed 5x5 tile — a pattern fixed on the screen. Interleaved gradient noise
        (Jimenez 2014) gives every pixel its own turn without a repeating tile. The turn stays inside one 60-degree wedge (the
        3 slice lines repeat every PI/3), so neighbouring pixels sample in similar directions: the GTAO pass got faster too.
     2. The Poisson denoise builds its "rotation" as mat2(sin, -cos, sin, cos). That is no rotation: for about half of all pixels
        the kernel collapsed to a line, so the denoise smeared along lines instead of averaging the pattern away. A proper rotation,
        with blue-noise angles (64x64, void-and-cluster, embedded) instead of r160's simplex texture from Math.random (new per load).
     Still 16 samples = 3 directions x 6 steps, so the AO depth is the original one. Measured against 30 samples with the broken
     denoise: as clean or cleaner in all 7 test scenes, at the frame time of 16 samples (gtao-leistung-2026-10-01).
     If the library text differs, nothing is patched. */
  var PD_DREHUNG = '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';
  function gtaoRauschen(ao) {
    var g = ao && ao.gtaoMaterial, p = ao && ao.pdMaterial;
    var DREH = 'vec4 noiseTexel = textureLod(tNoise, noiseUv, 0.0);', MAT = 'mat2(noiseVec.x, -noiseVec.y, noiseVec.x, noiseVec.y)';
    if (!g || !p || g.fragmentShader.indexOf(DREH) < 0 || p.fragmentShader.indexOf(MAT) < 0 || !w.atob) return false;
    g.fragmentShader = g.fragmentShader.replace(DREH, 'float hmR = fract(52.9829189 * fract(dot(floor(gl_FragCoord.xy), vec2(0.06711056, 0.00583715))));'
      + ' float hmA = hmR * PI / 3.; vec4 noiseTexel = vec4(cos(hmA) * .5 + .5, sin(hmA) * .5 + .5, .5, 1.);');
    p.fragmentShader = p.fragmentShader.replace(MAT, 'mat2(noiseVec.y, noiseVec.x, -noiseVec.x, noiseVec.y)');
    var roh = w.atob(PD_DREHUNG), d = new Uint8Array(64 * 64 * 4);
    for (var i = 0; i < 64 * 64; i++) d[i * 4] = d[i * 4 + 1] = d[i * 4 + 2] = d[i * 4 + 3] = roh.charCodeAt(i);
    var tx = new T.DataTexture(d, 64, 64); tx.wrapS = tx.wrapT = T.RepeatWrapping; tx.needsUpdate = true;
    if (ao.pdNoiseTexture) ao.pdNoiseTexture.dispose();
    ao.pdNoiseTexture = tx; p.uniforms.tNoise.value = tx;
    g.needsUpdate = true; p.needsUpdate = true;
    return true;
  }
  function nachLaden() {
    if (nach || nachLaeuft || !/^https:\/\/esm\.sh\/three@0\.160\.0\/?$/.test(dreiQuelle)) return;
    nachLaeuft = true;
    Promise.all(['EffectComposer', 'RenderPass', 'GTAOPass', 'OutputPass', 'ShaderPass', 'UnrealBloomPass'].map(function (n) {
      return modul(POST_QUELLE + n + '.js');
    })).then(function (M) {
      nachLaeuft = false;
      if (!rd || !sc || !cam) return;
      var b = (leinwand && leinwand.clientWidth) || 800, h = (leinwand && leinwand.clientHeight) || 480;
      /* KANTENGLAETTUNG: der Zusammensetzer zeichnet in einen eigenen Puffer, und der hatte keine
         Mehrfachabtastung — seit der Umgebungsverdeckung waren alle Kanten gezackt, duenne Fugen
         zerfielen in Punkte (gesehen 2026-09-27). 4-fach MSAA im Puffer (WebGL2). */
      var ziel = new T.WebGLRenderTarget(b * rd.getPixelRatio(), h * rd.getPixelRatio(),
        { type: T.HalfFloatType, samples: rd.capabilities && rd.capabilities.isWebGL2 ? 4 : 0 });
      var comp = new M[0].EffectComposer(rd, ziel);
      comp.addPass(new M[1].RenderPass(sc, cam));
      var ao = new M[2].GTAOPass(sc, cam, b, h);
      ao.output = M[2].GTAOPass.OUTPUT.Default;
      ao.blendIntensity = 1;
      /* Masse in cm. Abgestimmt im Bild (2026-09-27): mit 28 cm und Staerke 1 aenderte sich im
         Mittel 1,3 Tonwerte — nicht zu sehen. 55 cm und 1,6 legen die Kehlen, den Raum unter
         den Haengeschraenken und den Boden unter Insel und Fuessen sichtbar ab. */
      /* Dot grid (2026-10-01): 16 samples = 3 directions x 6 steps (the original AO depth). gtaoRauschen removes the dot grid
         (no fixed 5x5 tile, a real denoise rotation, 4 rings / 32 taps); 30 samples did it too, at +8 to +14 ms per frame (DPR 2). */
      ao.updateGtaoMaterial({ radius: 55, distanceExponent: 1, thickness: 30, scale: 1.6, samples: 16,
        distanceFallOff: 1, screenSpaceRadius: false });
      ao.updatePdMaterial({ lumaPhi: 10, depthPhi: 2, normalPhi: 3, radius: 5, radiusExponent: 1,
        rings: 4, samples: 32 });
      gtaoRauschen(ao);
      /* Die Auswahl-Linien gehoeren nicht in die Verdeckung: als Flaechen im Tiefenpuffer legten sie dunkle Flecken um den Schrank. */
      var aoZeichnen = ao.render;
      ao.render = function () {
        var sicht = markierung ? markierung.visible : false;
        if (markierung) markierung.visible = false;
        try { return aoZeichnen.apply(ao, arguments); } finally { if (markierung) markierung.visible = sicht; }
      };
      comp.addPass(ao);
      /* LICHTHOF (Stufe 3): nur was heller als 1,6 ist — Deckenspots, LED-Leisten, Fenster und ihre Spiegelpunkte —
         bekommt einen feinen Schein, wie Lichtquellen auf jedem Foto. Die Schwelle liegt ueber jeder beleuchteten Flaeche,
         auch ueber weissem Hochglanz: der erste Versuch (Schwelle darunter) legte einen Schleier ueber das Bild. */
      var hof = new M[5].UnrealBloomPass(new T.Vector2(b, h), 0.3, 0.35, 1.6);
      comp.addPass(hof);
      /* WIE EIN FOTO (Vorschlag Realismus 2026-09-28): im fertigen Bild eine leichte Randabdunklung und ein feines,
         festes Korn — eine randlos gleich helle, glatte Flaeche ist das deutlichste Zeichen eines Computerbildes. Ein
         Leuchten heller Stellen (Bloom) wurde erprobt und verworfen: die hellen Hochglanzfronten loesten es ueberall aus,
         ein Schleier lag ueber dem Bild und Schwarz wurde grau (Spuele 21 → 88). */
      var ausgabe = new M[3].OutputPass();
      ausgabeNeutral(ausgabe);
      comp.addPass(ausgabe);
      var look = new M[4].ShaderPass(FOTO_LOOK);
      comp.addPass(look);
      comp.setPixelRatio(rd.getPixelRatio());
      comp.setSize(b, h);
      nach = { comp: comp, ao: ao, look: look, hof: hof };
      if (!foto) zeichnen();
    }).catch(function () { nachLaeuft = false; });
  }
  /* Was die Kamera ausserhalb des Raums sieht (malen): Boden und Decke laufen in der Frontansicht mit langer Brennweite und in
     der herausgezoomten Raumansicht weiter (weitGruppe); das Lichtfenster auf ihrer Seite blendet sich aus. */
  function schaleNachKamera() {
    var h = huelleJetzt, c = cam && cam.position;
    var draussen = !!h && !!c && (c.x < h.minX - 1 || c.x > h.maxX + 1 || c.z < h.minY - 1 || c.z > h.maxY + 1);
    /* Auch waehrend einer Fahrt von draussen herein (erster Zug aus der Tele-Wandansicht oder der weiten Raumansicht): sonst fehlten
       Boden und Decke fuer einen Augenblick. */
    if (weitGruppe) weitGruppe.visible = !!(kugel && ((kugel.art === 'front' && teleHier()) || (kugel.art === 'raum' && draussen) || (fahrt && draussen)));
    if (fensterGruppe) fensterGruppe.visible = !kameraAussen(lichtFenster && lichtFenster.seite);
    /* Phase 1: the views out are drawn while the camera is in the room or stands at most 30 cm outside it (the customer's camera
       "in the door" of an open side), below the ceiling — and never the view of the side the camera stands behind. */
    if (aussenGruppe) {
      var raus = h && c ? Math.max(h.minX - c.x, c.x - h.maxX, h.minY - c.z, c.z - h.maxY, 0) : Infinity;
      aussenGruppe.visible = !!h && !!c && c.y < hoeheJetzt && raus <= 30;
      aussenGruppe.children.forEach(function (g2) { g2.visible = !kameraAussen(g2.userData.seite); });
    }
  }
  /* MEMORY (2026-10-01): every rebuild left 189 geometries (Glanzia U, measured) with their buffers and VAOs, all of the
     kitchen's own materials and one reflection target in GPU memory. The old kitchen belongs to the planner alone — except what
     the new scene keeps using and what the module caches hold (wood, floor, room, worktop and decor images, U57, light
     materials, contact shadows, decor models, reflection and studio environments). It is released after the FIRST frame of the
     new kitchen: by then the new materials hold the shader programs and the new texture copies the GPU images — nothing is
     compiled or uploaded again. Render-target textures are released only by their target (raumSpiegel). */
  var freigabeOffen = [];
  function texturenVon(m) {
    var out = [];
    for (var k in m) { var v = m[k]; if (v && v.isTexture) out.push(v); }
    if (m.uniforms) for (var u in m.uniforms) { var x = m.uniforms[u] && m.uniforms[u].value; if (x && x.isTexture) out.push(x); }
    return out;
  }
  function materialienVon(o) { return Array.isArray(o.material) ? o.material : (o.material ? [o.material] : []); }
  function ressourcenSammeln(wurzel, s) {
    wurzel.traverse(function (o) {
      if (o.geometry) s.geo.add(o.geometry);
      materialienVon(o).forEach(function (m) { s.mat.add(m); texturenVon(m).forEach(function (t) { s.tex.add(t); }); });
    });
  }
  function geteilteSammeln(s) {
    var nimm = function (v, tiefe) {
      if (!v || typeof v !== 'object' || tiefe > 3) return;
      if (v.isBufferGeometry) s.geo.add(v);
      else if (v.isMaterial) { s.mat.add(v); texturenVon(v).forEach(function (t) { s.tex.add(t); }); }
      else if (v.isTexture) s.tex.add(v);
      else if (v.isObject3D) ressourcenSammeln(v, s);
      else if (Array.isArray(v)) v.forEach(function (x) { nimm(x, tiefe + 1); });
      else Object.keys(v).forEach(function (k) { nimm(v[k], tiefe + 1); });
    };
    [dielenBild, fliesenBild, steinBild, musterBild, geraetBilder, teppichBilder, raumBilder, vouteBilder, aussichtTex, fensterKarteTex,
      plattenBilder, dekorTex, bibKarten, dekorLaengs, u57Geos, scheinMats, kontaktMats, kontaktMat, kontaktGeos, dekoModellFertig, spiegelTex,
      studioEnv, glanzEnv].forEach(function (v) { nimm(v, 0); });
  }
  function szeneFreigeben() {
    var alte = freigabeOffen, bleibt = { geo: new Set(), mat: new Set(), tex: new Set() };
    freigabeOffen = [];
    if (sc) { ressourcenSammeln(sc, bleibt); if (sc.environment) bleibt.tex.add(sc.environment); }
    geteilteSammeln(bleibt);
    alte.forEach(function (kinder) {
      kinder.forEach(function (a) {
        a.traverse(function (o) {
          if (o.geometry && !bleibt.geo.has(o.geometry)) { bleibt.geo.add(o.geometry); o.geometry.dispose(); }
          materialienVon(o).forEach(function (m) {
            if (bleibt.mat.has(m)) return;
            bleibt.mat.add(m);
            texturenVon(m).forEach(function (t) {
              if (bleibt.tex.has(t) || t.isRenderTargetTexture) return;
              bleibt.tex.add(t); t.dispose();
            });
            programmBehalten(m);
            m.dispose();
          });
        });
      });
    });
  }
  /* SHADER PROGRAMS STAY COMPILED (2026-10-01, measured): three counts a program's users by live materials and destroys it with
     the last one. The old code never disposed materials, so every program stayed compiled; with the release, a cabinet change that
     brought a material variant back (appliance glass, steel, displays) recompiled 15-29 programs — one rebuild 0.7-2 s instead of
     ~0.1 s. The program list is detached before dispose: the program stays in three's cache (bounded by the material variants of
     the catalogue, as before), the material itself, its geometry and its textures are freed. Not for ShaderMaterial: its entry in
     the shader cache must go with it. */
  function programmBehalten(m) {
    if (!rd || !rd.properties || m.isShaderMaterial) return;
    var eig = rd.properties.get(m);
    if (eig) eig.programs = undefined;
  }
  function nachDemBild() {
    if (!freigabeOffen.length) return;
    try { szeneFreigeben(); } catch (e) { freigabeOffen = []; }
  }
  function malen() {
    pufferFrisch = false;
    var klein = (w.innerWidth || 800) < 768;
    if (pendelGruppe) pendelGruppe.visible = !(kugel && (kugel.art === 'front' || kugel.art === 'oben'));
    schaleNachKamera();
    if (nach && !ohneNach && !(klein && zieht)) {
      kontaktWeg(false);
      try { nach.comp.render(); return; } catch (e) { nach = null; } finally { nachDemBild(); }
    }
    kontaktWeg(true);
    rd.render(sc, cam);
    nachDemBild();
  }

  function steuerung(cv) {
    /* BEDIENUNG MIT DEM FINGER (Betreiber 2026-09-24: „auf dem Handy bequem bewegen").
       Ein Finger dreht, zwei Finger zoomen (Abstand) und verschieben (Mitte) — wie in jeder
       Karten- und Foto-App. Ein kurzer Tipper ohne Bewegung waehlt den Schrank darunter
       (HMKonfig3D.beimAntippen). Maus: ziehen dreht, Rad zoomt, wie bisher. */
    var finger = {}, start = null, zwei = null;
    var anzahl = function () { return Object.keys(finger).length; };
    /* Zeichnen aus einer Eingabe: die Kamera folgt sofort; Spruenge ohne Eingabe faehrt fahrtAnwenden weich. */
    var zeichneEingabe = function () { eingabe = true; try { zeichnen(); } finally { eingabe = false; } };
    /* Ein einzelnes Ereignis bewegt hoechstens so weit: haengt der Browser kurz (Neuaufbau nach einer spaet geladenen Deko),
       kommt die ganze aufgelaufene Bewegung in EINEM Ereignis an — das drehte das Bild in einem Satz. */
    var grenze = function (v, g) { return Math.max(-g, Math.min(g, v)); };
    var paar = function () {
      var k = Object.keys(finger), a = finger[k[0]], b = finger[k[1]];
      return { d: Math.hypot(a.x - b.x, a.y - b.y), mx: (a.x + b.x) / 2, my: (a.y + b.y) / 2 };
    };
    var aufPerspektive = function () {
      if (kugel.art === 'front' || kugel.art === 'oben' || kugel.art === 'raum') fahrtStarten();
      /* Wer dreht, verlaesst den Aufriss: eine gedrehte Frontansicht ist keine mehr. Ab dem
         ersten Zug uebernimmt wieder die perspektivische Kamera — und zwar aus der Lage,
         die der Aufriss zuletzt zeigte, damit das Bild nicht springt. */
      /* Von der Frontansicht aus WIRKLICH aus ihrer Lage (2026-09-28): bis hierher blieb der Winkel
         der letzten freien Ansicht stehen, der Blickpunkt sprang auf Wand A und der Abstand auf den
         ganzen Raum — seit die Wandknoepfe der Planer-App die Frontansicht oeffnen, warf der erste Zug
         danach das Bild herum. Jetzt: dieselbe Richtung und derselbe Blickpunkt wie die Frontkamera;
         war die Gegenzeile weggeschnitten, tritt die Kamera nur bis vor sie zurueck. */
      var fz = kugel.art === 'front' && cam ? kugel.frontZiel : null;
      if (fz) {
        /* Seit 2026-09-30 wie aus der Raumansicht: Blickpunkt auf IHREM Blickstrahl in der Tiefe der Wand, ihre Hoehe und ihr
           Bildwinkel (vorher zielte die freie Kamera auf 0,38 der Raumhoehe mit 62 Grad — ein Kippen und Weiten im ersten Zug).
           War die Gegenzeile weggeschnitten, steht die Kamera ausserhalb der Raumgrenze: das faehrt weich (fahrtStarten). */
        var fwF = new T.Vector3(); cam.getWorldDirection(fwF);
        var hqF = fwF.x * fwF.x + fwF.z * fwF.z;
        var tF = hqF > 1e-6 ? ((fz.x - cam.position.x) * fwF.x + (fz.z - cam.position.z) * fwF.z) / hqF : 300;
        tF = Math.max(KAMERA_MIN, tF);
        kugel.ziel = { x: cam.position.x + fwF.x * tF, y: cam.position.y + fwF.y * tF, z: cam.position.z + fwF.z * tF };
        kugel.th = Math.max(thGrenze(0), Math.min(thGrenze(1), Math.asin(Math.max(-1, Math.min(1, -fwF.y)))));
        kugel.ph = Math.atan2(-fwF.x, -fwF.z);
        kugel.r = Math.max(KAMERA_MIN, fz.frei ? Math.min(tF, fz.frei) : tF);
        /* Die Tele-Wandansicht (eine Zeile, 10–25 m davor, schmales Objektiv) wird nicht uebernommen: im Raum waere das ein
           Fernrohr. Dann der Raum-Bildwinkel und ein Abstand, der dort Sinn hat — die Fahrt fuehrt hin. */
        if (cam.fov < 40) { kugel.fovBasisH = null; kugel.r = Math.min(kugel.r, 600); }
        else kugel.fovBasisH = Math.tan(cam.fov * Math.PI / 360) * cam.aspect;
        kugelGueltigMachen(kugel);
        kugel.art = null; kugel.wandId = null; kugel.frontZiel = null;
        return;
      }
      if (kugel.art === 'raum') {
        /* Aus der Raumansicht heraus: dieselbe Lage als freie Perspektive. Bisher zielte sie auf den Schwerpunkt in
           Kuechenhoehe statt dorthin, wohin die Raumkamera sah, und nahm 62 Grad statt ihres Bildwinkels — der erste Zug sprang
           (gemessen 7 Grad Richtung, 9 Grad Bildwinkel). Jetzt: Blickpunkt auf IHREM Blickstrahl, auf Hoehe des Schwerpunkts
           der Kueche; ihr Bildwinkel bleibt. Was die Raumgrenze danach noch verschiebt, faehrt weich (fahrtStarten). */
        if (cam && kugel.raumZiel) {
          var zr = kugel.raumZiel, fw = new T.Vector3(); cam.getWorldDirection(fw);
          var hq = fw.x * fw.x + fw.z * fw.z;
          var tr = hq > 1e-6 ? ((zr.x - cam.position.x) * fw.x + (zr.z - cam.position.z) * fw.z) / hq : 300;
          tr = Math.max(KAMERA_MIN, tr);
          kugel.ziel = { x: cam.position.x + fw.x * tr, y: cam.position.y + fw.y * tr, z: cam.position.z + fw.z * tr };
          kugel.th = Math.max(thGrenze(0), Math.min(thGrenze(1), Math.asin(Math.max(-1, Math.min(1, -fw.y)))));
          kugel.ph = Math.atan2(-fw.x, -fw.z);
          kugel.r = tr;
          kugel.fovBasisH = Math.tan(cam.fov * Math.PI / 360) * cam.aspect;
        }
        kugel.art = null; kugel.wandId = null; kugel.raumZiel = null;
        kugelGueltigMachen(kugel);
        return;
      }
      if (kugel.art === 'front' || kugel.art === 'oben') {
        if (kugel.art === 'front') { kugel.th = 0.03; kugel.ph = kugel.ph || 0; }
        /* Aus der Draufsicht gleich in die erlaubte Neigung (sonst klemmte der naechste Zug 1,18 auf 0,5 — ein Sprung). */
        else { kugel.th = Math.min(1.18, thGrenze(1)); kugel.ph = Math.PI * 0.26; }
        kugel.art = null; kugel.wandId = null; kugel.ziel = null;
        kugel.r = passRadius();
        kugelGueltigMachen(kugel);
      }
    };
    cv.addEventListener('pointerdown', function (e) {
      finger[e.pointerId] = { x: e.clientX, y: e.clientY };
      try { cv.setPointerCapture(e.pointerId); } catch (x) { /* ältere Browser */ }
      if (anzahl() === 1) start = { x: e.clientX, y: e.clientY, t: Date.now(), bewegt: false };
      else { start = null; zwei = paar(); }
    });
    var los = function (e) {
      var war = finger[e.pointerId];
      delete finger[e.pointerId];
      try { cv.releasePointerCapture(e.pointerId); } catch (x) { /* egal */ }
      if (anzahl() < 2) zwei = null;
      /* Ein Tipper: kurz, kaum bewegt, ein Finger. */
      if (war && start && !start.bewegt && Date.now() - start.t < 450
          && typeof w.HMKonfig3D.beimAntippen === 'function') {
        var sel = treffer(cv, e.clientX, e.clientY);
        w.HMKonfig3D.beimAntippen(sel);
      }
      if (!anzahl()) {
        start = null;
        /* Ende des Ziehens: einmal mit Umgebungsverdeckung nachzeichnen (Telefon). */
        if (zieht) { zieht = false; zeichnen(); }
      } else if (anzahl() === 1) { var k = Object.keys(finger)[0]; start = { x: finger[k].x, y: finger[k].y, t: 0, bewegt: true }; }
    };
    cv.addEventListener('pointerup', los);
    cv.addEventListener('pointercancel', los);
    cv.addEventListener('pointermove', function (e) {
      var f = finger[e.pointerId];
      if (!f) return;
      var dx = grenze(e.clientX - f.x, 40), dy = grenze(e.clientY - f.y, 40);
      f.x = e.clientX; f.y = e.clientY;
      if (start && Math.hypot(e.clientX - start.x, e.clientY - start.y) > 6) start.bewegt = true;
      if (anzahl() >= 2 && zwei && kugel.art === 'raum') {
        var jetztR = paar();
        if (zwei.d > 10 && jetztR.d > 10) {
          kugel.lupe = Math.max(0.45, Math.min(2.2, (kugel.lupe || 1) * Math.max(0.8, Math.min(1.25, zwei.d / jetztR.d))));
          kugel.gezoomt = true;
        }
        zwei = jetztR;
        zieht = true;
        zeichneEingabe();
        return;
      }
      if (anzahl() >= 2 && zwei) {
        aufPerspektive();
        var jetzt = paar();
        /* Zoomen: Verhaeltnis der Fingerabstaende. */
        if (zwei.d > 10 && jetzt.d > 10) {
          kugel.r = Math.max(120, Math.min(kugelRGrenze(kugel), kugel.r * Math.max(0.8, Math.min(1.25, zwei.d / jetzt.d))));
          kugel.gezoomt = true;
        }
        /* Verschieben: die Mitte der beiden Finger zieht den Blickpunkt ueber den Boden. */
        var hoch = Math.max(1, cv.clientHeight || 400), k2 = kugel.r / hoch * 1.1;
        var mdx = grenze(jetzt.mx - zwei.mx, 60), mdy = grenze(jetzt.my - zwei.my, 60);
        var ziel = kugel.ziel || { x: +zustand.A / 2, z: 60 };
        var rx = Math.cos(kugel.ph), rz = -Math.sin(kugel.ph), fx = -Math.sin(kugel.ph), fz = -Math.cos(kugel.ph);
        ziel = { x: ziel.x - rx * mdx * k2 + fx * mdy * k2, y: ziel.y, z: ziel.z - rz * mdx * k2 + fz * mdy * k2 };
        if (bbJetzt) {
          ziel.x = Math.max(bbJetzt.minX - 150, Math.min(bbJetzt.maxX + 150, ziel.x));
          ziel.z = Math.max(bbJetzt.minY - 150, Math.min(bbJetzt.maxY + 250, ziel.z));
        }
        var zielAlt = kugel.ziel, gueltigZ = kugelGueltig(kugel);
        kugel.ziel = ziel;
        if (gueltigZ && !kugelGueltig(kugel)) kugel.ziel = zielAlt;
        zwei = jetzt;
        zieht = true;
        zeichneEingabe();
        return;
      }
      if (!start || !start.bewegt) return;
      aufPerspektive();
      var ph0 = kugel.ph, th0 = kugel.th, gueltig0 = kugelGueltig(kugel);
      kugel.ph -= dx * 0.006;
      kugel.th = Math.max(thGrenze(0), Math.min(thGrenze(1), kugel.th + dy * 0.005));
      /* Eine Richtung ohne Standort im Raum (hinter der Zeile) wird nicht angenommen: erst nur die Neigung, dann nur die
         Drehung zuruecknehmen, sonst beides — die Kamera bleibt an der Grenze stehen, statt an der Wand entlangzurutschen. */
      if (gueltig0 && !kugelGueltig(kugel)) {
        var th1 = kugel.th; kugel.th = th0;
        if (!kugelGueltig(kugel)) { kugel.ph = ph0; kugel.th = th1; if (!kugelGueltig(kugel)) kugel.th = th0; }
      }
      zieht = true;
      zeichneEingabe();
      /* Wer selbst dreht, steht auf keinem der drei Blickwinkel mehr. Die Schalter duerfen
         dann keinen mehr als aktiv zeigen — ein Schalter, der eine Lage behauptet, die man
         gerade verlassen hat, ist schlimmer als keiner. */
      if (typeof w.HMKonfig3D.beimDrehen === 'function') w.HMKonfig3D.beimDrehen();
    });
    cv.addEventListener('wheel', function (e) {
      e.preventDefault();
      /* Ein Rad-Ereignis mit sehr grossem Wert (manche Maeuse, nach einem Haenger) zoomte in einem Satz: hoechstens 200. */
      var radY = grenze(e.deltaY, 200);
      /* Eine orthografische Kamera zoomt ueber ihren AUSSCHNITT, nicht ueber den Abstand —
         weiter weg heisst dort gar nichts. */
      /* Raumansicht: die Kamera steht schon am Rand des Raums — zoomen heisst dort Brennweite (weiter/enger), nicht Abstand.
         Wandansicht im Raum: hoechstens 1,8-fach zurueck, weiter stand die Kueche als kleiner Kasten im Leeren. */
      if (kugel.art === 'raum') {
        kugel.lupe = Math.max(0.45, Math.min(2.2, (kugel.lupe || 1) * (1 + radY * 0.0012)));
      } else if (kugel.art === 'front' || kugel.art === 'oben') {
        kugel.lupe = Math.max(0.25, Math.min(kugel.art === 'front' && huelleJetzt ? 1.8 : 4, (kugel.lupe || 1) * (1 + radY * 0.0012)));
      } else {
        kugel.r = Math.max(120, Math.min(kugelRGrenze(kugel), kugel.r * (1 + radY * 0.0012)));
      }
      /* Ab jetzt bestimmt der Kunde die Groesse — die Rahmung darf sie nicht zurueckdrehen. */
      kugel.gezoomt = true;
      zeichneEingabe();
    }, { passive: false });
    if (w.ResizeObserver) {
      if (ro) ro.disconnect();
      ro = new w.ResizeObserver(function () { groesse(); });
      ro.observe(cv);
    }
  }

  /* Der Abstand, aus dem der GANZE Raum ins Bild passt. Der Radius stand bisher fest —
     einmal beim Aufbau aus der Ausdehnung gerechnet, ohne Brennweite und ohne Seitenformat
     der Flaeche. Auf 390 px ist das Bild hochkant schmal: der waagrechte Oeffnungswinkel
     schrumpft mit dem Seitenformat, und die Draufsicht schnitt den Raum an.
     Gerechnet wird gegen die Umkugel des Raumes — sie ist etwas grosszuegiger als der
     Quader und deshalb von der Drehung unabhaengig; der Zuschlag ist der Rand. */
  function passRadius(zuschlag) {
    if (!bbJetzt || !cam) return kugel ? kugel.r : 600;
    var R = 0.5 * Math.sqrt(bbJetzt.breite * bbJetzt.breite
      + bbJetzt.tiefe * bbJetzt.tiefe + hoeheJetzt * hoeheJetzt);
    var fv = cam.fov * Math.PI / 180;
    var fh = 2 * Math.atan(Math.tan(fv / 2) * Math.max(0.2, cam.aspect));
    return R / Math.tan(Math.min(fv, fh) / 2) * (zuschlag || 1.08);
  }

  /* Feste Blickwinkel für alle, die nicht ziehen mögen.

     `front` sah bis hierher IMMER auf Wand A: `ph = 0` ist eine Richtung im Raum, keine
     Aussage ueber die geplante Wand. In der Parallelkueche stand damit beim Blick auf C die
     Zeile von A im Weg, und ein Wandwechsel aenderte das Bild ueberhaupt nicht — gemessen
     C -> A: dasselbe Bild. Die Richtung kommt jetzt aus der Geometrie der Wand selbst
     (ihrer Innennormalen), genau wie die Wandgruppen der Szene. Raum, Waende und Schraenke
     bleiben unberuehrt; bewegt wird die Kamera. */
  function blick(art, wandId) {
    if (!kugel) return;
    fahrtStarten(); kugel.fovBasisH = null;
    kugel.art = art; kugel.gezoomt = false; kugel.ziel = null; kugel.lupe = 1; kugel.frontZiel = null;
    kugel.wandId = art === 'front' ? (wandId || null) : null;
    /* Die beiden massstaeblichen Blicke rechnen ihren Ausschnitt bei JEDEM Zeichnen neu —
       sie muessen dem Seitenverhaeltnis der Flaeche folgen, und das aendert sich beim
       Drehen des Telefons ohne einen weiteren Klick. Hier steht deshalb nur, WAS gezeigt
       werden soll; das WIE steht in `zeichnen()`.

       Fuer die freie Perspektive bleibt alles beim Alten: Kugelwinkel und Abstand. */
    if (art !== 'front' && art !== 'oben' && art !== 'raum') {
      kugel.th = Math.PI * 0.16; kugel.ph = Math.PI * 0.26;
      /* VON DER OFFENEN SEITE, nicht aus einer festen Richtung. Mit ph = 0,26 pi stand die
         Kamera bei der L-Kueche AUSSERHALB von Wand B, und der Kunde sah die Rueckseiten der
         Schraenke (Betreiber 2026-09-24). Die Summe der Innennormalen zeigt dorthin, wo keine
         Wand steht — dieselbe Regel wie in der Draufsicht; bei der Zeile bleibt ein leichter
         Dreiviertelblick. Blickpunkt ist die Mitte des Raumes, nicht die von Wand A. */
      var offen = offeneRichtung();
      if (offen) {
        kugel.ph = Math.atan2(offen.x, offen.z) + (offen.zeile ? Math.PI * 0.14 : 0);
        kugel.ziel = offen.mitte;
        kugel.r = passRadius(1.02);
      }
    }
    zeichnen();
  }

  /* DER RAUM ALS RECHTECK (Vorschlag Realismus 2026-09-28): um alle Waende und Bloecke; fehlt ihm die Tiefe (gerade Kueche,
     nur eine Wand), dann 360 cm. `luecken`: die Stuecke jeder Seite, an denen keine Wand des Kunden steht — dort schliesst
     die Ansicht den Raum. Nur fuer achsparallele Raeume (alle Formen des Planers); sonst null (offen wie bisher). */
  function raumHuelle(raum, t) {
    /* Eine Quelle (2026-09-29): der Kern rechnet die Huelle — die Sockelleiste fragt dieselbe, ob ein Zeilenende an einer Wand
       steht. Die Rechnung hier bleibt nur fuer einen alten Kern ohne K.raumHuelle. */
    if (K.raumHuelle) return K.raumHuelle(raum, t);
    var waende = raum.waende || [], xs = [], ys = [];
    if (waende.some(function (w) { return Math.abs(w.p0.x - w.p1.x) > 0.5 && Math.abs(w.p0.y - w.p1.y) > 0.5; })) return null;
    waende.forEach(function (w) { xs.push(w.p0.x, w.p1.x); ys.push(w.p0.y, w.p1.y); });
    (raum.bloecke || []).forEach(function (b) {
      var n = K.wandNormaleInnen(b);
      xs.push(b.p0.x, b.p1.x, b.p0.x + n.x * t, b.p1.x + n.x * t);
      ys.push(b.p0.y, b.p1.y, b.p0.y + n.y * t, b.p1.y + n.y * t);
    });
    if (!xs.length) return null;
    var h = { minX: Math.min.apply(null, xs), maxX: Math.max.apply(null, xs), minY: Math.min.apply(null, ys), maxY: Math.max.apply(null, ys) };
    if (h.maxX - h.minX < 150) return null;
    /* Mindesttiefe 360 nur, wo der Raum nach vorn offen ist. Zweizeilig mit 240 cm schloss die Gegenwand C den Raum bei
       240 — die Huelle lief trotzdem bis 360, HINTER die Zeile C, und die Raumkamera stand dort (Probe 2026-09-29: Rueckwand
       formatfuellend von hinten). */
    var vornZu = waende.some(function (w) { return Math.abs(w.p0.y - w.p1.y) <= 0.5 && Math.abs(w.p0.y - h.maxY) < 1; });
    if (h.maxY - h.minY < 330 && (!vornZu || h.maxY - h.minY < 1)) h.maxY = h.minY + 360;
    var seiten = { minY: [h.minX, h.maxX], maxY: [h.minX, h.maxX], minX: [h.minY, h.maxY], maxX: [h.minY, h.maxY] };
    var belegt = { minY: [], maxY: [], minX: [], maxX: [] };
    waende.forEach(function (w) {
      if (Math.abs(w.p0.y - w.p1.y) <= 0.5) {
        var sy = Math.abs(w.p0.y - h.minY) < 1 ? 'minY' : (Math.abs(w.p0.y - h.maxY) < 1 ? 'maxY' : null);
        if (sy) belegt[sy].push([Math.min(w.p0.x, w.p1.x), Math.max(w.p0.x, w.p1.x)]);
      } else {
        var sx = Math.abs(w.p0.x - h.minX) < 1 ? 'minX' : (Math.abs(w.p0.x - h.maxX) < 1 ? 'maxX' : null);
        if (sx) belegt[sx].push([Math.min(w.p0.y, w.p1.y), Math.max(w.p0.y, w.p1.y)]);
      }
    });
    h.luecken = [];
    Object.keys(seiten).forEach(function (s) {
      var a = seiten[s][0], e = seiten[s][1];
      belegt[s].sort(function (p, q) { return p[0] - q[0]; }).forEach(function (iv) {
        if (iv[0] - a >= 5) h.luecken.push({ seite: s, a: a, b: iv[0] });
        a = Math.max(a, iv[1]);
      });
      if (e - a >= 5) h.luecken.push({ seite: s, a: a, b: e });
    });
    return h;
  }

  /* KHRONOS PBR NEUTRAL (Lichtregie 2026-09-29) als eigene Tonkurve fuer three r160 (dort gibt es sie noch nicht). Der Code
     der Khronos-Referenz (pbrNeutral.glsl) — NICHT der aus three r162, der zu reinem Weiss statt zu `newPeak` mischte.
     Muss vor dem ersten Uebersetzen eines Materials stehen; der Ausgabeschritt der Nachbearbeitung wird in nachLaden
     eigens darauf umgestellt (er kennt nur die eingebauten Kurven und liesse die eigene still weg). */
  var tonkurveFertig = false;
  function tonkurveNeutral() {
    if (tonkurveFertig) return true;
    var alt = 'vec3 CustomToneMapping( vec3 color ) { return color; }';
    if (!T.ShaderChunk || !T.CustomToneMapping || T.ShaderChunk.tonemapping_pars_fragment.indexOf(alt) < 0) return false;
    T.ShaderChunk.tonemapping_pars_fragment = T.ShaderChunk.tonemapping_pars_fragment.replace(alt, [
      'vec3 CustomToneMapping( vec3 color ) {',
      '\tconst float StartCompression = 0.8 - 0.04;',
      '\tconst float Desaturation = 0.15;',
      '\tcolor *= toneMappingExposure;',
      '\tfloat x = min( color.r, min( color.g, color.b ) );',
      '\tfloat offset = x < 0.08 ? x - 6.25 * x * x : 0.04;',
      '\tcolor -= offset;',
      '\tfloat peak = max( color.r, max( color.g, color.b ) );',
      '\tif ( peak < StartCompression ) return color;',
      '\tconst float d = 1. - StartCompression;',
      '\tfloat newPeak = 1. - d * d / ( peak + d - StartCompression );',
      '\tcolor *= newPeak / peak;',
      '\tfloat g = 1. - 1. / ( Desaturation * ( peak - newPeak ) + 1. );',
      '\treturn mix( color, vec3( newPeak ), g );',
      '}'
    ].join('\n'));
    tonkurveFertig = true;
    return true;
  }
  function ausgabeNeutral(op) {
    if (!op || !op.material || rd.toneMapping !== T.CustomToneMapping) return;
    var marke = '#elif defined( AGX_TONE_MAPPING )';
    if (op.material.fragmentShader.indexOf(marke) < 0) return;
    op.material.fragmentShader = op.material.fragmentShader.replace(marke,
      '#elif defined( CUSTOM_TONE_MAPPING )\n\t\t\t\tgl_FragColor.rgb = CustomToneMapping( gl_FragColor.rgb );\n\t\t\t' + marke);
    /* Der Pass baut seine Schalter neu, sobald Kurve oder Farbraum „wechseln" — als schon gesetzt melden. */
    op._toneMapping = rd.toneMapping; op._outputColorSpace = rd.outputColorSpace;
    op.material.defines = { CUSTOM_TONE_MAPPING: '' };
    if (T.ColorManagement && T.SRGBTransfer && T.ColorManagement.getTransfer(rd.outputColorSpace) === T.SRGBTransfer) op.material.defines.SRGB_TRANSFER = '';
    op.material.needsUpdate = true;
  }

  /* DAS LICHTFENSTER (Lichtregie 2026-09-29). Woher das Tageslicht kommt: ein Fenster in einer Seitenwand, die keine Wand des
     Kunden ist — die laengste freie, bei Gleichstand die Seite des Looks — sichtbar, mit Aussicht, wie links im KU-S11-Bild.
     Gibt es keine freie Seitenwand (U-Kueche), ein Fenster in der offenen Vorderseite hinter der Kamera: nicht zu sehen, nur
     sein Licht. Nur durch dieses Fenster faellt die Sonne (sonnenBlende). Masse in Weltkoordinaten: `a`..`b` entlang der
     Seite, `unten`..`oben` Hoehe. */
  function lichtFensterWaehlen(h, RH, li) {
    if (!h) return null;
    var tiefe = h.maxY - h.minY, links = !li || li.seite !== 'rechts';
    var seiten = h.luecken.filter(function (l) { return (l.seite === 'minX' || l.seite === 'maxX') && l.b - l.a >= 170; });
    seiten.sort(function (p, q) {
      var d = (q.b - q.a) - (p.b - p.a);
      if (Math.abs(d) > 20) return d;
      return p.seite === (links ? 'minX' : 'maxX') ? -1 : 1;
    });
    if (seiten.length) {
      var l = seiten[0], fb = Math.min(150, l.b - l.a - 70);
      /* Etwas vor der Raummitte (zur Kamera hin): weg von Eck- und Hochschraenken, und im Raumbild noch am Rand zu sehen. */
      var mitte = Math.max(l.a + fb / 2 + 35, Math.min(l.b - fb / 2 - 35, h.minY + tiefe * 0.6));
      var oben = Math.min(RH - 32, 222);
      return { seite: l.seite, a: mitte - fb / 2, b: mitte + fb / 2, unten: Math.max(88, oben - 130), oben: oben, sichtbar: true };
    }
    var vorn = h.luecken.filter(function (l) { return l.seite === 'maxY' && l.b - l.a >= 160; })
      .sort(function (p, q) { return (q.b - q.a) - (p.b - p.a); })[0];
    if (!vorn) return null;
    var fb2 = Math.min(220, vorn.b - vorn.a - 60), m2 = vorn.a + (vorn.b - vorn.a) * (links ? 0.4 : 0.6);
    m2 = Math.max(vorn.a + fb2 / 2 + 25, Math.min(vorn.b - fb2 / 2 - 25, m2));
    return { seite: 'maxY', a: m2 - fb2 / 2, b: m2 + fb2 / 2, unten: 60, oben: Math.min(RH - 25, 230), sichtbar: false };
  }
  /* Mitte des Lichtfensters in Weltkoordinaten und seine Innennormale (waagrecht, in den Raum). */
  /* Helligkeit und Farbe der Aussicht hinter Fenstern (Look): am Abend (Kontrast) blaue Stunde statt Mittagslicht. */
  function aussenFarbe(basis) {
    var li = (lookJetzt && lookJetzt.licht) || {}, c = new T.Color(li.aussenFarbe || '#FFFFFF');
    return c.multiplyScalar(basis * (li.aussen || 1));
  }
  function lichtFensterLage(f, h) {
    var m = (f.a + f.b) / 2, y = (f.unten + f.oben) / 2;
    if (f.seite === 'minX') return { p: new T.Vector3(h.minX, y, m), n: new T.Vector3(1, 0, 0) };
    if (f.seite === 'maxX') return { p: new T.Vector3(h.maxX, y, m), n: new T.Vector3(-1, 0, 0) };
    return { p: new T.Vector3(m, y, h.maxY), n: new T.Vector3(0, 0, -1) };
  }
  /* Das sichtbare Lichtfenster in der Seitenwand — gebaut wie die Fenster des Kunden: Aussicht, Scheibe, Blendrahmen mit
     Mittelpfosten, Fensterbank. Rahmen und Pfosten werfen Schatten: sie zeichnen die Sprossen in den Sonnenfleck. */
  /* Wirft Schatten nur fuer die Fenstersonne: Rahmen und Blende gehoeren zum Sonnenfleck, nicht zum Hauptlicht (sonst
     legte das Hauptlicht den Fensterrahmen als dunkle Figur auf den Hochschrank daneben — gesehen 2026-09-29). */
  function nurFuerSonne(r, o, c, schattenKamera) {
    if (!fensterSonne || schattenKamera !== fensterSonne.shadow.camera) o.modelViewMatrix.makeScale(0, 0, 0);
  }
  /* Das sichtbare Lichtfenster (Rahmen, Glas, Bank, Aussicht). Steht die Kamera AUSSERHALB des Raums auf seiner Seite —
     die Wandansicht mit langer Brennweite tut das in kleinen Raeumen —, blendet malen() es aus: die Wand dort ist von aussen
     unsichtbar, Rahmen und Bank waren es nicht und standen als weisse Saeule vor der Kueche (Betreiber 2026-09-29). */
  var fensterGruppe = null, aussenGruppe = null, fensterEcht = false, aussichtJetzt = null;
  function kameraAussen(seite) {
    var h = huelleJetzt, c = cam && cam.position;
    if (!h || !c || !seite) return false;
    return seite === 'minX' ? c.x < h.minX - 1 : seite === 'maxX' ? c.x > h.maxX + 1 : seite === 'minY' ? c.z < h.minY - 1 : c.z > h.maxY + 1;
  }
  function raumFensterBauen(f, h, li, wandFarbe) {
    var b = f.b - f.a, fh = f.oben - f.unten, rt = 6, gr = new T.Group();
    var lage = lichtFensterLage(f, h);
    gr.position.set(lage.p.x, 0, lage.p.z);
    gr.rotation.y = f.seite === 'minX' ? Math.PI / 2 : -Math.PI / 2;
    var teil = function (me) { me.userData.durchlaessig = true; me.onBeforeShadow = nurFuerSonne; gr.add(me); return me; };
    var fotoT = aussichtFuer(b, fh);
    var aussen = teil(new T.Mesh(new T.PlaneGeometry(b, fh),
      new T.MeshBasicMaterial({ map: fotoT || himmelBild(), color: aussenFarbe(fotoT ? 1.9 : 2.4) })));
    aussen.position.set(0, f.unten + fh / 2, 0.4);
    aussen.userData.ohneSchatten = true;
    var glasM = new T.MeshStandardMaterial({ color: '#CFE0E6', roughness: 0.1, metalness: 0.1, transparent: true, opacity: 0.35 });
    var scheibe = teil(new T.Mesh(new T.PlaneGeometry(b, fh), glasM));
    scheibe.position.set(0, f.unten + fh / 2, 1.0);
    var rahmenM = new T.MeshStandardMaterial({ color: '#F4F2EE', roughness: 0.55, metalness: 0 });
    [[b, rt, 0, f.oben - rt / 2], [b, rt, 0, f.unten + rt / 2], [rt, fh - 2 * rt, -b / 2 + rt / 2, f.unten + fh / 2],
     [rt, fh - 2 * rt, b / 2 - rt / 2, f.unten + fh / 2], [3, fh - 2 * rt, 0, f.unten + fh / 2]].forEach(function (r) {
      var me = teil(new T.Mesh(new T.BoxGeometry(r[0], r[1], 5), rahmenM));
      me.position.set(r[2], r[3], 2.5);
    });
    var bank = teil(new T.Mesh(new T.BoxGeometry(b + 8, 3, 16), new T.MeshStandardMaterial({ color: wandFarbe || '#EDE9E3', roughness: 0.5 })));
    bank.position.set(0, f.unten - 1.5, 8);
    return gr;
  }
  /* ---------- ARCHITECTURAL SHELL, PHASE 1 (2026-10-01) ----------
     Everything below builds the room AROUND the kitchen. Its inputs are the hull (form + measured walls), the room height and
     the daylight window chosen by lichtFensterWaehlen — never series, colour, worktop or gloss (see ARCHITEKTUR). */

  /* A pose for a part: position + rotation (radians, XYZ order). */
  function lageM(x, y, z, rx, ry, rz) {
    return new T.Matrix4().compose(new T.Vector3(x, y, z), new T.Quaternion().setFromEuler(new T.Euler(rx || 0, ry || 0, rz || 0)),
      new T.Vector3(1, 1, 1));
  }
  /* Several parts as ONE indexed geometry (one draw call for a window frame or a row of trees instead of dozens). A part:
     { g: geometry, m: pose, uv: [u0, v0, du, dv] (window of an atlas), farbe: [r, g, b] (all vertices), flaechen: six colours
     (box faces +x, -x, +y, -y, +z, -z), nachNormal: function (nx, ny, nz) -> colour }. The parts are disposed. */
  function netzVereinen(teile) {
    var pos = [], nor = [], uv = [], col = [], idx = [], basis = 0;
    var mitFarbe = teile.some(function (t) { return !!(t.farbe || t.flaechen || t.nachNormal); });
    teile.forEach(function (t) {
      var k = t.g.clone();
      if (t.m) k.applyMatrix4(t.m);
      var p = k.attributes.position, n = k.attributes.normal, u = k.attributes.uv;
      for (var i = 0; i < p.count; i++) {
        pos.push(p.getX(i), p.getY(i), p.getZ(i));
        var nx = n ? n.getX(i) : 0, ny = n ? n.getY(i) : 1, nz = n ? n.getZ(i) : 0;
        nor.push(nx, ny, nz);
        var u0 = u ? u.getX(i) : 0, v0 = u ? u.getY(i) : 0;
        uv.push(t.uv ? t.uv[0] + u0 * t.uv[2] : u0, t.uv ? t.uv[1] + v0 * t.uv[3] : v0);
        if (mitFarbe) {
          var c = t.nachNormal ? t.nachNormal(nx, ny, nz) : (t.flaechen ? t.flaechen[Math.min(5, Math.floor(i / 4))] : (t.farbe || [1, 1, 1]));
          col.push(c[0], c[1], c[2]);
        }
      }
      if (k.index) for (var j = 0; j < k.index.count; j++) idx.push(k.index.getX(j) + basis);
      else for (var j2 = 0; j2 < p.count; j2++) idx.push(j2 + basis);
      basis += p.count;
      k.dispose(); t.g.dispose();
    });
    var out = new T.BufferGeometry();
    out.setAttribute('position', new T.Float32BufferAttribute(pos, 3));
    out.setAttribute('normal', new T.Float32BufferAttribute(nor, 3));
    out.setAttribute('uv', new T.Float32BufferAttribute(uv, 2));
    if (mitFarbe) out.setAttribute('color', new T.Float32BufferAttribute(col, 3));
    out.setIndex(idx);
    return out;
  }
  /* sRGB hex -> linear [r, g, b] times k (vertex colours are linear). */
  function linFarbe(hex, k) {
    var c = new T.Color(hex);
    return [c.r * (k == null ? 1 : k), c.g * (k == null ? 1 : k), c.b * (k == null ? 1 : k)];
  }

  /* WALL SURFACE WITH OPENINGS: a wall plane of `breite` x `hoehe` (x from -breite/2 to +breite/2, y from 0) minus
     rectangular openings, as ONE geometry whose UVs stay those of the whole plane — shading and plaster continue around every
     opening exactly as on the closed wall, and one draw call carries the whole wall. loecher: [{ x0, x1, y0, y1 }]. */
  function wandFlaecheMitLoechern(breite, hoehe, loecher) {
    var x0 = -breite / 2, x1 = breite / 2, kl = function (v, a, b) { return Math.max(a, Math.min(b, v)); };
    var L = loecher.map(function (l) { return { x0: kl(l.x0, x0, x1), x1: kl(l.x1, x0, x1), y0: kl(l.y0, 0, hoehe), y1: kl(l.y1, 0, hoehe) }; })
      .filter(function (l) { return l.x1 - l.x0 > 0.1 && l.y1 - l.y0 > 0.1; });
    var reihe = function (werte) { return werte.sort(function (p, q) { return p - q; }).filter(function (v, i, a) { return i === 0 || v - a[i - 1] > 0.05; }); };
    var xs = [x0, x1]; L.forEach(function (l) { xs.push(l.x0, l.x1); }); xs = reihe(xs);
    var teile = [];
    for (var k = 0; k + 1 < xs.length; k++) {
      var xa = xs[k], xb = xs[k + 1], xm = (xa + xb) / 2;
      var hier = L.filter(function (l) { return l.x0 < xm && l.x1 > xm; });
      var ys = [0, hoehe]; hier.forEach(function (l) { ys.push(l.y0, l.y1); }); ys = reihe(ys);
      for (var j = 0; j + 1 < ys.length; j++) {
        var ya = ys[j], yb = ys[j + 1], ym = (ya + yb) / 2;
        if (hier.some(function (l) { return l.y0 < ym && l.y1 > ym; })) continue;
        teile.push({ g: new T.PlaneGeometry(xb - xa, yb - ya), m: lageM(xm, ym, 0), uv: [(xa - x0) / breite, ya / hoehe, (xb - xa) / breite, (yb - ya) / hoehe] });
      }
    }
    return netzVereinen(teile);
  }
  /* A flat decal on a wall (contact-shadow seam, LED glow) must not hang in front of an opening — GTAO would also read it as a
     wall there (a hard dark band, measured). Its quads (grid of 2 x 2 or 4 x 4 vertices, UVs linear inside each quad) are
     rebuilt without the openings; everywhere else the decal stays exactly where and how it was. loecher in the parent frame. */
  function decalOhneLoecher(me, loecher) {
    var g = me.geometry, p = g && g.attributes.position, uv = g && g.attributes.uv;
    if (!p || !uv || (p.count !== 4 && p.count !== 16) || me.rotation.x || me.rotation.y || me.rotation.z) return false;
    var n = p.count === 16 ? 4 : 2, ox = me.position.x, oy = me.position.y;
    var L = loecher.map(function (l) { return { x0: l.x0 - ox, x1: l.x1 - ox, y0: l.y0 - oy, y1: l.y1 - oy }; });
    var bb = new T.Box3().setFromBufferAttribute(p);
    if (!L.some(function (l) { return l.x0 < bb.max.x && l.x1 > bb.min.x && l.y0 < bb.max.y && l.y1 > bb.min.y; })) return false;
    var z0 = p.getZ(0), pos = [], tex = [], nor = [], idx = [], k = 0;
    var V = function (i, j) { var q = j * n + i; return { x: p.getX(q), y: p.getY(q), u: uv.getX(q), v: uv.getY(q) }; };
    for (var j = 0; j + 1 < n; j++) for (var i = 0; i + 1 < n; i++) {
      var a = V(i, j), b = V(i + 1, j), c = V(i, j + 1);
      var xa = Math.min(a.x, b.x), xb = Math.max(a.x, b.x), ya = Math.min(a.y, c.y), yb = Math.max(a.y, c.y);
      if (xb - xa < 1e-4 || yb - ya < 1e-4) continue;
      var uAt = (function (a, b) { return function (x) { return a.u + (b.u - a.u) * (x - a.x) / (b.x - a.x); }; })(a, b);
      var vAt = (function (a, c) { return function (y) { return a.v + (c.v - a.v) * (y - a.y) / (c.y - a.y); }; })(a, c);
      var rects = [[xa, xb, ya, yb]];
      L.forEach(function (l) {
        var neu = [];
        rects.forEach(function (r) {
          if (l.x1 <= r[0] || l.x0 >= r[1] || l.y1 <= r[2] || l.y0 >= r[3]) { neu.push(r); return; }
          if (l.x0 > r[0]) neu.push([r[0], l.x0, r[2], r[3]]);
          if (l.x1 < r[1]) neu.push([l.x1, r[1], r[2], r[3]]);
          var cx0 = Math.max(r[0], l.x0), cx1 = Math.min(r[1], l.x1);
          if (l.y0 > r[2]) neu.push([cx0, cx1, r[2], l.y0]);
          if (l.y1 < r[3]) neu.push([cx0, cx1, l.y1, r[3]]);
        });
        rects = neu;
      });
      rects.forEach(function (r) {
        [[r[0], r[2]], [r[1], r[2]], [r[1], r[3]], [r[0], r[3]]].forEach(function (q) { pos.push(q[0], q[1], z0); tex.push(uAt(q[0]), vAt(q[1])); nor.push(0, 0, 1); });
        idx.push(k, k + 1, k + 2, k, k + 2, k + 3); k += 4;
      });
    }
    var neu = new T.BufferGeometry();
    neu.setAttribute('position', new T.Float32BufferAttribute(pos, 3));
    neu.setAttribute('uv', new T.Float32BufferAttribute(tex, 2));
    neu.setAttribute('normal', new T.Float32BufferAttribute(nor, 3));
    neu.setIndex(idx);
    /* Contact geometries are freed by kontaktAufraeumen at the next rebuild (as before); the glow's plane is the kitchen's own. */
    if (me.userData.kontaktSchrank) kontaktGeos.push(neu); else g.dispose();
    me.geometry = neu;
    return true;
  }
  /* The wide floor and ceiling of the front views (weitGruppe) stop at every wall with a window: seen through the window they
     would cover the view out (a ceiling 2.5 m high just behind the glass). Rectangle around the room centre (cx, cz), W wide. */
  function weitRechteck(h, oeff, cx, cz, W) {
    var x0 = cx - W / 2, x1 = cx + W / 2, z0 = cz - W / 2, z1 = cz + W / 2;
    if (h && oeff) {
      if (oeff.minX.length) x0 = h.minX; if (oeff.maxX.length) x1 = h.maxX;
      if (oeff.minY.length) z0 = h.minY; if (oeff.maxY.length) z1 = h.maxY;
    }
    return { b: x1 - x0, t: z1 - z0, x: (x0 + x1) / 2, z: (z0 + z1) / 2 };
  }
  /* Every phase-1 opening per side of the hull, in world coordinates along that side (a..b) with its height: the daylight window
     and every customer window on a customer wall (customer data unchanged: wall, position x, width, sill height). */
  function oeffnungenP1(raum, h, z, RH, lf) {
    var aus = { minX: [], maxX: [], minY: [], maxY: [], kunde: [] };
    if (lf) aus[lf.seite].push({ a: lf.a, b: lf.b, unten: lf.unten, oben: lf.oben, licht: true });
    K.aktiveMerkmale(z).forEach(function (m) {
      if (m.typ !== 'fenster' || !(m.breite > 0)) return;
      var w = (raum.waende || []).filter(function (x) { return x.id === m.wand; })[0];
      if (!w) return;
      var f = K.fensterOeffnung(m, RH), p0 = K.weltPunkt3D(w, m.x, 0, 0), p1 = K.weltPunkt3D(w, m.x + m.breite, 0, 0), seite = null;
      if (Math.abs(w.p0.y - w.p1.y) <= 0.5) seite = Math.abs(w.p0.y - h.minY) < 1 ? 'minY' : (Math.abs(w.p0.y - h.maxY) < 1 ? 'maxY' : null);
      else seite = Math.abs(w.p0.x - h.minX) < 1 ? 'minX' : (Math.abs(w.p0.x - h.maxX) < 1 ? 'maxX' : null);
      if (!seite) return;
      var quer = seite === 'minY' || seite === 'maxY';
      var o = { a: quer ? Math.min(p0.x, p1.x) : Math.min(p0.z, p1.z), b: quer ? Math.max(p0.x, p1.x) : Math.max(p0.z, p1.z), unten: f.unten, oben: f.oben,
        seite: seite, m: m };
      aus[seite].push(o); aus.kunde.push(o);
    });
    return aus;
  }

  /* SHADOW GAP (Schattenfuge): the ceiling board stops F cm short of every wall and the slot above it runs F cm up into the
     slab — how drywall ceilings are finished in current residential work. The visible ceiling stays at the measured room
     height; the walls reach up into the slot. The slot has no light of its own, so it reads as the fine dark line it is in a
     real room. Slot ceiling and the four board edges are one mesh. */
  function deckenFuge(h, RH, F) {
    var HB = h.maxX - h.minX, HT = h.maxY - h.minY, cx = (h.minX + h.maxX) / 2, cz = (h.minY + h.maxY) / 2;
    var x0 = h.minX + F, x1 = h.maxX - F, z0 = h.minY + F, z1 = h.maxY - F;
    var geo = netzVereinen([
      { g: new T.PlaneGeometry(HB + 4, HT + 4), m: lageM(cx, RH + F, cz, Math.PI / 2, 0, 0) },
      { g: new T.PlaneGeometry(x1 - x0, F), m: lageM(cx, RH + F / 2, z0, 0, Math.PI, 0) },
      { g: new T.PlaneGeometry(x1 - x0, F), m: lageM(cx, RH + F / 2, z1, 0, 0, 0) },
      { g: new T.PlaneGeometry(z1 - z0, F), m: lageM(x0, RH + F / 2, cz, 0, -Math.PI / 2, 0) },
      { g: new T.PlaneGeometry(z1 - z0, F), m: lageM(x1, RH + F / 2, cz, 0, Math.PI / 2, 0) }
    ]);
    /* Painted like the ceiling, but inside a slot of a few centimetres hardly any light arrives: its value is that of the
       shadow (GTAO, radius 55 cm, cannot see a 2.5 cm slot). */
    return new T.Mesh(geo, new T.MeshStandardMaterial({ color: '#8E8A84', roughness: 0.95, metalness: 0.02, envMapIntensity: 0.15 }));
  }
  /* The same ceiling image on a smaller board: crop it symmetrically so every point keeps its value (the cove glow and the
     ceiling shading stay exactly where they were; only the outermost centimetres now lie in the slot). */
  function deckeAusschnitt(t, B, Tf, b, tf) {
    if (!t) return t;
    var k = t.clone();
    k.repeat.set(b / B, tf / Tf);
    k.offset.set((1 - k.repeat.x) / 2, (1 - k.repeat.y) / 2);
    return k;
  }

  /* THE FLOOR, LAID PIECE BY PIECE. One scan of the library (colour, relief, roughness) is cut into planks or tiles in the
     shader: every piece reads its own random window of the scan (and half of them turned by 180 degrees), its own small tone
     shift, and the joints between them are drawn at their real width (fading to their average darkening where a joint is
     thinner than a pixel). No repeat can show, and nothing new is downloaded — the scans are already in the theme. Rows run
     along the longer side of the room, starting at its corner, so the same room is always laid the same way.
     eiche: restrained natural oak, planks 20 x 180 cm with free end joints, fine V-joint, oiled matt (roughness 0.52-0.74).
     stein: large-format porcelain in a limestone look, 120 x 60 cm in third bond, 3 mm grout, honed (0.44-0.56). */
  var BODEN_P1 = {
    eiche: { bib: 'acg-wood095', L: 180, B: 20, drittel: false, fuge: 0.14, fugeHell: 0.5, kachel: 90, farbe: '#B39C82',
      streuung: 0.12, kontrast: 0.8, rauh: [0.52, 0.74], env: 0.45, relief: 0.35 },
    stein: { bib: 'acg-marble018', L: 120, B: 60, drittel: true, fuge: 0.3, fugeHell: 0.8, kachel: 150, farbe: '#C7C1B8',
      streuung: 0.05, kontrast: 0.45, rauh: [0.44, 0.56], env: 0.5, relief: 0.25 }
  };
  var BODEN_NORMAL_ZIEL = 'vec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;';
  var BODEN_GLSL_KOPF = [
    'uniform vec2 hmBodenUrsprung;', 'uniform float hmBodenQuer;', 'uniform vec4 hmBodenMass;', 'uniform vec4 hmBodenWerte;',
    'uniform vec3 hmBodenMittel;', 'uniform vec2 hmBodenRauh;', 'varying vec2 vHmBoden;',
    'float hmHash( vec2 p ) { return fract( sin( dot( p, vec2( 127.1, 311.7 ) ) ) * 43758.5453 ); }', ''
  ].join('\n');
  /* hmBodenMass: element length, element width, joint width, size of the scan (cm). hmBodenWerte: third bond (1) or free end
     joints (0), tone spread, contrast towards the mean colour, darkness of the joint. */
  var BODEN_GLSL_FARBE = [
    'vec2 hmW = vHmBoden - hmBodenUrsprung;',
    'vec2 hmQ = hmBodenQuer > 0.5 ? hmW.yx : hmW;',
    'vec2 hmGx = dFdx( hmQ ), hmGy = dFdy( hmQ );',
    'float hmL = hmBodenMass.x, hmB = hmBodenMass.y;',
    'float hmReihe = floor( hmQ.y / hmB );',
    'float hmSchub = hmBodenWerte.x > 0.5 ? mod( hmReihe, 3.0 ) * hmL / 3.0 : hmHash( vec2( hmReihe, 7.13 ) ) * hmL;',
    'float hmXs = hmQ.x + hmSchub;',
    'float hmStueck = floor( hmXs / hmL );',
    'vec2 hmLok = vec2( hmXs - hmStueck * hmL, hmQ.y - hmReihe * hmB );',
    'float hmD = min( min( hmLok.x, hmL - hmLok.x ), min( hmLok.y, hmB - hmLok.y ) );',
    'float hmH1 = hmHash( vec2( hmReihe + 0.37, hmStueck - 0.61 ) ), hmH2 = hmHash( vec2( hmStueck * 1.7 + 3.1, hmReihe * 0.9 - 5.3 ) );',
    'float hmDreh = step( 0.5, hmH2 );',
    'vec2 hmT = mix( hmLok, vec2( hmL, hmB ) - hmLok, hmDreh );',
    'vec2 hmUv = ( hmT + vec2( hmH1, fract( hmH2 * 7.3 ) ) * hmBodenMass.w ) / hmBodenMass.w;',
    'float hmS = hmDreh > 0.5 ? -1.0 : 1.0;',
    'vec2 hmDx = hmGx * hmS / hmBodenMass.w, hmDy = hmGy * hmS / hmBodenMass.w;',
    'float hmFw = max( 0.5 * ( length( hmGx ) + length( hmGy ) ), 1e-4 );',
    'float hmFuge = hmBodenMass.z >= hmFw',
    '  ? 1.0 - smoothstep( 0.5 * hmBodenMass.z - 0.5 * hmFw, 0.5 * hmBodenMass.z + 0.5 * hmFw, hmD )',
    '  : ( hmBodenMass.z / hmFw ) * ( 1.0 - smoothstep( 0.0, hmFw, hmD ) );',
    '#ifdef USE_MAP',
    '\tvec4 sampledDiffuseColor = textureGrad( map, hmUv, hmDx, hmDy );',
    '\tdiffuseColor *= sampledDiffuseColor;',
    '#endif',
    'diffuseColor.rgb = mix( hmBodenMittel, diffuseColor.rgb, hmBodenWerte.z ) * ( 1.0 + ( hmH1 - 0.5 ) * hmBodenWerte.y );',
    'diffuseColor.rgb *= mix( 1.0, hmBodenWerte.w, hmFuge );'
  ].join('\n');
  var BODEN_GLSL_RAUH = [
    'float roughnessFactor = roughness;',
    '#ifdef USE_ROUGHNESSMAP',
    '\tvec4 texelRoughness = textureGrad( roughnessMap, hmUv, hmDx, hmDy );',
    '\troughnessFactor = mix( hmBodenRauh.x, hmBodenRauh.y, texelRoughness.g );',
    '#endif',
    'roughnessFactor = mix( roughnessFactor, 0.92, hmFuge );'
  ].join('\n');
  /* The tangent frame of the plane runs along +x (u) and -z (v); the pieces run along x or z, half of them turned. */
  var BODEN_GLSL_NORMAL = [
    'vec3 mapN = textureGrad( normalMap, hmUv, hmDx, hmDy ).xyz * 2.0 - 1.0;',
    '\tmapN.xy *= hmS;',
    '\tmapN = hmBodenQuer > 0.5 ? vec3( mapN.y, - mapN.x, mapN.z ) : vec3( mapN.x, - mapN.y, mapN.z );'
  ].join('\n');
  function bodenShader(sh, U) {
    Object.keys(U).forEach(function (k) { sh.uniforms[k] = U[k]; });
    sh.vertexShader = 'varying vec2 vHmBoden;\n' + sh.vertexShader.replace('#include <worldpos_vertex>',
      '#include <worldpos_vertex>\n\tvHmBoden = ( modelMatrix * vec4( transformed, 1.0 ) ).xz;');
    sh.fragmentShader = BODEN_GLSL_KOPF + sh.fragmentShader
      .replace('#include <map_fragment>', BODEN_GLSL_FARBE)
      .replace('#include <roughnessmap_fragment>', BODEN_GLSL_RAUH)
      .replace('#include <normal_fragment_maps>', T.ShaderChunk.normal_fragment_maps.replace(BODEN_NORMAL_ZIEL, BODEN_GLSL_NORMAL));
  }
  var bodenShaderOk = null;
  function bodenP1(art, h) {
    var p = BODEN_P1[art] || BODEN_P1.stein;
    var m = new T.MeshStandardMaterial({ color: p.farbe, roughness: (p.rauh[0] + p.rauh[1]) / 2, metalness: 0, envMapIntensity: p.env });
    m.userData.bodenP1 = art;
    if (bodenShaderOk === null) {
      var ch = T.ShaderChunk || {};
      bodenShaderOk = !!(rd && rd.capabilities && rd.capabilities.isWebGL2 && typeof ch.normal_fragment_maps === 'string'
        && ch.normal_fragment_maps.indexOf(BODEN_NORMAL_ZIEL) >= 0 && typeof ch.meshphysical_frag === 'string'
        && ch.meshphysical_frag.indexOf('#include <map_fragment>') >= 0 && ch.meshphysical_frag.indexOf('#include <roughnessmap_fragment>') >= 0);
    }
    var c = bibKarte(p.bib, 'c'), n = bibKarte(p.bib, 'n'), r = bibKarte(p.bib, 'r');
    /* Until the scans are loaded (or without WebGL 2): the floor in its mean colour — a rebuild follows the load. */
    if (!bodenShaderOk || !c || !n || !r) return m;
    m.map = c; m.normalMap = n; m.roughnessMap = r; m.normalScale = new T.Vector2(p.relief, p.relief);
    m.color.copy(bibTonung(p.bib, p.farbe)); m.roughness = 1;
    var mittel = new T.Color(p.farbe);
    var U = {
      hmBodenUrsprung: { value: new T.Vector2(h.minX, h.minY) },
      hmBodenQuer: { value: (h.maxY - h.minY) > (h.maxX - h.minX) ? 1 : 0 },
      hmBodenMass: { value: new T.Vector4(p.L, p.B, p.fuge, p.kachel) },
      hmBodenWerte: { value: new T.Vector4(p.drittel ? 1 : 0, p.streuung, p.kontrast, p.fugeHell) },
      hmBodenMittel: { value: new T.Vector3(mittel.r, mittel.g, mittel.b) },
      hmBodenRauh: { value: new T.Vector2(p.rauh[0], p.rauh[1]) }
    };
    boxSpiegelMat(m);
    var box = m.onBeforeCompile;
    m.onBeforeCompile = function (sh, r2) { if (box) box.call(this, sh, r2); bodenShader(sh, U); };
    m.customProgramCacheKey = function () { return 'hmBox1|hmBoden1'; };
    m.__hmBox = true;
    return m;
  }

  /* THE WINDOW AS AN OPENING (phase 1). A wall of `wand` cm; the frame sits `laibung` cm deep, so the room sees a plastered
     reveal on three sides and an interior sill (light stone, 2.2 cm, 3 cm proud of the wall, 3 cm ears left and right).
     Outer frame, casements, glazing spacer and handles are ONE mesh (vertex colours). Double glazing as two panes 2.4 cm apart:
     the inner pane carries the reflection of the room (additive, the Fresnel of the real BRDF — no transmission pass), the
     outer pane a faint grey-green tint. Local frame: x along the wall (centre of the opening = 0), y = height above the floor,
     z into the room (wall surface = 0). The outer size is the opening the customer (or the daylight rule) gave — never more.
     CASEMENTS BY WIDTH (clear opening b): b < 90 cm one casement (handle on its side), 90 <= b < 240 two casements meeting in
     the middle (handle on the left one), b >= 240 three (the middle one fixed, handles on the outer two); below 45 cm width or
     height a fixed light without casement — profiles of 5.5 cm would leave no glass. */
  var FENSTER_P1 = { wand: 30, laibung: 16, blend: 4.5, blendTiefe: 7, fluegel: 5.5, fluegelUnten: 7, fluegelTiefe: 6.5,
    glas: 2.4, bank: 2.2, bankVor: 3, ohr: 3, einFluegel: 90, dreiFluegel: 240, festUnter: 45 };
  var RAHMEN_P1 = { warmweiss: { farbe: '#ECEAE5', rauh: 0.42, metall: 0 }, alu: { farbe: '#C6C7C5', rauh: 0.42, metall: 0.35 } };
  var SEITE_DREHUNG = { minX: Math.PI / 2, maxX: -Math.PI / 2, maxY: Math.PI, minY: 0 };
  function fensterFluegel(b, fh) {
    var P = FENSTER_P1;
    if (b < P.festUnter || fh < P.festUnter) return 0;
    return b < P.einFluegel ? 1 : (b < P.dreiFluegel ? 2 : 3);
  }
  function fensterKoerper(b, unten, oben, wandFarbe) {
    var P = FENSTER_P1, fh = oben - unten, D = P.laibung, yM = (unten + oben) / 2, gr = new T.Group();
    gr.userData.fensterP1 = true;
    var teil = function (me) { me.userData.durchlaessig = true; me.onBeforeShadow = nurFuerSonne; gr.add(me); return me; };
    /* Reveal: inside (0 .. -D) and the short outer reveal beyond the frame, smooth plaster in the wall colour. */
    var lb = [];
    [[0, -D], [-D - P.blendTiefe, -P.wand]].forEach(function (zz) {
      var d = zz[0] - zz[1], zm = (zz[0] + zz[1]) / 2;
      lb.push({ g: new T.PlaneGeometry(d, fh), m: lageM(-b / 2, yM, zm, 0, Math.PI / 2, 0) });
      lb.push({ g: new T.PlaneGeometry(d, fh), m: lageM(b / 2, yM, zm, 0, -Math.PI / 2, 0) });
      lb.push({ g: new T.PlaneGeometry(b, d), m: lageM(0, oben, zm, Math.PI / 2, 0, 0) });
    });
    teil(new T.Mesh(netzVereinen(lb), new T.MeshStandardMaterial({ color: wandFarbe, roughness: 0.92, metalness: 0.02, envMapIntensity: 0.35 })));
    /* Interior sill: a honed light stone, its top in the plane of the opening's lower edge. */
    var bank = teil(new T.Mesh(new T.BoxGeometry(b + 2 * P.ohr, P.bank, D + P.bankVor),
      new T.MeshStandardMaterial({ color: '#E2DDD5', roughness: 0.5, metalness: 0, envMapIntensity: 0.45 })));
    bank.position.set(0, unten - P.bank / 2, (P.bankVor - D) / 2);
    /* Frame, casements, spacer, handles, outer sill — one mesh. */
    var r = RAHMEN_P1[ARCHITEKTUR.rahmen] || RAHMEN_P1.warmweiss, weiss = [1, 1, 1], teile = [];
    var kasten = function (bx, by, bz, x, y, z, farbe) { if (bx > 0.05 && by > 0.05) teile.push({ g: new T.BoxGeometry(bx, by, bz), m: lageM(x, y, z), farbe: farbe || weiss }); };
    var zb = -D - P.blendTiefe / 2, bi = b - 2 * P.blend, hi = fh - 2 * P.blend, yu = unten + P.blend, yo = oben - P.blend;
    kasten(b, P.blend, P.blendTiefe, 0, oben - P.blend / 2, zb);
    kasten(b, P.blend, P.blendTiefe, 0, unten + P.blend / 2, zb);
    kasten(P.blend, hi, P.blendTiefe, -b / 2 + P.blend / 2, yM, zb);
    kasten(P.blend, hi, P.blendTiefe, b / 2 - P.blend / 2, yM, zb);
    var zs = -D - P.fluegelTiefe / 2 + 1, fl = P.fluegel, glasPos = [], dunkel = linFarbe('#4E5355', 1), silber = linFarbe('#C8C9CA', 1);
    var n = fensterFluegel(b, fh), ab = 1.1;
    var abstand = function (gx0, gx1, gy0, gy1, zg) {   /* the spacer between the panes */
      kasten(gx1 - gx0, ab, P.glas, (gx0 + gx1) / 2, gy1 - ab / 2, zg, dunkel);
      kasten(gx1 - gx0, ab, P.glas, (gx0 + gx1) / 2, gy0 + ab / 2, zg, dunkel);
      kasten(ab, gy1 - gy0 - 2 * ab, P.glas, gx0 + ab / 2, (gy0 + gy1) / 2, zg, dunkel);
      kasten(ab, gy1 - gy0 - 2 * ab, P.glas, gx1 - ab / 2, (gy0 + gy1) / 2, zg, dunkel);
    };
    if (n === 0) {
      /* fixed light: the glazing sits directly in the outer frame */
      glasPos.push([-bi / 2, bi / 2, yu, yo, zb + 1.2]);
      abstand(-bi / 2, bi / 2, yu, yo, zb - P.glas / 2 + 1.2);
    }
    var felder = n === 1 ? [[-bi / 2, bi / 2, 'rechts']] : n === 2 ? [[-bi / 2, 0, 'rechts'], [0, bi / 2, null]]
      : n === 3 ? [[-bi / 2, -bi / 6, 'rechts'], [-bi / 6, bi / 6, null], [bi / 6, bi / 2, 'links']] : [];
    var yh = yu + hi * 0.46, zv = zs + P.fluegelTiefe / 2;
    felder.forEach(function (fd) {
      var xa = fd[0], xe = fd[1], xm = (xa + xe) / 2, sb = xe - xa;
      kasten(sb, fl, P.fluegelTiefe, xm, yo - fl / 2, zs);
      kasten(sb, P.fluegelUnten, P.fluegelTiefe, xm, yu + P.fluegelUnten / 2, zs);
      kasten(fl, hi - fl - P.fluegelUnten, P.fluegelTiefe, xa + fl / 2, (yu + P.fluegelUnten + yo - fl) / 2, zs);
      kasten(fl, hi - fl - P.fluegelUnten, P.fluegelTiefe, xe - fl / 2, (yu + P.fluegelUnten + yo - fl) / 2, zs);
      /* glass of this casement, and its spacer (the dark band every insulated glazing shows at its edge) */
      var gx0 = xa + fl, gx1 = xe - fl, gy0 = yu + P.fluegelUnten, gy1 = yo - fl;
      glasPos.push([gx0, gx1, gy0, gy1, zs - 1.2]);
      abstand(gx0, gx1, gy0, gy1, zs - 1.2 - P.glas / 2);
      /* handle on the opening side, lever pointing down (closed) */
      if (fd[2]) {
        var xg = fd[2] === 'rechts' ? xe - fl / 2 : xa + fl / 2;
        kasten(2.8, 7.5, 1.2, xg, yh, zv + 0.6, silber);
        kasten(1.7, 11, 1.7, xg, yh - 5, zv + 2.1, silber);
      }
    });
    /* outer sill (aluminium), seen through the glass when looking down */
    kasten(b + 6, 1.2, P.wand - D - P.blendTiefe + 4, 0, unten - 1.2, -(D + P.blendTiefe + P.wand + 4) / 2, linFarbe('#A9AAA8', 1));
    var rahmenM = new T.MeshStandardMaterial({ color: r.farbe, roughness: r.rauh, metalness: r.metall, envMapIntensity: 0.6, vertexColors: true });
    teil(new T.Mesh(netzVereinen(teile), rahmenM));
    /* Glass: inner pane = reflection of the room (adds light only), outer pane = tint (takes a little). */
    var spiegelG = [], tonG = [];
    glasPos.forEach(function (q) {
      var w = q[1] - q[0], hg = q[3] - q[2], x = (q[0] + q[1]) / 2, y = (q[2] + q[3]) / 2, zg = q[4];
      if (w < 1 || hg < 1) return;
      spiegelG.push({ g: new T.PlaneGeometry(w, hg), m: lageM(x, y, zg) });
      tonG.push({ g: new T.PlaneGeometry(w, hg), m: lageM(x, y, zg - P.glas) });
    });
    if (spiegelG.length) {
      var spiegelM = new T.MeshStandardMaterial({ color: '#000000', roughness: 0.04, metalness: 0, envMapIntensity: 0.7,
        transparent: true, blending: T.AdditiveBlending, depthWrite: false });
      var tonM = new T.MeshBasicMaterial({ color: '#2F3A37', transparent: true, opacity: 0.12, depthWrite: false });
      var sp = teil(new T.Mesh(netzVereinen(spiegelG), spiegelM)), tn = teil(new T.Mesh(netzVereinen(tonG), tonM));
      sp.userData.ohneSchatten = true; tn.userData.ohneSchatten = true;
    }
    return gr;
  }
  /* The daylight window in its closing wall (the closing walls stand 1 cm behind the hull edge: the opening starts there). */
  function fensterEchtBauen(f, h, wandFarbe) {
    var gr = fensterKoerper(f.b - f.a, f.unten, f.oben, wandFarbe), lage = lichtFensterLage(f, h);
    gr.position.set(lage.p.x - lage.n.x, 0, lage.p.z - lage.n.z);
    gr.rotation.y = SEITE_DREHUNG[f.seite] || 0;
    return gr;
  }

  /* The sky shown until the photograph of the view out has arrived (phase 1 painted it; the painted garden itself is gone). */
  function zufallP1(saat) { var s = saat; return function () { s = (s * 16807) % 2147483647; return (s - 1) / 2147483646; }; }
  /* Sky: soft daylight, pale blue above, nearly white at the horizon (v 0.16 = eye height), a few flat, faint clouds. */
  function himmelP1() {
    if (raumBilder.himmelP1) return raumBilder.himmelP1;
    var W = 256, H = 256, cv = document.createElement('canvas'); cv.width = W; cv.height = H;
    var c = cv.getContext('2d'), g = c.createLinearGradient(0, 0, 0, H);
    g.addColorStop(0, '#B4CBE4'); g.addColorStop(0.5, '#CCDCEB'); g.addColorStop(0.8, '#E7EDF1'); g.addColorStop(0.845, '#EFF1F1');
    g.addColorStop(1, '#E4E5E0');
    c.fillStyle = g; c.fillRect(0, 0, W, H);
    var zu = zufallP1(17);
    for (var i = 0; i < 46; i++) {
      var x = zu() * W, y = H * (0.2 + zu() * 0.5), rx = 15 + zu() * 40, k = 0.14 + zu() * 0.12;
      c.save(); c.translate(x, y); c.scale(1, 0.22 + zu() * 0.1);
      var rg = c.createRadialGradient(0, 0, 0, 0, 0, rx);
      rg.addColorStop(0, 'rgba(255,255,255,' + k.toFixed(3) + ')'); rg.addColorStop(1, 'rgba(255,255,255,0)');
      c.fillStyle = rg; c.beginPath(); c.arc(0, 0, rx, 0, Math.PI * 2); c.fill(); c.restore();
    }
    var t = leinwandBild(cv, 2);
    t.wrapS = t.wrapT = T.ClampToEdgeWrapping;
    raumBilder.himmelP1 = t;
    return t;
  }
  /* THE VIEW OUT AS A PHOTOGRAPH (phase 1.1): a CC0 photograph (Poly Haven "Residential Garden", Greg Zaal; overcast courtyard
     garden), stored as a band of the panorama around the view direction — longitude ±lonMax, mapped as sin(lonK * lon) (a
     little more resolution straight out, still reaching grazing views), latitude latMin..latMax mapped as sin(lat) (more
     resolution at the horizon). Every surface of the view out reads the photograph by its DIRECTION from the projection centre
     (the window wall's middle at eye height, 140 cm): the photograph's horizon lies at eye level, its perspective is the
     camera's. One far cylinder (weite, 28 m) carries it — a backplate. A real ground plane under the photograph's lawn
     (correct parallax for the near ground) was compared and dropped: in oblique views it shears near planters and pots, and
     every line of sight passes the window near the projection centre anyway. Unlit, `hell` above the room (outside a little
     brighter than inside, highlights kept), no haze (the photograph has its own air). Until the image has arrived: a sky. */
  var FOTO_P1 = { lonMax: 85, lonK: 0.75, latMin: -45, latMax: 45, auge: 140, weite: 2800 };
  /* TWO EXTERIOR PRESETS (phase 1.2/1.3, approved): chosen ONLY by the kitchen form and the measured room — never by series,
     colour, gloss, worktop or cabinet style; the same plan always gives the same view out.
     'vorstadt' = Poly Haven "Suburban Garden" (CC0; retouched: swing frame, slide, trampoline and overhead wires removed) for
     every island kitchen (form 'insel': Insel and Doppelinsel) and every room with a floor area of 18 m2 or more;
     'wohnhof' = Poly Haven "Residential Garden" (CC0) for all other rooms. Floor area = the room hull of the measured walls,
     sides rounded to 0.1 cm, 18.0 m2 itself counts as spacious. */
  var AUSSICHT_P1 = { wohnhof: { datei: 'hm-aussicht-garten.webp', hell: 3.6 }, vorstadt: { datei: 'hm-aussicht-vorstadt.webp', hell: 3.6 } };
  function aussichtRegel(z, h) {
    if (z && z.form === 'insel') return 'vorstadt';
    if (!h) return 'wohnhof';
    var b = Math.round((h.maxX - h.minX) * 10) / 10, t = Math.round((h.maxY - h.minY) * 10) / 10;
    return b * t >= 180000 ? 'vorstadt' : 'wohnhof';
  }
  /* ONE photograph on the GPU — the one the current room uses. A preset change releases the other at once: the previous scene
     was freed before the view out is rebuilt, so nothing references it any more. An image that arrives after its preset was
     left is released on arrival; a room without a view out releases all (fotoBehalten(null)). */
  var fotoLaedt = {}, fotoAktiv = null;
  function fotoBehalten(key) {
    fotoAktiv = key;
    Object.keys(raumBilder).forEach(function (k) {
      if (k.indexOf('fotoP1:') === 0 && k !== key) { raumBilder[k].dispose(); delete raumBilder[k]; delete fotoLaedt[k]; }
    });
  }
  function fotoP1(datei) {
    var key = 'fotoP1:' + datei;
    fotoBehalten(key);
    if (raumBilder[key]) return raumBilder[key];
    if (!fotoLaedt[key] && T && T.TextureLoader) {
      var url = bibUrl(datei);
      if (url) {
        fotoLaedt[key] = true;
        new T.TextureLoader().load(url, function (tx) {
          if (key !== fotoAktiv) { tx.dispose(); delete fotoLaedt[key]; return; }
          if (T.SRGBColorSpace) tx.colorSpace = T.SRGBColorSpace;
          tx.wrapS = tx.wrapT = T.ClampToEdgeWrapping;
          tx.anisotropy = rd && rd.capabilities ? Math.min(8, rd.capabilities.getMaxAnisotropy()) : 1;
          raumBilder[key] = tx;
          dekoNeuBauen();
        }, undefined, function () { fotoLaedt[key] = 'fehlt'; });
      }
    }
    return null;
  }
  function aussenFotoMat(tx, zentrum, gier, hell) {
    var F = FOTO_P1, m = new T.MeshBasicMaterial({ map: tx, side: T.DoubleSide });
    m.color.setScalar(hell).multiply(aussenFarbe(1));
    var G = Math.PI / 180, U = { hmZentrum: { value: zentrum.clone() }, hmGier: { value: gier },
      hmBand: { value: new T.Vector4(F.lonK, Math.sin(F.lonK * F.lonMax * G), Math.sin(F.latMin * G), Math.sin(F.latMax * G)) } };
    m.onBeforeCompile = function (sh) {
      Object.keys(U).forEach(function (k) { sh.uniforms[k] = U[k]; });
      sh.vertexShader = 'varying vec3 vHmFotoW;\n' + sh.vertexShader.replace('#include <worldpos_vertex>',
        '#include <worldpos_vertex>\n\tvHmFotoW = ( modelMatrix * vec4( transformed, 1.0 ) ).xyz;');
      sh.fragmentShader = 'uniform vec3 hmZentrum;\nuniform float hmGier;\nuniform vec4 hmBand;\nvarying vec3 vHmFotoW;\n' + sh.fragmentShader.replace('#include <map_fragment>', [
        'vec3 hmR = normalize( vHmFotoW - hmZentrum );',
        'float hmC = cos( hmGier ), hmS = sin( hmGier );',
        'vec3 hmL = vec3( hmC * hmR.x + hmS * hmR.z, hmR.y, - hmS * hmR.x + hmC * hmR.z );',
        'float hmLon = atan( hmL.x, - hmL.z );',
        'vec2 hmUv = vec2( 0.5 + 0.5 * sin( hmBand.x * hmLon ) / hmBand.y, ( hmL.y - hmBand.z ) / ( hmBand.w - hmBand.z ) );',
        '#ifdef USE_MAP',
        '\tdiffuseColor *= texture2D( map, clamp( hmUv, vec2( 0.0005 ), vec2( 0.9995 ) ) );',
        '#endif'
      ].join('\n'));
    };
    m.customProgramCacheKey = function () { return 'hmFoto2'; };
    return m;
  }
  function aussenFotoBauen(f, h, preset) {
    var gr = new T.Group(), lage = lichtFensterLage(f, h), F = FOTO_P1, P = AUSSICHT_P1[preset] || AUSSICHT_P1.wohnhof;
    gr.position.set(lage.p.x - lage.n.x, 0, lage.p.z - lage.n.z);
    gr.rotation.y = SEITE_DREHUNG[f.seite] || 0;
    gr.userData.aussenP1 = true; gr.userData.seite = f.seite;
    var stueck = function (geo, m) {
      var me = new T.Mesh(geo, m);
      me.userData.ohneSchatten = true; me.userData.ohneEmpfang = true; me.userData.durchlaessig = true;
      me.userData.nurLive = true; me.userData.aussen = true; me.raycast = function () {};
      gr.add(me);
      return me;
    };
    var tx = fotoP1(P.datei);
    if (!tx) {
      /* until the photograph has arrived: the quiet sky of the painted view, nothing in front of it */
      var mh = new T.MeshBasicMaterial({ map: himmelP1(), side: T.BackSide });
      mh.color.multiplyScalar(1.75).multiply(aussenFarbe(1));
      stueck(new T.CylinderGeometry(F.weite, F.weite, 3300, 40, 1, true, Math.PI * 0.42, Math.PI * 1.16), mh).position.set(0, 3300 / 2 - 400, 0);
      return gr;
    }
    gr.updateMatrixWorld(true);
    /* projection centre in world coordinates: the middle of the openings on this wall at eye height, on the wall plane */
    var zentrum = new T.Vector3(0, F.auge, 0).applyMatrix4(gr.matrixWorld), gier = -(SEITE_DREHUNG[f.seite] || 0);
    /* above latMax the photograph's top row (sky) continues up to 65 degrees: steep views up out of a window stay sky */
    var R = F.weite, unten = F.auge - R * Math.tan(-F.latMin * Math.PI / 180) - 50;
    var oben = F.auge + R * Math.tan(65 * Math.PI / 180);
    var bogen = 2 * F.lonMax * Math.PI / 180 + 0.3;
    stueck(new T.CylinderGeometry(R, R, oben - unten, 64, 1, true, Math.PI - bogen / 2, bogen), aussenFotoMat(tx, zentrum, gier, P.hell))
      .position.set(0, (oben + unten) / 2, 0);
    return gr;
  }

  /* PHASE 2A — NATURAL LIGHT FROM THE VIEW OUT (ChatGPT "Premium Lifestyle — Phase 2A", 2026-10-02; 2A.1 the same day: every
     window). Only the natural light changes: the sun and the daylight of the windows. It depends ONLY on the exterior preset of
     the room (aussichtJetzt, phase 1.3) and on the real openings — never on series, colour, gloss or worktop: the same room with
     the same preset gets the same light. Spots, LED, cove, ground light, balance probe and exposure stay as they were.
     wohnhof  (Residential Garden, overcast): no direct sun through any window. Every window is a soft area light (RectAreaLight,
              no shadow): the window side brighter, a broad gradient into the room, light reveals and sills.
     vorstadt (Suburban Garden, clear sky): the sun as MEASURED in the photograph, fixed in WORLD space. The photograph's view
              straight out is aligned with the planner's daylight window, so the measurement is relative to that window's outward
              normal: azimuth +102 deg (to the right when looking out), elevation 65 deg (centre of the saturated sun disc at
              lon 214-216 / lat 64-65; the band is centred on lon 112; tree shadows, sunlit hedge front and shaded precast wall
              agree). In world space that vector is the same for every window: a window lets direct sun in only if the sun stands
              in front of its wall (dot(sun, outward normal) > 0); the daylight window itself stands 12 deg past its plane and gets
              none, a customer window on the wall to its right faces the sun almost square. Walls, reveals, frames, casements,
              cabinets and islands shadow the sun (shadow map of the window sun; the sun mask has a hole for every opening).
     WINDOW DAYLIGHT ENERGY. Radiance of a window = the photograph's cosine-weighted mean radiance as a window sees it (x the
     view's exposure `hell`): Residential 0.82, Suburban 0.92, x `staerke` 3.5 (the approved 2A baseline for the daylight window).
     With several windows the radiance of every window is scaled by k = (A_ref / A_total)^(1 - g), g = 0.5: A = clear glass area
     of an opening (opening minus outer frame minus casement profiles), A_ref = that of the daylight window (if there is none,
     of the largest window), A_total = sum over all openings. The daylight window alone keeps k = 1 (baseline unchanged); the
     total window flux grows with sqrt(A_ref * A_total): a 60 cm window adds a little, a 260 cm window much more, a second
     window of equal size adds 41 %, not 100 %. Suburban: a window whose wall faces the sun's side sees the circumsolar sky and
     the sunlit garden: radiance x (1 + 0.35 * max(0, horizontal sun . outward normal)); Residential (overcast) is isotropic.
     Colours are daylight CCTs, not the photograph's mean (that would tint the room green): Residential 6800 K, Suburban 6000 K.
     One area light per opening; their number changes only when windows are added or removed (three keeps the compiled
     programs of every count it has seen). */
  var TAGESLICHT_P2 = {
    /* Balance (sweep 2026-10-02, probe umverteilt/): the window carries 3.5 x its physical radiance, the main (sky) light and the
       fill give 15 % — front brightness stays within +-0.4 L* in side-window rooms (U fronts facing the window +2 L*), the sun
       patch is gone, ceiling and floor brighten towards the window. 1 x radiance alone changed nothing visible; 5.5 x with 72 %
       sky light over-lit the cabinet sides next to the window. */
    wohnhof: { haupt: 0.85, himmel: 0.85, sonne: null, fenster: { farbe: '#F7FAFF', strahldichte: 0.82, staerke: 3.5 } },
    vorstadt: { haupt: 0.85, himmel: 0.85, sonne: { azimut: 102, hoehe: 65, staerke: 1 }, fenster: { farbe: '#FFF9F0', strahldichte: 0.92, staerke: 3.5 },
      sonnenseite: 0.35 },
    energie: { g: 0.5 }
  };
  var LTC_QUELLE = 'https://esm.sh/three@0.160.0/examples/jsm/lights/RectAreaLightUniformsLib.js';
  var fensterLichter = [], ltcFertig = false, ltcLaeuft = false, oeffnungenJetzt = null, tageslichtInfo = null;
  function fensterLichtLaden() {
    if (ltcFertig || ltcLaeuft || !sc || !T || !T.RectAreaLight || !/^https:\/\/esm\.sh\/three@0\.160\.0\/?$/.test(dreiQuelle)) return;
    ltcLaeuft = true;
    modul(LTC_QUELLE).then(function (M) {
      ltcLaeuft = false;
      if (!sc || ltcFertig || !M || !M.RectAreaLightUniformsLib) return;
      M.RectAreaLightUniformsLib.init();
      ltcFertig = true;
      /* once: the room is lit again with the window light (and the room reflection captures it) */
      dekoNeuBauen();
    }, function () { ltcLaeuft = false; });
  }
  /* Clear glass of an opening: minus the outer frame on all sides, minus the casement profiles (fensterFluegel decides how many). */
  function glasFlaeche(b, fh) {
    var P = FENSTER_P1, n = fensterFluegel(b, fh);
    var gb = b - 2 * P.blend - n * 2 * P.fluegel, gh = fh - 2 * P.blend - (n ? P.fluegel + P.fluegelUnten : 0);
    return Math.max(0, gb) * Math.max(0, gh);
  }
  /* World frame of the measured sun: the daylight window's outward normal (without one: +z, the room's open front). */
  function sonneWelt(p2, lage) {
    var s = p2 && p2.sonne;
    if (!s) return null;
    var ox = lage ? -lage.n.x : 0, oz = lage ? -lage.n.z : 1, rx = -oz, rz = ox;
    var d = s.azimut * Math.PI / 180, e = s.hoehe * Math.PI / 180;
    var hx = Math.cos(d) * ox + Math.sin(d) * rx, hz = Math.cos(d) * oz + Math.sin(d) * rz;
    return { h: new T.Vector3(hx, 0, hz), zu: new T.Vector3(hx * Math.cos(e), Math.sin(e), hz * Math.cos(e)).normalize(), staerke: s.staerke || 1 };
  }
  var SEITE_AUSSEN = { minX: [-1, 0], maxX: [1, 0], minY: [0, -1], maxY: [0, 1] };
  /* Every opening as an area light (energy model above) and the sun's verdict per window; returns the sun's direction of
     travel if any window faces it (Suburban), else { an: false }. Fills tageslichtInfo for the probes. */
  function tageslichtSetzen(p2, h, lage) {
    var liste = [];
    if (p2 && h && oeffnungenJetzt) ['minX', 'maxX', 'minY', 'maxY'].forEach(function (seite) {
      (oeffnungenJetzt[seite] || []).forEach(function (o) { liste.push({ seite: seite, o: o, glas: glasFlaeche(o.b - o.a, o.oben - o.unten) / 1e4 }); });
    });
    var sw = sonneWelt(p2, lage), aRef = 0, aSum = 0;
    liste.forEach(function (x) { aSum += x.glas; if (x.o.licht) aRef = x.glas; });
    if (!aRef) liste.forEach(function (x) { aRef = Math.max(aRef, x.glas); });
    var k = aSum > 0 && aRef > 0 ? Math.pow(aRef / aSum, 1 - TAGESLICHT_P2.energie.g) : 1, sonneRein = false;
    tageslichtInfo = { aussicht: aussichtJetzt, k: +k.toFixed(3), aRef: +aRef.toFixed(3), aSumme: +aSum.toFixed(3),
      sonne: sw && { zu: sw.zu.toArray().map(function (v) { return +v.toFixed(3); }) }, fenster: [] };
    liste.forEach(function (x) {
      var au = SEITE_AUSSEN[x.seite], vorn = sw ? sw.h.x * au[0] + sw.h.z * au[1] : null;
      var seite = sw && p2.sonnenseite ? 1 + p2.sonnenseite * Math.max(0, vorn) : 1;
      /* the sun enters only if it stands in front of the wall AND its ray crosses the full wall depth (30 cm: reveal, frame,
         outer reveal) inside the opening — at 65 deg elevation that needs the wall to face it within ~60 deg */
      var sieht = false, grund = sw ? (vorn > 0.02 ? 'Laibung' : 'hinter der Wand') : null;
      if (sw && vorn > 0.02) {
        var e = TAGESLICHT_P2[aussichtJetzt] && p2.sonne ? p2.sonne.hoehe * Math.PI / 180 : 0, nK = Math.cos(e) * vorn, vK = Math.sin(e), lK = Math.cos(e) * Math.sqrt(Math.max(0, 1 - vorn * vorn));
        var D = FENSTER_P1.wand, hoch = x.o.oben - x.o.unten - 2 * FENSTER_P1.blend, breit = x.o.b - x.o.a - 2 * FENSTER_P1.blend;
        sieht = D * vK / nK < hoch && D * lK / nK < breit;
        if (sieht) grund = null;
      }
      if (sieht) sonneRein = true;
      x.radianz = p2.fenster.strahldichte * p2.fenster.staerke * k * seite;
      tageslichtInfo.fenster.push({ seite: x.seite, a: Math.round(x.o.a), b: Math.round(x.o.b), unten: Math.round(x.o.unten), oben: Math.round(x.o.oben),
        auto: !!x.o.licht, glas: +x.glas.toFixed(3), radianz: +x.radianz.toFixed(3), sonneVorn: sw ? +vorn.toFixed(3) : null, sonne: sieht, ohneSonneWeil: grund });
    });
    if (ltcFertig && sc) {
      while (fensterLichter.length < liste.length) { var nl = new T.RectAreaLight('#FFFFFF', 0, 1, 1); sc.add(nl); fensterLichter.push(nl); }
      fensterLichter.forEach(function (l, i) {
        var x = liste[i];
        l.visible = !!x;
        if (!x) { l.intensity = 0; return; }
        var P = FENSTER_P1, au = SEITE_AUSSEN[x.seite], u = (x.o.a + x.o.b) / 2, y = (x.o.unten + x.o.oben) / 2, tiefe = 1 + P.laibung;
        var px = x.seite === 'minX' ? h.minX : x.seite === 'maxX' ? h.maxX : u, pz = x.seite === 'minY' ? h.minY : x.seite === 'maxY' ? h.maxY : u;
        l.width = Math.max(1, x.o.b - x.o.a - 2 * P.blend); l.height = Math.max(1, x.o.oben - x.o.unten - 2 * P.blend);
        l.position.set(px + au[0] * tiefe, y, pz + au[1] * tiefe);
        l.lookAt(l.position.x - au[0], y, l.position.z - au[1]);
        l.color.set(p2.fenster.farbe);
        l.intensity = x.radianz;
        l.updateMatrixWorld();
      });
    }
    tageslichtInfo.lichter = fensterLichter.filter(function (l) { return l.visible; }).length;
    return sonneRein && sw ? { an: true, lauf: sw.zu.clone().negate(), staerke: sw.staerke, waerme: 0 } : { an: false };
  }
  /* The measured sun through every window that faces it: one directional light (fensterSonne) aimed at the room's centre, its
     shadow camera tight around the room (the eight corners with margin) — walls, sun mask, reveals, frames, casements, cabinets
     and islands give the real entry shape. Warm white, not orange (the look's sun colour). */
  function sonneSetzenP2(sr, li, h) {
    var mx = (h.minX + h.maxX) / 2, mz = (h.minY + h.maxY) / 2, ziel = new T.Vector3(mx, 0, mz), zuS = sr.lauf.clone().negate();
    fensterSonne.color.set(li.sonneFarbe || '#FFF3E2');
    fensterSonne.intensity = li.sonne * sr.staerke;
    fensterSonne.target.position.copy(ziel);
    fensterSonne.position.copy(ziel).addScaledVector(zuS, 1800);
    fensterSonne.updateMatrixWorld(); fensterSonne.target.updateMatrixWorld();
    var fk = fensterSonne.shadow.camera;
    fk.position.copy(fensterSonne.position); fk.lookAt(ziel); fk.updateMatrixWorld();
    var inv = fk.matrixWorldInverse, v = new T.Vector3(), mm = [Infinity, -Infinity, Infinity, -Infinity, Infinity, -Infinity];
    [h.minX - 40, h.maxX + 40].forEach(function (x) {
      [-10, hoeheJetzt + 10].forEach(function (y) {
        [h.minY - 40, h.maxY + 40].forEach(function (z2) {
          v.set(x, y, z2).applyMatrix4(inv);
          mm[0] = Math.min(mm[0], v.x); mm[1] = Math.max(mm[1], v.x); mm[2] = Math.min(mm[2], v.y);
          mm[3] = Math.max(mm[3], v.y); mm[4] = Math.min(mm[4], v.z); mm[5] = Math.max(mm[5], v.z);
        });
      });
    });
    fk.left = mm[0]; fk.right = mm[1]; fk.bottom = mm[2]; fk.top = mm[3];
    fk.near = Math.max(1, -mm[5] - 20); fk.far = -mm[4] + 20;
    fk.updateProjectionMatrix();
  }

  /* DIE SONNENBLENDE: eine unsichtbare Huelle um den Raum (Decke und vier Seiten), offen nur im Lichtfenster. Sie steht
     allein im Schattenwurf der Fenstersonne — das Hauptlicht faellt weiter von oben, wie bisher. Doppelseitig, damit sie
     von innen wie von aussen abschattet; Sprossen nur beim unsichtbaren Fenster (beim sichtbaren wirft der Rahmen sie). */
  function blendeBauen(h, RH, f, oeff) {
    var g = new T.Group(), m = new T.MeshBasicMaterial({ color: '#000000', side: T.DoubleSide });
    g.visible = false;
    var rand = 80, aus = 4, unten = -10, oben = RH + 3;
    /* Frontansicht mit langer Brennweite (nur Kuechenzeile): der Boden vor dem Raum (weitGruppe) steht im Bild — auch dort
       keine offene Sonne, sonst lag vorn ein ausgebrannter weisser Streifen (gesehen im Katalogfoto 2026-09-29). */
    var vorn = teleHier() ? VOR_RAUM : 0;
    var nurSonne = nurFuerSonne;
    var flaeche = function (breite, hoehe) {
      var me = new T.Mesh(new T.PlaneGeometry(breite, hoehe), m);
      me.userData.ohneEmpfang = true; me.userData.durchlaessig = true;
      me.raycast = function () {};
      me.onBeforeShadow = nurSonne;
      g.add(me);
      return me;
    };
    var decke = flaeche(h.maxX - h.minX + 2 * rand, h.maxY - h.minY + 2 * rand + vorn);
    decke.rotation.x = -Math.PI / 2;
    decke.position.set((h.minX + h.maxX) / 2, oben, (h.minY + h.maxY + vorn) / 2);
    /* Eine Seite als Rechtecke um das Loch: entlang `u` (Weltachse der Seite), Hoehe y. */
    var seite = function (s) {
      var lang = s === 'minY' || s === 'maxY', lo = (lang ? h.minX : h.minY) - rand, hi = (lang ? h.maxX : h.maxY + vorn) + rand;
      var loch = f && f.seite === s ? f : null, stuecke = [];
      /* Phase 2A.1: a hole for every real opening of the phase-1 room (daylight window and customer windows) */
      if (oeff) {
        var x0 = lo;
        (oeff[s] || []).slice().sort(function (p, q) { return p.a - q.a; }).forEach(function (o) {
          stuecke.push([x0, o.a, unten, oben], [o.a, o.b, unten, o.unten], [o.a, o.b, o.oben, oben]);
          x0 = Math.max(x0, o.b);
        });
        stuecke.push([x0, hi, unten, oben]);
      }
      else if (!loch) stuecke.push([lo, hi, unten, oben]);
      else {
        stuecke.push([lo, loch.a, unten, oben], [loch.b, hi, unten, oben], [loch.a, loch.b, unten, loch.unten], [loch.a, loch.b, loch.oben, oben]);
        if (!loch.sichtbar && !fensterEcht) {
          var mu = (loch.a + loch.b) / 2, fy = loch.unten + (loch.oben - loch.unten) * 0.62;
          stuecke.push([mu - 3, mu + 3, loch.unten, loch.oben], [loch.a, loch.b, fy - 3, fy + 3]);
        }
      }
      stuecke.forEach(function (q) {
        if (q[1] - q[0] < 0.5 || q[3] - q[2] < 0.5) return;
        var me = flaeche(q[1] - q[0], q[3] - q[2]), u = (q[0] + q[1]) / 2, y = (q[2] + q[3]) / 2;
        if (s === 'minY') me.position.set(u, y, h.minY - aus);
        else if (s === 'maxY') me.position.set(u, y, h.maxY + aus);
        else { me.rotation.y = Math.PI / 2; me.position.set(s === 'minX' ? h.minX - aus : h.maxX + aus, y, u); }
      });
    };
    ['minY', 'maxY', 'minX', 'maxX'].forEach(seite);
    if (vorn) {
      var ende = flaeche(h.maxX - h.minX + 2 * rand, oben - unten);
      ende.position.set((h.minX + h.maxX) / 2, (oben + unten) / 2, h.maxY + vorn + aus);
    }
    return g;
  }
  /* DIE LICHTREGIE je Look: Richtung und Staerke aller Lichter, Farben, Belichtung. Die Fenstersonne wird auf einen Punkt
     vor der Hauptzeile gezielt (`weite` cm vom Fenster, knapp vor den Fronten am Boden) — so liegt ihr Fleck immer im Bild,
     halb auf dem Boden, halb auf den Unterschraenken. Die Hoehe der Sonne folgt daraus (25–40 Grad je nach Weite). */
  /* Die Sonde des Ausgleichs (siehe AUSGLEICH_ANTEIL): Fehlbetrag je Achse aus Haupt- und Himmelslicht, als Kugelfunktionen
     (three: shGetIrradianceAt — x-Glied Koeffizient 3, z-Glied 2, z² 6, x²−y² 8, fest 0). */
  /* Die Kugelfunktionen des Ausgleichs werden auf schraegen Flaechen der hellsten Seite leicht negativ (bis -0,2 bei 45 Grad): im
     Shader auf >= 0 begrenzt — die Sonde bringt nur Licht, nimmt nie welches (Code-Pruefung 2026-10-01). Einmal, vor dem ersten
     Uebersetzen; fehlt die Stelle (andere three-Fassung), bleibt alles, wie es ist. */
  function sondeNieNegativ() {
    var sc0 = T && T.ShaderChunk, alt = 'vec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );';
    if (!sc0 || typeof sc0.lights_pars_begin !== 'string' || sc0.lights_pars_begin.indexOf(alt) < 0) return;
    sc0.lights_pars_begin = sc0.lights_pars_begin.replace(alt, 'vec3 irradiance = max( shGetIrradianceAt( worldNormal, lightProbe ), vec3( 0.0 ) );');
  }
  function ausgleichSetzen(sonde, li, he, hx, hz, hw) {
    var ah = aufheller.position.clone().sub(aufheller.target.position), ahl = ah.length() || 1;
    var hk = [li.haupt * Math.cos(he) * hx / hw, li.haupt * Math.cos(he) * hz / hw], hf = [li.himmel * ah.x / ahl, li.himmel * ah.z / ahl];
    var bekommt = function (ax, az) { return Math.max(0, ax * hk[0] + az * hk[1]) + Math.max(0, ax * hf[0] + az * hf[1]); };
    var e = [bekommt(1, 0), bekommt(-1, 0), bekommt(0, 1), bekommt(0, -1)], max = Math.max.apply(null, e);
    var d = e.map(function (v) { return (max - v) * AUSGLEICH_ANTEIL; });
    var ax = (d[0] - d[1]) / 2, az = (d[2] - d[3]) / 2, c = (d[0] + d[1] + d[2] + d[3]) / 4, b = ((d[0] + d[1]) - (d[2] + d[3])) / 4;
    var Q = (b + c) / 2, P = (c - 3 * b) / 2, Kc = (b + c) / 2;
    var k = [], c6 = P / 0.743125, c8 = Q / 0.429043;
    k[0] = (Kc + 0.247708 * c6) / 0.886227; k[1] = 0; k[2] = az / 1.023328; k[3] = ax / 1.023328; k[4] = 0; k[5] = 0; k[6] = c6; k[7] = 0; k[8] = c8;
    var farbe = new T.Color(li.hauptFarbe || '#FFFFFF');
    sonde.intensity = 1;
    for (var i = 0; i < 9; i++) sonde.sh.coefficients[i].set(farbe.r * k[i], farbe.g * k[i], farbe.b * k[i]);
  }
  function lichtRegie(li, raum, t) {
    if (!sonne) return;
    /* Phase 2A: with the phase-1 room the natural light follows the exterior preset only (TAGESLICHT_P2): the main (sky) light
       and the fill give part of their light to the windows (haupt, himmel < 1), the fill takes the preset's daylight colour. */
    var p2 = ARCHITEKTUR.an && ARCHITEKTUR.tageslicht && aussichtJetzt ? TAGESLICHT_P2[aussichtJetzt] : null;
    if (p2) li = Object.assign({}, li, { haupt: li.haupt * (p2.haupt || 1), himmel: li.himmel * (p2.himmel || 1), himmelFarbe: p2.himmelFarbe || li.himmelFarbe });
    var bb = K.raumBounds(raum, t), h = huelleJetzt, f = lichtFenster;
    var mx = (bb.minX + bb.maxX) / 2, mz = (bb.minY + bb.maxY) / 2;
    var lage = f && h ? lichtFensterLage(f, h) : null;
    /* Waagrechte Richtung zum Fenster (vom Raum aus); ohne Fenster wie bisher von links vorn. */
    var wx = -0.55, wz = 0.83;
    if (lage) { wx = lage.p.x - mx; wz = lage.p.z - mz; var wl = Math.hypot(wx, wz) || 1; wx /= wl; wz /= wl; }
    /* Hauptlicht: steil von oben, zur Fensterseite und nach vorn geneigt — Schatten unter die Haengeschraenke, die Fronten
       gleichmaessig und neutral. */
    var hx = wx * 0.42, hz = Math.max(0.35, wz * 0.3 + 0.62), hw = Math.hypot(hx, hz);
    var he = (li.hauptHoehe || 48) * Math.PI / 180, hd = new T.Vector3(hx / hw * Math.cos(he), Math.sin(he), hz / hw * Math.cos(he));
    sonne.color.set(li.hauptFarbe || '#FFFFFF');
    sonne.intensity = li.haupt;
    sonne.target.position.set(mx, 0, mz);
    sonne.position.set(mx + hd.x * 620, hd.y * 620, mz + hd.z * 620);
    var halb = Math.max(bb.breite, bb.tiefe, 300) * 0.75 + 120, sk = sonne.shadow.camera;
    sk.left = -halb; sk.right = halb; sk.top = halb; sk.bottom = -halb; sk.near = 50; sk.far = 1800;
    sk.updateProjectionMatrix();
    /* Himmelslicht: flach von der Fensterseite, kuehl, ohne Schatten. */
    aufheller.color.set(li.himmelFarbe || '#FFFFFF');
    aufheller.intensity = li.himmel;
    aufheller.target.position.set(mx, 90, mz);
    aufheller.position.set(mx + wx * 500, 90 + 220, mz + wz * 500);
    grundLicht.intensity = li.grund;
    grundLicht.color.set(li.grundOben || '#fdfcfa'); grundLicht.groundColor.set(li.grundUnten || '#b9b2a6');
    if (ausgleich) ausgleichSetzen(ausgleich, li, he, hx, hz, hw);

    /* Einbauleuchten mit echtem Ausstrahlwinkel (Halbwinkel ~38 Grad statt 60): ihr warmes Licht faellt auf Platte und Boden,
       nicht streifend auf die Oberschraenke — dort zog es dunkle Fronten ins Braune (gemessen 2026-09-29: Blau/Rot 0,84). */
    deckenSpots.forEach(function (dsp) { dsp.color.set(li.spotFarbe || '#FFF4E6'); });
    rd.toneMappingExposure = li.belichtung;
    /* DIE SONNE FAELLT NUR AUF DEN BODEN (Betreiber 2026-09-29 mit Bild der weissen Kueche: „تشوه بصري بالنسبة للشمس — انها من
       قوتها تخفي معالم الخزائن"; und „الشمس يجب ان لاتكون نفسها في كل مرة او في كل قياس"). Auf weissen Fronten brannte der Fleck
       aus, Fugen und Griffleisten verschwanden. Jetzt: Hoehe, Seitenwinkel, Staerke und Farbe kommen aus dem Raumrezept (jede
       Groesse und Farbe ein anderer Tag, manchmal ganz ohne Sonne), und gerechnet wird, wohin das Fenster seinen Fleck legt —
       beruehrt er eine Schrankzeile oder die Insel (Streifen bis Frontflucht + 18 cm), wird die Sonne hoeher gestellt, dann
       gerader gerichtet; findet sich keine freie Lage, bleibt der Tag bedeckt (nur Himmelslicht). */
    fensterSonne.intensity = 0;
    /* Phase 2A/2A.1: the windows' daylight and the measured world sun (TAGESLICHT_P2); the size recipe's sun (height, side
       angle, strength, warmth per room size) is no longer used with the phase-1 room. No sun, no sun shadow map. */
    fensterLichtLaden();
    var srP2 = tageslichtSetzen(p2, p2 ? h : null, lage);
    fensterSonne.castShadow = !p2 || !!srP2.an;
    /* without sun its 2048 shadow map is released (three allocates it again when a window faces the sun) */
    if (p2 && !srP2.an && fensterSonne.shadow.map) { fensterSonne.shadow.map.dispose(); fensterSonne.shadow.map = null; }
    if (p2) { if (srP2.an && li.sonne > 0 && h) sonneSetzenP2(srP2, li, h); return; }
    var sr = (rezeptJetzt && rezeptJetzt.sonne) || { an: true, hoehe: 32, seitwaerts: 12, staerke: 1, waerme: 0 };
    if (!lage || !sr.an || !(li.sonne > 0)) return;
    var hindernisse = [], tStreifen = (K.platteTiefe ? K.platteTiefe() : 62) + 18;
    (raum.waende || []).concat(raum.bloecke || []).forEach(function (w) {
      var n2 = K.wandNormaleInnen(w), insel = (raum.bloecke || []).indexOf(w) >= 0, d2 = insel ? t + 12 : tStreifen;
      var xs2 = [w.p0.x, w.p1.x, w.p0.x + n2.x * d2, w.p1.x + n2.x * d2], zs2 = [w.p0.y, w.p1.y, w.p0.y + n2.y * d2, w.p1.y + n2.y * d2];
      hindernisse.push([Math.min.apply(null, xs2) - (insel ? 10 : 0), Math.max.apply(null, xs2) + (insel ? 10 : 0),
        Math.min.apply(null, zs2) - (insel ? 10 : 0), Math.max.apply(null, zs2) + (insel ? 10 : 0)]);
    });
    /* Die vier Ecken der Lichtoeffnung (innen, ohne Rahmen). */
    var rahmen = f.sichtbar ? 6 : 0, ecken = [[f.a + rahmen, f.unten + rahmen], [f.b - rahmen, f.unten + rahmen], [f.b - rahmen, f.oben - rahmen], [f.a + rahmen, f.oben - rahmen]]
      .map(function (q) {
        if (f.seite === 'minX') return new T.Vector3(h.minX, q[1], q[0]);
        if (f.seite === 'maxX') return new T.Vector3(h.maxX, q[1], q[0]);
        return new T.Vector3(q[0], q[1], h.maxY);
      });
    var fleckFrei = function (lauf) {
      var p = ecken.map(function (e) { var tt = e.y / -lauf.y; return [e.x + lauf.x * tt, e.z + lauf.z * tt]; });
      for (var i = 0; i <= 6; i++) {
        for (var j = 0; j <= 6; j++) {
          var u = i / 6, v2 = j / 6;
          var px = (p[0][0] * (1 - u) + p[1][0] * u) * (1 - v2) + (p[3][0] * (1 - u) + p[2][0] * u) * v2;
          var pz = (p[0][1] * (1 - u) + p[1][1] * u) * (1 - v2) + (p[3][1] * (1 - u) + p[2][1] * u) * v2;
          for (var k = 0; k < hindernisse.length; k++) {
            var r = hindernisse[k];
            if (px > r[0] && px < r[1] && pz > r[2] && pz < r[3]) return false;
          }
        }
      }
      return true;
    };
    /* Laufrichtung des Lichts: die Innennormale des Fensters um `phi` gedreht (zur Hauptzeile hin positiv), abwaerts um `e`. */
    var zurZeile = (function () {
      var zl = (raum.waende || [])[0];
      if (!zl) return 1;
      var mz2 = (zl.p0.y + zl.p1.y) / 2, mx2 = (zl.p0.x + zl.p1.x) / 2;
      var qx = -lage.n.z, qz = lage.n.x;
      return ((mx2 - lage.p.x) * qx + (mz2 - lage.p.z) * qz) >= 0 ? 1 : -1;
    })();
    var laufFuer = function (eGrad, phiGrad) {
      var e = eGrad * Math.PI / 180, ph = phiGrad * zurZeile * Math.PI / 180, c = Math.cos(ph), s2 = Math.sin(ph);
      var hx = lage.n.x * c - lage.n.z * s2, hz = lage.n.x * s2 + lage.n.z * c;
      return new T.Vector3(hx * Math.cos(e), -Math.sin(e), hz * Math.cos(e)).normalize();
    };
    var lauf = null;
    for (var eG = sr.hoehe; eG <= 62 && !lauf; eG += 3) {
      [sr.seitwaerts, sr.seitwaerts / 2, 0].forEach(function (phiG) { if (!lauf && fleckFrei(laufFuer(eG, phiG))) lauf = laufFuer(eG, phiG); });
    }
    if (!lauf) return;
    /* Zielpunkt: die Mitte des Flecks am Boden; von dort zur Sonne. */
    var zuS = lauf.clone().negate(), mitteF = new T.Vector3();
    ecken.forEach(function (e) { var tt = e.y / -lauf.y; mitteF.add(new T.Vector3(e.x + lauf.x * tt, 0, e.z + lauf.z * tt)); });
    var ziel = mitteF.multiplyScalar(0.25);
    var farbeS = new T.Color(li.sonneFarbe || '#FFF3E2').lerp(new T.Color(sr.waerme > 0 ? '#FFD9B0' : '#FFFFFF'), Math.abs(sr.waerme));
    fensterSonne.color.copy(farbeS);
    fensterSonne.intensity = li.sonne * sr.staerke;
    fensterSonne.target.position.copy(ziel);
    fensterSonne.position.copy(ziel).addScaledVector(zuS, 1800);
    fensterSonne.updateMatrixWorld(); fensterSonne.target.updateMatrixWorld();
    /* Schattenkamera eng um den Raum: die acht Ecken (mit Rand) im Blick der Sonne. */
    var fk = fensterSonne.shadow.camera;
    fk.position.copy(fensterSonne.position); fk.lookAt(ziel); fk.updateMatrixWorld();
    var inv = fk.matrixWorldInverse, v = new T.Vector3(), mm = [Infinity, -Infinity, Infinity, -Infinity, Infinity, -Infinity];
    [h.minX - 90, h.maxX + 90].forEach(function (x) {
      [-10, hoeheJetzt + 10].forEach(function (y) {
        [h.minY - 90, h.maxY + 90 + (teleHier() ? VOR_RAUM : 0)].forEach(function (z2) {
          v.set(x, y, z2).applyMatrix4(inv);
          mm[0] = Math.min(mm[0], v.x); mm[1] = Math.max(mm[1], v.x); mm[2] = Math.min(mm[2], v.y);
          mm[3] = Math.max(mm[3], v.y); mm[4] = Math.min(mm[4], v.z); mm[5] = Math.max(mm[5], v.z);
        });
      });
    });
    fk.left = mm[0]; fk.right = mm[1]; fk.bottom = mm[2]; fk.top = mm[3];
    fk.near = Math.max(1, -mm[5] - 20); fk.far = -mm[4] + 20;
    fk.updateProjectionMatrix();
  }

  /* Wohin der Raum offen ist (Summe der Innennormalen) und wo seine Mitte liegt. */
  function offeneRichtung() {
    if (!raumJetzt || !bbJetzt) return null;
    var rx = 0, rz = 0;
    raumJetzt.waende.forEach(function (o) {
      var n = K.wandNormaleInnen(o);
      rx += n.x; rz += n.y;
    });
    var l = Math.sqrt(rx * rx + rz * rz);
    if (l < 0.01) { rx = 0; rz = 1; l = 1; }
    return { x: rx / l, z: rz / l, zeile: raumJetzt.waende.length === 1,
             mitte: { x: (bbJetzt.minX + bbJetzt.maxX) / 2,
                      z: raumJetzt.waende.length === 1 ? 60 : (bbJetzt.minY + bbJetzt.maxY) / 2 } };
  }

  /* Wie tief vor der Wand ein Aufriss noch dazugehoert. Ein Korpus ist 47 cm tief, mit
     Arbeitsplatte und Griff gut 60; was weiter im Raum steht, gehoert zur GEGENUEBER
     liegenden Zeile und hat im Aufriss dieser Wand nichts verloren. */
  var AUFRISS_TIEFE = 160;

  /* Wie hoch reicht auf DIESER Wand der Inhalt?

     Gemessen im Fall des Betreibers: Raumhoehe 251 cm, hoechster Gegenstand ein 87 cm hoher
     Unterschrank. Der Aufriss rahmte die volle Raumhoehe — rund zwei Drittel des Bildes
     waren leere Wand, und die Kueche klebte als schmaler Streifen unten.

     Gerechnet wird deshalb ueber das, was tatsaechlich an der Wand steht: die drei Reihen
     mit ihren eigenen Hoehen, die Arbeitsplatte und die Wandgegenstaende. Nichts davon ist
     geraten — es sind dieselben Quellen, aus denen die Szene ihre Koerper baut. Waechst der
     Inhalt (Hochschrank, Haengeschrank, hohes Fenster, Dunstabzug), waechst der Ausschnitt
     mit; abgeschnitten wird nie. Die Raumhoehe selbst bleibt unberuehrt. */
  function wandInhalt(w) {
    var g = K.geo(datenJetzt), oben = 0;
    var hoch = function (v) { if (v > oben) oben = v; };
    /* Arbeitsplatte ueber der belegten Strecke — sie gehoert zur Zeile. */
    if (K.items(zustand, datenJetzt, w.id, 'boden').length) {
      hoch(g.korpus_hoehe + g.arbeitsplatte_dicke);
    }
    ['boden', 'oben', 'aufsatz'].forEach(function (zl) {
      K.items(zustand, datenJetzt, w.id, zl).forEach(function (it) {
        var y = zl === 'oben' ? g.haenge_unterkante + (it.off || 0)
              : (zl === 'aufsatz' ? g.hochschrank_hoehe + (it.off || 0) : 0);
        hoch(y + (it.m.h || 0));
      });
    });
    (zustand.merkmale || []).forEach(function (m) {
      if (m.wand !== w.id) return;
      if (m.typ === 'fenster') hoch(K.fensterOeffnung(m, hoeheJetzt).oben);
      else if (m.typ === 'haube') hoch(m.hoehe + K.HAUBE.h);
      else hoch(m.hoehe || 0);
    });
    /* Ohne jeden Inhalt bleibt die Wand, wie sie ist — sonst zeigte eine leere Wand nichts. */
    if (oben <= 0) oben = hoeheJetzt;
    /* Eine Handbreit Luft ueber dem hoechsten Stueck, aber nie mehr als die Wand hoch ist. */
    return { unten: 0, oben: Math.min(hoeheJetzt, oben + 25) };
  }

  /* ---------- Die Frontansicht als RAUMANSICHT ----------

     Der technische Aufriss existiert bereits — als 2D-Frontansicht. Sie zeigt Wandbreite,
     Schrankstellen, Anschlusshoehen und Fenster massstaeblich und flach; das ist ihre
     Aufgabe, und sie bleibt unberuehrt.

     Die dreidimensionale Frontansicht hat eine andere: der Kunde soll die Kueche sehen, wie
     er im Raum davorsteht. Deshalb steht hier eine perspektivische Kamera auf der RAUMSEITE
     der gewaehlten Wand, in Augenhoehe, und blickt auf deren Mitte. Boden, Seitenwaende und
     die Tiefe der Koerper bleiben damit sichtbar.

     Der Abstand kommt aus der Geometrie, nicht aus einer Tabelle:

       WUNSCH  — so weit, dass rund neun Zehntel der Wandbreite ins Bild kommen.
       GRENZE  — steht der Wand eine ANDERE WAND gegenueber, endet der Weg vor deren Zeile;
                 gemessen sind das in der Parallelkueche 214 cm, in der U-Kueche 238 cm.
                 Gibt es keine solche Wand, ist der Raum dort offen und die Kamera darf
                 weiter zurueck — bei der geraden Kueche ist die Huelle sogar null tief.
       Eine Insel ist KEINE Gegenwand: sie steht im Vordergrund, und genau so gehoert sie
       ins Bild.

     Auf schmalen Schirmen wird die Brennweite etwas weiter, aber nicht weitwinklig: 52 statt
     42 Grad senkrecht. Lieber etwas weniger Wand als ein Fischauge. */
  var AUGENHOEHE = 160;

  /* RAUMANSICHT — DIE KLUGE KAMERA (Realismus Stufe 2, Betreiber 2026-09-28: „اريده بشكل احترافي وذكي"). Wie das Foto
     einer fertigen Kueche: die Kamera steht IM Raum in Augenhoehe eines Fotografen und schaut waagrecht — senkrechte Kanten
     bleiben senkrecht, wie auf jedem Innenraumfoto. WO sie steht, wird nicht geraten, sondern gesucht: aus den wirklichen
     Schrankreihen (je Wand und Insel Anfang/Ende, Wand/Front, Boden/Oberkante) entstehen Punkte, die im Bild liegen sollen;
     fuer viele Kandidaten — Richtung um die offene Seite herum (±40 Grad), Hoehe 120/135 cm, Brennweite 60–78 Grad — wird
     der kleinste Abstand gesucht, bei dem die Kueche ins Bild passt, und jeder Kandidat bewertet: wie viel der Kueche im
     Bild ist (am wichtigsten), wie gut sie das Bild fuellt, wie wenig die Brennweite verzerrt, und ein leichter Schraegblick
     (zwei Fluchtpunkte, wie beim Fotografen) vor dem frontalen. Die Kamera bleibt im Raum (25 cm vor jeder Wand) und nie
     in einer Schrankreihe oder einer Insel. Findet sich nichts, bleibt die freie Perspektive (zeichnen faellt zurueck). */
  var RAUM_AUGE = 130;
  function raumPunkte() {
    var g = K.geo(datenJetzt), pkte = [];
    (raumJetzt.waende || []).concat(raumJetzt.bloecke || []).forEach(function (w) {
      var von = Infinity, bis = -Infinity;
      ['boden', 'oben', 'aufsatz'].forEach(function (zl) {
        K.items(zustand, datenJetzt, w.id, zl).forEach(function (it) { von = Math.min(von, it.x); bis = Math.max(bis, it.x + it.b); });
      });
      if (!(bis > von)) return;
      var oben = Math.min(hoeheJetzt, wandInhalt(w).oben - 20), tief = Math.max(g.korpus_tiefe, K.platteTiefe());
      [von, bis].forEach(function (sx) {
        [0, tief].forEach(function (d) {
          [0, oben].forEach(function (hh) { var q = K.weltPunkt3D(w, sx, d, hh); pkte.push([q.x, q.y, q.z]); });
        });
      });
      w.raumReihe = { von: von, bis: bis, tief: tief };
    });
    return pkte;
  }
  /* Steht der Punkt frei? Nicht in einer Schrankreihe (95 cm vor ihrer Wand, auf ihrer Laenge) und nicht in einer Insel. */
  function raumFrei(px, pz) {
    return (raumJetzt.waende || []).concat(raumJetzt.bloecke || []).every(function (w) {
      var r = w.raumReihe;
      if (!r) return true;
      var a = K.weltPunkt3D(w, r.von, 0, 0), b = K.weltPunkt3D(w, r.bis, 0, 0);
      var ux = b.x - a.x, uz = b.z - a.z, L = Math.sqrt(ux * ux + uz * uz) || 1;
      ux /= L; uz /= L;
      var n = K.wandNormaleInnen(w), s = (px - a.x) * ux + (pz - a.z) * uz, d = (px - a.x) * n.x + (pz - a.z) * n.y;
      var insel = (raumJetzt.bloecke || []).indexOf(w) >= 0;
      /* ABSTAND HALTEN (2026-09-29, U 260/210/210 wie KU-S11): 40 cm hinter dem Zeilenende stand die Kamera neben der
         Seitenwand eines Hochschranks, und die fuellte ein Drittel des Bildes. Jetzt 90 cm hinter dem Ende und 45 cm vor
         den Fronten — sonst lieber ein anderer Standort. */
      /* AUF DER VERLAENGERUNG EINER ZEILE (2026-09-29, zweizeilig 240): 95 cm hinter dem Zeilenende, genau in ihrer Flucht,
         verdeckte die Seitenwand des letzten Schranks die ganze Zeile und fuellte ein Drittel des Bildes. Hinter dem Ende
         einer Wandzeile steht die Kamera deshalb nur ausserhalb ihrer Tiefe (30 cm davor). */
      if (!insel) return d > 105 || d < -5 || ((s < -90 || s > L + 90) && d > r.tief + 30);
      return s < -90 || s > L + 90 || d > r.tief + 80 || d < -80;
    });
  }
  function raumKamera(seitenformat) {
    var off = offeneRichtung(), h = huelleJetzt;
    if (!off || !bbJetzt || !cam || !h) return false;
    var pkte = raumPunkte();
    if (pkte.length < 4) return false;
    var mx = 0, mz = 0;
    pkte.forEach(function (q) { mx += q[0]; mz += q[2]; });
    var ziel = { x: mx / pkte.length, z: mz / pkte.length };
    kugel.raumZiel = ziel;
    var sf = Math.max(0.3, seitenformat), basis = Math.atan2(off.x, off.z), best = null;
    /* ZWEIZEILIG (2026-09-29, Probe 240 cm): die beiden Zeilen stehen sich gegenueber, ihre Innennormalen heben sich auf —
       die „offene Richtung“ zeigte dann auf die Gegenzeile, kein Standort war frei, und die Kamera fiel in eine Zeile
       (Bild: Rueckwand formatfuellend). Dann wird entlang des Gangs gesucht, von beiden Enden. */
    /* In der Tuer stehen darf die Kamera nur an einer Seite OHNE Wand des Kunden (auch ohne Durchgangswand) und nicht am
       Lichtfenster. */
    var fensterK = lichtFenster && lichtFenster.sichtbar ? lichtFenster.seite : null;
    var wandAufSeite = function (seite) {
      return (raumJetzt.waende || []).some(function (w) {
        if (seite === 'minY' || seite === 'maxY') { var yv = seite === 'minY' ? h.minY : h.maxY; return Math.abs(w.p0.y - w.p1.y) <= 0.5 && Math.abs(w.p0.y - yv) < 1; }
        var xv = seite === 'minX' ? h.minX : h.maxX; return Math.abs(w.p0.x - w.p1.x) <= 0.5 && Math.abs(w.p0.x - xv) < 1;
      });
    };
    var rand = function (seite) { return !wandAufSeite(seite) && seite !== fensterK ? -20 : 25; };
    var basen = [basis], sumX = 0, sumZ = 0;
    (raumJetzt.waende || []).forEach(function (o) { var n0 = K.wandNormaleInnen(o); sumX += n0.x; sumZ += n0.y; });
    if (Math.hypot(sumX, sumZ) < 0.01 && raumJetzt.waende && raumJetzt.waende[0]) {
      var w0 = raumJetzt.waende[0], ux0 = w0.p1.x - w0.p0.x, uz0 = w0.p1.y - w0.p0.y;
      basen = [Math.atan2(ux0, uz0), Math.atan2(-ux0, -uz0)];
    }
    var bewerte = function (px, auge, pz, fx, fz, hf) {
      var th = Math.tan(hf * Math.PI / 360), tv = th / sf, drin = 0, lo = Infinity, hi = -Infinity;
      pkte.forEach(function (q) {
        var vx = q[0] - px, vy = q[1] - auge, vz = q[2] - pz, vor = vx * fx + vz * fz;
        if (vor < 30) return;
        var sx = (vx * fz - vz * fx) / vor / th, sy = vy / vor / tv;
        if (Math.abs(sx) <= 0.96 && Math.abs(sy) <= 0.94) drin++;
        lo = Math.min(lo, sx); hi = Math.max(hi, sx);
      });
      return { anteil: drin / pkte.length, fuellt: Math.min(1, Math.max(0, Math.min(hi, 1) - Math.max(lo, -1)) / 2) };
    };
    basen.forEach(function (basisB) {
    for (var dg = -40; dg <= 40; dg += 8) {
      var wink = basisB + dg * Math.PI / 180, dx = Math.sin(wink), dz = Math.cos(wink);
      /* Wie weit zurueck geht es in dieser Richtung, ohne die Wand zu verlassen? An einer OFFENEN Seite (keine Wand des
         Kunden, nicht die Fensterseite) darf die Kamera in der Tuer stehen, 20 cm hinter der gedachten Wand — wie ein
         Fotograf im kurzen Raum (zweizeilig 240: sonst gab es keinen Standort, und die Kamera fiel in eine Zeile). */
      var dMax = 1400;
      if (dx > 1e-3) dMax = Math.min(dMax, (h.maxX - rand('maxX') - ziel.x) / dx);
      if (dx < -1e-3) dMax = Math.min(dMax, (h.minX + rand('minX') - ziel.x) / dx);
      if (dz > 1e-3) dMax = Math.min(dMax, (h.maxY - rand('maxY') - ziel.z) / dz);
      if (dz < -1e-3) dMax = Math.min(dMax, (h.minY + rand('minY') - ziel.z) / dz);
      if (!(dMax > 100)) continue;
      [120, 135].forEach(function (auge) {
        [60, 66, 72, 78, 86].forEach(function (hf) {
          var d, e = null;
          for (d = 110; d <= dMax; d += 10) {
            var px = ziel.x + dx * d, pz = ziel.z + dz * d;
            if (!raumFrei(px, pz)) continue;
            e = bewerte(px, auge, pz, -dx, -dz, hf);
            if (e.anteil >= 0.999) break;
          }
          if (!e) return;
          var schraeg = 1 - 0.25 * Math.abs(Math.abs(dg) - 16) / 40;
          var punkte = Math.pow(e.anteil, 4) * (0.55 + 0.45 * e.fuellt) * (1 - (hf - 60) / 90) * schraeg * (auge === 135 ? 1 : 0.97);
          if (!best || punkte > best.punkte) best = { punkte: punkte, px: ziel.x + dx * Math.min(d, dMax), pz: ziel.z + dz * Math.min(d, dMax), auge: auge, hf: hf };
        });
      });
    }
    });
    if (!best) return false;
    /* MITTIG UND GANZ (Betreiber 2026-09-29, Bild „Ganze Küche": „الصورة مسحوبة الى اليسار اكثر"): die Kamera sah auf den
       Schwerpunkt der Kueche, und von der Ecke des Raums aus lag der nicht in der Mitte ihrer Breite — links fiel die Spuele
       aus dem Bild, rechts stand leere Wand. Jetzt dreht die Richtung auf die Mitte zwischen dem linken und dem rechten Rand
       der Kueche, und das Objektiv wird so weit, dass sie ganz hineinpasst (hoechstens 100 Grad). Die Kamera bleibt
       waagrecht: senkrechte Kanten bleiben senkrecht. */
    /* Nur so viel wie noetig: passt die ganze Kueche mit hoechstens 15 Grad mehr Bildwinkel, wird sie mittig ganz gezeigt.
       Sonst bleibt der Bildwinkel, und die Richtung rutscht nur, wenn EINE Seite abgeschnitten ist und die andere Luft hat —
       um hoechstens diese Luft. Im Gang der zweizeiligen Kueche (beide nahen Enden weit aussen) aendert sich so fast nichts;
       zog die volle Mitte dort die Richtung zur naeheren Zeile, fuellte deren Hochschrank das halbe Bild. */
    var a0 = Math.atan2(ziel.x - best.px, ziel.z - best.pz), amin = Infinity, amax = -Infinity;
    pkte.forEach(function (q) {
      /* Was naeher als 130 cm an der Kamera steht (das Zeilenende direkt neben ihr), bestimmt den Ausschnitt nicht. */
      if (Math.hypot(q[0] - best.px, q[2] - best.pz) < 130) return;
      var a = Math.atan2(q[0] - best.px, q[2] - best.pz) - a0;
      while (a > Math.PI) a -= 2 * Math.PI;
      while (a < -Math.PI) a += 2 * Math.PI;
      if (Math.abs(a) > 1.75) return;
      amin = Math.min(amin, a); amax = Math.max(amax, a);
    });
    var richt = a0, hfNeu = best.hf;
    /* Nur mit einer Ecke (L, U, Insel vor L/U): dort liegt ein Schenkel oft halb ausserhalb. Zeile und Gang bleiben, wie die
       Suche sie gerahmt hat — im Gang zog das Nachrutschen die Richtung zum nahen Hochschrank der kuerzeren Zeile. */
    var mitEcke = !!(K.schrankEcken && K.schrankEcken(raumJetzt).length);
    if (mitEcke && amax > amin) {
      var noetig = (amax - amin) * 1.08 * 180 / Math.PI;
      if (noetig <= best.hf + 15) {
        hfNeu = Math.max(best.hf, noetig);
        richt = a0 + (amin + amax) / 2;
      } else {
        /* Die Haelfte des waagrechten Bildwinkels in Radiant; ueber = abgeschnitten, Luft = frei. */
        var Hh = Math.atan(Math.tan(best.hf * Math.PI / 360)) , ueberP = amax * 1.04 - Hh, ueberM = -amin * 1.04 - Hh;
        if (ueberP > 0 && ueberM < 0) richt = a0 + Math.min(ueberP, -ueberM);
        else if (ueberM > 0 && ueberP < 0) richt = a0 - Math.min(ueberM, -ueberP);
      }
    }
    /* ZOOMEN IN DER RAUMANSICHT (Betreiber 2026-09-29: „هذا اقصى بعد وهذه قليل لانه لاتظهر كل الخزائن" — U-Kueche: die nahen
       Schenkelenden standen auch bei 100 Grad ausserhalb). Bis zur Lupe 1,2 weitet sich das Objektiv. Darueber geht die
       Kamera in Blickrichtung zurueck — durch die offene Seite aus dem Raum — und das Objektiv wird dabei wieder enger: bei
       der groessten Lupe (2,2) steht sie genau so weit weg, dass die GANZE Kueche mit 72 Grad ins Bild passt. Weiter hinaus
       stand die Kueche als kleiner Kasten im Leeren. Die Wand hinter ihr ist von aussen unsichtbar, Boden und Decke laufen
       weiter (weitGruppe, malen), das Lichtfenster blendet sich dort aus. */
    var lupeR = kugel.lupe || 1, FOV_ZIEL = 72;
    var hZiel = 2 * Math.atan(Math.tan(FOV_ZIEL * Math.PI / 360) * sf);
    var passt = function (d) {
      var x0 = best.px - Math.sin(richt) * d, z0 = best.pz - Math.cos(richt) * d, halbH = 0, halbV = 0;
      for (var i = 0; i < pkte.length; i++) {
        var q = pkte[i], vx = q[0] - x0, vz = q[2] - z0;
        var vor = vx * Math.sin(richt) + vz * Math.cos(richt);
        if (vor < 20) return false;
        halbH = Math.max(halbH, Math.abs(Math.atan2(vx * Math.cos(richt) - vz * Math.sin(richt), vor)));
        halbV = Math.max(halbV, Math.abs(Math.atan2(q[1] - best.auge, vor)));
      }
      return halbH * 2.12 <= hZiel && halbV * 2.12 <= FOV_ZIEL * Math.PI / 180;
    };
    var dFit = 0;
    while (dFit < 900 && !passt(dFit)) dFit += 20;
    var vf = 2 * Math.atan(Math.tan(hfNeu * Math.PI / 360) / sf) * 180 / Math.PI;
    var fovInnen = Math.min(100, vf * Math.min(lupeR, 1.2));
    var tZ = dFit > 0 ? Math.max(0, Math.min(1, (lupeR - 1.2) / 1.0)) : 0;
    var zurueck = dFit * tZ;
    cam.fov = Math.max(30, Math.min(100, fovInnen + (FOV_ZIEL - fovInnen) * tZ)); cam.near = 10; cam.updateProjectionMatrix();
    var kx = best.px - Math.sin(richt) * zurueck, kz = best.pz - Math.cos(richt) * zurueck;
    cam.position.set(kx, best.auge, kz);
    var dZiel = Math.hypot(ziel.x - best.px, ziel.z - best.pz) || 300;
    cam.lookAt(kx + Math.sin(richt) * dZiel, best.auge - 4, kz + Math.cos(richt) * dZiel);
    return true;
  }

  function frontKamera(seitenformat) {
    /* Auch die Insel (ein Block): in der Planer-App ist sie ein Wandknopf wie jede Wand (2026-09-28). */
    var w = kugel.wandId && raumJetzt
      ? raumJetzt.waende.concat(raumJetzt.bloecke || []).filter(function (x) { return x.id === kugel.wandId; })[0] : null;
    if (!w || !cam) return false;
    var tr = K.wandTransform3D(w);
    var mp = K.weltPunkt3D(w, tr.laenge / 2, 0, 0);
    var inh = wandInhalt(w);

    /* WAS INS BILD MUSS — vor der Frage, wo die Kamera steht.

       Waagerecht vier Fuenftel der Wandbreite: der Rest des Bildes zeigt Boden, Seitenwand
       und den Raum um die Kueche herum. Senkrecht von einem Stueck Boden VOR der Zeile bis
       ueber den obersten Schrank. Der Boden ist ausdruecklich Teil des Ausschnitts: ohne ihn
       schwebte die Kueche in einer Wand, und genau so sah die Ansicht vorher aus. */
    /* GEMESSEN AN DEN FRONTEN, NICHT AN DER WAND (2026-09-28, Wandknoepfe der Planer-App). Bis
       hierher stand hier 0,8 x Wandlaenge auf der Wandebene — mit der Luft unten (x 1,25) also die
       ganze Wand von Rand zu Rand. Die Fronten stehen aber eine Plattentiefe naeher an der Kamera und
       erscheinen groesser: die Zeile lief links und rechts aus dem Bild, bei der Hauptwand einer
       L-Kueche (360 cm) stand der Hochschrank am Anfang nur zur Haelfte da. Jetzt gilt die ganze
       Laenge auf der FRONTEBENE; mit der Luft fuellt die Zeile vier Fuenftel der Breite. */
    var breitZiel = tr.laenge;
    var vorne = Math.max(K.geo(datenJetzt).korpus_tiefe + 3, K.platteTiefe());
    var untenZiel = -30;
    /* GERAHMT WIRD DIE GANZE WAND, vom Boden bis zur Decke — nicht nur, was gerade daran
       steht. Zwei Gruende, und der zweite ist der wichtigere:

       Erstens ist das die Aufnahme, die der Kunde erwartet: die Wand ganz, davor ein Stueck
       Boden, links und rechts so viel Raum, dass die Nachbarwaende mit ins Bild kommen.
       Aus dem Inhalt gerechnet stand die Kamera dagegen dicht vor der Zeile, und von der
       U-Kueche waren nur die beiden Ecken zu sehen.

       Zweitens steht das Bild dann STILL. Ein Ausschnitt, der dem Inhalt folgt, ruckt bei
       jedem gesetzten Haengeschrank ein Stueck zurueck — der Kunde setzt einen Schrank und
       die ganze Kueche springt. Die Raumhoehe aendert sich nur, wenn er sie selbst aendert. */
    var obenZiel = Math.max(hoeheJetzt, inh.oben + 10);
    var zielY = (untenZiel + obenZiel) / 2;

    /* WO DIE KAMERA STEHT. Naeher als 2,6 m steht man der Kueche auf den Fuessen — weiter
       weg geht sie nur, wenn die Wand so breit ist, dass sie sonst nicht ins Bild passt. */
    var grundFov = seitenformat < 1 ? 52 : 42;
    var maxFov = seitenformat < 1 ? 64 : 58;
    var fhGrund = 2 * Math.atan(Math.tan(grundFov * Math.PI / 360) * seitenformat);
    var d = Math.max(260, vorne + (breitZiel / 2) / Math.tan(fhGrund / 2));

    /* Steht dieser Wand eine andere Wand GEGENUEBER? Dann endet der Weg vor deren Zeile.
       Die gerade Kueche hat dort nichts — ihre Huelle ist null tief, und sie bleibt frei. */
    var gegen = raumJetzt.waende.some(function (o) {
      if (o.id === w.id) return false;
      var n = K.wandNormaleInnen(o);
      return Math.abs(n.x + tr.innen.x) < 0.01 && Math.abs(n.y + tr.innen.y) < 0.01;
    });
    var dRaum = 900;
    if (gegen && bbJetzt) {
      var weit = 1e9;
      var pruef = function (achse, richtung, min, max) {
        if (Math.abs(richtung) < 1e-6) return;
        weit = Math.min(weit, ((richtung > 0 ? max : min) - achse) / richtung);
      };
      pruef(mp.x, tr.innen.x, bbJetzt.minX, bbJetzt.maxX);
      pruef(mp.z, tr.innen.y, bbJetzt.minY, bbJetzt.maxY);
      dRaum = Math.max(120, weit - K.geo(datenJetzt).korpus_tiefe - 30);
    }
    /* MIT GEGENZEILE BLEIBT ES BEI DER WANDEBENE (0,8 x Laenge, wie vor 2026-09-28). Dort tritt die Kamera
       durch die Gegenzeile zurueck, und die Near-Ebene (unten) schneidet mit ihr auch den Boden vor der Zeile
       weg: jeder Zentimeter weiter zurueck ist ein Stueck Boden weniger. An den Fronten gerahmt stand die
       Kamera in der zweizeiligen Kueche (360 cm) 110 cm weiter hinten, und unten lag ein grauer Streifen
       ueber 15 % der Bildhoehe. */
    if (gegen) {
      breitZiel = tr.laenge * 0.8; vorne = 0;
      d = Math.max(260, (breitZiel / 2) / Math.tan(fhGrund / 2));
      /* Aus demselben Grund endet der Ausschnitt unten an der Bodenlinie der Zeile statt 30 cm darunter:
         der Boden davor liegt zum Teil vor der Near-Ebene und fehlte im Bild (Insel Kuechenseite: grauer
         Streifen ueber 3,6 % der Hoehe). */
      untenZiel = 0;
      zielY = (untenZiel + obenZiel) / 2;
    }
    d = Math.max(120, Math.min(d, 900));

    /* LANGE BRENNWEITE (Betreiber 2026-09-29, Hinweis seines Designers: „Front ohne Kamera — sonst wird der Render 3D").
       Ein Katalogbild einer Kuechenzeile entsteht von weit vorne mit langem Objektiv: alle Senkrechten bleiben senkrecht,
       jede Tuer ist so breit wie die andere, nichts laeuft zu den Raendern hin auseinander. Die Kamera steht dafuer weit
       VOR dem Raum (dessen Gegenwand schaut nach innen und ist von aussen unsichtbar) — praktisch keine stuerzenden
       Linien. Eine Zeile gegenueber schneidet die Near-Ebene weg wie bisher; Boden und
       Decke laufen bis zur Kamera weiter (weitGruppe). Ein ganz flacher Aufriss (orthografisch) waere eine Zeichnung — die
       gibt es schon in 2D; hier bleibt ein Hauch Tiefe, damit es ein Foto ist. */
    if (teleHier()) {
      var hT = FRONT_TELE * Math.PI / 180, vT = 2 * Math.atan(Math.tan(hT / 2) / seitenformat);
      var dT = Math.max(vorne + (breitZiel * 1.2 / 2) / Math.tan(hT / 2),
                        ((obenZiel - untenZiel) * 1.12 / 2) / Math.tan(vT / 2));
      dT = Math.max(60, dT * (kugel.lupe || 1));
      cam.near = gegen ? Math.max(10, dT - dRaum + 5) : 10;
      cam.far = Math.max(4000, dT + 3000);
      cam.fov = vT * 180 / Math.PI;
      cam.aspect = seitenformat;
      cam.updateProjectionMatrix();
      /* In Augenhoehe, nicht in Bildmitte: aus 110 cm verdeckte eine Insel die ganze Zeile dahinter, und keine
         Arbeitsplatte war zu sehen. Aus 10–25 m ist die Neigung zur Bildmitte kaum 2 Grad — die Senkrechten bleiben
         praktisch senkrecht. */
      cam.position.set(mp.x + tr.innen.x * dT, AUGENHOEHE, mp.z + tr.innen.y * dT);
      cam.lookAt(mp.x, zielY, mp.z);
      kugel.frontZiel = { x: mp.x, z: mp.z, frei: gegen ? dRaum : null };
      return true;
    }

    /* WELCHES OBJEKTIV. In einer Kueche ist der Bildwinkel die wichtigere Stellschraube:
       wer zurueckgehen will, stoesst nach zwei Metern an die Zeile gegenueber. Ein
       Innenraumfoto entsteht deshalb mit einem WEITEREN Objektiv, nicht mit mehr Abstand.

       Zwei Forderungen, beide gegen denselben Abstand gerechnet — die Wandbreite waagerecht
       und der Ausschnitt Boden-bis-Oberkante senkrecht. Die groessere gewinnt; gedeckelt
       wird bei der Grenze, ab der eine Kueche verzeichnet aussieht. */
    var noetig = function (abstand) {
      var winkel = function (y) { return Math.atan((y - AUGENHOEHE) / abstand); };
      var mitte = winkel(zielY);
      var senkrecht = 2 * Math.max(Math.abs(winkel(obenZiel) - mitte), Math.abs(mitte - winkel(untenZiel)));
      var waagerecht = 2 * Math.atan((breitZiel / 2 / Math.max(30, abstand - vorne)) / seitenformat);
      /* LUFT. Ohne diesen Faktor sitzt die Wand exakt im Rahmen — sie beruehrt oben die
         Decke, unten den Boden, und das Bild sieht aus, als klebte die Kamera daran.
         Ein Viertel mehr, als noetig waere, laesst den Raum um die Kueche herum stehen:
         Boden davor, Decke darueber, links und rechts die Nachbarwaende. */
      return 180 / Math.PI * Math.max(senkrecht, waagerecht) * 1.25;
    };
    /* ZUERST ZURUECKTRETEN, DANN WEITEN. Beides rahmt dasselbe Bild, aber nicht gleich gut:
       ein weites Objektiv zieht die Zeile in die Laenge, die der Kamera am naechsten steht.
       Gemessen an der U-Kueche mit beiden Reihen auf Wand B: aus 260 cm brauchte der
       Ausschnitt 57,6 Grad — die Seitenzeilen standen gestreckt am Rand, ihre Haengeschraenke
       angeschnitten. Aus rund 400 cm genuegen die natuerlichen 42 Grad.
       Gewichen wird nur so weit, wie der Raum es hergibt: steht eine Zeile gegenueber, endet
       der Weg dort, und DANN erst weitet sich das Objektiv — bis zu der Grenze, ab der eine
       Kueche verzeichnet aussieht. */
    if (noetig(d) > grundFov) {
      /* Zurueckgetreten wird MITTELWEIT: 6 m reichen, um eine ganze U-Kueche mit beiden
         Seitenzeilen ins Bild zu nehmen. Weiter wuerde die Kueche zur Briefmarke, und das
         Bild beantwortet nicht mehr die Frage, wegen der es geoeffnet wurde.
         Die Gegenzeile begrenzt den Weg NICHT mehr — sie wird geschnitten, nicht umgangen. */
      var oben = 600, unten = d;
      for (var i = 0; i < 24 && oben - unten > 1; i++) {
        var m = (oben + unten) / 2;
        if (noetig(m) > grundFov) unten = m; else oben = m;
      }
      if (noetig(oben) < noetig(d)) d = oben;
    }
    var fov = Math.min(maxFov, Math.max(grundFov, noetig(d)));

    /* Das Mausrad wirkt ZULETZT: erst steht die Rahmung, dann darf der Kunde sie aendern. */
    d = Math.max(60, d * (kugel.lupe || 1));

    /* DIE GEGENZEILE WIRD WEGGESCHNITTEN, NICHT AUSGEWICHEN.

       Gemessen an der U-Kueche: vor Wand B steht Wand C, und die Kamera durfte nur 223 cm
       zurueck. Um die 2,51 m hohe Wand von dort ins Bild zu bekommen, riss das Objektiv auf
       58 Grad auf — die naechststehende Zeile wurde in die Laenge gezogen, und das Bild
       klebte an der Wand. In einer Parallelkueche ist es dasselbe, nur enger.

       Ein Fotograf kann in so einem Raum nicht weiter zurueck. Ein Grundriss schon: er
       schneidet den Raum auf. Genau das tut die Near-Ebene — sie ist dasselbe Werkzeug, mit
       dem schon der frueher Aufriss die Gegenzeile loeste. Die Kamera tritt so weit zurueck,
       wie die Rahmung es braucht, notfalls durch die Wand hindurch, und alles, was dabei
       zwischen sie und die Kueche geraet, wird GEOMETRISCH abgeschnitten. Kein Objekt wird
       versteckt, die Szene bleibt unberuehrt — der Kunde sieht seine Kueche wie in einem
       aufgeschnittenen Modell. */
    cam.near = gegen ? Math.max(10, d - dRaum + 5) : 10;
    cam.fov = fov;
    cam.aspect = seitenformat;
    cam.updateProjectionMatrix();
    cam.position.set(mp.x + tr.innen.x * d, AUGENHOEHE, mp.z + tr.innen.y * d);
    cam.lookAt(mp.x, zielY, mp.z);
    /* Fuer den ersten Zug danach (aufPerspektive): der Blickpunkt, und — wenn die Gegenzeile
       weggeschnitten ist — wie weit die freie Kamera zuruecktreten darf, ohne hinter ihr zu stehen. */
    kugel.frontZiel = { x: mp.x, z: mp.z, frei: gegen ? dRaum : null };
    return true;
  }

  /* Was von oben WIRKLICH zu sehen ist: die Waende mit ihrer Schranktiefe und die Bloecke.
     `raumBounds` nimmt die Waende als Linien — von oben ist eine Wand aber so breit wie das,
     was an ihr steht. Ohne diese Tiefe rahmte die Draufsicht eine Huelle, die schmaler war
     als ihr eigener Inhalt, und der Rest war Boden. */
  function obenInhalt() {
    if (!raumJetzt) return null;
    /* Gemessen wird mit der GROESSEREN der beiden Tiefen. Der Korpus ist 52 cm tief, die
       Arbeitsplatte 60 — und von oben sieht man die Platte, nicht den Korpus. Mit 52
       gerechnet ragte die Insel 2 cm ueber den Rahmen hinaus und stand am unteren Bildrand
       an: 13 px Rand oben, 0 px unten, bei einem sonst symmetrischen Ausschnitt. */
    var t = Math.max(K.geo(datenJetzt).korpus_tiefe, K.platteTiefe());
    var xs = [], zs = [];
    var nimm = function (x, z) { xs.push(x); zs.push(z); };
    /* Vor einer WAND stehen die Schraenke nach innen — eine Richtung genuegt. Ein BLOCK
       steht frei im Raum: er kann nach beiden Seiten Koerper und Ueberstand haben, und
       welche Seite das ist, sagt die Strecke nicht. Gemessen an der Inselkueche: nach einer
       Richtung gerechnet endete der Kasten bei z = 220, die Insel selbst lief aber darueber
       hinaus und stand am unteren Bildrand an — 0 px Rand unten gegen 9 px oben. */
    var kanten = function (tiefen) {
      return function (teil) {
        var tr = K.wandTransform3D(teil);
        [0, tr.laenge].forEach(function (ab) {
          tiefen.forEach(function (tief) {
            var p = K.weltPunkt3D(teil, ab, tief, 0);
            nimm(p.x, p.z);
          });
        });
      };
    };
    raumJetzt.waende.forEach(kanten([0, t]));
    (raumJetzt.bloecke || []).forEach(kanten([-t, 0, t]));
    if (!xs.length) return null;
    return { minX: Math.min.apply(null, xs), maxX: Math.max.apply(null, xs),
             minZ: Math.min.apply(null, zs), maxZ: Math.max.apply(null, zs) };
  }

  /* Die Draufsicht als echter Blick von oben: senkrecht, massstaeblich, ganzer Raum. */
  /* DER KASTEN DER DRAUFSICHT — einer fuer die Bodenplatte UND die Kamera.

     Vorher rechneten beide ihren eigenen: die Platte aus der reinen Raumhuelle, die Kamera
     aus Huelle UND Inhalt. Bei der geraden Kueche hat die Huelle TIEFE 0 — es gibt nur eine
     Wand, also eine Linie. Die Platte fiel damit auf ihren Ersatzwert von 60 cm zurueck und
     wurde auf die Wandlinie zentriert: die Haelfte lag HINTER der Wand. Gemessen: Platte
     bei z -30..+30, Rahmen bei 0..60 — 30 cm Versatz, im Bild 56 px Rand oben gegen 234
     unten. */
  function obenKasten() {
    if (!bbJetzt) return null;
    var ib = obenInhalt();
    var minX = ib ? Math.min(ib.minX, bbJetzt.minX) : bbJetzt.minX;
    var maxX = ib ? Math.max(ib.maxX, bbJetzt.maxX) : bbJetzt.maxX;
    var minZ = ib ? Math.min(ib.minZ, bbJetzt.minY) : bbJetzt.minY;
    var maxZ = ib ? Math.max(ib.maxZ, bbJetzt.maxY) : bbJetzt.maxY;
    return { minX: minX, maxX: maxX, minZ: minZ, maxZ: maxZ };
  }

  function obenKamera(seitenformat) {
    var ks = obenKasten();
    if (!ks || !cam) return false;
    var mx = (ks.minX + ks.maxX) / 2, mz = (ks.minZ + ks.maxZ) / 2;
    var breit = Math.max(ks.maxX - ks.minX, 60), tief = Math.max(ks.maxZ - ks.minZ, 60);

    /* AUS WELCHER RICHTUNG. Nicht aus dem Formnamen und nicht aus Wandbuchstaben, sondern
       aus den Waenden selbst: die Summe ihrer Innennormalen zeigt in die offene Seite des
       Raumes. Bei der U-Kueche zeigen -x, +z und +x zusammen nach +z — genau dorthin, wo
       keine Wand steht. Bei der L-Kueche ergibt sich die Diagonale, also der Dreiviertel-
       blick, der eine Ecke am besten zeigt. Steht die Summe bei null, bleibt +z. */
    var rx = 0, rz = 0;
    raumJetzt.waende.forEach(function (o) {
      var n = K.wandNormaleInnen(o);
      rx += n.x; rz += n.y;
    });
    var laenge = Math.sqrt(rx * rx + rz * rz);
    if (laenge < 0.01) { rx = 0; rz = 1; laenge = 1; }
    rx /= laenge; rz /= laenge;

    /* WIE STEIL. 58 Grad ueber der Waagerechten: steil genug, dass der Grundriss lesbar
       wird, flach genug, dass die Waende noch Flaeche haben und der Raum raeumlich bleibt.
       Senkrecht von oben — der frueher Stand — laesst jede Wand auf eine Linie zusammen-
       fallen; der Kunde sah Schrankdeckel auf einer Flaeche und keinen Raum. */
    var NEIGUNG = 58 * Math.PI / 180;

    var fov = 42;
    cam.fov = fov; cam.near = 10; cam.aspect = seitenformat;
    cam.updateProjectionMatrix();
    var fv = fov * Math.PI / 180;
    var fh = 2 * Math.atan(Math.tan(fv / 2) * seitenformat);

    /* WIE WEIT. Schraeg von oben ist die Tiefe verkuerzt und die Wandhoehe kippt ins Bild —
       beides gehoert in die senkrechte Forderung. Ein Achtel Luft ringsum. */
    var hoch = tief * Math.sin(NEIGUNG) + hoeheJetzt * Math.cos(NEIGUNG);
    /* Reichlich Luft — der Kunde soll den ganzen Raum sehen, nicht in ihm stehen. Mit einem
       Achtel Rand fuellte die U-Kueche das Bild bis an die Kante; mit knapp der Haelfte mehr
       liegt der Raum als Ganzes darin, so wie auf einem Grundriss. */
    var d = Math.max((breit * 1.45 / 2) / Math.tan(fh / 2),
                     (hoch * 1.45 / 2) / Math.tan(fv / 2));
    d = Math.max(150, Math.min(1400, d)) * (kugel.lupe || 1);

    cam.position.set(mx + rx * d * Math.cos(NEIGUNG),
                     Math.max(60, d * Math.sin(NEIGUNG)),
                     mz + rz * d * Math.cos(NEIGUNG));
    cam.lookAt(mx, hoeheJetzt * 0.18, mz);
    return true;
  }

  /* ---------- Foto-Modus (S4, 2026-09-26) ----------

     Betreiber: „echte Realistik, wie die Fotos meiner fertigen Kuechen" — Entscheidung: beides,
     die Live-Ansicht UND ein Foto per Pfadverfolgung. Das Foto rechnet dieselbe Szene mit echtem
     Lichttransport: indirektes Licht zwischen Fronten, Wand und Boden, weiche Schatten,
     Spiegelungen auf Hochglanz und Platte. three-gpu-pathtracer 0.0.23 ist die letzte Fassung
     fuer three < 0.180 (0.0.24 verlangt 0.180); geladen mit DERSELBEN three-Instanz (esm.sh
     deps), sonst kennt er unsere Materialien nicht.

     Das vorgerechnete Umgebungslicht (PMREM) kann der Pfadverfolger nicht lesen. Fuer die Dauer
     des Fotos stehen deshalb ein heller Verlaufshimmel und eine flaechige Deckenleuchte im Raum;
     `fotoStop` stellt alles zurueck. Auf dem Telefon mit halber Aufloesung und weniger Proben. */
  var PT_QUELLE = 'https://esm.sh/three-gpu-pathtracer@0.0.23?deps=three@0.160.0,three-mesh-bvh@0.7.6';
  var foto = null, ptModul = null;

  /* DIE FOTOSZENE. Gerechnet wird nicht `sc` selbst, sondern eine Kopie aus Einzel-Meshes:
     unsere Korpusse tragen je Flaeche ein eigenes Material (Mehrfachmaterial mit Gruppen), und
     daran vertauscht die Bibliothek die Materialien — gemessen: Fronten und Boden schwarz, die
     Platte in Holz. Je Gruppe ein eigenes Mesh mit genau einem Material behebt das (gemessen:
     Holzfronten, schwarze Platte, Dielen). Lichter kommen mit, das Halbkugellicht nicht (der
     Pfadverfolger kennt es nicht; sein Anteil kommt aus dem Verlaufshimmel). */
  /* KLARLACK IM FOTO: three-gpu-pathtracer 0.0.23 rechnet `clearcoat` auf unseren Fronten schwarz
     (gemessen 2026-09-27 an Glanzia Weiss: alle Fronten schwarz, mit clearcoat 0 weiss). Fuer das Foto
     bekommt ein Klarlack-Material eine Kopie ohne Klarlack, dafuer glatter — es spiegelt weiter wie
     Hochglanz. Live bleibt der Klarlack. Je Material eine Kopie. */
  /* Heller Hochglanz im Foto, bewusst getrennt von GLANZ_HELL (gilt nur live): die Kopie erbt sonst die Werte des
     Live-Lacks. Stand vor der Live-Aenderung vom 2026-09-30 (Betreiber: das Foto bleibt, wie es war) — Rauheit 0,14
     ohne Klarlack, env 1,0; Lackrauheit 0,02 und die abgeschaltete Eigenhelle, damit die Kopie Wert fuer Wert gleicht. */
  var FOTO_HELLGLANZ = { rauh: 0.14, lackRauh: 0.02, env: 1.0 };
  function fotoMat(mat) {
    /* Die Live-Anhebung des Sockels gehoert nicht ins Foto: dort wuerde sie leuchten. */
    if (mat && mat.userData && mat.userData.liveAufhellung && !mat.clearcoat) {
      if (!mat.userData.fotoKopie) { var q0 = mat.clone(); q0.emissiveIntensity = 0; q0.userData = {}; mat.userData.fotoKopie = q0; }
      return mat.userData.fotoKopie;
    }
    if (!mat || !mat.clearcoat) return mat;
    if (!mat.userData.fotoKopie) {
      var k = mat.clone();
      /* Glanzia-Fronten tragen beides: Live-Anhebung (raus) und Klarlack (wie unten). */
      if (mat.userData.liveAufhellung) { k.emissiveIntensity = 0; k.userData = {}; }
      k.clearcoat = 0;
      var dunkel = new T.Color(k.color).getHSL({}).l < 0.5;
      k.roughness = Math.min(k.roughness, dunkel ? 0.08 : 0.14);
      /* Heller Hochglanz: Foto-Werte statt der geerbten Live-Werte (FOTO_HELLGLANZ); HM_SPIEGEL_STAERKE wirkt nur im Live-Shader. */
      if (mat.userData.hellGlanz) {
        k.metalness = 0; k.roughness = FOTO_HELLGLANZ.rauh; k.clearcoatRoughness = FOTO_HELLGLANZ.lackRauh;
        k.envMapIntensity = FOTO_HELLGLANZ.env; k.emissive.copy(k.color); k.emissiveIntensity = 0; k.userData = {};
      }
      /* Grau Hochglanz im Foto: das Abendlicht und die fehlende Spiegelumgebung liessen es auf 75
         absinken (Live 119, Betreiber-Foto ~112, gemessen 2026-09-28). Nur die Foto-Kopie wird heller. */
      if (dunkel && mat.envMap) k.color.multiplyScalar(1.8);
      k.envMap = null;
      mat.userData.fotoKopie = k;
    }
    return mat.userData.fotoKopie;
  }
  function fotoSzene(M) {
    sc.updateMatrixWorld(true);
    var fs = new T.Scene(), eigene = [], ledTeile = [];
    fs.background = sc.background;
    var env = new M.GradientEquirectTexture(256);
    env.topColor.set('#fff8ee'); env.bottomColor.set('#a99d8a'); env.exponent = 2;
    /* Hochglanz-Raum: gedaempftes Tageslicht, damit LED in Sockel und Nische das Bild tragen. */
    /* Neutraler als zuerst (#b9ad9e/#6b6053): das warme Abendlicht machte Grau Hochglanz braun
       (Betreiber 2026-09-27). */
    if (glanzRaum) { env.topColor.set('#dcd9d5'); env.bottomColor.set('#85817b'); }
    env.update();
    fs.environment = env;
    sc.traverse(function (o) {
      if (o.isLight && !o.isHemisphereLight && !o.isLightProbe) {
        var l = o.clone();
        if (glanzRaum) l.intensity *= 0.7;
        l.position.setFromMatrixPosition(o.matrixWorld);
        if (o.target) {
          var zt = new T.Object3D();
          zt.position.setFromMatrixPosition(o.target.matrixWorld);
          fs.add(zt); l.target = zt;
        }
        fs.add(l);
        return;
      }
      if (!o.isMesh || !o.visible || o.userData.nurLive) return;
      /* LED-LEISTE IM FOTO: der duenne leuchtende Streifen allein laesst den Pfadverfolger
         rauschen (er trifft ihn nur zufaellig — gesehen 2026-09-27: die Rueckwand koernig bei
         100 %). Er wird durch ein Rechtecklicht derselben Groesse ersetzt, das nach unten
         strahlt und direkt abgetastet wird; sichtbar bleibt ein heller, nicht leuchtender Streifen. */
      if (o.userData.led && T.RectAreaLight) {
        /* Gesammelt und unten zu EINEM Licht je durchgehender Leiste zusammengelegt: mit einem
           Licht je Schrank (~20) waehlte der Pfadverfolger je Durchgang eines davon aus, und das
           Bild koernte (gesehen 2026-09-27). */
        ledTeile.push({ o: o, key: o.parent.uuid + '|' + o.position.y.toFixed(1) + '|' + o.position.z.toFixed(1),
          x0: o.position.x - o.userData.led.b / 2, x1: o.position.x + o.userData.led.b / 2 });
        var hell = new T.Mesh(o.geometry, new T.MeshStandardMaterial({ color: '#FFF6E8', roughness: 0.5 }));
        hell.applyMatrix4(o.matrixWorld);
        fs.add(hell);
        return;
      }
      var mats = Array.isArray(o.material) ? o.material : null, m;
      if (!mats) { m = new T.Mesh(o.geometry, fotoMat(o.material)); m.applyMatrix4(o.matrixWorld); fs.add(m); return; }
      var g = o.geometry, idx = g.index;
      var gruppen = g.groups.length ? g.groups
        : [{ start: 0, count: idx ? idx.count : g.attributes.position.count, materialIndex: 0 }];
      gruppen.forEach(function (gr) {
        var mat = mats[gr.materialIndex];
        /* Unsichtbare Flaechen (offener Deckel von Spuelen- und Herdumbauschrank) kennt der
           Pfadverfolger nicht — sie kommen gar nicht erst in die Fotoszene. */
        if (!mat || mat.visible === false) return;
        var ng = new T.BufferGeometry();
        Object.keys(g.attributes).forEach(function (k) { ng.setAttribute(k, g.attributes[k]); });
        if (idx) ng.setIndex(new T.BufferAttribute(idx.array.slice(gr.start, gr.start + gr.count), 1));
        eigene.push(ng);
        m = new T.Mesh(ng, fotoMat(mat)); m.applyMatrix4(o.matrixWorld); fs.add(m);
      });
    });
    /* LED-Leisten je Gruppe, Hoehe und Tiefe nach x sortiert; Luecken bis 10 cm werden ueberbrueckt. */
    var nachKey = {};
    ledTeile.forEach(function (t) { (nachKey[t.key] = nachKey[t.key] || []).push(t); });
    Object.keys(nachKey).forEach(function (k) {
      var liste = nachKey[k].sort(function (p, q) { return p.x0 - q.x0; }), laeufe = [];
      liste.forEach(function (t) {
        var l = laeufe[laeufe.length - 1];
        if (l && t.x0 - l.x1 <= 10) { l.x1 = Math.max(l.x1, t.x1); l.staerke = Math.max(l.staerke, t.o.userData.led.staerke || 14); }
        else laeufe.push({ x0: t.x0, x1: t.x1, o: t.o, staerke: t.o.userData.led.staerke || 14 });
      });
      laeufe.forEach(function (l) {
        var o = l.o, par = o.parent;
        /* 12 cm breit bei gleicher Lichtmenge wie ein 3-cm-Streifen: kleine, sehr helle Flaechen
           spiegeln sich in glatten Fronten als Koerner (gemessen 2026-09-27: 3 cm koernig, 12 cm ruhig). */
        var rl = new T.RectAreaLight('#FFE6C4', l.staerke * 3 / 12, l.x1 - l.x0, 12);
        var p = new T.Vector3((l.x0 + l.x1) / 2, o.position.y - 0.3, o.position.z);
        rl.position.copy(par.localToWorld(p));
        par.getWorldQuaternion(rl.quaternion);
        rl.quaternion.multiply(new T.Quaternion().setFromAxisAngle(new T.Vector3(1, 0, 0), -Math.PI / 2));
        fs.add(rl);
      });
    });
    return { szene: fs, env: env, eigene: eigene };
  }
  function fotoStop(ohneZeichnen) {
    if (!foto) return;
    var f = foto; foto = null;
    if (f.raf) w.cancelAnimationFrame(f.raf);
    /* dispose() der Bibliothek wirft in 0.0.23 selbst (gemessen) — abgefangen. */
    try { f.pt.dispose(); } catch (e) { /* bekannt */ }
    (f.eigene || []).forEach(function (g) { g.dispose(); });
    if (f.env && f.env.dispose) f.env.dispose();
    if (f.belichtung != null) rd.toneMappingExposure = f.belichtung;
    if (f.entrauscher) f.entrauscher.dispose();
    if (f.gross) {
      rd.setPixelRatio(f.gross.pr);
      var gb = leinwand && leinwand.clientWidth, gh = leinwand && leinwand.clientHeight;
      if (gb && gh) rd.setSize(gb, gh, false);
    }
    if (schilderEbene) schilderEbene.style.visibility = '';
    /* Die Seite erfaehrt es: das Standbild ist weg, „Bild speichern" gilt nicht mehr. */
    if (typeof w.HMKonfig3D.beimFotoEnde === 'function') { try { w.HMKonfig3D.beimFotoEnde(); } catch (e) { /* Seite */ } }
    if (!ohneZeichnen) zeichnen();
  }
  /* DAS FOTO ALS DATEI (Betreiber 2026-09-28: „das Bild ist gross und das Herunterladen dauert").
     Bisher eine data:-Adresse der ganzen Leinwand in Qualitaet 0,92 — auf einem grossen Bildschirm
     mehrere Megabyte, synchron kodiert (die Seite stand still) und als Text im Link. Jetzt:
     hoechstens 1600 px an der langen Seite, JPEG 0,85, asynchron als Blob mit Objektadresse. */
  /* QUALITAET (Betreiber 2026-09-26: „beim Herunterladen ist das Bild sehr, sehr schlecht"). Das Budget
     von 1,2 Millionen Punkten wurde auf die Leinwand hochgezogen und fuer die Datei wieder verkleinert —
     gespeichert war ein vergroessertes, koerniges Bild. Jetzt wird GENAU in der Dateigroesse gerechnet
     (gemessen Glanzia grau, 1366 × 820 @2: 63 s statt 57 s, sichtbar weniger Koerner), und nach dem
     ersten fertigen Bild rechnet der Desktop weiter bis zum Dreifachen der Durchgaenge (rund zwei
     Minuten): das Standbild wird von selbst schaerfer, „Bild speichern" nimmt immer den letzten Stand.
     Telefone bleiben wie sie sind (Betreiber: die Handy-Qualitaet passt). JPEG 0,92 statt 0,85. */
  /* Das erste Bild in Dateigroesse mit 60 % der Durchgaenge: gemessen kam es mit allen erst nach 72 s statt
     44 s — so steht es etwa so schnell da wie vorher, der Rest ist Nachschaerfen. */
  /* 2500 PX BREIT (Betreiber 2026-09-27: „الصورة دقتها سيئة جدا عند التنزيل — ارفعها ال ٢٥٠٠PX"). Gemessen vorher: das
     Telefon rechnete mit renderScale 0,5 auf seiner kleinen Leinwand (358 × 260 Punkte) und speicherte das vergroessert
     (716 × 520) — daher „sehr schlecht"; der Desktop war auf 1600 px begrenzt. Jetzt ist die Datei 2500 px breit:
       Desktop — die Pfadverfolgung rechnet DIREKT in 2500 px (Zeichenpuffer fuer die Dauer des Fotos umgestellt, danach
                 zurueck), das erste Bild mit weniger Durchgaengen (entrauscht), danach wird wie bisher nachgeschaerft;
       Telefon — Pfadverfolgung in 2500 px ist dort nicht zu schaffen (48-fache Arbeit); das Foto ist ein scharfes Standbild
                 der 3D-Szene in 2500 px, in vier Kacheln mit Rand gerechnet (Speicher wie beim 1600-px-Deckblatt). */
  var FOTO_BREITE = 2500, FOTO_PROBEN = 120, FOTO_PROBEN_GLANZ = 200, FOTO_ERST = 0.35, FOTO_NACH = 3, FOTO_JPEG = 0.92;
  function alsDatei(cv) {
    return new Promise(function (fertig) {
      if (cv.toBlob) cv.toBlob(function (b) { fertig(b ? URL.createObjectURL(b) : cv.toDataURL('image/jpeg', FOTO_JPEG)); }, 'image/jpeg', FOTO_JPEG);
      else fertig(cv.toDataURL('image/jpeg', FOTO_JPEG));
    });
  }
  function fotoDatei() {
    var q = rd.domElement, f = Math.min(1, FOTO_BREITE / Math.max(1, q.width));
    var cv = q;
    if (f < 1) {
      cv = document.createElement('canvas');
      cv.width = Math.round(q.width * f); cv.height = Math.round(q.height * f);
      var c = cv.getContext('2d');
      c.imageSmoothingQuality = 'high';
      c.drawImage(q, 0, 0, cv.width, cv.height);
    }
    return alsDatei(cv);
  }
  /* Die 3D-Szene als Standbild in voller Dateigroesse (Telefon-Foto): 2 x 2 Kacheln ueber setViewOffset, jede mit
     48 px Rand (die Umgebungsverdeckung rechnet im Bildraum — ohne Rand saeume sich die Kachelgrenzen), nur das
     Innere wird eingesetzt. Danach Puffer, Nachbearbeitung und Kamera wie vorher. */
  function grossRaster(B) {
    var cb = leinwand && leinwand.clientWidth, ch = leinwand && leinwand.clientHeight;
    if (!cb || !ch) return null;
    var H = Math.max(1, Math.round(B * ch / cb)), NX = 2, NY = 2, RAND = 48;
    var tb = Math.ceil(B / NX), th = Math.ceil(H / NY), rb = tb + 2 * RAND, rh = th + 2 * RAND;
    var ziel = document.createElement('canvas'); ziel.width = B; ziel.height = H;
    var c2 = ziel.getContext('2d');
    var q = rd.domElement, pr = rd.getPixelRatio(), markSicht = markierung ? markierung.visible : false;
    try {
      rd.setPixelRatio(1); rd.setSize(rb, rh, false);
      if (nach) { nach.comp.setPixelRatio(1); nach.comp.setSize(rb, rh); }
      if (markierung) markierung.visible = false;
      kontaktWeg(!(nach && !ohneNach));
      cam.aspect = B / H;
      for (var iy = 0; iy < NY; iy++) {
        for (var ix = 0; ix < NX; ix++) {
          cam.setViewOffset(B, H, ix * tb - RAND, iy * th - RAND, rb, rh);
          if (nach && !ohneNach) { try { nach.comp.render(); } catch (e) { rd.render(sc, cam); } }
          else rd.render(sc, cam);
          c2.drawImage(q, RAND, RAND, tb, th, ix * tb, iy * th, tb, th);
        }
      }
    } finally {
      cam.clearViewOffset();
      if (markierung) markierung.visible = markSicht;
      rd.setPixelRatio(pr); rd.setSize(cb, ch, false);
      if (nach) { nach.comp.setPixelRatio(pr); nach.comp.setSize(cb, ch); }
      cam.aspect = cb / Math.max(1, ch); cam.updateProjectionMatrix();
      zeichnen();
    }
    return ziel;
  }
  function fotoRaster(fortschritt) {
    return new Promise(function (fertig, fehler) {
      if (fortschritt) fortschritt(0.1);
      /* Erst die Meldung zeichnen lassen, dann rechnen (die Seite steht dafuer kurz still). */
      w.requestAnimationFrame(function () {
        var cv = null;
        /* DAS FOTO EINER KUECHENZEILE IST EIN KATALOGBILD (Betreiber 2026-09-29): von vorne mit langer Brennweite, auch aus
           der Raumansicht oder der Perspektive heraus. Danach steht die Ansicht wieder, wie sie war; der Browser malt
           dazwischen nicht. L, U, zweizeilig und Insel fotografieren weiter die Ansicht, die der Kunde sieht (teleHier). */
        var vorher = kugel ? { art: kugel.art, wandId: kugel.wandId, lupe: kugel.lupe, frontZiel: kugel.frontZiel } : null;
        /* Eine laufende Kamerafahrt endet jetzt (das Foto zeigt die Ziel-Lage), und nichts faehrt danach nach: der Schritt nach
           dem Foto haette es sonst verworfen (fotoStop) — gesehen in der Code-Pruefung 2026-10-01. */
        fahrtAnhalten(); zeichnen();
        var tele = teleHier() && vorher && vorher.art !== 'front';
        var pendelSicht = pendelGruppe ? pendelGruppe.visible : false;
        try {
          if (tele) {
            kugel.art = 'front'; kugel.wandId = raumJetzt.waende[0].id; kugel.lupe = 1;
            var cb0 = leinwand.clientWidth || 800, ch0 = leinwand.clientHeight || 600;
            if (!frontKamera(cb0 / Math.max(1, ch0))) throw new Error('keine Front');
            if (weitGruppe) weitGruppe.visible = true;
            if (pendelGruppe) pendelGruppe.visible = false;
          }
          cv = grossRaster(FOTO_BREITE);
        } catch (e) { cv = null; }
        if (tele) {
          kugel.art = vorher.art; kugel.wandId = vorher.wandId; kugel.lupe = vorher.lupe; kugel.frontZiel = vorher.frontZiel;
          if (pendelGruppe) pendelGruppe.visible = pendelSicht;
          zeichnen();
        }
        fahrtWeiter();
        if (!cv) { fehler(new Error('kein Standbild')); return; }
        foto = { raster: cv, raf: 0 };
        if (fortschritt) fortschritt(1);
        fertig({ abgebrochen: false, bild: function () { return alsDatei(cv); }, weiter: false });
      });
    });
  }
  /* KEINE PFADVERFOLGUNG IM LADEN (Betreiber 2026-09-28: „هذه مشكلة كبيرة جدا"). Die Pfadverfolgung rechnet auf der
     Grafikkarte des BESUCHERS (Shopify liefert nur die Dateien). Auf dem MacBook Air des Betreibers fror sie den Rechner
     zweimal ein — einmal mit ganzen Bildern (gpuEvent „progress timeout", WindowServer-Watchdog, Neustart per Knopf), einmal
     sogar mit 4 x 4 Kacheln beim ersten Lauf. Solche Laptops sind haeufig; ein eingefrorener Rechner kostet den Kunden und
     das Vertrauen. Das Foto ist deshalb auf JEDEM Geraet das scharfe Standbild der 3D-Ansicht in 2500 px (grossRaster, wie
     bisher am Telefon): fertig in ein bis zwei Sekunden, ohne Dauerlast. Der Code der Pfadverfolgung bleibt, abgeschaltet —
     wieder einschalten nur mit einer Loesung, die auf einem lueftrlosen Laptop nachweislich nicht einfriert. */
  var FOTO_PFADVERFOLGUNG = false;
  function fotoStart(fortschritt) {
    if (!rd || !sc || !cam || !T) return Promise.reject(new Error('keine Szene'));
    fotoStop(true);
    if (!FOTO_PFADVERFOLGUNG || (w.innerWidth || 800) < 768) return fotoRaster(fortschritt);
    var laden2 = ptModul ? Promise.resolve(ptModul) : modul(PT_QUELLE).then(function (m) { ptModul = m; return m; });
    return laden2.then(function (M) {
      zeichnen();                                   /* Kamera und Rahmung auf den letzten Stand */
      var klein = (w.innerWidth || 800) < 768;
      /* three-gpu-pathtracer 0.0.23 liest `scene.environmentRotation`/`backgroundRotation` — die
         gibt es erst ab three r162, geladen ist r160. Ohne sie bricht schon der Konstruktor ab
         (gemessen: „Cannot read properties of undefined (reading 'x')" in makeRotationFromEuler).
         Als Standard „keine Drehung" am Prototyp — die Live-Ansicht liest die Felder nicht. */
      ['environmentRotation', 'backgroundRotation'].forEach(function (f) {
        if (!(f in T.Scene.prototype)) T.Scene.prototype[f] = new T.Euler();
      });
      var fsz = fotoSzene(M);
      if (schilderEbene) schilderEbene.style.visibility = 'hidden';
      /* Zeichenpuffer fuer die Dauer des Fotos in Dateigroesse (2500 px breit, Seitenverhaeltnis der Ansicht) —
         die Leinwand zeigt es verkleinert; fotoStop stellt zurueck. */
      var gross = null;
      if (!klein) {
        var qb = rd.domElement.width, qh = rd.domElement.height;
        gross = { pr: rd.getPixelRatio(), b: FOTO_BREITE, h: Math.max(1, Math.round(FOTO_BREITE * qh / Math.max(1, qb))) };
        rd.setPixelRatio(1); rd.setSize(gross.b, gross.h, false);
      }
      var pt = new M.WebGLPathTracer(rd);
      /* IN DATEIGROESSE RECHNEN (Betreiber 2026-09-28: „das Foto dauert sehr lange"; 2026-09-26: „die
         gespeicherte Datei ist sehr schlecht"). Die volle Leinwand (auf einem grossen Bildschirm 3–4
         Millionen Punkte, 108 s) war zu langsam, ein festes Budget von 1,2 Millionen Punkten zu grob —
         es wurde hochgezogen und fuer die Datei wieder verkleinert. Jetzt genau die Groesse der Datei
         (lange Seite hoechstens FOTO_MAX). */
      pt.renderScale = klein ? 0.5 : 1;
      /* Eine Kachel: mit 2 x 2 blieb die untere Haelfte des Bildes leer (gemessen). */
      pt.tiles.set(1, 1);
      /* Hochglanz spiegelt kleine helle Lichter als Koerner (gesehen 2026-09-27) — dort staerker filtern. */
      pt.filterGlossyFactor = glanzRaum ? 1 : 0.5;
      pt.minSamples = 1;
      /* Hochglanz-Raum: wie in der Vorlage ein Abendbild — Belichtung tiefer, damit Weiss nicht
         ausbrennt und das LED-Licht in Sockel und unter den Haengeschraenken sichtbar wird. */
      var belichtung = rd.toneMappingExposure;
      if (glanzRaum) rd.toneMappingExposure = 0.95;
      pt.setScene(fsz.szene, cam);
      /* Weniger Durchgaenge, dafuer immer entrauscht (unten) — vorher 400 / 220. Auf dem Desktop kommt
         das erste Bild nach zielErst, danach wird bis zielEnde nachgeschaerft; Telefone rechnen wie bisher. */
      var zielVoll = glanzRaum ? (klein ? 140 : FOTO_PROBEN_GLANZ) : (klein ? 90 : FOTO_PROBEN);
      var zielErst = klein ? zielVoll : Math.round(zielVoll * FOTO_ERST);
      var zielEnde = klein ? zielVoll : zielVoll * FOTO_NACH;
      foto = { pt: pt, env: fsz.env, eigene: fsz.eigene, raf: 0, belichtung: belichtung, gross: gross };
      /* ENTRAUSCHEN (Hochglanz-Raum): glatte Fronten im gedaempften Licht koernen auch nach 400
         Durchgaengen (gesehen 2026-09-27). Die Ausgabe laeuft dann durch den kantenschonenden
         Entrauscher der Bibliothek (glslSmartDeNoise) statt durch die einfache Kopie — Tonkurve
         und Farbraum rechnet er selbst. Mit wachsender Zahl der Durchgaenge wird er sanfter: das
         erste Bild braucht ihn staerker, das nachgeschaerfte soll Maserung und Kanten behalten. */
      if (M.DenoiseMaterial) {
        var dm = new M.DenoiseMaterial({ blending: T.NoBlending,
          premultipliedAlpha: rd.getContextAttributes().premultipliedAlpha });
        /* Matte Kuechen: sanfter entrauschen — Holzmaserung und Fugen sollen bleiben. */
        var sig = glanzRaum ? [2.6, 1.6] : [2.0, 1.2], schw = glanzRaum ? [0.1, 0.05] : [0.07, 0.035];
        dm.uniforms.kSigma.value = 1.5;
        pt.renderToCanvasCallback = function (quelle, renderer, quad) {
          var alt = quad.material, ac = renderer.autoClear;
          var f = zielEnde > zielErst ? Math.min(1, Math.max(0, (pt.samples - zielErst) / (zielEnde - zielErst))) : 0;
          dm.uniforms.sigma.value = sig[0] + (sig[1] - sig[0]) * f;
          dm.uniforms.threshold.value = schw[0] + (schw[1] - schw[0]) * f;
          dm.uniforms.map.value = quelle.texture;
          quad.material = dm; renderer.autoClear = false;
          quad.render(renderer);
          renderer.autoClear = ac; quad.material = alt;
        };
        foto.entrauscher = dm;
      }
      return new Promise(function (fertig) {
        var meins = foto, gemeldet = false, letzte = 0;
        var schritt = function () {
          if (foto !== meins) { if (!gemeldet) fertig({ abgebrochen: true }); return; }
          pt.renderSample();
          if (!gemeldet) {
            if (fortschritt) fortschritt(Math.min(1, pt.samples / zielErst));
            if (pt.samples >= zielErst) {
              gemeldet = true; letzte = pt.samples;
              fertig({ abgebrochen: false, bild: fotoDatei, weiter: zielEnde > zielErst });
            }
          } else if (pt.samples - letzte >= 40 || pt.samples >= zielEnde) {
            letzte = pt.samples;
            var besser = w.HMKonfig3D.beimFotoBesser;
            if (typeof besser === 'function') { try { besser(fotoDatei, Math.min(1, (pt.samples - zielErst) / Math.max(1, zielEnde - zielErst))); } catch (e) { /* Seite */ } }
          }
          if (pt.samples < zielEnde) { meins.raf = w.requestAnimationFrame(schritt); return; }
          meins.raf = 0;
        };
        meins.raf = w.requestAnimationFrame(schritt);
      });
    });
  }

  w.HMKonfig3D = {
    laden: laden,
    bereit: function () { return !!T; },
    szene: function (cv, z, daten) { zustand = z; aufbauen(cv, z, daten); },
    groesse: groesse,
    blick: blick,
    markieren: markieren,
    /* (breite) → JPEG-Data-URL der aktuellen 3D-Ansicht fuer das Deckblatt des PDF, sonst null. */
    schnappschuss: schnappschuss,
    foto: fotoStart,
    fotoStop: function () { fotoStop(false); },
    /* Nur solange gerechnet wird: ein fertiges Foto steht noch im Bild (foto bleibt bis zur naechsten
       Bewegung gesetzt), aber ein Druck auf „Foto" soll dann ein neues rechnen, nicht „abbrechen". */
    fotoLaeuft: function () { return !!(foto && foto.raf); },
    /* Umgebungsverdeckung an/aus (Vergleich, Proben); gibt zurueck, ob sie jetzt zeichnet. */
    /* Dekorbilder: { 'artisan eiche': url, … } — aus dem Abschnitt (Theme-Assets). */
    dekore: function (quellen) {
      Object.keys(quellen || {}).forEach(function (k) { if (quellen[k]) dekorQuellen[dekorName(k)] = quellen[k]; });
    },
    /* Echte Deko-Modelle: { pflanze, schale, apfel, limette, brett, krug: url } — aus dem Abschnitt. */
    /* Aussicht hinter den Fenstern: Bild-URL aus dem Abschnitt. */
    aussicht: function (url) { if (url) aussichtQuelle = String(url); },
    dekoModelle: function (quellen) {
      Object.keys(quellen || {}).forEach(function (k) { if (quellen[k]) dekoModellQuellen[k] = quellen[k]; });
    },
    /* Nur fuer Proben: innere Objekte (Schatten-Diagnose). */
    _intern: function () { return { T: T, rd: rd, sc: sc, cam: cam, kugel: kugel, sonne: sonne, fensterSonne: fensterSonne, root: root, nurFuerSonne: nurFuerSonne,
      huelle: huelleJetzt, raum: raumJetzt, fenster: lichtFenster, belegt: huelleJetzt ? belegteSeiten(huelleJetzt) : null, raumKamera: raumKamera, raumFrei: raumFrei, raumPunkte: raumPunkte, aussicht: aussichtJetzt,
      fensterLicht: fensterLichter[0] && fensterLichter[0].visible ? { i: fensterLichter[0].intensity, b: fensterLichter[0].width, h: fensterLichter[0].height,
        pos: fensterLichter[0].position.toArray(), farbe: fensterLichter[0].color.getHexString() } : null,
      tageslicht: tageslichtInfo && JSON.parse(JSON.stringify(tageslichtInfo)), sonneSchatten: !!(fensterSonne && fensterSonne.castShadow),
      fotos: Object.keys(raumBilder).filter(function (k) { return k.indexOf('fotoP1:') === 0; }) }; },
    /* Nur fuer Proben (Lichtpult): Werte in das Licht des aktuellen Looks mischen und neu aufbauen. */
    _licht: function (werte) {
      if (!werte || !lookJetzt) return null;
      Object.keys(werte).forEach(function (k) { if (k === 'hebung') GLANZIA_HEBUNG = werte[k]; else lookJetzt.licht[k] = werte[k]; });
      if (leinwand && zustand && datenJetzt) aufbauen(leinwand, zustand, datenJetzt);
      zeichnen();
      var fk = fensterSonne && fensterSonne.shadow.camera, r3 = function (v) { return v ? [Math.round(v.x), Math.round(v.y), Math.round(v.z)] : null; };
      return { look: lookJetzt.name, licht: lookJetzt.licht, fenster: lichtFenster, huelle: huelleJetzt && { minX: huelleJetzt.minX, maxX: huelleJetzt.maxX, minY: huelleJetzt.minY, maxY: huelleJetzt.maxY },
        sonne: fensterSonne && { i: fensterSonne.intensity, pos: r3(fensterSonne.position), ziel: r3(fensterSonne.target.position),
          kam: fk && [fk.left, fk.right, fk.bottom, fk.top, fk.near, fk.far].map(Math.round), karte: !!fensterSonne.shadow.map },
        blende: sonnenBlende ? sonnenBlende.children.length : 0, haupt: sonne && { i: sonne.intensity, pos: r3(sonne.position) },
        belichtung: rd.toneMappingExposure, kurve: rd.toneMapping,
        rezept: rezeptJetzt && { boden: rezeptJetzt.boden, platte: rezeptJetzt.platte, decke: rezeptJetzt.decke, finish: rezeptJetzt.deckeFinish, raster: rezeptJetzt.spotRaster, seite: rezeptJetzt.seite },
        bib: { geladen: Object.keys(bibKarten).length, laedt: Object.keys(bibLaedt).length, fehlt: Object.keys(bibFehlt), basis: bibUrl('x'),
          aufFlaechen: (function () { var b = {}; root.traverse(function (o) { var m = o.isMesh && o.material; if (m && m.userData && m.userData.bib) b[m.userData.bib] = (b[m.userData.bib] || 0) + 1; }); return b; })() } };
    },
    /* Only for probes (phase 1): set values of the architectural shell and rebuild; returns the values now in force. */
    _architektur: function (werte) {
      Object.keys(werte || {}).forEach(function (k) {
        if (k === 'bodenP1') Object.keys(werte[k]).forEach(function (art) { Object.assign(BODEN_P1[art], werte[k][art]); });
        else if (k === 'tageslichtP2') Object.keys(werte[k]).forEach(function (pr) { Object.keys(werte[k][pr]).forEach(function (teil) {
          var v = werte[k][pr][teil]; TAGESLICHT_P2[pr][teil] = v && typeof v === 'object' ? Object.assign({}, TAGESLICHT_P2[pr][teil] || {}, v) : v; }); });
        else ARCHITEKTUR[k] = werte[k];
      });
      if (leinwand && zustand && datenJetzt) aufbauen(leinwand, zustand, datenJetzt);
      zeichnen();
      return JSON.parse(JSON.stringify(ARCHITEKTUR));
    },
    verdeckung: function (an) {
      if (an != null) { ohneNach = !an; if (rd) zeichnen(); }
      return !!nach && !ohneNach;
    },
    beimDrehen: null,
    beimAntippen: null,
    beimFotoEnde: null,
    /* (bild, anteil): das Standbild ist schaerfer geworden — `bild()` liefert die neue Datei. */
    beimFotoBesser: null
  };
})(window);
